!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.factom = e() : t.factom = e();
}(window, function () {
  return function (t) {
    var e = {};

    function r(n) {
      if (e[n]) return e[n].exports;
      var i = e[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
    }

    return r.m = t, r.c = e, r.d = function (t, e, n) {
      r.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, r.t = function (t, e) {
      if (1 & e && (t = r(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var i in t) {
        r.d(n, i, function (e) {
          return t[e];
        }.bind(null, i));
      }
      return n;
    }, r.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return r.d(e, "a", e), e;
    }, r.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, r.p = "", r(r.s = 70);
  }([function (t, e, r) {
    "use strict";

    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
       * @license  MIT
       */
      var n = r(36),
          i = r(37),
          o = r(26);

      function s() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
      }

      function a(t, e) {
        if (s() < e) throw new RangeError("Invalid typed array length");
        return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t;
      }

      function u(t, e, r) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, r);

        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return l(this, t);
        }

        return c(this, t, e, r);
      }

      function c(t, e, r, n) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, r, n) {
          if (e.byteLength, r < 0 || e.byteLength < r) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < r + (n || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === r && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, r) : new Uint8Array(e, r, n);
          u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = f(t, e);
          return t;
        }(t, e, r, n) : "string" == typeof e ? function (t, e, r) {
          "string" == typeof r && "" !== r || (r = "utf8");
          if (!u.isEncoding(r)) throw new TypeError('"encoding" must be a valid string encoding');
          var n = 0 | d(e, r),
              i = (t = a(t, n)).write(e, r);
          i !== n && (t = t.slice(0, i));
          return t;
        }(t, e, r) : function (t, e) {
          if (u.isBuffer(e)) {
            var r = 0 | p(e.length);
            return 0 === (t = a(t, r)).length ? t : (e.copy(t, 0, 0, r), t);
          }

          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (n = e.length) != n ? a(t, 0) : f(t, e);
            if ("Buffer" === e.type && o(e.data)) return f(t, e.data);
          }

          var n;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
        }(t, e);
      }

      function h(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative');
      }

      function l(t, e) {
        if (h(e), t = a(t, e < 0 ? 0 : 0 | p(e)), !u.TYPED_ARRAY_SUPPORT) for (var r = 0; r < e; ++r) {
          t[r] = 0;
        }
        return t;
      }

      function f(t, e) {
        var r = e.length < 0 ? 0 : 0 | p(e.length);
        t = a(t, r);

        for (var n = 0; n < r; n += 1) {
          t[n] = 255 & e[n];
        }

        return t;
      }

      function p(t) {
        if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
        return 0 | t;
      }

      function d(t, e) {
        if (u.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var r = t.length;
        if (0 === r) return 0;

        for (var n = !1;;) {
          switch (e) {
            case "ascii":
            case "latin1":
            case "binary":
              return r;

            case "utf8":
            case "utf-8":
            case void 0:
              return H(t).length;

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * r;

            case "hex":
              return r >>> 1;

            case "base64":
              return q(t).length;

            default:
              if (n) return H(t).length;
              e = ("" + e).toLowerCase(), n = !0;
          }
        }
      }

      function y(t, e, r) {
        var n = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === r || r > this.length) && (r = this.length), r <= 0) return "";
        if ((r >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return O(this, e, r);

            case "utf8":
            case "utf-8":
              return A(this, e, r);

            case "ascii":
              return T(this, e, r);

            case "latin1":
            case "binary":
              return R(this, e, r);

            case "base64":
              return C(this, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return j(this, e, r);

            default:
              if (n) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), n = !0;
          }
        }
      }

      function v(t, e, r) {
        var n = t[e];
        t[e] = t[r], t[r] = n;
      }

      function m(t, e, r, n, i) {
        if (0 === t.length) return -1;

        if ("string" == typeof r ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, isNaN(r) && (r = i ? 0 : t.length - 1), r < 0 && (r = t.length + r), r >= t.length) {
          if (i) return -1;
          r = t.length - 1;
        } else if (r < 0) {
          if (!i) return -1;
          r = 0;
        }

        if ("string" == typeof e && (e = u.from(e, n)), u.isBuffer(e)) return 0 === e.length ? -1 : g(t, e, r, n, i);
        if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? i ? Uint8Array.prototype.indexOf.call(t, e, r) : Uint8Array.prototype.lastIndexOf.call(t, e, r) : g(t, [e], r, n, i);
        throw new TypeError("val must be string, number or Buffer");
      }

      function g(t, e, r, n, i) {
        var o,
            s = 1,
            a = t.length,
            u = e.length;

        if (void 0 !== n && ("ucs2" === (n = String(n).toLowerCase()) || "ucs-2" === n || "utf16le" === n || "utf-16le" === n)) {
          if (t.length < 2 || e.length < 2) return -1;
          s = 2, a /= 2, u /= 2, r /= 2;
        }

        function c(t, e) {
          return 1 === s ? t[e] : t.readUInt16BE(e * s);
        }

        if (i) {
          var h = -1;

          for (o = r; o < a; o++) {
            if (c(t, o) === c(e, -1 === h ? 0 : o - h)) {
              if (-1 === h && (h = o), o - h + 1 === u) return h * s;
            } else -1 !== h && (o -= o - h), h = -1;
          }
        } else for (r + u > a && (r = a - u), o = r; o >= 0; o--) {
          for (var l = !0, f = 0; f < u; f++) {
            if (c(t, o + f) !== c(e, f)) {
              l = !1;
              break;
            }
          }

          if (l) return o;
        }

        return -1;
      }

      function _(t, e, r, n) {
        r = Number(r) || 0;
        var i = t.length - r;
        n ? (n = Number(n)) > i && (n = i) : n = i;
        var o = e.length;
        if (o % 2 != 0) throw new TypeError("Invalid hex string");
        n > o / 2 && (n = o / 2);

        for (var s = 0; s < n; ++s) {
          var a = parseInt(e.substr(2 * s, 2), 16);
          if (isNaN(a)) return s;
          t[r + s] = a;
        }

        return s;
      }

      function b(t, e, r, n) {
        return V(H(e, t.length - r), t, r, n);
      }

      function w(t, e, r, n) {
        return V(function (t) {
          for (var e = [], r = 0; r < t.length; ++r) {
            e.push(255 & t.charCodeAt(r));
          }

          return e;
        }(e), t, r, n);
      }

      function E(t, e, r, n) {
        return w(t, e, r, n);
      }

      function k(t, e, r, n) {
        return V(q(e), t, r, n);
      }

      function x(t, e, r, n) {
        return V(function (t, e) {
          for (var r, n, i, o = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
            r = t.charCodeAt(s), n = r >> 8, i = r % 256, o.push(i), o.push(n);
          }

          return o;
        }(e, t.length - r), t, r, n);
      }

      function C(t, e, r) {
        return 0 === e && r === t.length ? n.fromByteArray(t) : n.fromByteArray(t.slice(e, r));
      }

      function A(t, e, r) {
        r = Math.min(t.length, r);

        for (var n = [], i = e; i < r;) {
          var o,
              s,
              a,
              u,
              c = t[i],
              h = null,
              l = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (i + l <= r) switch (l) {
            case 1:
              c < 128 && (h = c);
              break;

            case 2:
              128 == (192 & (o = t[i + 1])) && (u = (31 & c) << 6 | 63 & o) > 127 && (h = u);
              break;

            case 3:
              o = t[i + 1], s = t[i + 2], 128 == (192 & o) && 128 == (192 & s) && (u = (15 & c) << 12 | (63 & o) << 6 | 63 & s) > 2047 && (u < 55296 || u > 57343) && (h = u);
              break;

            case 4:
              o = t[i + 1], s = t[i + 2], a = t[i + 3], 128 == (192 & o) && 128 == (192 & s) && 128 == (192 & a) && (u = (15 & c) << 18 | (63 & o) << 12 | (63 & s) << 6 | 63 & a) > 65535 && u < 1114112 && (h = u);
          }
          null === h ? (h = 65533, l = 1) : h > 65535 && (h -= 65536, n.push(h >>> 10 & 1023 | 55296), h = 56320 | 1023 & h), n.push(h), i += l;
        }

        return function (t) {
          var e = t.length;
          if (e <= S) return String.fromCharCode.apply(String, t);
          var r = "",
              n = 0;

          for (; n < e;) {
            r += String.fromCharCode.apply(String, t.slice(n, n += S));
          }

          return r;
        }(n);
      }

      e.Buffer = u, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return u.alloc(+t);
      }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function foo() {
              return 42;
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
        } catch (t) {
          return !1;
        }
      }(), e.kMaxLength = s(), u.poolSize = 8192, u._augment = function (t) {
        return t.__proto__ = u.prototype, t;
      }, u.from = function (t, e, r) {
        return c(null, t, e, r);
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
        value: null,
        configurable: !0
      })), u.alloc = function (t, e, r) {
        return function (t, e, r, n) {
          return h(e), e <= 0 ? a(t, e) : void 0 !== r ? "string" == typeof n ? a(t, e).fill(r, n) : a(t, e).fill(r) : a(t, e);
        }(null, t, e, r);
      }, u.allocUnsafe = function (t) {
        return l(null, t);
      }, u.allocUnsafeSlow = function (t) {
        return l(null, t);
      }, u.isBuffer = function (t) {
        return !(null == t || !t._isBuffer);
      }, u.compare = function (t, e) {
        if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;

        for (var r = t.length, n = e.length, i = 0, o = Math.min(r, n); i < o; ++i) {
          if (t[i] !== e[i]) {
            r = t[i], n = e[i];
            break;
          }
        }

        return r < n ? -1 : n < r ? 1 : 0;
      }, u.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;

          default:
            return !1;
        }
      }, u.concat = function (t, e) {
        if (!o(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return u.alloc(0);
        var r;
        if (void 0 === e) for (e = 0, r = 0; r < t.length; ++r) {
          e += t[r].length;
        }
        var n = u.allocUnsafe(e),
            i = 0;

        for (r = 0; r < t.length; ++r) {
          var s = t[r];
          if (!u.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
          s.copy(n, i), i += s.length;
        }

        return n;
      }, u.byteLength = d, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

        for (var e = 0; e < t; e += 2) {
          v(this, e, e + 1);
        }

        return this;
      }, u.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

        for (var e = 0; e < t; e += 4) {
          v(this, e, e + 3), v(this, e + 1, e + 2);
        }

        return this;
      }, u.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

        for (var e = 0; e < t; e += 8) {
          v(this, e, e + 7), v(this, e + 1, e + 6), v(this, e + 2, e + 5), v(this, e + 3, e + 4);
        }

        return this;
      }, u.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? A(this, 0, t) : y.apply(this, arguments);
      }, u.prototype.equals = function (t) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === u.compare(this, t);
      }, u.prototype.inspect = function () {
        var t = "",
            r = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, r).match(/.{2}/g).join(" "), this.length > r && (t += " ... ")), "<Buffer " + t + ">";
      }, u.prototype.compare = function (t, e, r, n, i) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === r && (r = t ? t.length : 0), void 0 === n && (n = 0), void 0 === i && (i = this.length), e < 0 || r > t.length || n < 0 || i > this.length) throw new RangeError("out of range index");
        if (n >= i && e >= r) return 0;
        if (n >= i) return -1;
        if (e >= r) return 1;
        if (this === t) return 0;

        for (var o = (i >>>= 0) - (n >>>= 0), s = (r >>>= 0) - (e >>>= 0), a = Math.min(o, s), c = this.slice(n, i), h = t.slice(e, r), l = 0; l < a; ++l) {
          if (c[l] !== h[l]) {
            o = c[l], s = h[l];
            break;
          }
        }

        return o < s ? -1 : s < o ? 1 : 0;
      }, u.prototype.includes = function (t, e, r) {
        return -1 !== this.indexOf(t, e, r);
      }, u.prototype.indexOf = function (t, e, r) {
        return m(this, t, e, r, !0);
      }, u.prototype.lastIndexOf = function (t, e, r) {
        return m(this, t, e, r, !1);
      }, u.prototype.write = function (t, e, r, n) {
        if (void 0 === e) n = "utf8", r = this.length, e = 0;else if (void 0 === r && "string" == typeof e) n = e, r = this.length, e = 0;else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(r) ? (r |= 0, void 0 === n && (n = "utf8")) : (n = r, r = void 0);
        }
        var i = this.length - e;
        if ((void 0 === r || r > i) && (r = i), t.length > 0 && (r < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        n || (n = "utf8");

        for (var o = !1;;) {
          switch (n) {
            case "hex":
              return _(this, t, e, r);

            case "utf8":
            case "utf-8":
              return b(this, t, e, r);

            case "ascii":
              return w(this, t, e, r);

            case "latin1":
            case "binary":
              return E(this, t, e, r);

            case "base64":
              return k(this, t, e, r);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return x(this, t, e, r);

            default:
              if (o) throw new TypeError("Unknown encoding: " + n);
              n = ("" + n).toLowerCase(), o = !0;
          }
        }
      }, u.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        };
      };
      var S = 4096;

      function T(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(127 & t[i]);
        }

        return n;
      }

      function R(t, e, r) {
        var n = "";
        r = Math.min(t.length, r);

        for (var i = e; i < r; ++i) {
          n += String.fromCharCode(t[i]);
        }

        return n;
      }

      function O(t, e, r) {
        var n = t.length;
        (!e || e < 0) && (e = 0), (!r || r < 0 || r > n) && (r = n);

        for (var i = "", o = e; o < r; ++o) {
          i += N(t[o]);
        }

        return i;
      }

      function j(t, e, r) {
        for (var n = t.slice(e, r), i = "", o = 0; o < n.length; o += 2) {
          i += String.fromCharCode(n[o] + 256 * n[o + 1]);
        }

        return i;
      }

      function P(t, e, r) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > r) throw new RangeError("Trying to access beyond buffer length");
      }

      function I(t, e, r, n, i, o) {
        if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > i || e < o) throw new RangeError('"value" argument is out of bounds');
        if (r + n > t.length) throw new RangeError("Index out of range");
      }

      function B(t, e, r, n) {
        e < 0 && (e = 65535 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 2); i < o; ++i) {
          t[r + i] = (e & 255 << 8 * (n ? i : 1 - i)) >>> 8 * (n ? i : 1 - i);
        }
      }

      function F(t, e, r, n) {
        e < 0 && (e = 4294967295 + e + 1);

        for (var i = 0, o = Math.min(t.length - r, 4); i < o; ++i) {
          t[r + i] = e >>> 8 * (n ? i : 3 - i) & 255;
        }
      }

      function L(t, e, r, n, i, o) {
        if (r + n > t.length) throw new RangeError("Index out of range");
        if (r < 0) throw new RangeError("Index out of range");
      }

      function M(t, e, r, n, o) {
        return o || L(t, 0, r, 4), i.write(t, e, r, n, 23, 4), r + 4;
      }

      function D(t, e, r, n, o) {
        return o || L(t, 0, r, 8), i.write(t, e, r, n, 52, 8), r + 8;
      }

      u.prototype.slice = function (t, e) {
        var r,
            n = this.length;
        if ((t = ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), (e = void 0 === e ? n : ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), e < t && (e = t), u.TYPED_ARRAY_SUPPORT) (r = this.subarray(t, e)).__proto__ = u.prototype;else {
          var i = e - t;
          r = new u(i, void 0);

          for (var o = 0; o < i; ++o) {
            r[o] = this[o + t];
          }
        }
        return r;
      }, u.prototype.readUIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || P(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n;
      }, u.prototype.readUIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || P(t, e, this.length);

        for (var n = this[t + --e], i = 1; e > 0 && (i *= 256);) {
          n += this[t + --e] * i;
        }

        return n;
      }, u.prototype.readUInt8 = function (t, e) {
        return e || P(t, 1, this.length), this[t];
      }, u.prototype.readUInt16LE = function (t, e) {
        return e || P(t, 2, this.length), this[t] | this[t + 1] << 8;
      }, u.prototype.readUInt16BE = function (t, e) {
        return e || P(t, 2, this.length), this[t] << 8 | this[t + 1];
      }, u.prototype.readUInt32LE = function (t, e) {
        return e || P(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
      }, u.prototype.readUInt32BE = function (t, e) {
        return e || P(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
      }, u.prototype.readIntLE = function (t, e, r) {
        t |= 0, e |= 0, r || P(t, e, this.length);

        for (var n = this[t], i = 1, o = 0; ++o < e && (i *= 256);) {
          n += this[t + o] * i;
        }

        return n >= (i *= 128) && (n -= Math.pow(2, 8 * e)), n;
      }, u.prototype.readIntBE = function (t, e, r) {
        t |= 0, e |= 0, r || P(t, e, this.length);

        for (var n = e, i = 1, o = this[t + --n]; n > 0 && (i *= 256);) {
          o += this[t + --n] * i;
        }

        return o >= (i *= 128) && (o -= Math.pow(2, 8 * e)), o;
      }, u.prototype.readInt8 = function (t, e) {
        return e || P(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
      }, u.prototype.readInt16LE = function (t, e) {
        e || P(t, 2, this.length);
        var r = this[t] | this[t + 1] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, u.prototype.readInt16BE = function (t, e) {
        e || P(t, 2, this.length);
        var r = this[t + 1] | this[t] << 8;
        return 32768 & r ? 4294901760 | r : r;
      }, u.prototype.readInt32LE = function (t, e) {
        return e || P(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
      }, u.prototype.readInt32BE = function (t, e) {
        return e || P(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
      }, u.prototype.readFloatLE = function (t, e) {
        return e || P(t, 4, this.length), i.read(this, t, !0, 23, 4);
      }, u.prototype.readFloatBE = function (t, e) {
        return e || P(t, 4, this.length), i.read(this, t, !1, 23, 4);
      }, u.prototype.readDoubleLE = function (t, e) {
        return e || P(t, 8, this.length), i.read(this, t, !0, 52, 8);
      }, u.prototype.readDoubleBE = function (t, e) {
        return e || P(t, 8, this.length), i.read(this, t, !1, 52, 8);
      }, u.prototype.writeUIntLE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || I(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = 1,
            o = 0;

        for (this[e] = 255 & t; ++o < r && (i *= 256);) {
          this[e + o] = t / i & 255;
        }

        return e + r;
      }, u.prototype.writeUIntBE = function (t, e, r, n) {
        (t = +t, e |= 0, r |= 0, n) || I(this, t, e, r, Math.pow(2, 8 * r) - 1, 0);
        var i = r - 1,
            o = 1;

        for (this[e + i] = 255 & t; --i >= 0 && (o *= 256);) {
          this[e + i] = t / o & 255;
        }

        return e + r;
      }, u.prototype.writeUInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
      }, u.prototype.writeUInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
      }, u.prototype.writeUInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
      }, u.prototype.writeUInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : F(this, t, e, !0), e + 4;
      }, u.prototype.writeUInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : F(this, t, e, !1), e + 4;
      }, u.prototype.writeIntLE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          I(this, t, e, r, i - 1, -i);
        }

        var o = 0,
            s = 1,
            a = 0;

        for (this[e] = 255 & t; ++o < r && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o - 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
        }

        return e + r;
      }, u.prototype.writeIntBE = function (t, e, r, n) {
        if (t = +t, e |= 0, !n) {
          var i = Math.pow(2, 8 * r - 1);
          I(this, t, e, r, i - 1, -i);
        }

        var o = r - 1,
            s = 1,
            a = 0;

        for (this[e + o] = 255 & t; --o >= 0 && (s *= 256);) {
          t < 0 && 0 === a && 0 !== this[e + o + 1] && (a = 1), this[e + o] = (t / s >> 0) - a & 255;
        }

        return e + r;
      }, u.prototype.writeInt8 = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
      }, u.prototype.writeInt16LE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : B(this, t, e, !0), e + 2;
      }, u.prototype.writeInt16BE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : B(this, t, e, !1), e + 2;
      }, u.prototype.writeInt32LE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : F(this, t, e, !0), e + 4;
      }, u.prototype.writeInt32BE = function (t, e, r) {
        return t = +t, e |= 0, r || I(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : F(this, t, e, !1), e + 4;
      }, u.prototype.writeFloatLE = function (t, e, r) {
        return M(this, t, e, !0, r);
      }, u.prototype.writeFloatBE = function (t, e, r) {
        return M(this, t, e, !1, r);
      }, u.prototype.writeDoubleLE = function (t, e, r) {
        return D(this, t, e, !0, r);
      }, u.prototype.writeDoubleBE = function (t, e, r) {
        return D(this, t, e, !1, r);
      }, u.prototype.copy = function (t, e, r, n) {
        if (r || (r = 0), n || 0 === n || (n = this.length), e >= t.length && (e = t.length), e || (e = 0), n > 0 && n < r && (n = r), n === r) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (r < 0 || r >= this.length) throw new RangeError("sourceStart out of bounds");
        if (n < 0) throw new RangeError("sourceEnd out of bounds");
        n > this.length && (n = this.length), t.length - e < n - r && (n = t.length - e + r);
        var i,
            o = n - r;
        if (this === t && r < e && e < n) for (i = o - 1; i >= 0; --i) {
          t[i + e] = this[i + r];
        } else if (o < 1e3 || !u.TYPED_ARRAY_SUPPORT) for (i = 0; i < o; ++i) {
          t[i + e] = this[i + r];
        } else Uint8Array.prototype.set.call(t, this.subarray(r, r + o), e);
        return o;
      }, u.prototype.fill = function (t, e, r, n) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (n = e, e = 0, r = this.length) : "string" == typeof r && (n = r, r = this.length), 1 === t.length) {
            var i = t.charCodeAt(0);
            i < 256 && (t = i);
          }

          if (void 0 !== n && "string" != typeof n) throw new TypeError("encoding must be a string");
          if ("string" == typeof n && !u.isEncoding(n)) throw new TypeError("Unknown encoding: " + n);
        } else "number" == typeof t && (t &= 255);

        if (e < 0 || this.length < e || this.length < r) throw new RangeError("Out of range index");
        if (r <= e) return this;
        var o;
        if (e >>>= 0, r = void 0 === r ? this.length : r >>> 0, t || (t = 0), "number" == typeof t) for (o = e; o < r; ++o) {
          this[o] = t;
        } else {
          var s = u.isBuffer(t) ? t : H(new u(t, n).toString()),
              a = s.length;

          for (o = 0; o < r - e; ++o) {
            this[o + e] = s[o % a];
          }
        }
        return this;
      };
      var U = /[^+\/0-9A-Za-z-_]/g;

      function N(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16);
      }

      function H(t, e) {
        var r;
        e = e || 1 / 0;

        for (var n = t.length, i = null, o = [], s = 0; s < n; ++s) {
          if ((r = t.charCodeAt(s)) > 55295 && r < 57344) {
            if (!i) {
              if (r > 56319) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              if (s + 1 === n) {
                (e -= 3) > -1 && o.push(239, 191, 189);
                continue;
              }

              i = r;
              continue;
            }

            if (r < 56320) {
              (e -= 3) > -1 && o.push(239, 191, 189), i = r;
              continue;
            }

            r = 65536 + (i - 55296 << 10 | r - 56320);
          } else i && (e -= 3) > -1 && o.push(239, 191, 189);

          if (i = null, r < 128) {
            if ((e -= 1) < 0) break;
            o.push(r);
          } else if (r < 2048) {
            if ((e -= 2) < 0) break;
            o.push(r >> 6 | 192, 63 & r | 128);
          } else if (r < 65536) {
            if ((e -= 3) < 0) break;
            o.push(r >> 12 | 224, r >> 6 & 63 | 128, 63 & r | 128);
          } else {
            if (!(r < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            o.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, 63 & r | 128);
          }
        }

        return o;
      }

      function q(t) {
        return n.toByteArray(function (t) {
          if ((t = function (t) {
            return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
          }(t).replace(U, "")).length < 2) return "";

          for (; t.length % 4 != 0;) {
            t += "=";
          }

          return t;
        }(t));
      }

      function V(t, e, r, n) {
        for (var i = 0; i < n && !(i + r >= e.length || i >= t.length); ++i) {
          e[i + r] = t[i];
        }

        return i;
      }
    }).call(this, r(3));
  }, function (t, e) {
    t.exports = function (t) {
      return t && t.__esModule ? t : {
        default: t
      };
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(25),
          i = r(11),
          o = r(8),
          s = o.RCD_TYPE_1,
          a = o.secretToPublicKey,
          u = o.sha256d,
          c = r(9),
          h = c.FACTOID_PUBLIC_PREFIX,
          l = c.FACTOID_PRIVATE_PREFIX,
          f = c.ENTRYCREDIT_PUBLIC_PREFIX,
          p = c.ENTRYCREDIT_PRIVATE_PREFIX,
          d = c.VALID_PREFIXES,
          y = c.PUBLIC_ADDRESS_VALID_PREFIXES,
          v = c.PRIVATE_ADDRESS_VALID_PREFIXES,
          m = c.EC_ADDRESS_VALID_PREFIXES,
          g = c.FCT_ADDRESS_VALID_PREFIXES;

      function _(t) {
        try {
          if (!d.has(t.slice(0, 2))) return !1;
          var r = e.from(n.decode(t));
          return 38 === r.length && !!u(r.slice(0, 34)).slice(0, 4).equals(r.slice(34, 38));
        } catch (t) {
          return !1;
        }
      }

      function b(t) {
        return _(t) && "FA" === t.substring(0, 2);
      }

      function w(t) {
        return C(t, h, !0);
      }

      function E(t) {
        return C(t, l);
      }

      function k(t) {
        return C(t, f);
      }

      function x(t) {
        return C(t, p);
      }

      function C(t, r, i) {
        var o = e.from(t, "hex");
        if (32 !== o.length) throw new Error("Key ".concat(o, " is not 32 bytes long."));
        var s = e.concat([r, i ? A(o) : o]),
            a = u(s).slice(0, 4);
        return n.encode(e.concat([s, a]));
      }

      function A(t) {
        return u(e.concat([s, t]));
      }

      t.exports = {
        isValidAddress: _,
        addressToKey: function addressToKey(t) {
          if (!_(t)) throw new Error("Invalid address ".concat(t, "."));
          if (t.startsWith("FA")) throw new Error("A public Factoid address does not hold a public key but a RCD hash. Use addressToRcdHash function instead.");
          return e.from(n.decode(t).slice(2, 34));
        },
        addressToRcdHash: function addressToRcdHash(t) {
          if (!b(t)) throw new Error("Address ".concat(t, " is not a valid public Factoid address"));
          return e.from(n.decode(t).slice(2, 34));
        },
        isValidPublicAddress: function isValidPublicAddress(t) {
          return _(t) && y.has(t.substring(0, 2));
        },
        isValidPrivateAddress: function isValidPrivateAddress(t) {
          return _(t) && v.has(t.substring(0, 2));
        },
        isValidEcAddress: function isValidEcAddress(t) {
          return _(t) && m.has(t.substring(0, 2));
        },
        isValidPublicEcAddress: function isValidPublicEcAddress(t) {
          return _(t) && "EC" === t.substring(0, 2);
        },
        isValidPrivateEcAddress: function isValidPrivateEcAddress(t) {
          return _(t) && "Es" === t.substring(0, 2);
        },
        isValidFctAddress: function isValidFctAddress(t) {
          return _(t) && g.has(t.substring(0, 2));
        },
        isValidPublicFctAddress: b,
        isValidPrivateFctAddress: function isValidPrivateFctAddress(t) {
          return _(t) && "Fs" === t.substring(0, 2);
        },
        getPublicAddress: function getPublicAddress(t) {
          if (!_(t)) throw new Error("Invalid address ".concat(t, "."));
          if ("s" !== t[1]) return t;
          var e = n.decode(t).slice(2, 34),
              r = a(e);
          return "F" === t[0] ? w(r) : k(r);
        },
        keyToPublicFctAddress: w,
        rcdHashToPublicFctAddress: function rcdHashToPublicFctAddress(t) {
          return C(t, h);
        },
        seedToPrivateFctAddress: E,
        keyToPublicEcAddress: k,
        seedToPrivateEcAddress: x,
        generateRandomFctAddress: function generateRandomFctAddress() {
          var t = i.randomBytes(32);
          return {
            public: w(i.sign.keyPair.fromSeed(t).publicKey),
            private: E(t)
          };
        },
        generateRandomEcAddress: function generateRandomEcAddress() {
          var t = i.randomBytes(32);
          return {
            public: k(i.sign.keyPair.fromSeed(t).publicKey),
            private: x(t)
          };
        }
      };
    }).call(this, r(0).Buffer);
  }, function (t, e) {
    var r;

    r = function () {
      return this;
    }();

    try {
      r = r || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (r = window);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    var n = r(51),
        i = r(78),
        o = Object.prototype.toString;

    function s(t) {
      return "[object Array]" === o.call(t);
    }

    function a(t) {
      return null !== t && "object" == typeof t;
    }

    function u(t) {
      return "[object Function]" === o.call(t);
    }

    function c(t, e) {
      if (null != t) if ("object" != typeof t && (t = [t]), s(t)) for (var r = 0, n = t.length; r < n; r++) {
        e.call(null, t[r], r, t);
      } else for (var i in t) {
        Object.prototype.hasOwnProperty.call(t, i) && e.call(null, t[i], i, t);
      }
    }

    t.exports = {
      isArray: s,
      isArrayBuffer: function isArrayBuffer(t) {
        return "[object ArrayBuffer]" === o.call(t);
      },
      isBuffer: i,
      isFormData: function isFormData(t) {
        return "undefined" != typeof FormData && t instanceof FormData;
      },
      isArrayBufferView: function isArrayBufferView(t) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && t.buffer instanceof ArrayBuffer;
      },
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isNumber: function isNumber(t) {
        return "number" == typeof t;
      },
      isObject: a,
      isUndefined: function isUndefined(t) {
        return void 0 === t;
      },
      isDate: function isDate(t) {
        return "[object Date]" === o.call(t);
      },
      isFile: function isFile(t) {
        return "[object File]" === o.call(t);
      },
      isBlob: function isBlob(t) {
        return "[object Blob]" === o.call(t);
      },
      isFunction: u,
      isStream: function isStream(t) {
        return a(t) && u(t.pipe);
      },
      isURLSearchParams: function isURLSearchParams(t) {
        return "undefined" != typeof URLSearchParams && t instanceof URLSearchParams;
      },
      isStandardBrowserEnv: function isStandardBrowserEnv() {
        return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
      },
      forEach: c,
      merge: function t() {
        var e = {};

        function r(r, n) {
          "object" == typeof e[n] && "object" == typeof r ? e[n] = t(e[n], r) : e[n] = r;
        }

        for (var n = 0, i = arguments.length; n < i; n++) {
          c(arguments[n], r);
        }

        return e;
      },
      deepMerge: function t() {
        var e = {};

        function r(r, n) {
          "object" == typeof e[n] && "object" == typeof r ? e[n] = t(e[n], r) : e[n] = "object" == typeof r ? t({}, r) : r;
        }

        for (var n = 0, i = arguments.length; n < i; n++) {
          c(arguments[n], r);
        }

        return e;
      },
      extend: function extend(t, e, r) {
        return c(e, function (e, i) {
          t[i] = r && "function" == typeof e ? n(e, r) : e;
        }), t;
      },
      trim: function trim(t) {
        return t.replace(/^\s*/, "").replace(/\s*$/, "");
      }
    };
  }, function (t, e, r) {
    t.exports = r(31);
  }, function (t, e) {
    function r(t, e, r, n, i, o, s) {
      try {
        var a = t[o](s),
            u = a.value;
      } catch (t) {
        return void r(t);
      }

      a.done ? e(u) : Promise.resolve(u).then(n, i);
    }

    t.exports = function (t) {
      return function () {
        var e = this,
            n = arguments;
        return new Promise(function (i, o) {
          var s = t.apply(e, n);

          function a(t) {
            r(s, i, o, a, u, "next", t);
          }

          function u(t) {
            r(s, i, o, a, u, "throw", t);
          }

          a(void 0);
        });
      };
    };
  }, function (t, e) {
    t.exports = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(1)(r(17)),
          i = r(11).sign,
          o = r(43),
          s = r(44),
          a = r(46),
          u = e.from("01", "hex"),
          c = o.fromString("8000000000000000", !0, 16);
      t.exports = {
        RCD_TYPE_1: u,
        sha256: function sha256(t) {
          return e.from(s().update(t).digest());
        },
        sha512: function sha512(t) {
          return e.from(a().update(t).digest());
        },
        sha256d: function sha256d(t) {
          return e.from(s().update(s().update(t).digest()).digest());
        },
        toHex: function toHex(t) {
          return e.isBuffer(t) ? t.toString("hex") : t;
        },
        encodeVarInt: function encodeVarInt(t) {
          var r = [];
          0 !== t && "0" !== t || r.push(0);
          var n = o.fromValue(t, !0),
              i = !1;
          n.and(c).isZero() || (r.push(129), i = !0);

          for (var s = 0; s < 9; ++s) {
            var a = n.shiftRightUnsigned(56).toNumber();
            (a || i) && (i = !0, 8 !== s ? a |= 128 : a &= 127, r.push(a)), n = n.shiftLeft(7);
          }

          return e.from(r);
        },
        isIterable: function isIterable(t) {
          return null != t && "function" == typeof t[Symbol.iterator];
        },
        flatMap: function flatMap(t, e) {
          var r;
          return (r = []).concat.apply(r, (0, n.default)(t.map(e)));
        },
        secretToPublicKey: function secretToPublicKey(t) {
          var r = i.keyPair.fromSeed(t);
          return e.from(r.publicKey);
        }
      };
    }).call(this, r(0).Buffer);
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var r = "000000000000000000000000000000000000000000000000000000000000000a",
          n = new Map([[1, "DIRECTORY_BLOCK_SIGNATURE"], [2, "REVEAL_MATRYOSHKA_HASH"], [3, "ADD_REPLACE_MATRYOSHKA_HASH"], [4, "INCREASE_SERVER_COUNT"], [5, "ADD_FEDERATED_SERVER"], [6, "ADD_AUDIT_SERVER"], [7, "REMOVE_FEDERATED_SERVER"], [8, "ADD_FEDERATED_SERVER_SIGNING_KEY"], [9, "ADD_FEDERATED_SERVER_BITCOIN_ANCHOR_KEY"], [10, "SERVER_FAULT_HANDOFF"], [11, "COINBASE_DESCRIPTOR"], [12, "COINBASE_DESCRIPTOR_CANCEL"], [13, "ADD_AUTHORITY_FACTOID_ADDRESS"], [14, "ADD_AUTHORITY_EFFICIENCY"]]);
      t.exports = {
        MAX_TRANSACTION_SIZE: 10240,
        MAX_ENTRY_PAYLOAD_SIZE: 10240,
        MAX_ENTRY_SIZE: 10275,
        CHAIN_CREATION_COST: 10,
        NULL_HASH: "0000000000000000000000000000000000000000000000000000000000000000",
        ADMIN_BLOCKS_CHAIN_ID: r,
        ENTRY_CREDIT_BLOCKS_CHAIN_ID: "000000000000000000000000000000000000000000000000000000000000000c",
        FACTOID_BLOCKS_CHAIN_ID: "000000000000000000000000000000000000000000000000000000000000000f",
        RESERVED_CHAIN_IDS: new Set([r, "000000000000000000000000000000000000000000000000000000000000000c", "000000000000000000000000000000000000000000000000000000000000000f"]),
        VALID_PREFIXES: new Set(["Fs", "FA", "EC", "Es"]),
        PUBLIC_ADDRESS_VALID_PREFIXES: new Set(["FA", "EC"]),
        PRIVATE_ADDRESS_VALID_PREFIXES: new Set(["Fs", "Es"]),
        EC_ADDRESS_VALID_PREFIXES: new Set(["EC", "Es"]),
        FCT_ADDRESS_VALID_PREFIXES: new Set(["FA", "Fs"]),
        FACTOID_PUBLIC_PREFIX: e.from("5fb1", "hex"),
        FACTOID_PRIVATE_PREFIX: e.from("6478", "hex"),
        ENTRYCREDIT_PUBLIC_PREFIX: e.from("592a", "hex"),
        ENTRYCREDIT_PRIVATE_PREFIX: e.from("5db6", "hex"),
        ADMIN_ID_TO_CODE: n
      };
    }).call(this, r(0).Buffer);
  }, function (t, e) {
    function r(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }

    t.exports = function (t, e, n) {
      return e && r(t.prototype, e), n && r(t, n), t;
    };
  }, function (t, e, r) {
    !function (t) {
      "use strict";

      var e = function e(t) {
        var e,
            r = new Float64Array(16);
        if (t) for (e = 0; e < t.length; e++) {
          r[e] = t[e];
        }
        return r;
      },
          n = function n() {
        throw new Error("no PRNG");
      },
          i = new Uint8Array(16),
          o = new Uint8Array(32);

      o[0] = 9;
      var s = e(),
          a = e([1]),
          u = e([56129, 1]),
          c = e([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]),
          h = e([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]),
          l = e([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]),
          f = e([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]),
          p = e([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);

      function d(t, e, r, n) {
        t[e] = r >> 24 & 255, t[e + 1] = r >> 16 & 255, t[e + 2] = r >> 8 & 255, t[e + 3] = 255 & r, t[e + 4] = n >> 24 & 255, t[e + 5] = n >> 16 & 255, t[e + 6] = n >> 8 & 255, t[e + 7] = 255 & n;
      }

      function y(t, e, r, n, i) {
        var o,
            s = 0;

        for (o = 0; o < i; o++) {
          s |= t[e + o] ^ r[n + o];
        }

        return (1 & s - 1 >>> 8) - 1;
      }

      function v(t, e, r, n) {
        return y(t, e, r, n, 16);
      }

      function m(t, e, r, n) {
        return y(t, e, r, n, 32);
      }

      function g(t, e, r, n) {
        !function (t, e, r, n) {
          for (var i, o = 255 & n[0] | (255 & n[1]) << 8 | (255 & n[2]) << 16 | (255 & n[3]) << 24, s = 255 & r[0] | (255 & r[1]) << 8 | (255 & r[2]) << 16 | (255 & r[3]) << 24, a = 255 & r[4] | (255 & r[5]) << 8 | (255 & r[6]) << 16 | (255 & r[7]) << 24, u = 255 & r[8] | (255 & r[9]) << 8 | (255 & r[10]) << 16 | (255 & r[11]) << 24, c = 255 & r[12] | (255 & r[13]) << 8 | (255 & r[14]) << 16 | (255 & r[15]) << 24, h = 255 & n[4] | (255 & n[5]) << 8 | (255 & n[6]) << 16 | (255 & n[7]) << 24, l = 255 & e[0] | (255 & e[1]) << 8 | (255 & e[2]) << 16 | (255 & e[3]) << 24, f = 255 & e[4] | (255 & e[5]) << 8 | (255 & e[6]) << 16 | (255 & e[7]) << 24, p = 255 & e[8] | (255 & e[9]) << 8 | (255 & e[10]) << 16 | (255 & e[11]) << 24, d = 255 & e[12] | (255 & e[13]) << 8 | (255 & e[14]) << 16 | (255 & e[15]) << 24, y = 255 & n[8] | (255 & n[9]) << 8 | (255 & n[10]) << 16 | (255 & n[11]) << 24, v = 255 & r[16] | (255 & r[17]) << 8 | (255 & r[18]) << 16 | (255 & r[19]) << 24, m = 255 & r[20] | (255 & r[21]) << 8 | (255 & r[22]) << 16 | (255 & r[23]) << 24, g = 255 & r[24] | (255 & r[25]) << 8 | (255 & r[26]) << 16 | (255 & r[27]) << 24, _ = 255 & r[28] | (255 & r[29]) << 8 | (255 & r[30]) << 16 | (255 & r[31]) << 24, b = 255 & n[12] | (255 & n[13]) << 8 | (255 & n[14]) << 16 | (255 & n[15]) << 24, w = o, E = s, k = a, x = u, C = c, A = h, S = l, T = f, R = p, O = d, j = y, P = v, I = m, B = g, F = _, L = b, M = 0; M < 20; M += 2) {
            w ^= (i = (I ^= (i = (R ^= (i = (C ^= (i = w + I | 0) << 7 | i >>> 25) + w | 0) << 9 | i >>> 23) + C | 0) << 13 | i >>> 19) + R | 0) << 18 | i >>> 14, A ^= (i = (E ^= (i = (B ^= (i = (O ^= (i = A + E | 0) << 7 | i >>> 25) + A | 0) << 9 | i >>> 23) + O | 0) << 13 | i >>> 19) + B | 0) << 18 | i >>> 14, j ^= (i = (S ^= (i = (k ^= (i = (F ^= (i = j + S | 0) << 7 | i >>> 25) + j | 0) << 9 | i >>> 23) + F | 0) << 13 | i >>> 19) + k | 0) << 18 | i >>> 14, L ^= (i = (P ^= (i = (T ^= (i = (x ^= (i = L + P | 0) << 7 | i >>> 25) + L | 0) << 9 | i >>> 23) + x | 0) << 13 | i >>> 19) + T | 0) << 18 | i >>> 14, w ^= (i = (x ^= (i = (k ^= (i = (E ^= (i = w + x | 0) << 7 | i >>> 25) + w | 0) << 9 | i >>> 23) + E | 0) << 13 | i >>> 19) + k | 0) << 18 | i >>> 14, A ^= (i = (C ^= (i = (T ^= (i = (S ^= (i = A + C | 0) << 7 | i >>> 25) + A | 0) << 9 | i >>> 23) + S | 0) << 13 | i >>> 19) + T | 0) << 18 | i >>> 14, j ^= (i = (O ^= (i = (R ^= (i = (P ^= (i = j + O | 0) << 7 | i >>> 25) + j | 0) << 9 | i >>> 23) + P | 0) << 13 | i >>> 19) + R | 0) << 18 | i >>> 14, L ^= (i = (F ^= (i = (B ^= (i = (I ^= (i = L + F | 0) << 7 | i >>> 25) + L | 0) << 9 | i >>> 23) + I | 0) << 13 | i >>> 19) + B | 0) << 18 | i >>> 14;
          }

          w = w + o | 0, E = E + s | 0, k = k + a | 0, x = x + u | 0, C = C + c | 0, A = A + h | 0, S = S + l | 0, T = T + f | 0, R = R + p | 0, O = O + d | 0, j = j + y | 0, P = P + v | 0, I = I + m | 0, B = B + g | 0, F = F + _ | 0, L = L + b | 0, t[0] = w >>> 0 & 255, t[1] = w >>> 8 & 255, t[2] = w >>> 16 & 255, t[3] = w >>> 24 & 255, t[4] = E >>> 0 & 255, t[5] = E >>> 8 & 255, t[6] = E >>> 16 & 255, t[7] = E >>> 24 & 255, t[8] = k >>> 0 & 255, t[9] = k >>> 8 & 255, t[10] = k >>> 16 & 255, t[11] = k >>> 24 & 255, t[12] = x >>> 0 & 255, t[13] = x >>> 8 & 255, t[14] = x >>> 16 & 255, t[15] = x >>> 24 & 255, t[16] = C >>> 0 & 255, t[17] = C >>> 8 & 255, t[18] = C >>> 16 & 255, t[19] = C >>> 24 & 255, t[20] = A >>> 0 & 255, t[21] = A >>> 8 & 255, t[22] = A >>> 16 & 255, t[23] = A >>> 24 & 255, t[24] = S >>> 0 & 255, t[25] = S >>> 8 & 255, t[26] = S >>> 16 & 255, t[27] = S >>> 24 & 255, t[28] = T >>> 0 & 255, t[29] = T >>> 8 & 255, t[30] = T >>> 16 & 255, t[31] = T >>> 24 & 255, t[32] = R >>> 0 & 255, t[33] = R >>> 8 & 255, t[34] = R >>> 16 & 255, t[35] = R >>> 24 & 255, t[36] = O >>> 0 & 255, t[37] = O >>> 8 & 255, t[38] = O >>> 16 & 255, t[39] = O >>> 24 & 255, t[40] = j >>> 0 & 255, t[41] = j >>> 8 & 255, t[42] = j >>> 16 & 255, t[43] = j >>> 24 & 255, t[44] = P >>> 0 & 255, t[45] = P >>> 8 & 255, t[46] = P >>> 16 & 255, t[47] = P >>> 24 & 255, t[48] = I >>> 0 & 255, t[49] = I >>> 8 & 255, t[50] = I >>> 16 & 255, t[51] = I >>> 24 & 255, t[52] = B >>> 0 & 255, t[53] = B >>> 8 & 255, t[54] = B >>> 16 & 255, t[55] = B >>> 24 & 255, t[56] = F >>> 0 & 255, t[57] = F >>> 8 & 255, t[58] = F >>> 16 & 255, t[59] = F >>> 24 & 255, t[60] = L >>> 0 & 255, t[61] = L >>> 8 & 255, t[62] = L >>> 16 & 255, t[63] = L >>> 24 & 255;
        }(t, e, r, n);
      }

      function _(t, e, r, n) {
        !function (t, e, r, n) {
          for (var i, o = 255 & n[0] | (255 & n[1]) << 8 | (255 & n[2]) << 16 | (255 & n[3]) << 24, s = 255 & r[0] | (255 & r[1]) << 8 | (255 & r[2]) << 16 | (255 & r[3]) << 24, a = 255 & r[4] | (255 & r[5]) << 8 | (255 & r[6]) << 16 | (255 & r[7]) << 24, u = 255 & r[8] | (255 & r[9]) << 8 | (255 & r[10]) << 16 | (255 & r[11]) << 24, c = 255 & r[12] | (255 & r[13]) << 8 | (255 & r[14]) << 16 | (255 & r[15]) << 24, h = 255 & n[4] | (255 & n[5]) << 8 | (255 & n[6]) << 16 | (255 & n[7]) << 24, l = 255 & e[0] | (255 & e[1]) << 8 | (255 & e[2]) << 16 | (255 & e[3]) << 24, f = 255 & e[4] | (255 & e[5]) << 8 | (255 & e[6]) << 16 | (255 & e[7]) << 24, p = 255 & e[8] | (255 & e[9]) << 8 | (255 & e[10]) << 16 | (255 & e[11]) << 24, d = 255 & e[12] | (255 & e[13]) << 8 | (255 & e[14]) << 16 | (255 & e[15]) << 24, y = 255 & n[8] | (255 & n[9]) << 8 | (255 & n[10]) << 16 | (255 & n[11]) << 24, v = 255 & r[16] | (255 & r[17]) << 8 | (255 & r[18]) << 16 | (255 & r[19]) << 24, m = 255 & r[20] | (255 & r[21]) << 8 | (255 & r[22]) << 16 | (255 & r[23]) << 24, g = 255 & r[24] | (255 & r[25]) << 8 | (255 & r[26]) << 16 | (255 & r[27]) << 24, _ = 255 & r[28] | (255 & r[29]) << 8 | (255 & r[30]) << 16 | (255 & r[31]) << 24, b = 255 & n[12] | (255 & n[13]) << 8 | (255 & n[14]) << 16 | (255 & n[15]) << 24, w = 0; w < 20; w += 2) {
            o ^= (i = (m ^= (i = (p ^= (i = (c ^= (i = o + m | 0) << 7 | i >>> 25) + o | 0) << 9 | i >>> 23) + c | 0) << 13 | i >>> 19) + p | 0) << 18 | i >>> 14, h ^= (i = (s ^= (i = (g ^= (i = (d ^= (i = h + s | 0) << 7 | i >>> 25) + h | 0) << 9 | i >>> 23) + d | 0) << 13 | i >>> 19) + g | 0) << 18 | i >>> 14, y ^= (i = (l ^= (i = (a ^= (i = (_ ^= (i = y + l | 0) << 7 | i >>> 25) + y | 0) << 9 | i >>> 23) + _ | 0) << 13 | i >>> 19) + a | 0) << 18 | i >>> 14, b ^= (i = (v ^= (i = (f ^= (i = (u ^= (i = b + v | 0) << 7 | i >>> 25) + b | 0) << 9 | i >>> 23) + u | 0) << 13 | i >>> 19) + f | 0) << 18 | i >>> 14, o ^= (i = (u ^= (i = (a ^= (i = (s ^= (i = o + u | 0) << 7 | i >>> 25) + o | 0) << 9 | i >>> 23) + s | 0) << 13 | i >>> 19) + a | 0) << 18 | i >>> 14, h ^= (i = (c ^= (i = (f ^= (i = (l ^= (i = h + c | 0) << 7 | i >>> 25) + h | 0) << 9 | i >>> 23) + l | 0) << 13 | i >>> 19) + f | 0) << 18 | i >>> 14, y ^= (i = (d ^= (i = (p ^= (i = (v ^= (i = y + d | 0) << 7 | i >>> 25) + y | 0) << 9 | i >>> 23) + v | 0) << 13 | i >>> 19) + p | 0) << 18 | i >>> 14, b ^= (i = (_ ^= (i = (g ^= (i = (m ^= (i = b + _ | 0) << 7 | i >>> 25) + b | 0) << 9 | i >>> 23) + m | 0) << 13 | i >>> 19) + g | 0) << 18 | i >>> 14;
          }

          t[0] = o >>> 0 & 255, t[1] = o >>> 8 & 255, t[2] = o >>> 16 & 255, t[3] = o >>> 24 & 255, t[4] = h >>> 0 & 255, t[5] = h >>> 8 & 255, t[6] = h >>> 16 & 255, t[7] = h >>> 24 & 255, t[8] = y >>> 0 & 255, t[9] = y >>> 8 & 255, t[10] = y >>> 16 & 255, t[11] = y >>> 24 & 255, t[12] = b >>> 0 & 255, t[13] = b >>> 8 & 255, t[14] = b >>> 16 & 255, t[15] = b >>> 24 & 255, t[16] = l >>> 0 & 255, t[17] = l >>> 8 & 255, t[18] = l >>> 16 & 255, t[19] = l >>> 24 & 255, t[20] = f >>> 0 & 255, t[21] = f >>> 8 & 255, t[22] = f >>> 16 & 255, t[23] = f >>> 24 & 255, t[24] = p >>> 0 & 255, t[25] = p >>> 8 & 255, t[26] = p >>> 16 & 255, t[27] = p >>> 24 & 255, t[28] = d >>> 0 & 255, t[29] = d >>> 8 & 255, t[30] = d >>> 16 & 255, t[31] = d >>> 24 & 255;
        }(t, e, r, n);
      }

      var b = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);

      function w(t, e, r, n, i, o, s) {
        var a,
            u,
            c = new Uint8Array(16),
            h = new Uint8Array(64);

        for (u = 0; u < 16; u++) {
          c[u] = 0;
        }

        for (u = 0; u < 8; u++) {
          c[u] = o[u];
        }

        for (; i >= 64;) {
          for (g(h, c, s, b), u = 0; u < 64; u++) {
            t[e + u] = r[n + u] ^ h[u];
          }

          for (a = 1, u = 8; u < 16; u++) {
            a = a + (255 & c[u]) | 0, c[u] = 255 & a, a >>>= 8;
          }

          i -= 64, e += 64, n += 64;
        }

        if (i > 0) for (g(h, c, s, b), u = 0; u < i; u++) {
          t[e + u] = r[n + u] ^ h[u];
        }
        return 0;
      }

      function E(t, e, r, n, i) {
        var o,
            s,
            a = new Uint8Array(16),
            u = new Uint8Array(64);

        for (s = 0; s < 16; s++) {
          a[s] = 0;
        }

        for (s = 0; s < 8; s++) {
          a[s] = n[s];
        }

        for (; r >= 64;) {
          for (g(u, a, i, b), s = 0; s < 64; s++) {
            t[e + s] = u[s];
          }

          for (o = 1, s = 8; s < 16; s++) {
            o = o + (255 & a[s]) | 0, a[s] = 255 & o, o >>>= 8;
          }

          r -= 64, e += 64;
        }

        if (r > 0) for (g(u, a, i, b), s = 0; s < r; s++) {
          t[e + s] = u[s];
        }
        return 0;
      }

      function k(t, e, r, n, i) {
        var o = new Uint8Array(32);

        _(o, n, i, b);

        for (var s = new Uint8Array(8), a = 0; a < 8; a++) {
          s[a] = n[a + 16];
        }

        return E(t, e, r, s, o);
      }

      function x(t, e, r, n, i, o, s) {
        var a = new Uint8Array(32);

        _(a, o, s, b);

        for (var u = new Uint8Array(8), c = 0; c < 8; c++) {
          u[c] = o[c + 16];
        }

        return w(t, e, r, n, i, u, a);
      }

      var C = function C(t) {
        var e, r, n, i, o, s, a, u;
        this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0, e = 255 & t[0] | (255 & t[1]) << 8, this.r[0] = 8191 & e, r = 255 & t[2] | (255 & t[3]) << 8, this.r[1] = 8191 & (e >>> 13 | r << 3), n = 255 & t[4] | (255 & t[5]) << 8, this.r[2] = 7939 & (r >>> 10 | n << 6), i = 255 & t[6] | (255 & t[7]) << 8, this.r[3] = 8191 & (n >>> 7 | i << 9), o = 255 & t[8] | (255 & t[9]) << 8, this.r[4] = 255 & (i >>> 4 | o << 12), this.r[5] = o >>> 1 & 8190, s = 255 & t[10] | (255 & t[11]) << 8, this.r[6] = 8191 & (o >>> 14 | s << 2), a = 255 & t[12] | (255 & t[13]) << 8, this.r[7] = 8065 & (s >>> 11 | a << 5), u = 255 & t[14] | (255 & t[15]) << 8, this.r[8] = 8191 & (a >>> 8 | u << 8), this.r[9] = u >>> 5 & 127, this.pad[0] = 255 & t[16] | (255 & t[17]) << 8, this.pad[1] = 255 & t[18] | (255 & t[19]) << 8, this.pad[2] = 255 & t[20] | (255 & t[21]) << 8, this.pad[3] = 255 & t[22] | (255 & t[23]) << 8, this.pad[4] = 255 & t[24] | (255 & t[25]) << 8, this.pad[5] = 255 & t[26] | (255 & t[27]) << 8, this.pad[6] = 255 & t[28] | (255 & t[29]) << 8, this.pad[7] = 255 & t[30] | (255 & t[31]) << 8;
      };

      function A(t, e, r, n, i, o) {
        var s = new C(o);
        return s.update(r, n, i), s.finish(t, e), 0;
      }

      function S(t, e, r, n, i, o) {
        var s = new Uint8Array(16);
        return A(s, 0, r, n, i, o), v(t, e, s, 0);
      }

      function T(t, e, r, n, i) {
        var o;
        if (r < 32) return -1;

        for (x(t, 0, e, 0, r, n, i), A(t, 16, t, 32, r - 32, t), o = 0; o < 16; o++) {
          t[o] = 0;
        }

        return 0;
      }

      function R(t, e, r, n, i) {
        var o,
            s = new Uint8Array(32);
        if (r < 32) return -1;
        if (k(s, 0, 32, n, i), 0 !== S(e, 16, e, 32, r - 32, s)) return -1;

        for (x(t, 0, e, 0, r, n, i), o = 0; o < 32; o++) {
          t[o] = 0;
        }

        return 0;
      }

      function O(t, e) {
        var r;

        for (r = 0; r < 16; r++) {
          t[r] = 0 | e[r];
        }
      }

      function j(t) {
        var e,
            r,
            n = 1;

        for (e = 0; e < 16; e++) {
          r = t[e] + n + 65535, n = Math.floor(r / 65536), t[e] = r - 65536 * n;
        }

        t[0] += n - 1 + 37 * (n - 1);
      }

      function P(t, e, r) {
        for (var n, i = ~(r - 1), o = 0; o < 16; o++) {
          n = i & (t[o] ^ e[o]), t[o] ^= n, e[o] ^= n;
        }
      }

      function I(t, r) {
        var n,
            i,
            o,
            s = e(),
            a = e();

        for (n = 0; n < 16; n++) {
          a[n] = r[n];
        }

        for (j(a), j(a), j(a), i = 0; i < 2; i++) {
          for (s[0] = a[0] - 65517, n = 1; n < 15; n++) {
            s[n] = a[n] - 65535 - (s[n - 1] >> 16 & 1), s[n - 1] &= 65535;
          }

          s[15] = a[15] - 32767 - (s[14] >> 16 & 1), o = s[15] >> 16 & 1, s[14] &= 65535, P(a, s, 1 - o);
        }

        for (n = 0; n < 16; n++) {
          t[2 * n] = 255 & a[n], t[2 * n + 1] = a[n] >> 8;
        }
      }

      function B(t, e) {
        var r = new Uint8Array(32),
            n = new Uint8Array(32);
        return I(r, t), I(n, e), m(r, 0, n, 0);
      }

      function F(t) {
        var e = new Uint8Array(32);
        return I(e, t), 1 & e[0];
      }

      function L(t, e) {
        var r;

        for (r = 0; r < 16; r++) {
          t[r] = e[2 * r] + (e[2 * r + 1] << 8);
        }

        t[15] &= 32767;
      }

      function M(t, e, r) {
        for (var n = 0; n < 16; n++) {
          t[n] = e[n] + r[n];
        }
      }

      function D(t, e, r) {
        for (var n = 0; n < 16; n++) {
          t[n] = e[n] - r[n];
        }
      }

      function U(t, e, r) {
        var n,
            i,
            o = 0,
            s = 0,
            a = 0,
            u = 0,
            c = 0,
            h = 0,
            l = 0,
            f = 0,
            p = 0,
            d = 0,
            y = 0,
            v = 0,
            m = 0,
            g = 0,
            _ = 0,
            b = 0,
            w = 0,
            E = 0,
            k = 0,
            x = 0,
            C = 0,
            A = 0,
            S = 0,
            T = 0,
            R = 0,
            O = 0,
            j = 0,
            P = 0,
            I = 0,
            B = 0,
            F = 0,
            L = r[0],
            M = r[1],
            D = r[2],
            U = r[3],
            N = r[4],
            H = r[5],
            q = r[6],
            V = r[7],
            z = r[8],
            Y = r[9],
            K = r[10],
            W = r[11],
            X = r[12],
            G = r[13],
            $ = r[14],
            Z = r[15];
        o += (n = e[0]) * L, s += n * M, a += n * D, u += n * U, c += n * N, h += n * H, l += n * q, f += n * V, p += n * z, d += n * Y, y += n * K, v += n * W, m += n * X, g += n * G, _ += n * $, b += n * Z, s += (n = e[1]) * L, a += n * M, u += n * D, c += n * U, h += n * N, l += n * H, f += n * q, p += n * V, d += n * z, y += n * Y, v += n * K, m += n * W, g += n * X, _ += n * G, b += n * $, w += n * Z, a += (n = e[2]) * L, u += n * M, c += n * D, h += n * U, l += n * N, f += n * H, p += n * q, d += n * V, y += n * z, v += n * Y, m += n * K, g += n * W, _ += n * X, b += n * G, w += n * $, E += n * Z, u += (n = e[3]) * L, c += n * M, h += n * D, l += n * U, f += n * N, p += n * H, d += n * q, y += n * V, v += n * z, m += n * Y, g += n * K, _ += n * W, b += n * X, w += n * G, E += n * $, k += n * Z, c += (n = e[4]) * L, h += n * M, l += n * D, f += n * U, p += n * N, d += n * H, y += n * q, v += n * V, m += n * z, g += n * Y, _ += n * K, b += n * W, w += n * X, E += n * G, k += n * $, x += n * Z, h += (n = e[5]) * L, l += n * M, f += n * D, p += n * U, d += n * N, y += n * H, v += n * q, m += n * V, g += n * z, _ += n * Y, b += n * K, w += n * W, E += n * X, k += n * G, x += n * $, C += n * Z, l += (n = e[6]) * L, f += n * M, p += n * D, d += n * U, y += n * N, v += n * H, m += n * q, g += n * V, _ += n * z, b += n * Y, w += n * K, E += n * W, k += n * X, x += n * G, C += n * $, A += n * Z, f += (n = e[7]) * L, p += n * M, d += n * D, y += n * U, v += n * N, m += n * H, g += n * q, _ += n * V, b += n * z, w += n * Y, E += n * K, k += n * W, x += n * X, C += n * G, A += n * $, S += n * Z, p += (n = e[8]) * L, d += n * M, y += n * D, v += n * U, m += n * N, g += n * H, _ += n * q, b += n * V, w += n * z, E += n * Y, k += n * K, x += n * W, C += n * X, A += n * G, S += n * $, T += n * Z, d += (n = e[9]) * L, y += n * M, v += n * D, m += n * U, g += n * N, _ += n * H, b += n * q, w += n * V, E += n * z, k += n * Y, x += n * K, C += n * W, A += n * X, S += n * G, T += n * $, R += n * Z, y += (n = e[10]) * L, v += n * M, m += n * D, g += n * U, _ += n * N, b += n * H, w += n * q, E += n * V, k += n * z, x += n * Y, C += n * K, A += n * W, S += n * X, T += n * G, R += n * $, O += n * Z, v += (n = e[11]) * L, m += n * M, g += n * D, _ += n * U, b += n * N, w += n * H, E += n * q, k += n * V, x += n * z, C += n * Y, A += n * K, S += n * W, T += n * X, R += n * G, O += n * $, j += n * Z, m += (n = e[12]) * L, g += n * M, _ += n * D, b += n * U, w += n * N, E += n * H, k += n * q, x += n * V, C += n * z, A += n * Y, S += n * K, T += n * W, R += n * X, O += n * G, j += n * $, P += n * Z, g += (n = e[13]) * L, _ += n * M, b += n * D, w += n * U, E += n * N, k += n * H, x += n * q, C += n * V, A += n * z, S += n * Y, T += n * K, R += n * W, O += n * X, j += n * G, P += n * $, I += n * Z, _ += (n = e[14]) * L, b += n * M, w += n * D, E += n * U, k += n * N, x += n * H, C += n * q, A += n * V, S += n * z, T += n * Y, R += n * K, O += n * W, j += n * X, P += n * G, I += n * $, B += n * Z, b += (n = e[15]) * L, s += 38 * (E += n * D), a += 38 * (k += n * U), u += 38 * (x += n * N), c += 38 * (C += n * H), h += 38 * (A += n * q), l += 38 * (S += n * V), f += 38 * (T += n * z), p += 38 * (R += n * Y), d += 38 * (O += n * K), y += 38 * (j += n * W), v += 38 * (P += n * X), m += 38 * (I += n * G), g += 38 * (B += n * $), _ += 38 * (F += n * Z), o = (n = (o += 38 * (w += n * M)) + (i = 1) + 65535) - 65536 * (i = Math.floor(n / 65536)), s = (n = s + i + 65535) - 65536 * (i = Math.floor(n / 65536)), a = (n = a + i + 65535) - 65536 * (i = Math.floor(n / 65536)), u = (n = u + i + 65535) - 65536 * (i = Math.floor(n / 65536)), c = (n = c + i + 65535) - 65536 * (i = Math.floor(n / 65536)), h = (n = h + i + 65535) - 65536 * (i = Math.floor(n / 65536)), l = (n = l + i + 65535) - 65536 * (i = Math.floor(n / 65536)), f = (n = f + i + 65535) - 65536 * (i = Math.floor(n / 65536)), p = (n = p + i + 65535) - 65536 * (i = Math.floor(n / 65536)), d = (n = d + i + 65535) - 65536 * (i = Math.floor(n / 65536)), y = (n = y + i + 65535) - 65536 * (i = Math.floor(n / 65536)), v = (n = v + i + 65535) - 65536 * (i = Math.floor(n / 65536)), m = (n = m + i + 65535) - 65536 * (i = Math.floor(n / 65536)), g = (n = g + i + 65535) - 65536 * (i = Math.floor(n / 65536)), _ = (n = _ + i + 65535) - 65536 * (i = Math.floor(n / 65536)), b = (n = b + i + 65535) - 65536 * (i = Math.floor(n / 65536)), o = (n = (o += i - 1 + 37 * (i - 1)) + (i = 1) + 65535) - 65536 * (i = Math.floor(n / 65536)), s = (n = s + i + 65535) - 65536 * (i = Math.floor(n / 65536)), a = (n = a + i + 65535) - 65536 * (i = Math.floor(n / 65536)), u = (n = u + i + 65535) - 65536 * (i = Math.floor(n / 65536)), c = (n = c + i + 65535) - 65536 * (i = Math.floor(n / 65536)), h = (n = h + i + 65535) - 65536 * (i = Math.floor(n / 65536)), l = (n = l + i + 65535) - 65536 * (i = Math.floor(n / 65536)), f = (n = f + i + 65535) - 65536 * (i = Math.floor(n / 65536)), p = (n = p + i + 65535) - 65536 * (i = Math.floor(n / 65536)), d = (n = d + i + 65535) - 65536 * (i = Math.floor(n / 65536)), y = (n = y + i + 65535) - 65536 * (i = Math.floor(n / 65536)), v = (n = v + i + 65535) - 65536 * (i = Math.floor(n / 65536)), m = (n = m + i + 65535) - 65536 * (i = Math.floor(n / 65536)), g = (n = g + i + 65535) - 65536 * (i = Math.floor(n / 65536)), _ = (n = _ + i + 65535) - 65536 * (i = Math.floor(n / 65536)), b = (n = b + i + 65535) - 65536 * (i = Math.floor(n / 65536)), o += i - 1 + 37 * (i - 1), t[0] = o, t[1] = s, t[2] = a, t[3] = u, t[4] = c, t[5] = h, t[6] = l, t[7] = f, t[8] = p, t[9] = d, t[10] = y, t[11] = v, t[12] = m, t[13] = g, t[14] = _, t[15] = b;
      }

      function N(t, e) {
        U(t, e, e);
      }

      function H(t, r) {
        var n,
            i = e();

        for (n = 0; n < 16; n++) {
          i[n] = r[n];
        }

        for (n = 253; n >= 0; n--) {
          N(i, i), 2 !== n && 4 !== n && U(i, i, r);
        }

        for (n = 0; n < 16; n++) {
          t[n] = i[n];
        }
      }

      function q(t, r, n) {
        var i,
            o,
            s = new Uint8Array(32),
            a = new Float64Array(80),
            c = e(),
            h = e(),
            l = e(),
            f = e(),
            p = e(),
            d = e();

        for (o = 0; o < 31; o++) {
          s[o] = r[o];
        }

        for (s[31] = 127 & r[31] | 64, s[0] &= 248, L(a, n), o = 0; o < 16; o++) {
          h[o] = a[o], f[o] = c[o] = l[o] = 0;
        }

        for (c[0] = f[0] = 1, o = 254; o >= 0; --o) {
          P(c, h, i = s[o >>> 3] >>> (7 & o) & 1), P(l, f, i), M(p, c, l), D(c, c, l), M(l, h, f), D(h, h, f), N(f, p), N(d, c), U(c, l, c), U(l, h, p), M(p, c, l), D(c, c, l), N(h, c), D(l, f, d), U(c, l, u), M(c, c, f), U(l, l, c), U(c, f, d), U(f, h, a), N(h, p), P(c, h, i), P(l, f, i);
        }

        for (o = 0; o < 16; o++) {
          a[o + 16] = c[o], a[o + 32] = l[o], a[o + 48] = h[o], a[o + 64] = f[o];
        }

        var y = a.subarray(32),
            v = a.subarray(16);
        return H(y, y), U(v, v, y), I(t, v), 0;
      }

      function V(t, e) {
        return q(t, e, o);
      }

      function z(t, e) {
        return n(e, 32), V(t, e);
      }

      function Y(t, e, r) {
        var n = new Uint8Array(32);
        return q(n, r, e), _(t, i, n, b);
      }

      C.prototype.blocks = function (t, e, r) {
        for (var n, i, o, s, a, u, c, h, l, f, p, d, y, v, m, g, _, b, w, E = this.fin ? 0 : 2048, k = this.h[0], x = this.h[1], C = this.h[2], A = this.h[3], S = this.h[4], T = this.h[5], R = this.h[6], O = this.h[7], j = this.h[8], P = this.h[9], I = this.r[0], B = this.r[1], F = this.r[2], L = this.r[3], M = this.r[4], D = this.r[5], U = this.r[6], N = this.r[7], H = this.r[8], q = this.r[9]; r >= 16;) {
          f = l = 0, f += (k += 8191 & (n = 255 & t[e + 0] | (255 & t[e + 1]) << 8)) * I, f += (x += 8191 & (n >>> 13 | (i = 255 & t[e + 2] | (255 & t[e + 3]) << 8) << 3)) * (5 * q), f += (C += 8191 & (i >>> 10 | (o = 255 & t[e + 4] | (255 & t[e + 5]) << 8) << 6)) * (5 * H), f += (A += 8191 & (o >>> 7 | (s = 255 & t[e + 6] | (255 & t[e + 7]) << 8) << 9)) * (5 * N), l = (f += (S += 8191 & (s >>> 4 | (a = 255 & t[e + 8] | (255 & t[e + 9]) << 8) << 12)) * (5 * U)) >>> 13, f &= 8191, f += (T += a >>> 1 & 8191) * (5 * D), f += (R += 8191 & (a >>> 14 | (u = 255 & t[e + 10] | (255 & t[e + 11]) << 8) << 2)) * (5 * M), f += (O += 8191 & (u >>> 11 | (c = 255 & t[e + 12] | (255 & t[e + 13]) << 8) << 5)) * (5 * L), f += (j += 8191 & (c >>> 8 | (h = 255 & t[e + 14] | (255 & t[e + 15]) << 8) << 8)) * (5 * F), p = l += (f += (P += h >>> 5 | E) * (5 * B)) >>> 13, p += k * B, p += x * I, p += C * (5 * q), p += A * (5 * H), l = (p += S * (5 * N)) >>> 13, p &= 8191, p += T * (5 * U), p += R * (5 * D), p += O * (5 * M), p += j * (5 * L), l += (p += P * (5 * F)) >>> 13, p &= 8191, d = l, d += k * F, d += x * B, d += C * I, d += A * (5 * q), l = (d += S * (5 * H)) >>> 13, d &= 8191, d += T * (5 * N), d += R * (5 * U), d += O * (5 * D), d += j * (5 * M), y = l += (d += P * (5 * L)) >>> 13, y += k * L, y += x * F, y += C * B, y += A * I, l = (y += S * (5 * q)) >>> 13, y &= 8191, y += T * (5 * H), y += R * (5 * N), y += O * (5 * U), y += j * (5 * D), v = l += (y += P * (5 * M)) >>> 13, v += k * M, v += x * L, v += C * F, v += A * B, l = (v += S * I) >>> 13, v &= 8191, v += T * (5 * q), v += R * (5 * H), v += O * (5 * N), v += j * (5 * U), m = l += (v += P * (5 * D)) >>> 13, m += k * D, m += x * M, m += C * L, m += A * F, l = (m += S * B) >>> 13, m &= 8191, m += T * I, m += R * (5 * q), m += O * (5 * H), m += j * (5 * N), g = l += (m += P * (5 * U)) >>> 13, g += k * U, g += x * D, g += C * M, g += A * L, l = (g += S * F) >>> 13, g &= 8191, g += T * B, g += R * I, g += O * (5 * q), g += j * (5 * H), _ = l += (g += P * (5 * N)) >>> 13, _ += k * N, _ += x * U, _ += C * D, _ += A * M, l = (_ += S * L) >>> 13, _ &= 8191, _ += T * F, _ += R * B, _ += O * I, _ += j * (5 * q), b = l += (_ += P * (5 * H)) >>> 13, b += k * H, b += x * N, b += C * U, b += A * D, l = (b += S * M) >>> 13, b &= 8191, b += T * L, b += R * F, b += O * B, b += j * I, w = l += (b += P * (5 * q)) >>> 13, w += k * q, w += x * H, w += C * N, w += A * U, l = (w += S * D) >>> 13, w &= 8191, w += T * M, w += R * L, w += O * F, w += j * B, k = f = 8191 & (l = (l = ((l += (w += P * I) >>> 13) << 2) + l | 0) + (f &= 8191) | 0), x = p += l >>>= 13, C = d &= 8191, A = y &= 8191, S = v &= 8191, T = m &= 8191, R = g &= 8191, O = _ &= 8191, j = b &= 8191, P = w &= 8191, e += 16, r -= 16;
        }

        this.h[0] = k, this.h[1] = x, this.h[2] = C, this.h[3] = A, this.h[4] = S, this.h[5] = T, this.h[6] = R, this.h[7] = O, this.h[8] = j, this.h[9] = P;
      }, C.prototype.finish = function (t, e) {
        var r,
            n,
            i,
            o,
            s = new Uint16Array(10);

        if (this.leftover) {
          for (o = this.leftover, this.buffer[o++] = 1; o < 16; o++) {
            this.buffer[o] = 0;
          }

          this.fin = 1, this.blocks(this.buffer, 0, 16);
        }

        for (r = this.h[1] >>> 13, this.h[1] &= 8191, o = 2; o < 10; o++) {
          this.h[o] += r, r = this.h[o] >>> 13, this.h[o] &= 8191;
        }

        for (this.h[0] += 5 * r, r = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += r, r = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += r, s[0] = this.h[0] + 5, r = s[0] >>> 13, s[0] &= 8191, o = 1; o < 10; o++) {
          s[o] = this.h[o] + r, r = s[o] >>> 13, s[o] &= 8191;
        }

        for (s[9] -= 8192, n = (1 ^ r) - 1, o = 0; o < 10; o++) {
          s[o] &= n;
        }

        for (n = ~n, o = 0; o < 10; o++) {
          this.h[o] = this.h[o] & n | s[o];
        }

        for (this.h[0] = 65535 & (this.h[0] | this.h[1] << 13), this.h[1] = 65535 & (this.h[1] >>> 3 | this.h[2] << 10), this.h[2] = 65535 & (this.h[2] >>> 6 | this.h[3] << 7), this.h[3] = 65535 & (this.h[3] >>> 9 | this.h[4] << 4), this.h[4] = 65535 & (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14), this.h[5] = 65535 & (this.h[6] >>> 2 | this.h[7] << 11), this.h[6] = 65535 & (this.h[7] >>> 5 | this.h[8] << 8), this.h[7] = 65535 & (this.h[8] >>> 8 | this.h[9] << 5), i = this.h[0] + this.pad[0], this.h[0] = 65535 & i, o = 1; o < 8; o++) {
          i = (this.h[o] + this.pad[o] | 0) + (i >>> 16) | 0, this.h[o] = 65535 & i;
        }

        t[e + 0] = this.h[0] >>> 0 & 255, t[e + 1] = this.h[0] >>> 8 & 255, t[e + 2] = this.h[1] >>> 0 & 255, t[e + 3] = this.h[1] >>> 8 & 255, t[e + 4] = this.h[2] >>> 0 & 255, t[e + 5] = this.h[2] >>> 8 & 255, t[e + 6] = this.h[3] >>> 0 & 255, t[e + 7] = this.h[3] >>> 8 & 255, t[e + 8] = this.h[4] >>> 0 & 255, t[e + 9] = this.h[4] >>> 8 & 255, t[e + 10] = this.h[5] >>> 0 & 255, t[e + 11] = this.h[5] >>> 8 & 255, t[e + 12] = this.h[6] >>> 0 & 255, t[e + 13] = this.h[6] >>> 8 & 255, t[e + 14] = this.h[7] >>> 0 & 255, t[e + 15] = this.h[7] >>> 8 & 255;
      }, C.prototype.update = function (t, e, r) {
        var n, i;

        if (this.leftover) {
          for ((i = 16 - this.leftover) > r && (i = r), n = 0; n < i; n++) {
            this.buffer[this.leftover + n] = t[e + n];
          }

          if (r -= i, e += i, this.leftover += i, this.leftover < 16) return;
          this.blocks(this.buffer, 0, 16), this.leftover = 0;
        }

        if (r >= 16 && (i = r - r % 16, this.blocks(t, e, i), e += i, r -= i), r) {
          for (n = 0; n < r; n++) {
            this.buffer[this.leftover + n] = t[e + n];
          }

          this.leftover += r;
        }
      };
      var K = T,
          W = R;
      var X = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

      function G(t, e, r, n) {
        for (var i, o, s, a, u, c, h, l, f, p, d, y, v, m, g, _, b, w, E, k, x, C, A, S, T, R, O = new Int32Array(16), j = new Int32Array(16), P = t[0], I = t[1], B = t[2], F = t[3], L = t[4], M = t[5], D = t[6], U = t[7], N = e[0], H = e[1], q = e[2], V = e[3], z = e[4], Y = e[5], K = e[6], W = e[7], G = 0; n >= 128;) {
          for (E = 0; E < 16; E++) {
            k = 8 * E + G, O[E] = r[k + 0] << 24 | r[k + 1] << 16 | r[k + 2] << 8 | r[k + 3], j[E] = r[k + 4] << 24 | r[k + 5] << 16 | r[k + 6] << 8 | r[k + 7];
          }

          for (E = 0; E < 80; E++) {
            if (i = P, o = I, s = B, a = F, u = L, c = M, h = D, U, f = N, p = H, d = q, y = V, v = z, m = Y, g = K, W, A = 65535 & (C = W), S = C >>> 16, T = 65535 & (x = U), R = x >>> 16, A += 65535 & (C = (z >>> 14 | L << 18) ^ (z >>> 18 | L << 14) ^ (L >>> 9 | z << 23)), S += C >>> 16, T += 65535 & (x = (L >>> 14 | z << 18) ^ (L >>> 18 | z << 14) ^ (z >>> 9 | L << 23)), R += x >>> 16, A += 65535 & (C = z & Y ^ ~z & K), S += C >>> 16, T += 65535 & (x = L & M ^ ~L & D), R += x >>> 16, x = X[2 * E], A += 65535 & (C = X[2 * E + 1]), S += C >>> 16, T += 65535 & x, R += x >>> 16, x = O[E % 16], S += (C = j[E % 16]) >>> 16, T += 65535 & x, R += x >>> 16, T += (S += (A += 65535 & C) >>> 16) >>> 16, A = 65535 & (C = w = 65535 & A | S << 16), S = C >>> 16, T = 65535 & (x = b = 65535 & T | (R += T >>> 16) << 16), R = x >>> 16, A += 65535 & (C = (N >>> 28 | P << 4) ^ (P >>> 2 | N << 30) ^ (P >>> 7 | N << 25)), S += C >>> 16, T += 65535 & (x = (P >>> 28 | N << 4) ^ (N >>> 2 | P << 30) ^ (N >>> 7 | P << 25)), R += x >>> 16, S += (C = N & H ^ N & q ^ H & q) >>> 16, T += 65535 & (x = P & I ^ P & B ^ I & B), R += x >>> 16, l = 65535 & (T += (S += (A += 65535 & C) >>> 16) >>> 16) | (R += T >>> 16) << 16, _ = 65535 & A | S << 16, A = 65535 & (C = y), S = C >>> 16, T = 65535 & (x = a), R = x >>> 16, S += (C = w) >>> 16, T += 65535 & (x = b), R += x >>> 16, I = i, B = o, F = s, L = a = 65535 & (T += (S += (A += 65535 & C) >>> 16) >>> 16) | (R += T >>> 16) << 16, M = u, D = c, U = h, P = l, H = f, q = p, V = d, z = y = 65535 & A | S << 16, Y = v, K = m, W = g, N = _, E % 16 == 15) for (k = 0; k < 16; k++) {
              x = O[k], A = 65535 & (C = j[k]), S = C >>> 16, T = 65535 & x, R = x >>> 16, x = O[(k + 9) % 16], A += 65535 & (C = j[(k + 9) % 16]), S += C >>> 16, T += 65535 & x, R += x >>> 16, b = O[(k + 1) % 16], A += 65535 & (C = ((w = j[(k + 1) % 16]) >>> 1 | b << 31) ^ (w >>> 8 | b << 24) ^ (w >>> 7 | b << 25)), S += C >>> 16, T += 65535 & (x = (b >>> 1 | w << 31) ^ (b >>> 8 | w << 24) ^ b >>> 7), R += x >>> 16, b = O[(k + 14) % 16], S += (C = ((w = j[(k + 14) % 16]) >>> 19 | b << 13) ^ (b >>> 29 | w << 3) ^ (w >>> 6 | b << 26)) >>> 16, T += 65535 & (x = (b >>> 19 | w << 13) ^ (w >>> 29 | b << 3) ^ b >>> 6), R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, O[k] = 65535 & T | R << 16, j[k] = 65535 & A | S << 16;
            }
          }

          A = 65535 & (C = N), S = C >>> 16, T = 65535 & (x = P), R = x >>> 16, x = t[0], S += (C = e[0]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[0] = P = 65535 & T | R << 16, e[0] = N = 65535 & A | S << 16, A = 65535 & (C = H), S = C >>> 16, T = 65535 & (x = I), R = x >>> 16, x = t[1], S += (C = e[1]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[1] = I = 65535 & T | R << 16, e[1] = H = 65535 & A | S << 16, A = 65535 & (C = q), S = C >>> 16, T = 65535 & (x = B), R = x >>> 16, x = t[2], S += (C = e[2]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[2] = B = 65535 & T | R << 16, e[2] = q = 65535 & A | S << 16, A = 65535 & (C = V), S = C >>> 16, T = 65535 & (x = F), R = x >>> 16, x = t[3], S += (C = e[3]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[3] = F = 65535 & T | R << 16, e[3] = V = 65535 & A | S << 16, A = 65535 & (C = z), S = C >>> 16, T = 65535 & (x = L), R = x >>> 16, x = t[4], S += (C = e[4]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[4] = L = 65535 & T | R << 16, e[4] = z = 65535 & A | S << 16, A = 65535 & (C = Y), S = C >>> 16, T = 65535 & (x = M), R = x >>> 16, x = t[5], S += (C = e[5]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[5] = M = 65535 & T | R << 16, e[5] = Y = 65535 & A | S << 16, A = 65535 & (C = K), S = C >>> 16, T = 65535 & (x = D), R = x >>> 16, x = t[6], S += (C = e[6]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[6] = D = 65535 & T | R << 16, e[6] = K = 65535 & A | S << 16, A = 65535 & (C = W), S = C >>> 16, T = 65535 & (x = U), R = x >>> 16, x = t[7], S += (C = e[7]) >>> 16, T += 65535 & x, R += x >>> 16, R += (T += (S += (A += 65535 & C) >>> 16) >>> 16) >>> 16, t[7] = U = 65535 & T | R << 16, e[7] = W = 65535 & A | S << 16, G += 128, n -= 128;
        }

        return n;
      }

      function $(t, e, r) {
        var n,
            i = new Int32Array(8),
            o = new Int32Array(8),
            s = new Uint8Array(256),
            a = r;

        for (i[0] = 1779033703, i[1] = 3144134277, i[2] = 1013904242, i[3] = 2773480762, i[4] = 1359893119, i[5] = 2600822924, i[6] = 528734635, i[7] = 1541459225, o[0] = 4089235720, o[1] = 2227873595, o[2] = 4271175723, o[3] = 1595750129, o[4] = 2917565137, o[5] = 725511199, o[6] = 4215389547, o[7] = 327033209, G(i, o, e, r), r %= 128, n = 0; n < r; n++) {
          s[n] = e[a - r + n];
        }

        for (s[r] = 128, s[(r = 256 - 128 * (r < 112 ? 1 : 0)) - 9] = 0, d(s, r - 8, a / 536870912 | 0, a << 3), G(i, o, s, r), n = 0; n < 8; n++) {
          d(t, 8 * n, i[n], o[n]);
        }

        return 0;
      }

      function Z(t, r) {
        var n = e(),
            i = e(),
            o = e(),
            s = e(),
            a = e(),
            u = e(),
            c = e(),
            l = e(),
            f = e();
        D(n, t[1], t[0]), D(f, r[1], r[0]), U(n, n, f), M(i, t[0], t[1]), M(f, r[0], r[1]), U(i, i, f), U(o, t[3], r[3]), U(o, o, h), U(s, t[2], r[2]), M(s, s, s), D(a, i, n), D(u, s, o), M(c, s, o), M(l, i, n), U(t[0], a, u), U(t[1], l, c), U(t[2], c, u), U(t[3], a, l);
      }

      function Q(t, e, r) {
        var n;

        for (n = 0; n < 4; n++) {
          P(t[n], e[n], r);
        }
      }

      function J(t, r) {
        var n = e(),
            i = e(),
            o = e();
        H(o, r[2]), U(n, r[0], o), U(i, r[1], o), I(t, i), t[31] ^= F(n) << 7;
      }

      function tt(t, e, r) {
        var n, i;

        for (O(t[0], s), O(t[1], a), O(t[2], a), O(t[3], s), i = 255; i >= 0; --i) {
          Q(t, e, n = r[i / 8 | 0] >> (7 & i) & 1), Z(e, t), Z(t, t), Q(t, e, n);
        }
      }

      function et(t, r) {
        var n = [e(), e(), e(), e()];
        O(n[0], l), O(n[1], f), O(n[2], a), U(n[3], l, f), tt(t, n, r);
      }

      function rt(t, r, i) {
        var o,
            s = new Uint8Array(64),
            a = [e(), e(), e(), e()];

        for (i || n(r, 32), $(s, r, 32), s[0] &= 248, s[31] &= 127, s[31] |= 64, et(a, s), J(t, a), o = 0; o < 32; o++) {
          r[o + 32] = t[o];
        }

        return 0;
      }

      var nt = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);

      function it(t, e) {
        var r, n, i, o;

        for (n = 63; n >= 32; --n) {
          for (r = 0, i = n - 32, o = n - 12; i < o; ++i) {
            e[i] += r - 16 * e[n] * nt[i - (n - 32)], r = e[i] + 128 >> 8, e[i] -= 256 * r;
          }

          e[i] += r, e[n] = 0;
        }

        for (r = 0, i = 0; i < 32; i++) {
          e[i] += r - (e[31] >> 4) * nt[i], r = e[i] >> 8, e[i] &= 255;
        }

        for (i = 0; i < 32; i++) {
          e[i] -= r * nt[i];
        }

        for (n = 0; n < 32; n++) {
          e[n + 1] += e[n] >> 8, t[n] = 255 & e[n];
        }
      }

      function ot(t) {
        var e,
            r = new Float64Array(64);

        for (e = 0; e < 64; e++) {
          r[e] = t[e];
        }

        for (e = 0; e < 64; e++) {
          t[e] = 0;
        }

        it(t, r);
      }

      function st(t, r, n, i) {
        var o,
            s,
            a = new Uint8Array(64),
            u = new Uint8Array(64),
            c = new Uint8Array(64),
            h = new Float64Array(64),
            l = [e(), e(), e(), e()];
        $(a, i, 32), a[0] &= 248, a[31] &= 127, a[31] |= 64;
        var f = n + 64;

        for (o = 0; o < n; o++) {
          t[64 + o] = r[o];
        }

        for (o = 0; o < 32; o++) {
          t[32 + o] = a[32 + o];
        }

        for ($(c, t.subarray(32), n + 32), ot(c), et(l, c), J(t, l), o = 32; o < 64; o++) {
          t[o] = i[o];
        }

        for ($(u, t, n + 64), ot(u), o = 0; o < 64; o++) {
          h[o] = 0;
        }

        for (o = 0; o < 32; o++) {
          h[o] = c[o];
        }

        for (o = 0; o < 32; o++) {
          for (s = 0; s < 32; s++) {
            h[o + s] += u[o] * a[s];
          }
        }

        return it(t.subarray(32), h), f;
      }

      function at(t, r) {
        var n = e(),
            i = e(),
            o = e(),
            u = e(),
            h = e(),
            l = e(),
            f = e();
        return O(t[2], a), L(t[1], r), N(o, t[1]), U(u, o, c), D(o, o, t[2]), M(u, t[2], u), N(h, u), N(l, h), U(f, l, h), U(n, f, o), U(n, n, u), function (t, r) {
          var n,
              i = e();

          for (n = 0; n < 16; n++) {
            i[n] = r[n];
          }

          for (n = 250; n >= 0; n--) {
            N(i, i), 1 !== n && U(i, i, r);
          }

          for (n = 0; n < 16; n++) {
            t[n] = i[n];
          }
        }(n, n), U(n, n, o), U(n, n, u), U(n, n, u), U(t[0], n, u), N(i, t[0]), U(i, i, u), B(i, o) && U(t[0], t[0], p), N(i, t[0]), U(i, i, u), B(i, o) ? -1 : (F(t[0]) === r[31] >> 7 && D(t[0], s, t[0]), U(t[3], t[0], t[1]), 0);
      }

      function ut(t, r, n, i) {
        var o,
            s = new Uint8Array(32),
            a = new Uint8Array(64),
            u = [e(), e(), e(), e()],
            c = [e(), e(), e(), e()];
        if (-1, n < 64) return -1;
        if (at(c, i)) return -1;

        for (o = 0; o < n; o++) {
          t[o] = r[o];
        }

        for (o = 0; o < 32; o++) {
          t[o + 32] = i[o];
        }

        if ($(a, t, n), ot(a), tt(u, c, a), et(c, r.subarray(32)), Z(u, c), J(s, u), n -= 64, m(r, 0, s, 0)) {
          for (o = 0; o < n; o++) {
            t[o] = 0;
          }

          return -1;
        }

        for (o = 0; o < n; o++) {
          t[o] = r[o + 64];
        }

        return n;
      }

      var ct = 32,
          ht = 24,
          lt = 32,
          ft = 32,
          pt = ht;

      function dt(t, e) {
        if (t.length !== ct) throw new Error("bad key size");
        if (e.length !== ht) throw new Error("bad nonce size");
      }

      function yt() {
        for (var t = 0; t < arguments.length; t++) {
          if (!(arguments[t] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
      }

      function vt(t) {
        for (var e = 0; e < t.length; e++) {
          t[e] = 0;
        }
      }

      t.lowlevel = {
        crypto_core_hsalsa20: _,
        crypto_stream_xor: x,
        crypto_stream: k,
        crypto_stream_salsa20_xor: w,
        crypto_stream_salsa20: E,
        crypto_onetimeauth: A,
        crypto_onetimeauth_verify: S,
        crypto_verify_16: v,
        crypto_verify_32: m,
        crypto_secretbox: T,
        crypto_secretbox_open: R,
        crypto_scalarmult: q,
        crypto_scalarmult_base: V,
        crypto_box_beforenm: Y,
        crypto_box_afternm: K,
        crypto_box: function crypto_box(t, e, r, n, i, o) {
          var s = new Uint8Array(32);
          return Y(s, i, o), K(t, e, r, n, s);
        },
        crypto_box_open: function crypto_box_open(t, e, r, n, i, o) {
          var s = new Uint8Array(32);
          return Y(s, i, o), W(t, e, r, n, s);
        },
        crypto_box_keypair: z,
        crypto_hash: $,
        crypto_sign: st,
        crypto_sign_keypair: rt,
        crypto_sign_open: ut,
        crypto_secretbox_KEYBYTES: ct,
        crypto_secretbox_NONCEBYTES: ht,
        crypto_secretbox_ZEROBYTES: 32,
        crypto_secretbox_BOXZEROBYTES: 16,
        crypto_scalarmult_BYTES: 32,
        crypto_scalarmult_SCALARBYTES: 32,
        crypto_box_PUBLICKEYBYTES: lt,
        crypto_box_SECRETKEYBYTES: ft,
        crypto_box_BEFORENMBYTES: 32,
        crypto_box_NONCEBYTES: pt,
        crypto_box_ZEROBYTES: 32,
        crypto_box_BOXZEROBYTES: 16,
        crypto_sign_BYTES: 64,
        crypto_sign_PUBLICKEYBYTES: 32,
        crypto_sign_SECRETKEYBYTES: 64,
        crypto_sign_SEEDBYTES: 32,
        crypto_hash_BYTES: 64
      }, t.randomBytes = function (t) {
        var e = new Uint8Array(t);
        return n(e, t), e;
      }, t.secretbox = function (t, e, r) {
        yt(t, e, r), dt(r, e);

        for (var n = new Uint8Array(32 + t.length), i = new Uint8Array(n.length), o = 0; o < t.length; o++) {
          n[o + 32] = t[o];
        }

        return T(i, n, n.length, e, r), i.subarray(16);
      }, t.secretbox.open = function (t, e, r) {
        yt(t, e, r), dt(r, e);

        for (var n = new Uint8Array(16 + t.length), i = new Uint8Array(n.length), o = 0; o < t.length; o++) {
          n[o + 16] = t[o];
        }

        return n.length < 32 ? null : 0 !== R(i, n, n.length, e, r) ? null : i.subarray(32);
      }, t.secretbox.keyLength = ct, t.secretbox.nonceLength = ht, t.secretbox.overheadLength = 16, t.scalarMult = function (t, e) {
        if (yt(t, e), 32 !== t.length) throw new Error("bad n size");
        if (32 !== e.length) throw new Error("bad p size");
        var r = new Uint8Array(32);
        return q(r, t, e), r;
      }, t.scalarMult.base = function (t) {
        if (yt(t), 32 !== t.length) throw new Error("bad n size");
        var e = new Uint8Array(32);
        return V(e, t), e;
      }, t.scalarMult.scalarLength = 32, t.scalarMult.groupElementLength = 32, t.box = function (e, r, n, i) {
        var o = t.box.before(n, i);
        return t.secretbox(e, r, o);
      }, t.box.before = function (t, e) {
        yt(t, e), function (t, e) {
          if (t.length !== lt) throw new Error("bad public key size");
          if (e.length !== ft) throw new Error("bad secret key size");
        }(t, e);
        var r = new Uint8Array(32);
        return Y(r, t, e), r;
      }, t.box.after = t.secretbox, t.box.open = function (e, r, n, i) {
        var o = t.box.before(n, i);
        return t.secretbox.open(e, r, o);
      }, t.box.open.after = t.secretbox.open, t.box.keyPair = function () {
        var t = new Uint8Array(lt),
            e = new Uint8Array(ft);
        return z(t, e), {
          publicKey: t,
          secretKey: e
        };
      }, t.box.keyPair.fromSecretKey = function (t) {
        if (yt(t), t.length !== ft) throw new Error("bad secret key size");
        var e = new Uint8Array(lt);
        return V(e, t), {
          publicKey: e,
          secretKey: new Uint8Array(t)
        };
      }, t.box.publicKeyLength = lt, t.box.secretKeyLength = ft, t.box.sharedKeyLength = 32, t.box.nonceLength = pt, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function (t, e) {
        if (yt(t, e), 64 !== e.length) throw new Error("bad secret key size");
        var r = new Uint8Array(64 + t.length);
        return st(r, t, t.length, e), r;
      }, t.sign.open = function (t, e) {
        if (yt(t, e), 32 !== e.length) throw new Error("bad public key size");
        var r = new Uint8Array(t.length),
            n = ut(r, t, t.length, e);
        if (n < 0) return null;

        for (var i = new Uint8Array(n), o = 0; o < i.length; o++) {
          i[o] = r[o];
        }

        return i;
      }, t.sign.detached = function (e, r) {
        for (var n = t.sign(e, r), i = new Uint8Array(64), o = 0; o < i.length; o++) {
          i[o] = n[o];
        }

        return i;
      }, t.sign.detached.verify = function (t, e, r) {
        if (yt(t, e, r), 64 !== e.length) throw new Error("bad signature size");
        if (32 !== r.length) throw new Error("bad public key size");
        var n,
            i = new Uint8Array(64 + t.length),
            o = new Uint8Array(64 + t.length);

        for (n = 0; n < 64; n++) {
          i[n] = e[n];
        }

        for (n = 0; n < t.length; n++) {
          i[n + 64] = t[n];
        }

        return ut(o, i, i.length, r) >= 0;
      }, t.sign.keyPair = function () {
        var t = new Uint8Array(32),
            e = new Uint8Array(64);
        return rt(t, e), {
          publicKey: t,
          secretKey: e
        };
      }, t.sign.keyPair.fromSecretKey = function (t) {
        if (yt(t), 64 !== t.length) throw new Error("bad secret key size");

        for (var e = new Uint8Array(32), r = 0; r < e.length; r++) {
          e[r] = t[32 + r];
        }

        return {
          publicKey: e,
          secretKey: new Uint8Array(t)
        };
      }, t.sign.keyPair.fromSeed = function (t) {
        if (yt(t), 32 !== t.length) throw new Error("bad seed size");

        for (var e = new Uint8Array(32), r = new Uint8Array(64), n = 0; n < 32; n++) {
          r[n] = t[n];
        }

        return rt(e, r, !0), {
          publicKey: e,
          secretKey: r
        };
      }, t.sign.publicKeyLength = 32, t.sign.secretKeyLength = 64, t.sign.seedLength = 32, t.sign.signatureLength = 64, t.hash = function (t) {
        yt(t);
        var e = new Uint8Array(64);
        return $(e, t, t.length), e;
      }, t.hash.hashLength = 64, t.verify = function (t, e) {
        return yt(t, e), 0 !== t.length && 0 !== e.length && t.length === e.length && 0 === y(t, 0, e, 0, t.length);
      }, t.setPRNG = function (t) {
        n = t;
      }, function () {
        var e = "undefined" != typeof self ? self.crypto || self.msCrypto : null;

        if (e && e.getRandomValues) {
          t.setPRNG(function (t, r) {
            var n,
                i = new Uint8Array(r);

            for (n = 0; n < r; n += 65536) {
              e.getRandomValues(i.subarray(n, n + Math.min(r - n, 65536)));
            }

            for (n = 0; n < r; n++) {
              t[n] = i[n];
            }

            vt(i);
          });
        } else (e = r(42)) && e.randomBytes && t.setPRNG(function (t, r) {
          var n,
              i = e.randomBytes(r);

          for (n = 0; n < r; n++) {
            t[n] = i[n];
          }

          vt(i);
        });
      }();
    }(t.exports ? t.exports : self.nacl = self.nacl || {});
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }));
    } : t.exports = function (t, e) {
      if (e) {
        t.super_ = e;

        var r = function r() {};

        r.prototype = e.prototype, t.prototype = new r(), t.prototype.constructor = t;
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(14),
        i = r(12);

    function o(t, e) {
      return 55296 == (64512 & t.charCodeAt(e)) && !(e < 0 || e + 1 >= t.length) && 56320 == (64512 & t.charCodeAt(e + 1));
    }

    function s(t) {
      return (t >>> 24 | t >>> 8 & 65280 | t << 8 & 16711680 | (255 & t) << 24) >>> 0;
    }

    function a(t) {
      return 1 === t.length ? "0" + t : t;
    }

    function u(t) {
      return 7 === t.length ? "0" + t : 6 === t.length ? "00" + t : 5 === t.length ? "000" + t : 4 === t.length ? "0000" + t : 3 === t.length ? "00000" + t : 2 === t.length ? "000000" + t : 1 === t.length ? "0000000" + t : t;
    }

    e.inherits = i, e.toArray = function (t, e) {
      if (Array.isArray(t)) return t.slice();
      if (!t) return [];
      var r = [];
      if ("string" == typeof t) {
        if (e) {
          if ("hex" === e) for ((t = t.replace(/[^a-z0-9]+/gi, "")).length % 2 != 0 && (t = "0" + t), i = 0; i < t.length; i += 2) {
            r.push(parseInt(t[i] + t[i + 1], 16));
          }
        } else for (var n = 0, i = 0; i < t.length; i++) {
          var s = t.charCodeAt(i);
          s < 128 ? r[n++] = s : s < 2048 ? (r[n++] = s >> 6 | 192, r[n++] = 63 & s | 128) : o(t, i) ? (s = 65536 + ((1023 & s) << 10) + (1023 & t.charCodeAt(++i)), r[n++] = s >> 18 | 240, r[n++] = s >> 12 & 63 | 128, r[n++] = s >> 6 & 63 | 128, r[n++] = 63 & s | 128) : (r[n++] = s >> 12 | 224, r[n++] = s >> 6 & 63 | 128, r[n++] = 63 & s | 128);
        }
      } else for (i = 0; i < t.length; i++) {
        r[i] = 0 | t[i];
      }
      return r;
    }, e.toHex = function (t) {
      for (var e = "", r = 0; r < t.length; r++) {
        e += a(t[r].toString(16));
      }

      return e;
    }, e.htonl = s, e.toHex32 = function (t, e) {
      for (var r = "", n = 0; n < t.length; n++) {
        var i = t[n];
        "little" === e && (i = s(i)), r += u(i.toString(16));
      }

      return r;
    }, e.zero2 = a, e.zero8 = u, e.join32 = function (t, e, r, i) {
      var o = r - e;
      n(o % 4 == 0);

      for (var s = new Array(o / 4), a = 0, u = e; a < s.length; a++, u += 4) {
        var c;
        c = "big" === i ? t[u] << 24 | t[u + 1] << 16 | t[u + 2] << 8 | t[u + 3] : t[u + 3] << 24 | t[u + 2] << 16 | t[u + 1] << 8 | t[u], s[a] = c >>> 0;
      }

      return s;
    }, e.split32 = function (t, e) {
      for (var r = new Array(4 * t.length), n = 0, i = 0; n < t.length; n++, i += 4) {
        var o = t[n];
        "big" === e ? (r[i] = o >>> 24, r[i + 1] = o >>> 16 & 255, r[i + 2] = o >>> 8 & 255, r[i + 3] = 255 & o) : (r[i + 3] = o >>> 24, r[i + 2] = o >>> 16 & 255, r[i + 1] = o >>> 8 & 255, r[i] = 255 & o);
      }

      return r;
    }, e.rotr32 = function (t, e) {
      return t >>> e | t << 32 - e;
    }, e.rotl32 = function (t, e) {
      return t << e | t >>> 32 - e;
    }, e.sum32 = function (t, e) {
      return t + e >>> 0;
    }, e.sum32_3 = function (t, e, r) {
      return t + e + r >>> 0;
    }, e.sum32_4 = function (t, e, r, n) {
      return t + e + r + n >>> 0;
    }, e.sum32_5 = function (t, e, r, n, i) {
      return t + e + r + n + i >>> 0;
    }, e.sum64 = function (t, e, r, n) {
      var i = t[e],
          o = n + t[e + 1] >>> 0,
          s = (o < n ? 1 : 0) + r + i;
      t[e] = s >>> 0, t[e + 1] = o;
    }, e.sum64_hi = function (t, e, r, n) {
      return (e + n >>> 0 < e ? 1 : 0) + t + r >>> 0;
    }, e.sum64_lo = function (t, e, r, n) {
      return e + n >>> 0;
    }, e.sum64_4_hi = function (t, e, r, n, i, o, s, a) {
      var u = 0,
          c = e;
      return u += (c = c + n >>> 0) < e ? 1 : 0, u += (c = c + o >>> 0) < o ? 1 : 0, t + r + i + s + (u += (c = c + a >>> 0) < a ? 1 : 0) >>> 0;
    }, e.sum64_4_lo = function (t, e, r, n, i, o, s, a) {
      return e + n + o + a >>> 0;
    }, e.sum64_5_hi = function (t, e, r, n, i, o, s, a, u, c) {
      var h = 0,
          l = e;
      return h += (l = l + n >>> 0) < e ? 1 : 0, h += (l = l + o >>> 0) < o ? 1 : 0, h += (l = l + a >>> 0) < a ? 1 : 0, t + r + i + s + u + (h += (l = l + c >>> 0) < c ? 1 : 0) >>> 0;
    }, e.sum64_5_lo = function (t, e, r, n, i, o, s, a, u, c) {
      return e + n + o + a + c >>> 0;
    }, e.rotr64_hi = function (t, e, r) {
      return (e << 32 - r | t >>> r) >>> 0;
    }, e.rotr64_lo = function (t, e, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    }, e.shr64_hi = function (t, e, r) {
      return t >>> r;
    }, e.shr64_lo = function (t, e, r) {
      return (t << 32 - r | e >>> r) >>> 0;
    };
  }, function (t, e) {
    function r(t, e) {
      if (!t) throw new Error(e || "Assertion failed");
    }

    t.exports = r, r.equal = function (t, e, r) {
      if (t != e) throw new Error(r || "Assertion failed: " + t + " != " + e);
    };
  }, function (t, e) {
    var r,
        n,
        i = t.exports = {};

    function o() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(t) {
      if (r === setTimeout) return setTimeout(t, 0);
      if ((r === o || !r) && setTimeout) return r = setTimeout, setTimeout(t, 0);

      try {
        return r(t, 0);
      } catch (e) {
        try {
          return r.call(null, t, 0);
        } catch (e) {
          return r.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        r = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        r = o;
      }

      try {
        n = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (t) {
        n = s;
      }
    }();
    var u,
        c = [],
        h = !1,
        l = -1;

    function f() {
      h && u && (h = !1, u.length ? c = u.concat(c) : l = -1, c.length && p());
    }

    function p() {
      if (!h) {
        var t = a(f);
        h = !0;

        for (var e = c.length; e;) {
          for (u = c, c = []; ++l < e;) {
            u && u[l].run();
          }

          l = -1, e = c.length;
        }

        u = null, h = !1, function (t) {
          if (n === clearTimeout) return clearTimeout(t);
          if ((n === s || !n) && clearTimeout) return n = clearTimeout, clearTimeout(t);

          try {
            n(t);
          } catch (e) {
            try {
              return n.call(null, t);
            } catch (e) {
              return n.call(this, t);
            }
          }
        }(t);
      }
    }

    function d(t, e) {
      this.fun = t, this.array = e;
    }

    function y() {}

    i.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; r < arguments.length; r++) {
        e[r - 1] = arguments[r];
      }
      c.push(new d(t, e)), 1 !== c.length || h || a(p);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = y, i.addListener = y, i.once = y, i.off = y, i.removeListener = y, i.removeAllListeners = y, i.emit = y, i.prependListener = y, i.prependOnceListener = y, i.listeners = function (t) {
      return [];
    }, i.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (t, e) {
    function r(t) {
      return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
        return typeof t;
      } : function (t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
      })(t);
    }

    function n(e) {
      return "function" == typeof Symbol && "symbol" === r(Symbol.iterator) ? t.exports = n = function n(t) {
        return r(t);
      } : t.exports = n = function n(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : r(t);
      }, n(e);
    }

    t.exports = n;
  }, function (t, e, r) {
    var n = r(39),
        i = r(40),
        o = r(41);

    t.exports = function (t) {
      return n(t) || i(t) || o();
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(1),
          i = n(r(17)),
          o = n(r(16)),
          s = n(r(7)),
          a = n(r(10)),
          u = r(11).sign,
          c = r(25),
          h = r(8),
          l = h.RCD_TYPE_1,
          f = h.encodeVarInt,
          p = h.sha256,
          d = h.sha256d,
          y = h.flatMap,
          v = r(9).MAX_TRANSACTION_SIZE,
          m = r(2),
          g = m.isValidFctAddress,
          _ = m.isValidPublicAddress,
          b = m.getPublicAddress,
          w = m.addressToKey,
          E = m.addressToRcdHash,
          k = function () {
        function t(e, r) {
          if ((0, s.default)(this, t), !_(e)) throw new TypeError("Address must be a valid Factoid or EntryCredit public address.");
          !function (t) {
            if (!Number.isSafeInteger(t)) throw new Error("Amount must be a safe integer (less than 2^53 - 1).");
            if (t < 0) throw new Error("Amount must be a positive number.");
          }(r), this.address = e, this.amount = r, Object.freeze(this);
        }

        return (0, a.default)(t, [{
          key: "marshalBinary",
          value: function value() {
            return e.concat([f(this.amount), e.from(c.decode(this.address).slice(2, 34))]);
          }
        }]), t;
      }();

      var x = function () {
        function t(r, n) {
          var a = this;
          if ((0, s.default)(this, t), r instanceof C) this.timestamp = r._timestamp || Date.now(), this.inputs = r._inputs, this.factoidOutputs = r._factoidOutputs, this.entryCreditOutputs = r._entryCreditOutputs, this.blockContext = n, this.marshalBinarySig = function (t, r, n, o) {
            var s = e.alloc(10);
            s.writeInt8(2), s.writeIntBE(t, 1, 6), s.writeInt8(r.length, 7), s.writeInt8(n.length, 8), s.writeInt8(o.length, 9);
            var a = r.map(function (t) {
              return t.marshalBinary();
            }),
                u = n.map(function (t) {
              return t.marshalBinary();
            }),
                c = o.map(function (t) {
              return t.marshalBinary();
            });
            return e.concat([s].concat((0, i.default)(a), (0, i.default)(u), (0, i.default)(c)));
          }(this.timestamp, this.inputs, this.factoidOutputs, this.entryCreditOutputs), this.id = p(this.marshalBinarySig).toString("hex"), 0 !== r._keys.length ? (this.rcds = r._keys.map(function (t) {
            return e.concat([l, e.from(t.publicKey)]);
          }), this.signatures = r._keys.map(function (t) {
            return e.from(u.detached(a.marshalBinarySig, t.secretKey));
          })) : (this.rcds = r._rcds, this.signatures = r._signatures, 0 !== this.rcds.length && 0 !== this.signatures.length && (function (t, e) {
            if (e.length !== t.length) throw new Error("The number of RCDs (".concat(e.length, ") does not equal the number of inputs (").concat(t.length, ")."));

            for (var r = 0; r < e.length; ++r) {
              A(t[r], e[r]);
            }
          }(this.inputs, this.rcds), function (t, e, r) {
            if (e.length !== r.length) throw new Error("The number of RCDs (".concat(e.length, ") does not equal the number of signatures (").concat(r.length, ")"));

            for (var n = 0; n < r.length; ++n) {
              S(t, e[n], r[n]);
            }
          }(this.marshalBinarySig, this.rcds, this.signatures)));else {
            if ("object" !== (0, o.default)(r)) throw new Error("Use `Transaction.builder()` syntax to create a new Transaction.");
            this.id = r.txid, this.timestamp = r.millitimestamp, this.inputs = r.inputs.map(function (t) {
              return new k(t.useraddress, t.amount);
            }), this.factoidOutputs = r.outputs.map(function (t) {
              return new k(t.useraddress, t.amount);
            }), this.entryCreditOutputs = r.outecs.map(function (t) {
              return new k(t.useraddress, t.amount);
            }), this.rcds = r.rcds.map(function (t) {
              return e.from(t, "hex");
            }), this.signatures = y(r.sigblocks, function (t) {
              return t.signatures;
            }).map(function (t) {
              return e.from(t, "hex");
            }), this.blockContext = n;
          }
          if (0 !== this.signatures.length && this.inputs.length !== this.signatures.length) throw new Error("All inputs must be signed or none of them.");
          this.totalInputs = this.inputs.reduce(function (t, e) {
            return t + e.amount;
          }, 0), this.totalFactoidOutputs = this.factoidOutputs.reduce(function (t, e) {
            return t + e.amount;
          }, 0), this.totalEntryCreditOutputs = this.entryCreditOutputs.reduce(function (t, e) {
            return t + e.amount;
          }, 0);
          var c = this.totalFactoidOutputs + this.totalEntryCreditOutputs;
          if (!Number.isSafeInteger(this.totalInputs) || !Number.isSafeInteger(c)) throw new Error("Total inputs/outputs are not safe integers (too big to be handled by the library).");
          if (0 === this.totalInputs) this.feesPaid = 0;else {
            if (!(this.totalInputs >= c)) throw new Error("Sum of Transaction outputs (".concat(c, ") is greater than the sum of inputs (").concat(this.totalInputs, ")"));
            this.feesPaid = this.totalInputs - c;
          }
          Object.freeze(this);
        }

        return (0, a.default)(t, [{
          key: "isSigned",
          value: function value() {
            return 0 !== this.signatures.length;
          }
        }, {
          key: "validateFees",
          value: function value(t) {
            return this.computeRequiredFees(t) <= this.feesPaid;
          }
        }, {
          key: "computeRequiredFees",
          value: function value(t, e) {
            return this.computeEcRequiredFees(e) * t;
          }
        }, {
          key: "computeEcRequiredFees",
          value: function value(t) {
            var e,
                r,
                n = t || {};
            if (this.isSigned()) e = this.marshalBinary().length, r = this.signatures.length;else if ("number" == typeof n.rcdSignatureLength && "number" == typeof n.numberOfSignatures) e = this.marshalBinarySig.length + n.rcdSignatureLength, r = n.numberOfSignatures;else {
              if (1 !== n.rcdType) throw new Error("Missing parameters to compute fees of unsigned transaction.");
              e = this.marshalBinarySig.length + 97 * this.inputs.length, r = this.inputs.length;
            }
            if (e > v) throw new Error("Transaction size is bigger than the maximum (".concat(v, " bytes)."));
            var i = Math.floor((e + 1023) / 1024);
            return i += 10 * (this.factoidOutputs.length + this.entryCreditOutputs.length), i += r;
          }
        }, {
          key: "marshalBinary",
          value: function value() {
            if (!this.isSigned()) throw new Error("Cannot marshal an unsigned Transaction.");

            for (var t = [this.marshalBinarySig], r = 0; r < this.rcds.length; ++r) {
              t.push(this.rcds[r]), t.push(this.signatures[r]);
            }

            return e.concat(t);
          }
        }], [{
          key: "builder",
          value: function value(t) {
            return new C(t);
          }
        }]), t;
      }();

      var C = function () {
        function t(e) {
          (0, s.default)(this, t), this._timestamp, this._inputs = [], this._factoidOutputs = [], this._entryCreditOutputs = [], this._keys = [], this._rcds = [], this._signatures = [], e instanceof x && (this._timestamp = e.timestamp, this._inputs = e.inputs, this._factoidOutputs = e.factoidOutputs, this._entryCreditOutputs = e.entryCreditOutputs);
        }

        return (0, a.default)(t, [{
          key: "input",
          value: function value(t, e) {
            if (!g(t)) throw new TypeError("First argument must be a valid Factoid address.");

            if (this._inputs.push(new k(b(t), e)), "s" === t[1]) {
              var r = w(t),
                  n = u.keyPair.fromSeed(r);

              this._keys.push(n);
            }

            return this;
          }
        }, {
          key: "output",
          value: function value(t, e) {
            var r = new k(t, e);
            return "F" === t[0] ? this._factoidOutputs.push(r) : this._entryCreditOutputs.push(r), this;
          }
        }, {
          key: "rcdSignature",
          value: function value(t, r) {
            return this._rcds.push(e.from(t, "hex")), this._signatures.push(e.from(r, "hex")), this;
          }
        }, {
          key: "timestamp",
          value: function value(t) {
            return this._timestamp = t, this;
          }
        }, {
          key: "build",
          value: function value() {
            return new x(this);
          }
        }]), t;
      }();

      function A(t, e) {
        if (!d(e).equals(E(t.address))) throw new Error("RCD does not match the RCD hash from input address ".concat(t.address, "."));
      }

      function S(t, r, n) {
        if (1 !== r[0]) throw new Error("Only RCD type 1 is currently supported. Invalid RCD: ".concat(r, "."));
        var i = e.from(r, 1).slice(1);
        if (!u.detached.verify(t, n, i)) throw new Error("Signature of Transaction is invalid.");
      }

      t.exports = {
        Transaction: x
      };
    }).call(this, r(0).Buffer);
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(1),
          i = n(r(5)),
          o = n(r(6)),
          s = n(r(7)),
          a = n(r(10)),
          u = r(11).sign,
          c = r(2),
          h = c.addressToKey,
          l = c.isValidPrivateEcAddress,
          f = c.isValidPublicEcAddress,
          p = r(9).MAX_ENTRY_PAYLOAD_SIZE,
          d = r(8),
          y = d.sha256,
          v = d.sha512,
          m = function () {
        function t(e) {
          if ((0, s.default)(this, t), !(e instanceof g)) throw new Error("Use `Entry.builder()` syntax to create a new Entry");
          this.chainId = e._chainId, this.content = e._content, this.timestamp = e._timestamp, this.extIds = Object.freeze(e._extIds), this.blockContext = Object.freeze(e._blockContext), Object.freeze(this);
        }

        return (0, a.default)(t, [{
          key: "size",
          value: function value() {
            return 35 + this.payloadSize();
          }
        }, {
          key: "payloadSize",
          value: function value() {
            return this.rawDataSize() + 2 * this.extIds.length;
          }
        }, {
          key: "rawDataSize",
          value: function value() {
            return this.content.length + this.extIds.reduce(function (t, e) {
              return t + e.length;
            }, 0);
          }
        }, {
          key: "remainingFreeBytes",
          value: function value() {
            var t = this.payloadSize();
            if (0 === t) return 1024;
            var e = t % 1024;
            return e ? 1024 - e : 0;
          }
        }, {
          key: "remainingMaxBytes",
          value: function value() {
            var t = p - this.payloadSize();
            if (t < 0) throw new Error("Entry cannot be larger than 10Kb");
            return t;
          }
        }, {
          key: "hash",
          value: function value() {
            var t = this.marshalBinary();
            return y(e.concat([v(t), t]));
          }
        }, {
          key: "hashHex",
          value: function value() {
            return this.hash().toString("hex");
          }
        }, {
          key: "marshalBinary",
          value: function value() {
            if (0 === this.chainId.length) throw new Error("ChainId is missing to marshal the entry");

            var t = function (t) {
              var r = [],
                  n = !0,
                  i = !1,
                  o = void 0;

              try {
                for (var s, a = t[Symbol.iterator](); !(n = (s = a.next()).done); n = !0) {
                  var u = s.value,
                      c = e.alloc(2);
                  c.writeInt16BE(u.length), r.push(c), r.push(u);
                }
              } catch (t) {
                i = !0, o = t;
              } finally {
                try {
                  n || null == a.return || a.return();
                } finally {
                  if (i) throw o;
                }
              }

              return e.concat(r);
            }(this.extIds),
                r = function (t, r) {
              var n = e.alloc(35);
              return n.writeInt8(0), t.copy(n, 1), n.writeInt16BE(r, 33), n;
            }(this.chainId, t.length);

            return e.concat([r, t, this.content]);
          }
        }, {
          key: "marshalBinaryHex",
          value: function value() {
            return this.marshalBinary().toString("hex");
          }
        }, {
          key: "ecCost",
          value: function value() {
            var t = this.payloadSize();
            if (t > p) throw new Error("Entry cannot be larger than 10Kb");
            return Math.ceil(t / 1024);
          }
        }, {
          key: "toObject",
          value: function value() {
            var t = {
              chainId: this.chainIdHex,
              extIds: this.extIdsHex,
              content: this.contentHex
            };
            return this.timestamp && (t.timestamp = this.timestamp), t;
          }
        }, {
          key: "chainIdHex",
          get: function get() {
            return this.chainId.toString("hex");
          }
        }, {
          key: "contentHex",
          get: function get() {
            return this.content.toString("hex");
          }
        }, {
          key: "extIdsHex",
          get: function get() {
            return this.extIds.map(function (t) {
              return t.toString("hex");
            });
          }
        }], [{
          key: "builder",
          value: function value(t) {
            return new g(t);
          }
        }]), t;
      }(),
          g = function () {
        function t(r) {
          (0, s.default)(this, t), r instanceof Object ? (this._chainId = r.chainId ? e.from(r.chainId, "hex") : e.from(""), this._extIds = Array.isArray(r.extIds) ? r.extIds.map(function (t) {
            return e.from(t, "hex");
          }) : [], this._content = r.content ? e.from(r.content, "hex") : e.from(""), this._timestamp = r.timestamp) : (this._extIds = [], this._content = e.from(""), this._chainId = e.from(""));
        }

        return (0, a.default)(t, [{
          key: "content",
          value: function value(t, r) {
            return t && (this._content = e.from(t, r || "hex")), this;
          }
        }, {
          key: "chainId",
          value: function value(t, r) {
            return t && (this._chainId = e.from(t, r || "hex")), this;
          }
        }, {
          key: "extIds",
          value: function value(t, r) {
            return Array.isArray(t) && (this._extIds = t.map(function (t) {
              return e.from(t, r || "hex");
            })), this;
          }
        }, {
          key: "extId",
          value: function value(t, r) {
            return t && this._extIds.push(e.from(t, r || "hex")), this;
          }
        }, {
          key: "timestamp",
          value: function value(t) {
            return this._timestamp = t, this;
          }
        }, {
          key: "blockContext",
          value: function value(t) {
            return this._blockContext = t, this;
          }
        }, {
          key: "build",
          value: function value() {
            return new m(this);
          }
        }]), t;
      }();

      function _(t, r, n) {
        C(t);
        var i,
            o,
            s = E(t);

        if (l(r)) {
          var a = h(r),
              c = u.keyPair.fromSeed(a);
          i = e.from(c.publicKey), o = e.from(u.detached(s, c.secretKey));
        } else {
          if (!f(r)) throw new Error("".concat(r, " is not a valid EC address"));
          if (!n) throw new Error("Signature of the commit missing.");
          if (console.warn("composeEntryCommit with signature is deprecated. Use composeEntryCommitDelegateSig."), i = h(r), o = e.from(n, "hex"), !u.detached.verify(s, o, i)) throw new Error("Invalid signature manually provided for the entry commit. (entry timestamp not fixed?)");
        }

        return e.concat([s, i, o]);
      }

      function b(t, e, r) {
        return w.apply(this, arguments);
      }

      function w() {
        return (w = (0, o.default)(i.default.mark(function t(r, n, o) {
          var s, a, c;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (C(r), f(n)) {
                    t.next = 3;
                    break;
                  }

                  throw new Error("".concat(n, " is not a valid public EC address"));

                case 3:
                  if ("function" == typeof o) {
                    t.next = 5;
                    break;
                  }

                  throw new Error("sign must be a function");

                case 5:
                  return s = E(r), t.t0 = e, t.next = 9, o(s);

                case 9:
                  if (t.t1 = t.sent, a = t.t0.from.call(t.t0, t.t1, "hex"), c = h(n), u.detached.verify(s, a, c)) {
                    t.next = 14;
                    break;
                  }

                  throw new Error("Invalid signature returned by the signing function for the entry commit.");

                case 14:
                  return t.abrupt("return", e.concat([s, c, a]));

                case 15:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).apply(this, arguments);
      }

      function E(t) {
        C(t);
        var r = e.alloc(40);
        return r.writeInt8(0), r.writeIntBE(t.timestamp || Date.now(), 1, 6), t.hash().copy(r, 7), r.writeInt8(t.ecCost(), 39), r;
      }

      function k(t) {
        return C(t), t.marshalBinary();
      }

      function x() {
        return (x = (0, o.default)(i.default.mark(function t(e, r, n) {
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, b(e, r, n);

                case 2:
                  return t.t0 = t.sent, t.t1 = k(e), t.abrupt("return", {
                    commit: t.t0,
                    reveal: t.t1
                  });

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).apply(this, arguments);
      }

      function C(t) {
        if (!(t instanceof m)) throw new Error("Argument must be an instance of Entry");
      }

      t.exports = {
        Entry: m,
        computeEntryTxId: function computeEntryTxId(t) {
          return C(t), y(E(t));
        },
        validateEntryInstance: C,
        composeEntryCommit: _,
        composeEntryCommitDelegateSig: b,
        composeEntryReveal: k,
        composeEntry: function composeEntry(t, e, r) {
          return {
            commit: _(t, e, r),
            reveal: k(t)
          };
        },
        composeEntryDelegateSig: function composeEntryDelegateSig(t, e, r) {
          return x.apply(this, arguments);
        },
        composeEntryLedger: E
      };
    }).call(this, r(0).Buffer);
  }, function (t, e, r) {
    "use strict";

    var n = r(27),
        i = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        e.push(r);
      }

      return e;
    };

    t.exports = l;
    var o = r(23);
    o.inherits = r(12);
    var s = r(62),
        a = r(65);
    o.inherits(l, s);

    for (var u = i(a.prototype), c = 0; c < u.length; c++) {
      var h = u[c];
      l.prototype[h] || (l.prototype[h] = a.prototype[h]);
    }

    function l(t) {
      if (!(this instanceof l)) return new l(t);
      s.call(this, t), a.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", f);
    }

    function f() {
      this.allowHalfOpen || this._writableState.ended || n.nextTick(p, this);
    }

    function p(t) {
      t.end();
    }

    Object.defineProperty(l.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function get() {
        return this._writableState.highWaterMark;
      }
    }), Object.defineProperty(l.prototype, "destroyed", {
      get: function get() {
        return void 0 !== this._readableState && void 0 !== this._writableState && this._readableState.destroyed && this._writableState.destroyed;
      },
      set: function set(t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t);
      }
    }), l.prototype._destroy = function (t, e) {
      this.push(null), this.end(), n.nextTick(e, t);
    };
  }, function (t, e, r) {
    (function (e, r, n) {
      var i;
      i = function i() {
        var t, i, o;
        return function t(e, r, n) {
          function i(s, a) {
            if (!r[s]) {
              if (!e[s]) {
                var u = "function" == typeof _dereq_ && _dereq_;
                if (!a && u) return u(s, !0);
                if (o) return o(s, !0);
                var c = new Error("Cannot find module '" + s + "'");
                throw c.code = "MODULE_NOT_FOUND", c;
              }

              var h = r[s] = {
                exports: {}
              };
              e[s][0].call(h.exports, function (t) {
                var r = e[s][1][t];
                return i(r || t);
              }, h, h.exports, t, e, r, n);
            }

            return r[s].exports;
          }

          for (var o = "function" == typeof _dereq_ && _dereq_, s = 0; s < n.length; s++) {
            i(n[s]);
          }

          return i;
        }({
          1: [function (t, e, r) {
            "use strict";

            e.exports = function (t) {
              var e = t._SomePromiseArray;

              function r(t) {
                var r = new e(t),
                    n = r.promise();
                return r.setHowMany(1), r.setUnwrap(), r.init(), n;
              }

              t.any = function (t) {
                return r(t);
              }, t.prototype.any = function () {
                return r(this);
              };
            };
          }, {}],
          2: [function (t, r, n) {
            "use strict";

            var i;

            try {
              throw new Error();
            } catch (t) {
              i = t;
            }

            var o = t("./schedule"),
                s = t("./queue"),
                a = t("./util");

            function u() {
              this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new s(16), this._normalQueue = new s(16), this._haveDrainedQueues = !1, this._trampolineEnabled = !0;
              var t = this;
              this.drainQueues = function () {
                t._drainQueues();
              }, this._schedule = o;
            }

            function c(t, e, r) {
              this._lateQueue.push(t, e, r), this._queueTick();
            }

            function h(t, e, r) {
              this._normalQueue.push(t, e, r), this._queueTick();
            }

            function l(t) {
              this._normalQueue._pushOne(t), this._queueTick();
            }

            function f(t) {
              for (; t.length() > 0;) {
                p(t);
              }
            }

            function p(t) {
              var e = t.shift();
              if ("function" != typeof e) e._settlePromises();else {
                var r = t.shift(),
                    n = t.shift();
                e.call(r, n);
              }
            }

            u.prototype.setScheduler = function (t) {
              var e = this._schedule;
              return this._schedule = t, this._customScheduler = !0, e;
            }, u.prototype.hasCustomScheduler = function () {
              return this._customScheduler;
            }, u.prototype.enableTrampoline = function () {
              this._trampolineEnabled = !0;
            }, u.prototype.disableTrampolineIfNecessary = function () {
              a.hasDevTools && (this._trampolineEnabled = !1);
            }, u.prototype.haveItemsQueued = function () {
              return this._isTickUsed || this._haveDrainedQueues;
            }, u.prototype.fatalError = function (t, r) {
              r ? (e.stderr.write("Fatal " + (t instanceof Error ? t.stack : t) + "\n"), e.exit(2)) : this.throwLater(t);
            }, u.prototype.throwLater = function (t, e) {
              if (1 === arguments.length && (e = t, t = function t() {
                throw e;
              }), "undefined" != typeof setTimeout) setTimeout(function () {
                t(e);
              }, 0);else try {
                this._schedule(function () {
                  t(e);
                });
              } catch (t) {
                throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
              }
            }, a.hasDevTools ? (u.prototype.invokeLater = function (t, e, r) {
              this._trampolineEnabled ? c.call(this, t, e, r) : this._schedule(function () {
                setTimeout(function () {
                  t.call(e, r);
                }, 100);
              });
            }, u.prototype.invoke = function (t, e, r) {
              this._trampolineEnabled ? h.call(this, t, e, r) : this._schedule(function () {
                t.call(e, r);
              });
            }, u.prototype.settlePromises = function (t) {
              this._trampolineEnabled ? l.call(this, t) : this._schedule(function () {
                t._settlePromises();
              });
            }) : (u.prototype.invokeLater = c, u.prototype.invoke = h, u.prototype.settlePromises = l), u.prototype._drainQueues = function () {
              f(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, f(this._lateQueue);
            }, u.prototype._queueTick = function () {
              this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues));
            }, u.prototype._reset = function () {
              this._isTickUsed = !1;
            }, r.exports = u, r.exports.firstLineError = i;
          }, {
            "./queue": 26,
            "./schedule": 29,
            "./util": 36
          }],
          3: [function (t, e, r) {
            "use strict";

            e.exports = function (t, e, r, n) {
              var i = !1,
                  o = function o(t, e) {
                this._reject(e);
              },
                  s = function s(t, e) {
                e.promiseRejectionQueued = !0, e.bindingPromise._then(o, o, null, this, t);
              },
                  a = function a(t, e) {
                0 == (50397184 & this._bitField) && this._resolveCallback(e.target);
              },
                  u = function u(t, e) {
                e.promiseRejectionQueued || this._reject(t);
              };

              t.prototype.bind = function (o) {
                i || (i = !0, t.prototype._propagateFrom = n.propagateFromFunction(), t.prototype._boundValue = n.boundValueFunction());
                var c = r(o),
                    h = new t(e);

                h._propagateFrom(this, 1);

                var l = this._target();

                if (h._setBoundTo(c), c instanceof t) {
                  var f = {
                    promiseRejectionQueued: !1,
                    promise: h,
                    target: l,
                    bindingPromise: c
                  };
                  l._then(e, s, void 0, h, f), c._then(a, u, void 0, h, f), h._setOnCancel(c);
                } else h._resolveCallback(l);

                return h;
              }, t.prototype._setBoundTo = function (t) {
                void 0 !== t ? (this._bitField = 2097152 | this._bitField, this._boundTo = t) : this._bitField = -2097153 & this._bitField;
              }, t.prototype._isBound = function () {
                return 2097152 == (2097152 & this._bitField);
              }, t.bind = function (e, r) {
                return t.resolve(r).bind(e);
              };
            };
          }, {}],
          4: [function (t, e, r) {
            "use strict";

            var n;
            "undefined" != typeof Promise && (n = Promise);
            var i = t("./promise")();
            i.noConflict = function () {
              try {
                Promise === i && (Promise = n);
              } catch (t) {}

              return i;
            }, e.exports = i;
          }, {
            "./promise": 22
          }],
          5: [function (t, e, r) {
            "use strict";

            var n = Object.create;

            if (n) {
              var i = n(null),
                  o = n(null);
              i[" size"] = o[" size"] = 0;
            }

            e.exports = function (e) {
              var r = t("./util"),
                  n = r.canEvaluate;

              function i(t) {
                return function (t, n) {
                  var i;

                  if (null != t && (i = t[n]), "function" != typeof i) {
                    var o = "Object " + r.classString(t) + " has no method '" + r.toString(n) + "'";
                    throw new e.TypeError(o);
                  }

                  return i;
                }(t, this.pop()).apply(t, this);
              }

              function o(t) {
                return t[this];
              }

              function s(t) {
                var e = +this;
                return e < 0 && (e = Math.max(0, e + t.length)), t[e];
              }

              r.isIdentifier, e.prototype.call = function (t) {
                var e = [].slice.call(arguments, 1);
                return e.push(t), this._then(i, void 0, void 0, e, void 0);
              }, e.prototype.get = function (t) {
                var e;
                if ("number" == typeof t) e = s;else if (n) {
                  var r = (void 0)(t);
                  e = null !== r ? r : o;
                } else e = o;
                return this._then(e, void 0, void 0, t, void 0);
              };
            };
          }, {
            "./util": 36
          }],
          6: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i) {
              var o = t("./util"),
                  s = o.tryCatch,
                  a = o.errorObj,
                  u = e._async;
              e.prototype.break = e.prototype.cancel = function () {
                if (!i.cancellation()) return this._warn("cancellation is disabled");

                for (var t = this, e = t; t._isCancellable();) {
                  if (!t._cancelBy(e)) {
                    e._isFollowing() ? e._followee().cancel() : e._cancelBranched();
                    break;
                  }

                  var r = t._cancellationParent;

                  if (null == r || !r._isCancellable()) {
                    t._isFollowing() ? t._followee().cancel() : t._cancelBranched();
                    break;
                  }

                  t._isFollowing() && t._followee().cancel(), t._setWillBeCancelled(), e = t, t = r;
                }
              }, e.prototype._branchHasCancelled = function () {
                this._branchesRemainingToCancel--;
              }, e.prototype._enoughBranchesHaveCancelled = function () {
                return void 0 === this._branchesRemainingToCancel || this._branchesRemainingToCancel <= 0;
              }, e.prototype._cancelBy = function (t) {
                return t === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), !!this._enoughBranchesHaveCancelled() && (this._invokeOnCancel(), !0));
              }, e.prototype._cancelBranched = function () {
                this._enoughBranchesHaveCancelled() && this._cancel();
              }, e.prototype._cancel = function () {
                this._isCancellable() && (this._setCancelled(), u.invoke(this._cancelPromises, this, void 0));
              }, e.prototype._cancelPromises = function () {
                this._length() > 0 && this._settlePromises();
              }, e.prototype._unsetOnCancel = function () {
                this._onCancelField = void 0;
              }, e.prototype._isCancellable = function () {
                return this.isPending() && !this._isCancelled();
              }, e.prototype.isCancellable = function () {
                return this.isPending() && !this.isCancelled();
              }, e.prototype._doInvokeOnCancel = function (t, e) {
                if (o.isArray(t)) for (var r = 0; r < t.length; ++r) {
                  this._doInvokeOnCancel(t[r], e);
                } else if (void 0 !== t) if ("function" == typeof t) {
                  if (!e) {
                    var n = s(t).call(this._boundValue());
                    n === a && (this._attachExtraTrace(n.e), u.throwLater(n.e));
                  }
                } else t._resultCancelled(this);
              }, e.prototype._invokeOnCancel = function () {
                var t = this._onCancel();

                this._unsetOnCancel(), u.invoke(this._doInvokeOnCancel, this, t);
              }, e.prototype._invokeInternalOnCancel = function () {
                this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel());
              }, e.prototype._resultCancelled = function () {
                this.cancel();
              };
            };
          }, {
            "./util": 36
          }],
          7: [function (t, e, r) {
            "use strict";

            e.exports = function (e) {
              var r = t("./util"),
                  n = t("./es5").keys,
                  i = r.tryCatch,
                  o = r.errorObj;
              return function (t, s, a) {
                return function (u) {
                  var c = a._boundValue();

                  t: for (var h = 0; h < t.length; ++h) {
                    var l = t[h];

                    if (l === Error || null != l && l.prototype instanceof Error) {
                      if (u instanceof l) return i(s).call(c, u);
                    } else if ("function" == typeof l) {
                      var f = i(l).call(c, u);
                      if (f === o) return f;
                      if (f) return i(s).call(c, u);
                    } else if (r.isObject(u)) {
                      for (var p = n(l), d = 0; d < p.length; ++d) {
                        var y = p[d];
                        if (l[y] != u[y]) continue t;
                      }

                      return i(s).call(c, u);
                    }
                  }

                  return e;
                };
              };
            };
          }, {
            "./es5": 13,
            "./util": 36
          }],
          8: [function (t, e, r) {
            "use strict";

            e.exports = function (t) {
              var e = !1,
                  r = [];

              function n() {
                this._trace = new n.CapturedTrace(i());
              }

              function i() {
                var t = r.length - 1;
                if (t >= 0) return r[t];
              }

              return t.prototype._promiseCreated = function () {}, t.prototype._pushContext = function () {}, t.prototype._popContext = function () {
                return null;
              }, t._peekContext = t.prototype._peekContext = function () {}, n.prototype._pushContext = function () {
                void 0 !== this._trace && (this._trace._promiseCreated = null, r.push(this._trace));
              }, n.prototype._popContext = function () {
                if (void 0 !== this._trace) {
                  var t = r.pop(),
                      e = t._promiseCreated;
                  return t._promiseCreated = null, e;
                }

                return null;
              }, n.CapturedTrace = null, n.create = function () {
                if (e) return new n();
              }, n.deactivateLongStackTraces = function () {}, n.activateLongStackTraces = function () {
                var r = t.prototype._pushContext,
                    o = t.prototype._popContext,
                    s = t._peekContext,
                    a = t.prototype._peekContext,
                    u = t.prototype._promiseCreated;
                n.deactivateLongStackTraces = function () {
                  t.prototype._pushContext = r, t.prototype._popContext = o, t._peekContext = s, t.prototype._peekContext = a, t.prototype._promiseCreated = u, e = !1;
                }, e = !0, t.prototype._pushContext = n.prototype._pushContext, t.prototype._popContext = n.prototype._popContext, t._peekContext = t.prototype._peekContext = i, t.prototype._promiseCreated = function () {
                  var t = this._peekContext();

                  t && null == t._promiseCreated && (t._promiseCreated = this);
                };
              }, n;
            };
          }, {}],
          9: [function (t, r, n) {
            "use strict";

            r.exports = function (r, n) {
              var i,
                  o,
                  s,
                  a = r._getDomain,
                  u = r._async,
                  c = t("./errors").Warning,
                  h = t("./util"),
                  l = t("./es5"),
                  f = h.canAttachTrace,
                  p = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,
                  d = /\((?:timers\.js):\d+:\d+\)/,
                  y = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,
                  v = null,
                  m = null,
                  g = !1,
                  _ = !(0 == h.env("BLUEBIRD_DEBUG")),
                  b = !(0 == h.env("BLUEBIRD_WARNINGS") || !_ && !h.env("BLUEBIRD_WARNINGS")),
                  w = !(0 == h.env("BLUEBIRD_LONG_STACK_TRACES") || !_ && !h.env("BLUEBIRD_LONG_STACK_TRACES")),
                  E = 0 != h.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (b || !!h.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

              r.prototype.suppressUnhandledRejections = function () {
                var t = this._target();

                t._bitField = -1048577 & t._bitField | 524288;
              }, r.prototype._ensurePossibleRejectionHandled = function () {
                if (0 == (524288 & this._bitField)) {
                  this._setRejectionIsUnhandled();

                  var t = this;
                  setTimeout(function () {
                    t._notifyUnhandledRejection();
                  }, 1);
                }
              }, r.prototype._notifyUnhandledRejectionIsHandled = function () {
                Y("rejectionHandled", i, void 0, this);
              }, r.prototype._setReturnedNonUndefined = function () {
                this._bitField = 268435456 | this._bitField;
              }, r.prototype._returnedNonUndefined = function () {
                return 0 != (268435456 & this._bitField);
              }, r.prototype._notifyUnhandledRejection = function () {
                if (this._isRejectionUnhandled()) {
                  var t = this._settledValue();

                  this._setUnhandledRejectionIsNotified(), Y("unhandledRejection", o, t, this);
                }
              }, r.prototype._setUnhandledRejectionIsNotified = function () {
                this._bitField = 262144 | this._bitField;
              }, r.prototype._unsetUnhandledRejectionIsNotified = function () {
                this._bitField = -262145 & this._bitField;
              }, r.prototype._isUnhandledRejectionNotified = function () {
                return (262144 & this._bitField) > 0;
              }, r.prototype._setRejectionIsUnhandled = function () {
                this._bitField = 1048576 | this._bitField;
              }, r.prototype._unsetRejectionIsUnhandled = function () {
                this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled());
              }, r.prototype._isRejectionUnhandled = function () {
                return (1048576 & this._bitField) > 0;
              }, r.prototype._warn = function (t, e, r) {
                return H(t, e, r || this);
              }, r.onPossiblyUnhandledRejection = function (t) {
                var e = a();
                o = "function" == typeof t ? null === e ? t : h.domainBind(e, t) : void 0;
              }, r.onUnhandledRejectionHandled = function (t) {
                var e = a();
                i = "function" == typeof t ? null === e ? t : h.domainBind(e, t) : void 0;
              };

              var k = function k() {};

              r.longStackTraces = function () {
                if (u.haveItemsQueued() && !J.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");

                if (!J.longStackTraces && W()) {
                  var t = r.prototype._captureStackTrace,
                      e = r.prototype._attachExtraTrace,
                      i = r.prototype._dereferenceTrace;
                  J.longStackTraces = !0, k = function k() {
                    if (u.haveItemsQueued() && !J.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                    r.prototype._captureStackTrace = t, r.prototype._attachExtraTrace = e, r.prototype._dereferenceTrace = i, n.deactivateLongStackTraces(), u.enableTrampoline(), J.longStackTraces = !1;
                  }, r.prototype._captureStackTrace = D, r.prototype._attachExtraTrace = U, r.prototype._dereferenceTrace = N, n.activateLongStackTraces(), u.disableTrampolineIfNecessary();
                }
              }, r.hasLongStackTraces = function () {
                return J.longStackTraces && W();
              };

              var x = function () {
                try {
                  if ("function" == typeof CustomEvent) {
                    var t = new CustomEvent("CustomEvent");
                    return h.global.dispatchEvent(t), function (t, e) {
                      var r = {
                        detail: e,
                        cancelable: !0
                      };
                      l.defineProperty(r, "promise", {
                        value: e.promise
                      }), l.defineProperty(r, "reason", {
                        value: e.reason
                      });
                      var n = new CustomEvent(t.toLowerCase(), r);
                      return !h.global.dispatchEvent(n);
                    };
                  }

                  return "function" == typeof Event ? (t = new Event("CustomEvent"), h.global.dispatchEvent(t), function (t, e) {
                    var r = new Event(t.toLowerCase(), {
                      cancelable: !0
                    });
                    return r.detail = e, l.defineProperty(r, "promise", {
                      value: e.promise
                    }), l.defineProperty(r, "reason", {
                      value: e.reason
                    }), !h.global.dispatchEvent(r);
                  }) : ((t = document.createEvent("CustomEvent")).initCustomEvent("testingtheevent", !1, !0, {}), h.global.dispatchEvent(t), function (t, e) {
                    var r = document.createEvent("CustomEvent");
                    return r.initCustomEvent(t.toLowerCase(), !1, !0, e), !h.global.dispatchEvent(r);
                  });
                } catch (t) {}

                return function () {
                  return !1;
                };
              }(),
                  C = h.isNode ? function () {
                return e.emit.apply(e, arguments);
              } : h.global ? function (t) {
                var e = "on" + t.toLowerCase(),
                    r = h.global[e];
                return !!r && (r.apply(h.global, [].slice.call(arguments, 1)), !0);
              } : function () {
                return !1;
              };

              function A(t, e) {
                return {
                  promise: e
                };
              }

              var S = {
                promiseCreated: A,
                promiseFulfilled: A,
                promiseRejected: A,
                promiseResolved: A,
                promiseCancelled: A,
                promiseChained: function promiseChained(t, e, r) {
                  return {
                    promise: e,
                    child: r
                  };
                },
                warning: function warning(t, e) {
                  return {
                    warning: e
                  };
                },
                unhandledRejection: function unhandledRejection(t, e, r) {
                  return {
                    reason: e,
                    promise: r
                  };
                },
                rejectionHandled: A
              },
                  T = function T(t) {
                var e = !1;

                try {
                  e = C.apply(null, arguments);
                } catch (t) {
                  u.throwLater(t), e = !0;
                }

                var r = !1;

                try {
                  r = x(t, S[t].apply(null, arguments));
                } catch (t) {
                  u.throwLater(t), r = !0;
                }

                return r || e;
              };

              function R() {
                return !1;
              }

              function O(t, e, r) {
                var n = this;

                try {
                  t(e, r, function (t) {
                    if ("function" != typeof t) throw new TypeError("onCancel must be a function, got: " + h.toString(t));

                    n._attachCancellationCallback(t);
                  });
                } catch (t) {
                  return t;
                }
              }

              function j(t) {
                if (!this._isCancellable()) return this;

                var e = this._onCancel();

                void 0 !== e ? h.isArray(e) ? e.push(t) : this._setOnCancel([e, t]) : this._setOnCancel(t);
              }

              function P() {
                return this._onCancelField;
              }

              function I(t) {
                this._onCancelField = t;
              }

              function B() {
                this._cancellationParent = void 0, this._onCancelField = void 0;
              }

              function F(t, e) {
                if (0 != (1 & e)) {
                  this._cancellationParent = t;
                  var r = t._branchesRemainingToCancel;
                  void 0 === r && (r = 0), t._branchesRemainingToCancel = r + 1;
                }

                0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo);
              }

              r.config = function (t) {
                if ("longStackTraces" in (t = Object(t)) && (t.longStackTraces ? r.longStackTraces() : !t.longStackTraces && r.hasLongStackTraces() && k()), "warnings" in t) {
                  var e = t.warnings;
                  J.warnings = !!e, E = J.warnings, h.isObject(e) && "wForgottenReturn" in e && (E = !!e.wForgottenReturn);
                }

                if ("cancellation" in t && t.cancellation && !J.cancellation) {
                  if (u.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                  r.prototype._clearCancellationData = B, r.prototype._propagateFrom = F, r.prototype._onCancel = P, r.prototype._setOnCancel = I, r.prototype._attachCancellationCallback = j, r.prototype._execute = O, L = F, J.cancellation = !0;
                }

                return "monitoring" in t && (t.monitoring && !J.monitoring ? (J.monitoring = !0, r.prototype._fireEvent = T) : !t.monitoring && J.monitoring && (J.monitoring = !1, r.prototype._fireEvent = R)), r;
              }, r.prototype._fireEvent = R, r.prototype._execute = function (t, e, r) {
                try {
                  t(e, r);
                } catch (t) {
                  return t;
                }
              }, r.prototype._onCancel = function () {}, r.prototype._setOnCancel = function (t) {}, r.prototype._attachCancellationCallback = function (t) {}, r.prototype._captureStackTrace = function () {}, r.prototype._attachExtraTrace = function () {}, r.prototype._dereferenceTrace = function () {}, r.prototype._clearCancellationData = function () {}, r.prototype._propagateFrom = function (t, e) {};

              var L = function L(t, e) {
                0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo);
              };

              function M() {
                var t = this._boundTo;
                return void 0 !== t && t instanceof r ? t.isFulfilled() ? t.value() : void 0 : t;
              }

              function D() {
                this._trace = new Z(this._peekContext());
              }

              function U(t, e) {
                if (f(t)) {
                  var r = this._trace;
                  if (void 0 !== r && e && (r = r._parent), void 0 !== r) r.attachExtraTrace(t);else if (!t.__stackCleaned__) {
                    var n = V(t);
                    h.notEnumerableProp(t, "stack", n.message + "\n" + n.stack.join("\n")), h.notEnumerableProp(t, "__stackCleaned__", !0);
                  }
                }
              }

              function N() {
                this._trace = void 0;
              }

              function H(t, e, n) {
                if (J.warnings) {
                  var i,
                      o = new c(t);
                  if (e) n._attachExtraTrace(o);else if (J.longStackTraces && (i = r._peekContext())) i.attachExtraTrace(o);else {
                    var s = V(o);
                    o.stack = s.message + "\n" + s.stack.join("\n");
                  }
                  T("warning", o) || z(o, "", !0);
                }
              }

              function q(t) {
                for (var e = [], r = 0; r < t.length; ++r) {
                  var n = t[r],
                      i = "    (No stack trace)" === n || v.test(n),
                      o = i && X(n);
                  i && !o && (g && " " !== n.charAt(0) && (n = "    " + n), e.push(n));
                }

                return e;
              }

              function V(t) {
                var e = t.stack,
                    r = t.toString();
                return e = "string" == typeof e && e.length > 0 ? function (t) {
                  for (var e = t.stack.replace(/\s+$/g, "").split("\n"), r = 0; r < e.length; ++r) {
                    var n = e[r];
                    if ("    (No stack trace)" === n || v.test(n)) break;
                  }

                  return r > 0 && "SyntaxError" != t.name && (e = e.slice(r)), e;
                }(t) : ["    (No stack trace)"], {
                  message: r,
                  stack: "SyntaxError" == t.name ? e : q(e)
                };
              }

              function z(t, e, r) {
                if ("undefined" != typeof console) {
                  var n;

                  if (h.isObject(t)) {
                    var i = t.stack;
                    n = e + m(i, t);
                  } else n = e + String(t);

                  "function" == typeof s ? s(n, r) : "function" != typeof console.log && "object" != typeof console.log || console.log(n);
                }
              }

              function Y(t, e, r, n) {
                var i = !1;

                try {
                  "function" == typeof e && (i = !0, "rejectionHandled" === t ? e(n) : e(r, n));
                } catch (t) {
                  u.throwLater(t);
                }

                "unhandledRejection" === t ? T(t, r, n) || i || z(r, "Unhandled rejection ") : T(t, n);
              }

              function K(t) {
                var e;
                if ("function" == typeof t) e = "[function " + (t.name || "anonymous") + "]";else {
                  if (e = t && "function" == typeof t.toString ? t.toString() : h.toString(t), /\[object [a-zA-Z0-9$_]+\]/.test(e)) try {
                    e = JSON.stringify(t);
                  } catch (t) {}
                  0 === e.length && (e = "(empty array)");
                }
                return "(<" + function (t) {
                  return t.length < 41 ? t : t.substr(0, 38) + "...";
                }(e) + ">, no stack trace)";
              }

              function W() {
                return "function" == typeof Q;
              }

              var X = function X() {
                return !1;
              },
                  G = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;

              function $(t) {
                var e = t.match(G);
                if (e) return {
                  fileName: e[1],
                  line: parseInt(e[2], 10)
                };
              }

              function Z(t) {
                this._parent = t, this._promisesCreated = 0;
                var e = this._length = 1 + (void 0 === t ? 0 : t._length);
                Q(this, Z), e > 32 && this.uncycle();
              }

              h.inherits(Z, Error), n.CapturedTrace = Z, Z.prototype.uncycle = function () {
                var t = this._length;

                if (!(t < 2)) {
                  for (var e = [], r = {}, n = 0, i = this; void 0 !== i; ++n) {
                    e.push(i), i = i._parent;
                  }

                  for (n = (t = this._length = n) - 1; n >= 0; --n) {
                    var o = e[n].stack;
                    void 0 === r[o] && (r[o] = n);
                  }

                  for (n = 0; n < t; ++n) {
                    var s = r[e[n].stack];

                    if (void 0 !== s && s !== n) {
                      s > 0 && (e[s - 1]._parent = void 0, e[s - 1]._length = 1), e[n]._parent = void 0, e[n]._length = 1;
                      var a = n > 0 ? e[n - 1] : this;
                      s < t - 1 ? (a._parent = e[s + 1], a._parent.uncycle(), a._length = a._parent._length + 1) : (a._parent = void 0, a._length = 1);

                      for (var u = a._length + 1, c = n - 2; c >= 0; --c) {
                        e[c]._length = u, u++;
                      }

                      return;
                    }
                  }
                }
              }, Z.prototype.attachExtraTrace = function (t) {
                if (!t.__stackCleaned__) {
                  this.uncycle();

                  for (var e = V(t), r = e.message, n = [e.stack], i = this; void 0 !== i;) {
                    n.push(q(i.stack.split("\n"))), i = i._parent;
                  }

                  !function (t) {
                    for (var e = t[0], r = 1; r < t.length; ++r) {
                      for (var n = t[r], i = e.length - 1, o = e[i], s = -1, a = n.length - 1; a >= 0; --a) {
                        if (n[a] === o) {
                          s = a;
                          break;
                        }
                      }

                      for (a = s; a >= 0; --a) {
                        var u = n[a];
                        if (e[i] !== u) break;
                        e.pop(), i--;
                      }

                      e = n;
                    }
                  }(n), function (t) {
                    for (var e = 0; e < t.length; ++e) {
                      (0 === t[e].length || e + 1 < t.length && t[e][0] === t[e + 1][0]) && (t.splice(e, 1), e--);
                    }
                  }(n), h.notEnumerableProp(t, "stack", function (t, e) {
                    for (var r = 0; r < e.length - 1; ++r) {
                      e[r].push("From previous event:"), e[r] = e[r].join("\n");
                    }

                    return r < e.length && (e[r] = e[r].join("\n")), t + "\n" + e.join("\n");
                  }(r, n)), h.notEnumerableProp(t, "__stackCleaned__", !0);
                }
              };

              var Q = function () {
                var t = /^\s*at\s*/,
                    e = function e(t, _e) {
                  return "string" == typeof t ? t : void 0 !== _e.name && void 0 !== _e.message ? _e.toString() : K(_e);
                };

                if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
                  Error.stackTraceLimit += 6, v = t, m = e;
                  var r = Error.captureStackTrace;
                  return X = function X(t) {
                    return p.test(t);
                  }, function (t, e) {
                    Error.stackTraceLimit += 6, r(t, e), Error.stackTraceLimit -= 6;
                  };
                }

                var n,
                    i = new Error();
                if ("string" == typeof i.stack && i.stack.split("\n")[0].indexOf("stackDetection@") >= 0) return v = /@/, m = e, g = !0, function (t) {
                  t.stack = new Error().stack;
                };

                try {
                  throw new Error();
                } catch (t) {
                  n = "stack" in t;
                }

                return "stack" in i || !n || "number" != typeof Error.stackTraceLimit ? (m = function m(t, e) {
                  return "string" == typeof t ? t : "object" != typeof e && "function" != typeof e || void 0 === e.name || void 0 === e.message ? K(e) : e.toString();
                }, null) : (v = t, m = e, function (t) {
                  Error.stackTraceLimit += 6;

                  try {
                    throw new Error();
                  } catch (e) {
                    t.stack = e.stack;
                  }

                  Error.stackTraceLimit -= 6;
                });
              }();

              "undefined" != typeof console && void 0 !== console.warn && (s = function s(t) {
                console.warn(t);
              }, h.isNode && e.stderr.isTTY ? s = function s(t, e) {
                var r = e ? "[33m" : "[31m";
                console.warn(r + t + "[0m\n");
              } : h.isNode || "string" != typeof new Error().stack || (s = function s(t, e) {
                console.warn("%c" + t, e ? "color: darkorange" : "color: red");
              }));
              var J = {
                warnings: b,
                longStackTraces: !1,
                cancellation: !1,
                monitoring: !1
              };
              return w && r.longStackTraces(), {
                longStackTraces: function longStackTraces() {
                  return J.longStackTraces;
                },
                warnings: function warnings() {
                  return J.warnings;
                },
                cancellation: function cancellation() {
                  return J.cancellation;
                },
                monitoring: function monitoring() {
                  return J.monitoring;
                },
                propagateFromFunction: function propagateFromFunction() {
                  return L;
                },
                boundValueFunction: function boundValueFunction() {
                  return M;
                },
                checkForgottenReturns: function checkForgottenReturns(t, e, r, n, i) {
                  if (void 0 === t && null !== e && E) {
                    if (void 0 !== i && i._returnedNonUndefined()) return;
                    if (0 == (65535 & n._bitField)) return;
                    r && (r += " ");
                    var o = "",
                        s = "";

                    if (e._trace) {
                      for (var a = e._trace.stack.split("\n"), u = q(a), c = u.length - 1; c >= 0; --c) {
                        var h = u[c];

                        if (!d.test(h)) {
                          var l = h.match(y);
                          l && (o = "at " + l[1] + ":" + l[2] + ":" + l[3] + " ");
                          break;
                        }
                      }

                      if (u.length > 0) {
                        var f = u[0];

                        for (c = 0; c < a.length; ++c) {
                          if (a[c] === f) {
                            c > 0 && (s = "\n" + a[c - 1]);
                            break;
                          }
                        }
                      }
                    }

                    var p = "a promise was created in a " + r + "handler " + o + "but was not returned from it, see http://goo.gl/rRqMUw" + s;

                    n._warn(p, !0, e);
                  }
                },
                setBounds: function setBounds(t, e) {
                  if (W()) {
                    for (var r, n, i = (t.stack || "").split("\n"), o = (e.stack || "").split("\n"), s = -1, a = -1, u = 0; u < i.length; ++u) {
                      if (c = $(i[u])) {
                        r = c.fileName, s = c.line;
                        break;
                      }
                    }

                    for (u = 0; u < o.length; ++u) {
                      var c;

                      if (c = $(o[u])) {
                        n = c.fileName, a = c.line;
                        break;
                      }
                    }

                    s < 0 || a < 0 || !r || !n || r !== n || s >= a || (X = function X(t) {
                      if (p.test(t)) return !0;
                      var e = $(t);
                      return !!(e && e.fileName === r && s <= e.line && e.line <= a);
                    });
                  }
                },
                warn: H,
                deprecated: function deprecated(t, e) {
                  var r = t + " is deprecated and will be removed in a future version.";
                  return e && (r += " Use " + e + " instead."), H(r);
                },
                CapturedTrace: Z,
                fireDomEvent: x,
                fireGlobalEvent: C
              };
            };
          }, {
            "./errors": 12,
            "./es5": 13,
            "./util": 36
          }],
          10: [function (t, e, r) {
            "use strict";

            e.exports = function (t) {
              function e() {
                return this.value;
              }

              function r() {
                throw this.reason;
              }

              t.prototype.return = t.prototype.thenReturn = function (r) {
                return r instanceof t && r.suppressUnhandledRejections(), this._then(e, void 0, void 0, {
                  value: r
                }, void 0);
              }, t.prototype.throw = t.prototype.thenThrow = function (t) {
                return this._then(r, void 0, void 0, {
                  reason: t
                }, void 0);
              }, t.prototype.catchThrow = function (t) {
                if (arguments.length <= 1) return this._then(void 0, r, void 0, {
                  reason: t
                }, void 0);

                var e = arguments[1],
                    n = function n() {
                  throw e;
                };

                return this.caught(t, n);
              }, t.prototype.catchReturn = function (r) {
                if (arguments.length <= 1) return r instanceof t && r.suppressUnhandledRejections(), this._then(void 0, e, void 0, {
                  value: r
                }, void 0);
                var n = arguments[1];
                n instanceof t && n.suppressUnhandledRejections();

                var i = function i() {
                  return n;
                };

                return this.caught(r, i);
              };
            };
          }, {}],
          11: [function (t, e, r) {
            "use strict";

            e.exports = function (t, e) {
              var r = t.reduce,
                  n = t.all;

              function i() {
                return n(this);
              }

              t.prototype.each = function (t) {
                return r(this, t, e, 0)._then(i, void 0, void 0, this, void 0);
              }, t.prototype.mapSeries = function (t) {
                return r(this, t, e, e);
              }, t.each = function (t, n) {
                return r(t, n, e, 0)._then(i, void 0, void 0, t, void 0);
              }, t.mapSeries = function (t, n) {
                return r(t, n, e, e);
              };
            };
          }, {}],
          12: [function (t, e, r) {
            "use strict";

            var n,
                i,
                o = t("./es5"),
                s = o.freeze,
                a = t("./util"),
                u = a.inherits,
                c = a.notEnumerableProp;

            function h(t, e) {
              function r(n) {
                if (!(this instanceof r)) return new r(n);
                c(this, "message", "string" == typeof n ? n : e), c(this, "name", t), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this);
              }

              return u(r, Error), r;
            }

            var l = h("Warning", "warning"),
                f = h("CancellationError", "cancellation error"),
                p = h("TimeoutError", "timeout error"),
                d = h("AggregateError", "aggregate error");

            try {
              n = TypeError, i = RangeError;
            } catch (t) {
              n = h("TypeError", "type error"), i = h("RangeError", "range error");
            }

            for (var y = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), v = 0; v < y.length; ++v) {
              "function" == typeof Array.prototype[y[v]] && (d.prototype[y[v]] = Array.prototype[y[v]]);
            }

            o.defineProperty(d.prototype, "length", {
              value: 0,
              configurable: !1,
              writable: !0,
              enumerable: !0
            }), d.prototype.isOperational = !0;
            var m = 0;

            function g(t) {
              if (!(this instanceof g)) return new g(t);
              c(this, "name", "OperationalError"), c(this, "message", t), this.cause = t, this.isOperational = !0, t instanceof Error ? (c(this, "message", t.message), c(this, "stack", t.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
            }

            d.prototype.toString = function () {
              var t = Array(4 * m + 1).join(" "),
                  e = "\n" + t + "AggregateError of:\n";
              m++, t = Array(4 * m + 1).join(" ");

              for (var r = 0; r < this.length; ++r) {
                for (var n = this[r] === this ? "[Circular AggregateError]" : this[r] + "", i = n.split("\n"), o = 0; o < i.length; ++o) {
                  i[o] = t + i[o];
                }

                e += (n = i.join("\n")) + "\n";
              }

              return m--, e;
            }, u(g, Error);
            var _ = Error.__BluebirdErrorTypes__;
            _ || (_ = s({
              CancellationError: f,
              TimeoutError: p,
              OperationalError: g,
              RejectionError: g,
              AggregateError: d
            }), o.defineProperty(Error, "__BluebirdErrorTypes__", {
              value: _,
              writable: !1,
              enumerable: !1,
              configurable: !1
            })), e.exports = {
              Error: Error,
              TypeError: n,
              RangeError: i,
              CancellationError: _.CancellationError,
              OperationalError: _.OperationalError,
              TimeoutError: _.TimeoutError,
              AggregateError: _.AggregateError,
              Warning: l
            };
          }, {
            "./es5": 13,
            "./util": 36
          }],
          13: [function (t, e, r) {
            var n = function () {
              "use strict";

              return void 0 === this;
            }();

            if (n) e.exports = {
              freeze: Object.freeze,
              defineProperty: Object.defineProperty,
              getDescriptor: Object.getOwnPropertyDescriptor,
              keys: Object.keys,
              names: Object.getOwnPropertyNames,
              getPrototypeOf: Object.getPrototypeOf,
              isArray: Array.isArray,
              isES5: n,
              propertyIsWritable: function propertyIsWritable(t, e) {
                var r = Object.getOwnPropertyDescriptor(t, e);
                return !(r && !r.writable && !r.set);
              }
            };else {
              var i = {}.hasOwnProperty,
                  o = {}.toString,
                  s = {}.constructor.prototype,
                  a = function a(t) {
                var e = [];

                for (var r in t) {
                  i.call(t, r) && e.push(r);
                }

                return e;
              };

              e.exports = {
                isArray: function isArray(t) {
                  try {
                    return "[object Array]" === o.call(t);
                  } catch (t) {
                    return !1;
                  }
                },
                keys: a,
                names: a,
                defineProperty: function defineProperty(t, e, r) {
                  return t[e] = r.value, t;
                },
                getDescriptor: function getDescriptor(t, e) {
                  return {
                    value: t[e]
                  };
                },
                freeze: function freeze(t) {
                  return t;
                },
                getPrototypeOf: function getPrototypeOf(t) {
                  try {
                    return Object(t).constructor.prototype;
                  } catch (t) {
                    return s;
                  }
                },
                isES5: n,
                propertyIsWritable: function propertyIsWritable() {
                  return !0;
                }
              };
            }
          }, {}],
          14: [function (t, e, r) {
            "use strict";

            e.exports = function (t, e) {
              var r = t.map;
              t.prototype.filter = function (t, n) {
                return r(this, t, n, e);
              }, t.filter = function (t, n, i) {
                return r(t, n, i, e);
              };
            };
          }, {}],
          15: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n) {
              var i = t("./util"),
                  o = e.CancellationError,
                  s = i.errorObj,
                  a = t("./catch_filter")(n);

              function u(t, e, r) {
                this.promise = t, this.type = e, this.handler = r, this.called = !1, this.cancelPromise = null;
              }

              function c(t) {
                this.finallyHandler = t;
              }

              function h(t, e) {
                return null != t.cancelPromise && (arguments.length > 1 ? t.cancelPromise._reject(e) : t.cancelPromise._cancel(), t.cancelPromise = null, !0);
              }

              function l() {
                return p.call(this, this.promise._target()._settledValue());
              }

              function f(t) {
                if (!h(this, t)) return s.e = t, s;
              }

              function p(t) {
                var i = this.promise,
                    a = this.handler;

                if (!this.called) {
                  this.called = !0;
                  var u = this.isFinallyHandler() ? a.call(i._boundValue()) : a.call(i._boundValue(), t);
                  if (u === n) return u;

                  if (void 0 !== u) {
                    i._setReturnedNonUndefined();

                    var p = r(u, i);

                    if (p instanceof e) {
                      if (null != this.cancelPromise) {
                        if (p._isCancelled()) {
                          var d = new o("late cancellation observer");
                          return i._attachExtraTrace(d), s.e = d, s;
                        }

                        p.isPending() && p._attachCancellationCallback(new c(this));
                      }

                      return p._then(l, f, void 0, this, void 0);
                    }
                  }
                }

                return i.isRejected() ? (h(this), s.e = t, s) : (h(this), t);
              }

              return u.prototype.isFinallyHandler = function () {
                return 0 === this.type;
              }, c.prototype._resultCancelled = function () {
                h(this.finallyHandler);
              }, e.prototype._passThrough = function (t, e, r, n) {
                return "function" != typeof t ? this.then() : this._then(r, n, void 0, new u(this, e, t), void 0);
              }, e.prototype.lastly = e.prototype.finally = function (t) {
                return this._passThrough(t, 0, p, p);
              }, e.prototype.tap = function (t) {
                return this._passThrough(t, 1, p);
              }, e.prototype.tapCatch = function (t) {
                var r = arguments.length;
                if (1 === r) return this._passThrough(t, 1, void 0, p);
                var n,
                    o = new Array(r - 1),
                    s = 0;

                for (n = 0; n < r - 1; ++n) {
                  var u = arguments[n];
                  if (!i.isObject(u)) return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + i.classString(u)));
                  o[s++] = u;
                }

                o.length = s;
                var c = arguments[n];
                return this._passThrough(a(o, c, this), 1, void 0, p);
              }, u;
            };
          }, {
            "./catch_filter": 7,
            "./util": 36
          }],
          16: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o, s) {
              var a = t("./errors").TypeError,
                  u = t("./util"),
                  c = u.errorObj,
                  h = u.tryCatch,
                  l = [];

              function f(t, r, i, o) {
                if (s.cancellation()) {
                  var a = new e(n),
                      u = this._finallyPromise = new e(n);
                  this._promise = a.lastly(function () {
                    return u;
                  }), a._captureStackTrace(), a._setOnCancel(this);
                } else (this._promise = new e(n))._captureStackTrace();

                this._stack = o, this._generatorFunction = t, this._receiver = r, this._generator = void 0, this._yieldHandlers = "function" == typeof i ? [i].concat(l) : l, this._yieldedPromise = null, this._cancellationPhase = !1;
              }

              u.inherits(f, o), f.prototype._isResolved = function () {
                return null === this._promise;
              }, f.prototype._cleanup = function () {
                this._promise = this._generator = null, s.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null);
              }, f.prototype._promiseCancelled = function () {
                if (!this._isResolved()) {
                  var t;
                  if (void 0 !== this._generator.return) this._promise._pushContext(), t = h(this._generator.return).call(this._generator, void 0), this._promise._popContext();else {
                    var r = new e.CancellationError("generator .return() sentinel");
                    e.coroutine.returnSentinel = r, this._promise._attachExtraTrace(r), this._promise._pushContext(), t = h(this._generator.throw).call(this._generator, r), this._promise._popContext();
                  }
                  this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(t);
                }
              }, f.prototype._promiseFulfilled = function (t) {
                this._yieldedPromise = null, this._promise._pushContext();
                var e = h(this._generator.next).call(this._generator, t);
                this._promise._popContext(), this._continue(e);
              }, f.prototype._promiseRejected = function (t) {
                this._yieldedPromise = null, this._promise._attachExtraTrace(t), this._promise._pushContext();
                var e = h(this._generator.throw).call(this._generator, t);
                this._promise._popContext(), this._continue(e);
              }, f.prototype._resultCancelled = function () {
                if (this._yieldedPromise instanceof e) {
                  var t = this._yieldedPromise;
                  this._yieldedPromise = null, t.cancel();
                }
              }, f.prototype.promise = function () {
                return this._promise;
              }, f.prototype._run = function () {
                this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0);
              }, f.prototype._continue = function (t) {
                var r = this._promise;
                if (t === c) return this._cleanup(), this._cancellationPhase ? r.cancel() : r._rejectCallback(t.e, !1);
                var n = t.value;
                if (!0 === t.done) return this._cleanup(), this._cancellationPhase ? r.cancel() : r._resolveCallback(n);
                var o = i(n, this._promise);

                if (o instanceof e || null !== (o = function (t, r, n) {
                  for (var o = 0; o < r.length; ++o) {
                    n._pushContext();

                    var s = h(r[o])(t);

                    if (n._popContext(), s === c) {
                      n._pushContext();

                      var a = e.reject(c.e);
                      return n._popContext(), a;
                    }

                    var u = i(s, n);
                    if (u instanceof e) return u;
                  }

                  return null;
                }(o, this._yieldHandlers, this._promise))) {
                  var s = (o = o._target())._bitField;

                  0 == (50397184 & s) ? (this._yieldedPromise = o, o._proxy(this, null)) : 0 != (33554432 & s) ? e._async.invoke(this._promiseFulfilled, this, o._value()) : 0 != (16777216 & s) ? e._async.invoke(this._promiseRejected, this, o._reason()) : this._promiseCancelled();
                } else this._promiseRejected(new a("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(n)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
              }, e.coroutine = function (t, e) {
                if ("function" != typeof t) throw new a("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                var r = Object(e).yieldHandler,
                    n = f,
                    i = new Error().stack;
                return function () {
                  var e = t.apply(this, arguments),
                      o = new n(void 0, void 0, r, i),
                      s = o.promise();
                  return o._generator = e, o._promiseFulfilled(void 0), s;
                };
              }, e.coroutine.addYieldHandler = function (t) {
                if ("function" != typeof t) throw new a("expecting a function but got " + u.classString(t));
                l.push(t);
              }, e.spawn = function (t) {
                if (s.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof t) return r("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                var n = new f(t, this),
                    i = n.promise();
                return n._run(e.spawn), i;
              };
            };
          }, {
            "./errors": 12,
            "./util": 36
          }],
          17: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o, s) {
              var a = t("./util");
              a.canEvaluate, a.tryCatch, a.errorObj, e.join = function () {
                var t,
                    e = arguments.length - 1;
                e > 0 && "function" == typeof arguments[e] && (t = arguments[e]);
                var n = [].slice.call(arguments);
                t && n.pop();
                var i = new r(n).promise();
                return void 0 !== t ? i.spread(t) : i;
              };
            };
          }, {
            "./util": 36
          }],
          18: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o, s) {
              var a = e._getDomain,
                  u = t("./util"),
                  c = u.tryCatch,
                  h = u.errorObj,
                  l = e._async;

              function f(t, e, r, n) {
                this.constructor$(t), this._promise._captureStackTrace();
                var i = a();
                this._callback = null === i ? e : u.domainBind(i, e), this._preservedValues = n === o ? new Array(this.length()) : null, this._limit = r, this._inFlight = 0, this._queue = [], l.invoke(this._asyncInit, this, void 0);
              }

              function p(t, r, i, o) {
                if ("function" != typeof r) return n("expecting a function but got " + u.classString(r));
                var s = 0;

                if (void 0 !== i) {
                  if ("object" != typeof i || null === i) return e.reject(new TypeError("options argument must be an object but it is " + u.classString(i)));
                  if ("number" != typeof i.concurrency) return e.reject(new TypeError("'concurrency' must be a number but it is " + u.classString(i.concurrency)));
                  s = i.concurrency;
                }

                return new f(t, r, s = "number" == typeof s && isFinite(s) && s >= 1 ? s : 0, o).promise();
              }

              u.inherits(f, r), f.prototype._asyncInit = function () {
                this._init$(void 0, -2);
              }, f.prototype._init = function () {}, f.prototype._promiseFulfilled = function (t, r) {
                var n = this._values,
                    o = this.length(),
                    a = this._preservedValues,
                    u = this._limit;

                if (r < 0) {
                  if (n[r = -1 * r - 1] = t, u >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved())) return !0;
                } else {
                  if (u >= 1 && this._inFlight >= u) return n[r] = t, this._queue.push(r), !1;
                  null !== a && (a[r] = t);

                  var l = this._promise,
                      f = this._callback,
                      p = l._boundValue();

                  l._pushContext();

                  var d = c(f).call(p, t, r, o),
                      y = l._popContext();

                  if (s.checkForgottenReturns(d, y, null !== a ? "Promise.filter" : "Promise.map", l), d === h) return this._reject(d.e), !0;
                  var v = i(d, this._promise);

                  if (v instanceof e) {
                    var m = (v = v._target())._bitField;

                    if (0 == (50397184 & m)) return u >= 1 && this._inFlight++, n[r] = v, v._proxy(this, -1 * (r + 1)), !1;
                    if (0 == (33554432 & m)) return 0 != (16777216 & m) ? (this._reject(v._reason()), !0) : (this._cancel(), !0);
                    d = v._value();
                  }

                  n[r] = d;
                }

                return ++this._totalResolved >= o && (null !== a ? this._filter(n, a) : this._resolve(n), !0);
              }, f.prototype._drainQueue = function () {
                for (var t = this._queue, e = this._limit, r = this._values; t.length > 0 && this._inFlight < e;) {
                  if (this._isResolved()) return;
                  var n = t.pop();

                  this._promiseFulfilled(r[n], n);
                }
              }, f.prototype._filter = function (t, e) {
                for (var r = e.length, n = new Array(r), i = 0, o = 0; o < r; ++o) {
                  t[o] && (n[i++] = e[o]);
                }

                n.length = i, this._resolve(n);
              }, f.prototype.preservedValues = function () {
                return this._preservedValues;
              }, e.prototype.map = function (t, e) {
                return p(this, t, e, null);
              }, e.map = function (t, e, r, n) {
                return p(t, e, r, n);
              };
            };
          }, {
            "./util": 36
          }],
          19: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o) {
              var s = t("./util"),
                  a = s.tryCatch;
              e.method = function (t) {
                if ("function" != typeof t) throw new e.TypeError("expecting a function but got " + s.classString(t));
                return function () {
                  var n = new e(r);
                  n._captureStackTrace(), n._pushContext();

                  var i = a(t).apply(this, arguments),
                      s = n._popContext();

                  return o.checkForgottenReturns(i, s, "Promise.method", n), n._resolveFromSyncValue(i), n;
                };
              }, e.attempt = e.try = function (t) {
                if ("function" != typeof t) return i("expecting a function but got " + s.classString(t));
                var n,
                    u = new e(r);

                if (u._captureStackTrace(), u._pushContext(), arguments.length > 1) {
                  o.deprecated("calling Promise.try with more than 1 argument");
                  var c = arguments[1],
                      h = arguments[2];
                  n = s.isArray(c) ? a(t).apply(h, c) : a(t).call(h, c);
                } else n = a(t)();

                var l = u._popContext();

                return o.checkForgottenReturns(n, l, "Promise.try", u), u._resolveFromSyncValue(n), u;
              }, e.prototype._resolveFromSyncValue = function (t) {
                t === s.errorObj ? this._rejectCallback(t.e, !1) : this._resolveCallback(t, !0);
              };
            };
          }, {
            "./util": 36
          }],
          20: [function (t, e, r) {
            "use strict";

            var n = t("./util"),
                i = n.maybeWrapAsError,
                o = t("./errors").OperationalError,
                s = t("./es5"),
                a = /^(?:name|message|stack|cause)$/;

            function u(t) {
              var e;

              if (function (t) {
                return t instanceof Error && s.getPrototypeOf(t) === Error.prototype;
              }(t)) {
                (e = new o(t)).name = t.name, e.message = t.message, e.stack = t.stack;

                for (var r = s.keys(t), i = 0; i < r.length; ++i) {
                  var u = r[i];
                  a.test(u) || (e[u] = t[u]);
                }

                return e;
              }

              return n.markAsOriginatingFromRejection(t), t;
            }

            e.exports = function (t, e) {
              return function (r, n) {
                if (null !== t) {
                  if (r) {
                    var o = u(i(r));
                    t._attachExtraTrace(o), t._reject(o);
                  } else if (e) {
                    var s = [].slice.call(arguments, 1);

                    t._fulfill(s);
                  } else t._fulfill(n);

                  t = null;
                }
              };
            };
          }, {
            "./errors": 12,
            "./es5": 13,
            "./util": 36
          }],
          21: [function (t, e, r) {
            "use strict";

            e.exports = function (e) {
              var r = t("./util"),
                  n = e._async,
                  i = r.tryCatch,
                  o = r.errorObj;

              function s(t, e) {
                if (!r.isArray(t)) return a.call(this, t, e);
                var s = i(e).apply(this._boundValue(), [null].concat(t));
                s === o && n.throwLater(s.e);
              }

              function a(t, e) {
                var r = this._boundValue(),
                    s = void 0 === t ? i(e).call(r, null) : i(e).call(r, null, t);

                s === o && n.throwLater(s.e);
              }

              function u(t, e) {
                if (!t) {
                  var r = new Error(t + "");
                  r.cause = t, t = r;
                }

                var s = i(e).call(this._boundValue(), t);
                s === o && n.throwLater(s.e);
              }

              e.prototype.asCallback = e.prototype.nodeify = function (t, e) {
                if ("function" == typeof t) {
                  var r = a;
                  void 0 !== e && Object(e).spread && (r = s), this._then(r, u, void 0, this, t);
                }

                return this;
              };
            };
          }, {
            "./util": 36
          }],
          22: [function (t, r, n) {
            "use strict";

            r.exports = function () {
              var n = function n() {
                return new d("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
              },
                  i = function i() {
                return new R.PromiseInspection(this._target());
              },
                  o = function o(t) {
                return R.reject(new d(t));
              };

              function s() {}

              var a,
                  u = {},
                  c = t("./util");
              a = c.isNode ? function () {
                var t = e.domain;
                return void 0 === t && (t = null), t;
              } : function () {
                return null;
              }, c.notEnumerableProp(R, "_getDomain", a);
              var h = t("./es5"),
                  l = t("./async"),
                  f = new l();
              h.defineProperty(R, "_async", {
                value: f
              });
              var p = t("./errors"),
                  d = R.TypeError = p.TypeError;
              R.RangeError = p.RangeError;
              var y = R.CancellationError = p.CancellationError;
              R.TimeoutError = p.TimeoutError, R.OperationalError = p.OperationalError, R.RejectionError = p.OperationalError, R.AggregateError = p.AggregateError;

              var v = function v() {},
                  m = {},
                  g = {},
                  _ = t("./thenables")(R, v),
                  b = t("./promise_array")(R, v, _, o, s),
                  w = t("./context")(R),
                  E = w.create,
                  k = t("./debuggability")(R, w),
                  x = (k.CapturedTrace, t("./finally")(R, _, g)),
                  C = t("./catch_filter")(g),
                  A = t("./nodeback"),
                  S = c.errorObj,
                  T = c.tryCatch;

              function R(t) {
                t !== v && function (t, e) {
                  if (null == t || t.constructor !== R) throw new d("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                  if ("function" != typeof e) throw new d("expecting a function but got " + c.classString(e));
                }(this, t), this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, this._resolveFromExecutor(t), this._promiseCreated(), this._fireEvent("promiseCreated", this);
              }

              function O(t) {
                this.promise._resolveCallback(t);
              }

              function j(t) {
                this.promise._rejectCallback(t, !1);
              }

              function P(t) {
                var e = new R(v);
                e._fulfillmentHandler0 = t, e._rejectionHandler0 = t, e._promise0 = t, e._receiver0 = t;
              }

              return R.prototype.toString = function () {
                return "[object Promise]";
              }, R.prototype.caught = R.prototype.catch = function (t) {
                var e = arguments.length;

                if (e > 1) {
                  var r,
                      n = new Array(e - 1),
                      i = 0;

                  for (r = 0; r < e - 1; ++r) {
                    var s = arguments[r];
                    if (!c.isObject(s)) return o("Catch statement predicate: expecting an object but got " + c.classString(s));
                    n[i++] = s;
                  }

                  if (n.length = i, "function" != typeof (t = arguments[r])) throw new d("The last argument to .catch() must be a function, got " + c.toString(t));
                  return this.then(void 0, C(n, t, this));
                }

                return this.then(void 0, t);
              }, R.prototype.reflect = function () {
                return this._then(i, i, void 0, this, void 0);
              }, R.prototype.then = function (t, e) {
                if (k.warnings() && arguments.length > 0 && "function" != typeof t && "function" != typeof e) {
                  var r = ".then() only accepts functions but was passed: " + c.classString(t);
                  arguments.length > 1 && (r += ", " + c.classString(e)), this._warn(r);
                }

                return this._then(t, e, void 0, void 0, void 0);
              }, R.prototype.done = function (t, e) {
                this._then(t, e, void 0, void 0, void 0)._setIsFinal();
              }, R.prototype.spread = function (t) {
                return "function" != typeof t ? o("expecting a function but got " + c.classString(t)) : this.all()._then(t, void 0, void 0, m, void 0);
              }, R.prototype.toJSON = function () {
                var t = {
                  isFulfilled: !1,
                  isRejected: !1,
                  fulfillmentValue: void 0,
                  rejectionReason: void 0
                };
                return this.isFulfilled() ? (t.fulfillmentValue = this.value(), t.isFulfilled = !0) : this.isRejected() && (t.rejectionReason = this.reason(), t.isRejected = !0), t;
              }, R.prototype.all = function () {
                return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new b(this).promise();
              }, R.prototype.error = function (t) {
                return this.caught(c.originatesFromRejection, t);
              }, R.getNewLibraryCopy = r.exports, R.is = function (t) {
                return t instanceof R;
              }, R.fromNode = R.fromCallback = function (t) {
                var e = new R(v);

                e._captureStackTrace();

                var r = arguments.length > 1 && !!Object(arguments[1]).multiArgs,
                    n = T(t)(A(e, r));
                return n === S && e._rejectCallback(n.e, !0), e._isFateSealed() || e._setAsyncGuaranteed(), e;
              }, R.all = function (t) {
                return new b(t).promise();
              }, R.cast = function (t) {
                var e = _(t);

                return e instanceof R || ((e = new R(v))._captureStackTrace(), e._setFulfilled(), e._rejectionHandler0 = t), e;
              }, R.resolve = R.fulfilled = R.cast, R.reject = R.rejected = function (t) {
                var e = new R(v);
                return e._captureStackTrace(), e._rejectCallback(t, !0), e;
              }, R.setScheduler = function (t) {
                if ("function" != typeof t) throw new d("expecting a function but got " + c.classString(t));
                return f.setScheduler(t);
              }, R.prototype._then = function (t, e, r, n, i) {
                var o = void 0 !== i,
                    s = o ? i : new R(v),
                    u = this._target(),
                    h = u._bitField;

                o || (s._propagateFrom(this, 3), s._captureStackTrace(), void 0 === n && 0 != (2097152 & this._bitField) && (n = 0 != (50397184 & h) ? this._boundValue() : u === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, s));
                var l = a();

                if (0 != (50397184 & h)) {
                  var p,
                      d,
                      m = u._settlePromiseCtx;
                  0 != (33554432 & h) ? (d = u._rejectionHandler0, p = t) : 0 != (16777216 & h) ? (d = u._fulfillmentHandler0, p = e, u._unsetRejectionIsUnhandled()) : (m = u._settlePromiseLateCancellationObserver, d = new y("late cancellation observer"), u._attachExtraTrace(d), p = e), f.invoke(m, u, {
                    handler: null === l ? p : "function" == typeof p && c.domainBind(l, p),
                    promise: s,
                    receiver: n,
                    value: d
                  });
                } else u._addCallbacks(t, e, s, n, l);

                return s;
              }, R.prototype._length = function () {
                return 65535 & this._bitField;
              }, R.prototype._isFateSealed = function () {
                return 0 != (117506048 & this._bitField);
              }, R.prototype._isFollowing = function () {
                return 67108864 == (67108864 & this._bitField);
              }, R.prototype._setLength = function (t) {
                this._bitField = -65536 & this._bitField | 65535 & t;
              }, R.prototype._setFulfilled = function () {
                this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this);
              }, R.prototype._setRejected = function () {
                this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this);
              }, R.prototype._setFollowing = function () {
                this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this);
              }, R.prototype._setIsFinal = function () {
                this._bitField = 4194304 | this._bitField;
              }, R.prototype._isFinal = function () {
                return (4194304 & this._bitField) > 0;
              }, R.prototype._unsetCancelled = function () {
                this._bitField = -65537 & this._bitField;
              }, R.prototype._setCancelled = function () {
                this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this);
              }, R.prototype._setWillBeCancelled = function () {
                this._bitField = 8388608 | this._bitField;
              }, R.prototype._setAsyncGuaranteed = function () {
                f.hasCustomScheduler() || (this._bitField = 134217728 | this._bitField);
              }, R.prototype._receiverAt = function (t) {
                var e = 0 === t ? this._receiver0 : this[4 * t - 4 + 3];
                if (e !== u) return void 0 === e && this._isBound() ? this._boundValue() : e;
              }, R.prototype._promiseAt = function (t) {
                return this[4 * t - 4 + 2];
              }, R.prototype._fulfillmentHandlerAt = function (t) {
                return this[4 * t - 4 + 0];
              }, R.prototype._rejectionHandlerAt = function (t) {
                return this[4 * t - 4 + 1];
              }, R.prototype._boundValue = function () {}, R.prototype._migrateCallback0 = function (t) {
                t._bitField;

                var e = t._fulfillmentHandler0,
                    r = t._rejectionHandler0,
                    n = t._promise0,
                    i = t._receiverAt(0);

                void 0 === i && (i = u), this._addCallbacks(e, r, n, i, null);
              }, R.prototype._migrateCallbackAt = function (t, e) {
                var r = t._fulfillmentHandlerAt(e),
                    n = t._rejectionHandlerAt(e),
                    i = t._promiseAt(e),
                    o = t._receiverAt(e);

                void 0 === o && (o = u), this._addCallbacks(r, n, i, o, null);
              }, R.prototype._addCallbacks = function (t, e, r, n, i) {
                var o = this._length();

                if (o >= 65531 && (o = 0, this._setLength(0)), 0 === o) this._promise0 = r, this._receiver0 = n, "function" == typeof t && (this._fulfillmentHandler0 = null === i ? t : c.domainBind(i, t)), "function" == typeof e && (this._rejectionHandler0 = null === i ? e : c.domainBind(i, e));else {
                  var s = 4 * o - 4;
                  this[s + 2] = r, this[s + 3] = n, "function" == typeof t && (this[s + 0] = null === i ? t : c.domainBind(i, t)), "function" == typeof e && (this[s + 1] = null === i ? e : c.domainBind(i, e));
                }
                return this._setLength(o + 1), o;
              }, R.prototype._proxy = function (t, e) {
                this._addCallbacks(void 0, void 0, e, t, null);
              }, R.prototype._resolveCallback = function (t, e) {
                if (0 == (117506048 & this._bitField)) {
                  if (t === this) return this._rejectCallback(n(), !1);

                  var r = _(t, this);

                  if (!(r instanceof R)) return this._fulfill(t);
                  e && this._propagateFrom(r, 2);

                  var i = r._target();

                  if (i !== this) {
                    var o = i._bitField;

                    if (0 == (50397184 & o)) {
                      var s = this._length();

                      s > 0 && i._migrateCallback0(this);

                      for (var a = 1; a < s; ++a) {
                        i._migrateCallbackAt(this, a);
                      }

                      this._setFollowing(), this._setLength(0), this._setFollowee(i);
                    } else if (0 != (33554432 & o)) this._fulfill(i._value());else if (0 != (16777216 & o)) this._reject(i._reason());else {
                      var u = new y("late cancellation observer");
                      i._attachExtraTrace(u), this._reject(u);
                    }
                  } else this._reject(n());
                }
              }, R.prototype._rejectCallback = function (t, e, r) {
                var n = c.ensureErrorObject(t),
                    i = n === t;

                if (!i && !r && k.warnings()) {
                  var o = "a promise was rejected with a non-error: " + c.classString(t);

                  this._warn(o, !0);
                }

                this._attachExtraTrace(n, !!e && i), this._reject(t);
              }, R.prototype._resolveFromExecutor = function (t) {
                if (t !== v) {
                  var e = this;
                  this._captureStackTrace(), this._pushContext();

                  var r = !0,
                      n = this._execute(t, function (t) {
                    e._resolveCallback(t);
                  }, function (t) {
                    e._rejectCallback(t, r);
                  });

                  r = !1, this._popContext(), void 0 !== n && e._rejectCallback(n, !0);
                }
              }, R.prototype._settlePromiseFromHandler = function (t, e, r, n) {
                var i = n._bitField;

                if (0 == (65536 & i)) {
                  var o;
                  n._pushContext(), e === m ? r && "number" == typeof r.length ? o = T(t).apply(this._boundValue(), r) : (o = S).e = new d("cannot .spread() a non-array: " + c.classString(r)) : o = T(t).call(e, r);

                  var s = n._popContext();

                  0 == (65536 & (i = n._bitField)) && (o === g ? n._reject(r) : o === S ? n._rejectCallback(o.e, !1) : (k.checkForgottenReturns(o, s, "", n, this), n._resolveCallback(o)));
                }
              }, R.prototype._target = function () {
                for (var t = this; t._isFollowing();) {
                  t = t._followee();
                }

                return t;
              }, R.prototype._followee = function () {
                return this._rejectionHandler0;
              }, R.prototype._setFollowee = function (t) {
                this._rejectionHandler0 = t;
              }, R.prototype._settlePromise = function (t, e, r, n) {
                var o = t instanceof R,
                    a = this._bitField,
                    u = 0 != (134217728 & a);
                0 != (65536 & a) ? (o && t._invokeInternalOnCancel(), r instanceof x && r.isFinallyHandler() ? (r.cancelPromise = t, T(e).call(r, n) === S && t._reject(S.e)) : e === i ? t._fulfill(i.call(r)) : r instanceof s ? r._promiseCancelled(t) : o || t instanceof b ? t._cancel() : r.cancel()) : "function" == typeof e ? o ? (u && t._setAsyncGuaranteed(), this._settlePromiseFromHandler(e, r, n, t)) : e.call(r, n, t) : r instanceof s ? r._isResolved() || (0 != (33554432 & a) ? r._promiseFulfilled(n, t) : r._promiseRejected(n, t)) : o && (u && t._setAsyncGuaranteed(), 0 != (33554432 & a) ? t._fulfill(n) : t._reject(n));
              }, R.prototype._settlePromiseLateCancellationObserver = function (t) {
                var e = t.handler,
                    r = t.promise,
                    n = t.receiver,
                    i = t.value;
                "function" == typeof e ? r instanceof R ? this._settlePromiseFromHandler(e, n, i, r) : e.call(n, i, r) : r instanceof R && r._reject(i);
              }, R.prototype._settlePromiseCtx = function (t) {
                this._settlePromise(t.promise, t.handler, t.receiver, t.value);
              }, R.prototype._settlePromise0 = function (t, e, r) {
                var n = this._promise0,
                    i = this._receiverAt(0);

                this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(n, t, i, e);
              }, R.prototype._clearCallbackDataAtIndex = function (t) {
                var e = 4 * t - 4;
                this[e + 2] = this[e + 3] = this[e + 0] = this[e + 1] = void 0;
              }, R.prototype._fulfill = function (t) {
                var e = this._bitField;

                if (!((117506048 & e) >>> 16)) {
                  if (t === this) {
                    var r = n();
                    return this._attachExtraTrace(r), this._reject(r);
                  }

                  this._setFulfilled(), this._rejectionHandler0 = t, (65535 & e) > 0 && (0 != (134217728 & e) ? this._settlePromises() : f.settlePromises(this), this._dereferenceTrace());
                }
              }, R.prototype._reject = function (t) {
                var e = this._bitField;

                if (!((117506048 & e) >>> 16)) {
                  if (this._setRejected(), this._fulfillmentHandler0 = t, this._isFinal()) return f.fatalError(t, c.isNode);
                  (65535 & e) > 0 ? f.settlePromises(this) : this._ensurePossibleRejectionHandled();
                }
              }, R.prototype._fulfillPromises = function (t, e) {
                for (var r = 1; r < t; r++) {
                  var n = this._fulfillmentHandlerAt(r),
                      i = this._promiseAt(r),
                      o = this._receiverAt(r);

                  this._clearCallbackDataAtIndex(r), this._settlePromise(i, n, o, e);
                }
              }, R.prototype._rejectPromises = function (t, e) {
                for (var r = 1; r < t; r++) {
                  var n = this._rejectionHandlerAt(r),
                      i = this._promiseAt(r),
                      o = this._receiverAt(r);

                  this._clearCallbackDataAtIndex(r), this._settlePromise(i, n, o, e);
                }
              }, R.prototype._settlePromises = function () {
                var t = this._bitField,
                    e = 65535 & t;

                if (e > 0) {
                  if (0 != (16842752 & t)) {
                    var r = this._fulfillmentHandler0;
                    this._settlePromise0(this._rejectionHandler0, r, t), this._rejectPromises(e, r);
                  } else {
                    var n = this._rejectionHandler0;
                    this._settlePromise0(this._fulfillmentHandler0, n, t), this._fulfillPromises(e, n);
                  }

                  this._setLength(0);
                }

                this._clearCancellationData();
              }, R.prototype._settledValue = function () {
                var t = this._bitField;
                return 0 != (33554432 & t) ? this._rejectionHandler0 : 0 != (16777216 & t) ? this._fulfillmentHandler0 : void 0;
              }, "undefined" != typeof Symbol && Symbol.toStringTag && h.defineProperty(R.prototype, Symbol.toStringTag, {
                get: function get() {
                  return "Object";
                }
              }), R.defer = R.pending = function () {
                return k.deprecated("Promise.defer", "new Promise"), {
                  promise: new R(v),
                  resolve: O,
                  reject: j
                };
              }, c.notEnumerableProp(R, "_makeSelfResolutionError", n), t("./method")(R, v, _, o, k), t("./bind")(R, v, _, k), t("./cancel")(R, b, o, k), t("./direct_resolve")(R), t("./synchronous_inspection")(R), t("./join")(R, b, _, v, f, a), R.Promise = R, R.version = "3.5.5", t("./call_get.js")(R), t("./generators.js")(R, o, v, _, s, k), t("./map.js")(R, b, o, _, v, k), t("./nodeify.js")(R), t("./promisify.js")(R, v), t("./props.js")(R, b, _, o), t("./race.js")(R, v, _, o), t("./reduce.js")(R, b, o, _, v, k), t("./settle.js")(R, b, k), t("./some.js")(R, b, o), t("./timers.js")(R, v, k), t("./using.js")(R, o, _, E, v, k), t("./any.js")(R), t("./each.js")(R, v), t("./filter.js")(R, v), c.toFastProperties(R), c.toFastProperties(R.prototype), P({
                a: 1
              }), P({
                b: 2
              }), P({
                c: 3
              }), P(1), P(function () {}), P(void 0), P(!1), P(new R(v)), k.setBounds(l.firstLineError, c.lastLineError), R;
            };
          }, {
            "./any.js": 1,
            "./async": 2,
            "./bind": 3,
            "./call_get.js": 5,
            "./cancel": 6,
            "./catch_filter": 7,
            "./context": 8,
            "./debuggability": 9,
            "./direct_resolve": 10,
            "./each.js": 11,
            "./errors": 12,
            "./es5": 13,
            "./filter.js": 14,
            "./finally": 15,
            "./generators.js": 16,
            "./join": 17,
            "./map.js": 18,
            "./method": 19,
            "./nodeback": 20,
            "./nodeify.js": 21,
            "./promise_array": 23,
            "./promisify.js": 24,
            "./props.js": 25,
            "./race.js": 27,
            "./reduce.js": 28,
            "./settle.js": 30,
            "./some.js": 31,
            "./synchronous_inspection": 32,
            "./thenables": 33,
            "./timers.js": 34,
            "./using.js": 35,
            "./util": 36
          }],
          23: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o) {
              var s = t("./util");

              function a(t) {
                var n = this._promise = new e(r);
                t instanceof e && n._propagateFrom(t, 3), n._setOnCancel(this), this._values = t, this._length = 0, this._totalResolved = 0, this._init(void 0, -2);
              }

              return s.isArray, s.inherits(a, o), a.prototype.length = function () {
                return this._length;
              }, a.prototype.promise = function () {
                return this._promise;
              }, a.prototype._init = function t(r, o) {
                var a = n(this._values, this._promise);

                if (a instanceof e) {
                  var u = (a = a._target())._bitField;

                  if (this._values = a, 0 == (50397184 & u)) return this._promise._setAsyncGuaranteed(), a._then(t, this._reject, void 0, this, o);
                  if (0 == (33554432 & u)) return 0 != (16777216 & u) ? this._reject(a._reason()) : this._cancel();
                  a = a._value();
                }

                if (null !== (a = s.asArray(a))) 0 !== a.length ? this._iterate(a) : -5 === o ? this._resolveEmptyArray() : this._resolve(function (t) {
                  switch (t) {
                    case -2:
                      return [];

                    case -3:
                      return {};

                    case -6:
                      return new Map();
                  }
                }(o));else {
                  var c = i("expecting an array or an iterable object but got " + s.classString(a)).reason();

                  this._promise._rejectCallback(c, !1);
                }
              }, a.prototype._iterate = function (t) {
                var r = this.getActualLength(t.length);
                this._length = r, this._values = this.shouldCopyValues() ? new Array(r) : this._values;

                for (var i = this._promise, o = !1, s = null, a = 0; a < r; ++a) {
                  var u = n(t[a], i);
                  s = u instanceof e ? (u = u._target())._bitField : null, o ? null !== s && u.suppressUnhandledRejections() : null !== s ? 0 == (50397184 & s) ? (u._proxy(this, a), this._values[a] = u) : o = 0 != (33554432 & s) ? this._promiseFulfilled(u._value(), a) : 0 != (16777216 & s) ? this._promiseRejected(u._reason(), a) : this._promiseCancelled(a) : o = this._promiseFulfilled(u, a);
                }

                o || i._setAsyncGuaranteed();
              }, a.prototype._isResolved = function () {
                return null === this._values;
              }, a.prototype._resolve = function (t) {
                this._values = null, this._promise._fulfill(t);
              }, a.prototype._cancel = function () {
                !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel());
              }, a.prototype._reject = function (t) {
                this._values = null, this._promise._rejectCallback(t, !1);
              }, a.prototype._promiseFulfilled = function (t, e) {
                return this._values[e] = t, ++this._totalResolved >= this._length && (this._resolve(this._values), !0);
              }, a.prototype._promiseCancelled = function () {
                return this._cancel(), !0;
              }, a.prototype._promiseRejected = function (t) {
                return this._totalResolved++, this._reject(t), !0;
              }, a.prototype._resultCancelled = function () {
                if (!this._isResolved()) {
                  var t = this._values;
                  if (this._cancel(), t instanceof e) t.cancel();else for (var r = 0; r < t.length; ++r) {
                    t[r] instanceof e && t[r].cancel();
                  }
                }
              }, a.prototype.shouldCopyValues = function () {
                return !0;
              }, a.prototype.getActualLength = function (t) {
                return t;
              }, a;
            };
          }, {
            "./util": 36
          }],
          24: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r) {
              var n = {},
                  i = t("./util"),
                  o = t("./nodeback"),
                  s = i.withAppended,
                  a = i.maybeWrapAsError,
                  u = i.canEvaluate,
                  c = t("./errors").TypeError,
                  h = {
                __isPromisified__: !0
              },
                  l = new RegExp("^(?:" + ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"].join("|") + ")$"),
                  f = function f(t) {
                return i.isIdentifier(t) && "_" !== t.charAt(0) && "constructor" !== t;
              };

              function p(t) {
                return !l.test(t);
              }

              function d(t) {
                try {
                  return !0 === t.__isPromisified__;
                } catch (t) {
                  return !1;
                }
              }

              function y(t, e, r) {
                var n = i.getDataPropertyOrDefault(t, e + r, h);
                return !!n && d(n);
              }

              function v(t, e, r, n) {
                for (var o = i.inheritedDataKeys(t), s = [], a = 0; a < o.length; ++a) {
                  var u = o[a],
                      h = t[u],
                      l = n === f || f(u, h, t);
                  "function" != typeof h || d(h) || y(t, u, e) || !n(u, h, t, l) || s.push(u, h);
                }

                return function (t, e, r) {
                  for (var n = 0; n < t.length; n += 2) {
                    var i = t[n];
                    if (r.test(i)) for (var o = i.replace(r, ""), s = 0; s < t.length; s += 2) {
                      if (t[s] === o) throw new c("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", e));
                    }
                  }
                }(s, e, r), s;
              }

              var m = function m(t) {
                return t.replace(/([$])/, "\\$");
              },
                  g = u ? void 0 : function (t, u, c, h, l, f) {
                var p = function () {
                  return this;
                }(),
                    d = t;

                function y() {
                  var i = u;
                  u === n && (i = this);
                  var c = new e(r);

                  c._captureStackTrace();

                  var h = "string" == typeof d && this !== p ? this[d] : t,
                      l = o(c, f);

                  try {
                    h.apply(i, s(arguments, l));
                  } catch (t) {
                    c._rejectCallback(a(t), !0, !0);
                  }

                  return c._isFateSealed() || c._setAsyncGuaranteed(), c;
                }

                return "string" == typeof d && (t = h), i.notEnumerableProp(y, "__isPromisified__", !0), y;
              };

              function _(t, e, r, o, s) {
                for (var a = new RegExp(m(e) + "$"), u = v(t, e, a, r), c = 0, h = u.length; c < h; c += 2) {
                  var l = u[c],
                      f = u[c + 1],
                      p = l + e;
                  if (o === g) t[p] = g(l, n, l, f, e, s);else {
                    var d = o(f, function () {
                      return g(l, n, l, f, e, s);
                    });
                    i.notEnumerableProp(d, "__isPromisified__", !0), t[p] = d;
                  }
                }

                return i.toFastProperties(t), t;
              }

              e.promisify = function (t, e) {
                if ("function" != typeof t) throw new c("expecting a function but got " + i.classString(t));
                if (d(t)) return t;

                var r = function (t, e, r) {
                  return g(t, e, void 0, t, null, r);
                }(t, void 0 === (e = Object(e)).context ? n : e.context, !!e.multiArgs);

                return i.copyDescriptors(t, r, p), r;
              }, e.promisifyAll = function (t, e) {
                if ("function" != typeof t && "object" != typeof t) throw new c("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
                var r = !!(e = Object(e)).multiArgs,
                    n = e.suffix;
                "string" != typeof n && (n = "Async");
                var o = e.filter;
                "function" != typeof o && (o = f);
                var s = e.promisifier;
                if ("function" != typeof s && (s = g), !i.isIdentifier(n)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");

                for (var a = i.inheritedDataKeys(t), u = 0; u < a.length; ++u) {
                  var h = t[a[u]];
                  "constructor" !== a[u] && i.isClass(h) && (_(h.prototype, n, o, s, r), _(h, n, o, s, r));
                }

                return _(t, n, o, s, r);
              };
            };
          }, {
            "./errors": 12,
            "./nodeback": 20,
            "./util": 36
          }],
          25: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i) {
              var o,
                  s = t("./util"),
                  a = s.isObject,
                  u = t("./es5");
              "function" == typeof Map && (o = Map);

              var c = function () {
                var t = 0,
                    e = 0;

                function r(r, n) {
                  this[t] = r, this[t + e] = n, t++;
                }

                return function (n) {
                  e = n.size, t = 0;
                  var i = new Array(2 * n.size);
                  return n.forEach(r, i), i;
                };
              }();

              function h(t) {
                var e,
                    r = !1;
                if (void 0 !== o && t instanceof o) e = c(t), r = !0;else {
                  var n = u.keys(t),
                      i = n.length;
                  e = new Array(2 * i);

                  for (var s = 0; s < i; ++s) {
                    var a = n[s];
                    e[s] = t[a], e[s + i] = a;
                  }
                }
                this.constructor$(e), this._isMap = r, this._init$(void 0, r ? -6 : -3);
              }

              function l(t) {
                var r,
                    o = n(t);
                return a(o) ? (r = o instanceof e ? o._then(e.props, void 0, void 0, void 0, void 0) : new h(o).promise(), o instanceof e && r._propagateFrom(o, 2), r) : i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
              }

              s.inherits(h, r), h.prototype._init = function () {}, h.prototype._promiseFulfilled = function (t, e) {
                if (this._values[e] = t, ++this._totalResolved >= this._length) {
                  var r;
                  if (this._isMap) r = function (t) {
                    for (var e = new o(), r = t.length / 2 | 0, n = 0; n < r; ++n) {
                      var i = t[r + n],
                          s = t[n];
                      e.set(i, s);
                    }

                    return e;
                  }(this._values);else {
                    r = {};

                    for (var n = this.length(), i = 0, s = this.length(); i < s; ++i) {
                      r[this._values[i + n]] = this._values[i];
                    }
                  }
                  return this._resolve(r), !0;
                }

                return !1;
              }, h.prototype.shouldCopyValues = function () {
                return !1;
              }, h.prototype.getActualLength = function (t) {
                return t >> 1;
              }, e.prototype.props = function () {
                return l(this);
              }, e.props = function (t) {
                return l(t);
              };
            };
          }, {
            "./es5": 13,
            "./util": 36
          }],
          26: [function (t, e, r) {
            "use strict";

            function n(t) {
              this._capacity = t, this._length = 0, this._front = 0;
            }

            n.prototype._willBeOverCapacity = function (t) {
              return this._capacity < t;
            }, n.prototype._pushOne = function (t) {
              var e = this.length();
              this._checkCapacity(e + 1), this[this._front + e & this._capacity - 1] = t, this._length = e + 1;
            }, n.prototype.push = function (t, e, r) {
              var n = this.length() + 3;
              if (this._willBeOverCapacity(n)) return this._pushOne(t), this._pushOne(e), void this._pushOne(r);
              var i = this._front + n - 3;

              this._checkCapacity(n);

              var o = this._capacity - 1;
              this[i + 0 & o] = t, this[i + 1 & o] = e, this[i + 2 & o] = r, this._length = n;
            }, n.prototype.shift = function () {
              var t = this._front,
                  e = this[t];
              return this[t] = void 0, this._front = t + 1 & this._capacity - 1, this._length--, e;
            }, n.prototype.length = function () {
              return this._length;
            }, n.prototype._checkCapacity = function (t) {
              this._capacity < t && this._resizeTo(this._capacity << 1);
            }, n.prototype._resizeTo = function (t) {
              var e = this._capacity;
              this._capacity = t, function (t, e, r, n, i) {
                for (var o = 0; o < i; ++o) {
                  r[o + n] = t[o + e], t[o + e] = void 0;
                }
              }(this, 0, this, e, this._front + this._length & e - 1);
            }, e.exports = n;
          }, {}],
          27: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i) {
              var o = t("./util"),
                  s = function s(t) {
                return t.then(function (e) {
                  return a(e, t);
                });
              };

              function a(t, a) {
                var u = n(t);
                if (u instanceof e) return s(u);
                if (null === (t = o.asArray(t))) return i("expecting an array or an iterable object but got " + o.classString(t));
                var c = new e(r);
                void 0 !== a && c._propagateFrom(a, 3);

                for (var h = c._fulfill, l = c._reject, f = 0, p = t.length; f < p; ++f) {
                  var d = t[f];
                  (void 0 !== d || f in t) && e.cast(d)._then(h, l, void 0, c, null);
                }

                return c;
              }

              e.race = function (t) {
                return a(t, void 0);
              }, e.prototype.race = function () {
                return a(this, void 0);
              };
            };
          }, {
            "./util": 36
          }],
          28: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o, s) {
              var a = e._getDomain,
                  u = t("./util"),
                  c = u.tryCatch;

              function h(t, r, n, i) {
                this.constructor$(t);
                var s = a();
                this._fn = null === s ? r : u.domainBind(s, r), void 0 !== n && (n = e.resolve(n))._attachCancellationCallback(this), this._initialValue = n, this._currentCancellable = null, this._eachValues = i === o ? Array(this._length) : 0 === i ? null : void 0, this._promise._captureStackTrace(), this._init$(void 0, -5);
              }

              function l(t, e) {
                this.isFulfilled() ? e._resolve(t) : e._reject(t);
              }

              function f(t, e, r, i) {
                return "function" != typeof e ? n("expecting a function but got " + u.classString(e)) : new h(t, e, r, i).promise();
              }

              function p(t) {
                this.accum = t, this.array._gotAccum(t);
                var r = i(this.value, this.array._promise);
                return r instanceof e ? (this.array._currentCancellable = r, r._then(d, void 0, void 0, this, void 0)) : d.call(this, r);
              }

              function d(t) {
                var r,
                    n = this.array,
                    i = n._promise,
                    o = c(n._fn);
                i._pushContext(), (r = void 0 !== n._eachValues ? o.call(i._boundValue(), t, this.index, this.length) : o.call(i._boundValue(), this.accum, t, this.index, this.length)) instanceof e && (n._currentCancellable = r);

                var a = i._popContext();

                return s.checkForgottenReturns(r, a, void 0 !== n._eachValues ? "Promise.each" : "Promise.reduce", i), r;
              }

              u.inherits(h, r), h.prototype._gotAccum = function (t) {
                void 0 !== this._eachValues && null !== this._eachValues && t !== o && this._eachValues.push(t);
              }, h.prototype._eachComplete = function (t) {
                return null !== this._eachValues && this._eachValues.push(t), this._eachValues;
              }, h.prototype._init = function () {}, h.prototype._resolveEmptyArray = function () {
                this._resolve(void 0 !== this._eachValues ? this._eachValues : this._initialValue);
              }, h.prototype.shouldCopyValues = function () {
                return !1;
              }, h.prototype._resolve = function (t) {
                this._promise._resolveCallback(t), this._values = null;
              }, h.prototype._resultCancelled = function (t) {
                if (t === this._initialValue) return this._cancel();
                this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof e && this._currentCancellable.cancel(), this._initialValue instanceof e && this._initialValue.cancel());
              }, h.prototype._iterate = function (t) {
                var r, n;
                this._values = t;
                var i = t.length;
                if (void 0 !== this._initialValue ? (r = this._initialValue, n = 0) : (r = e.resolve(t[0]), n = 1), this._currentCancellable = r, !r.isRejected()) for (; n < i; ++n) {
                  var o = {
                    accum: null,
                    value: t[n],
                    index: n,
                    length: i,
                    array: this
                  };
                  r = r._then(p, void 0, void 0, o, void 0);
                }
                void 0 !== this._eachValues && (r = r._then(this._eachComplete, void 0, void 0, this, void 0)), r._then(l, l, void 0, r, this);
              }, e.prototype.reduce = function (t, e) {
                return f(this, t, e, null);
              }, e.reduce = function (t, e, r, n) {
                return f(t, e, r, n);
              };
            };
          }, {
            "./util": 36
          }],
          29: [function (t, i, o) {
            "use strict";

            var s,
                a,
                u,
                c,
                h,
                l = t("./util"),
                f = l.getNativePromise();

            if (l.isNode && "undefined" == typeof MutationObserver) {
              var p = r.setImmediate,
                  d = e.nextTick;
              s = l.isRecentNode ? function (t) {
                p.call(r, t);
              } : function (t) {
                d.call(e, t);
              };
            } else if ("function" == typeof f && "function" == typeof f.resolve) {
              var y = f.resolve();

              s = function s(t) {
                y.then(t);
              };
            } else s = "undefined" != typeof MutationObserver && ("undefined" == typeof window || !window.navigator || !window.navigator.standalone && !window.cordova) && "classList" in document.documentElement ? (a = document.createElement("div"), u = {
              attributes: !0
            }, c = !1, h = document.createElement("div"), new MutationObserver(function () {
              a.classList.toggle("foo"), c = !1;
            }).observe(h, u), function (t) {
              var e = new MutationObserver(function () {
                e.disconnect(), t();
              });
              e.observe(a, u), c || (c = !0, h.classList.toggle("foo"));
            }) : void 0 !== n ? function (t) {
              n(t);
            } : "undefined" != typeof setTimeout ? function (t) {
              setTimeout(t, 0);
            } : function () {
              throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
            };

            i.exports = s;
          }, {
            "./util": 36
          }],
          30: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n) {
              var i = e.PromiseInspection;

              function o(t) {
                this.constructor$(t);
              }

              t("./util").inherits(o, r), o.prototype._promiseResolved = function (t, e) {
                return this._values[t] = e, ++this._totalResolved >= this._length && (this._resolve(this._values), !0);
              }, o.prototype._promiseFulfilled = function (t, e) {
                var r = new i();
                return r._bitField = 33554432, r._settledValueField = t, this._promiseResolved(e, r);
              }, o.prototype._promiseRejected = function (t, e) {
                var r = new i();
                return r._bitField = 16777216, r._settledValueField = t, this._promiseResolved(e, r);
              }, e.settle = function (t) {
                return n.deprecated(".settle()", ".reflect()"), new o(t).promise();
              }, e.prototype.settle = function () {
                return e.settle(this);
              };
            };
          }, {
            "./util": 36
          }],
          31: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n) {
              var i = t("./util"),
                  o = t("./errors").RangeError,
                  s = t("./errors").AggregateError,
                  a = i.isArray,
                  u = {};

              function c(t) {
                this.constructor$(t), this._howMany = 0, this._unwrap = !1, this._initialized = !1;
              }

              function h(t, e) {
                if ((0 | e) !== e || e < 0) return n("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
                var r = new c(t),
                    i = r.promise();
                return r.setHowMany(e), r.init(), i;
              }

              i.inherits(c, r), c.prototype._init = function () {
                if (this._initialized) if (0 !== this._howMany) {
                  this._init$(void 0, -5);

                  var t = a(this._values);
                  !this._isResolved() && t && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()));
                } else this._resolve([]);
              }, c.prototype.init = function () {
                this._initialized = !0, this._init();
              }, c.prototype.setUnwrap = function () {
                this._unwrap = !0;
              }, c.prototype.howMany = function () {
                return this._howMany;
              }, c.prototype.setHowMany = function (t) {
                this._howMany = t;
              }, c.prototype._promiseFulfilled = function (t) {
                return this._addFulfilled(t), this._fulfilled() === this.howMany() && (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0);
              }, c.prototype._promiseRejected = function (t) {
                return this._addRejected(t), this._checkOutcome();
              }, c.prototype._promiseCancelled = function () {
                return this._values instanceof e || null == this._values ? this._cancel() : (this._addRejected(u), this._checkOutcome());
              }, c.prototype._checkOutcome = function () {
                if (this.howMany() > this._canPossiblyFulfill()) {
                  for (var t = new s(), e = this.length(); e < this._values.length; ++e) {
                    this._values[e] !== u && t.push(this._values[e]);
                  }

                  return t.length > 0 ? this._reject(t) : this._cancel(), !0;
                }

                return !1;
              }, c.prototype._fulfilled = function () {
                return this._totalResolved;
              }, c.prototype._rejected = function () {
                return this._values.length - this.length();
              }, c.prototype._addRejected = function (t) {
                this._values.push(t);
              }, c.prototype._addFulfilled = function (t) {
                this._values[this._totalResolved++] = t;
              }, c.prototype._canPossiblyFulfill = function () {
                return this.length() - this._rejected();
              }, c.prototype._getRangeError = function (t) {
                var e = "Input array must contain at least " + this._howMany + " items but contains only " + t + " items";
                return new o(e);
              }, c.prototype._resolveEmptyArray = function () {
                this._reject(this._getRangeError(0));
              }, e.some = function (t, e) {
                return h(t, e);
              }, e.prototype.some = function (t) {
                return h(this, t);
              }, e._SomePromiseArray = c;
            };
          }, {
            "./errors": 12,
            "./util": 36
          }],
          32: [function (t, e, r) {
            "use strict";

            e.exports = function (t) {
              function e(t) {
                void 0 !== t ? (t = t._target(), this._bitField = t._bitField, this._settledValueField = t._isFateSealed() ? t._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0);
              }

              e.prototype._settledValue = function () {
                return this._settledValueField;
              };

              var r = e.prototype.value = function () {
                if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
                return this._settledValue();
              },
                  n = e.prototype.error = e.prototype.reason = function () {
                if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
                return this._settledValue();
              },
                  i = e.prototype.isFulfilled = function () {
                return 0 != (33554432 & this._bitField);
              },
                  o = e.prototype.isRejected = function () {
                return 0 != (16777216 & this._bitField);
              },
                  s = e.prototype.isPending = function () {
                return 0 == (50397184 & this._bitField);
              },
                  a = e.prototype.isResolved = function () {
                return 0 != (50331648 & this._bitField);
              };

              e.prototype.isCancelled = function () {
                return 0 != (8454144 & this._bitField);
              }, t.prototype.__isCancelled = function () {
                return 65536 == (65536 & this._bitField);
              }, t.prototype._isCancelled = function () {
                return this._target().__isCancelled();
              }, t.prototype.isCancelled = function () {
                return 0 != (8454144 & this._target()._bitField);
              }, t.prototype.isPending = function () {
                return s.call(this._target());
              }, t.prototype.isRejected = function () {
                return o.call(this._target());
              }, t.prototype.isFulfilled = function () {
                return i.call(this._target());
              }, t.prototype.isResolved = function () {
                return a.call(this._target());
              }, t.prototype.value = function () {
                return r.call(this._target());
              }, t.prototype.reason = function () {
                var t = this._target();

                return t._unsetRejectionIsUnhandled(), n.call(t);
              }, t.prototype._value = function () {
                return this._settledValue();
              }, t.prototype._reason = function () {
                return this._unsetRejectionIsUnhandled(), this._settledValue();
              }, t.PromiseInspection = e;
            };
          }, {}],
          33: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r) {
              var n = t("./util"),
                  i = n.errorObj,
                  o = n.isObject,
                  s = {}.hasOwnProperty;
              return function (t, a) {
                if (o(t)) {
                  if (t instanceof e) return t;

                  var u = function (t) {
                    try {
                      return function (t) {
                        return t.then;
                      }(t);
                    } catch (t) {
                      return i.e = t, i;
                    }
                  }(t);

                  if (u === i) {
                    a && a._pushContext();
                    var c = e.reject(u.e);
                    return a && a._popContext(), c;
                  }

                  if ("function" == typeof u) return function (t) {
                    try {
                      return s.call(t, "_promise0");
                    } catch (t) {
                      return !1;
                    }
                  }(t) ? (c = new e(r), t._then(c._fulfill, c._reject, void 0, c, null), c) : function (t, o, s) {
                    var a = new e(r),
                        u = a;
                    s && s._pushContext(), a._captureStackTrace(), s && s._popContext();
                    var c = !0,
                        h = n.tryCatch(o).call(t, function (t) {
                      a && (a._resolveCallback(t), a = null);
                    }, function (t) {
                      a && (a._rejectCallback(t, c, !0), a = null);
                    });
                    return c = !1, a && h === i && (a._rejectCallback(h.e, !0, !0), a = null), u;
                  }(t, u, a);
                }

                return t;
              };
            };
          }, {
            "./util": 36
          }],
          34: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n) {
              var i = t("./util"),
                  o = e.TimeoutError;

              function s(t) {
                this.handle = t;
              }

              s.prototype._resultCancelled = function () {
                clearTimeout(this.handle);
              };

              var a = function a(t) {
                return u(+this).thenReturn(t);
              },
                  u = e.delay = function (t, i) {
                var o, u;
                return void 0 !== i ? (o = e.resolve(i)._then(a, null, null, t, void 0), n.cancellation() && i instanceof e && o._setOnCancel(i)) : (o = new e(r), u = setTimeout(function () {
                  o._fulfill();
                }, +t), n.cancellation() && o._setOnCancel(new s(u)), o._captureStackTrace()), o._setAsyncGuaranteed(), o;
              };

              function c(t) {
                return clearTimeout(this.handle), t;
              }

              function h(t) {
                throw clearTimeout(this.handle), t;
              }

              e.prototype.delay = function (t) {
                return u(t, this);
              }, e.prototype.timeout = function (t, e) {
                var r, a;
                t = +t;
                var u = new s(setTimeout(function () {
                  r.isPending() && function (t, e, r) {
                    var n;
                    n = "string" != typeof e ? e instanceof Error ? e : new o("operation timed out") : new o(e), i.markAsOriginatingFromRejection(n), t._attachExtraTrace(n), t._reject(n), null != r && r.cancel();
                  }(r, e, a);
                }, t));
                return n.cancellation() ? (a = this.then(), (r = a._then(c, h, void 0, u, void 0))._setOnCancel(u)) : r = this._then(c, h, void 0, u, void 0), r;
              };
            };
          }, {
            "./util": 36
          }],
          35: [function (t, e, r) {
            "use strict";

            e.exports = function (e, r, n, i, o, s) {
              var a = t("./util"),
                  u = t("./errors").TypeError,
                  c = t("./util").inherits,
                  h = a.errorObj,
                  l = a.tryCatch,
                  f = {};

              function p(t) {
                setTimeout(function () {
                  throw t;
                }, 0);
              }

              function d(t, r) {
                var i = 0,
                    s = t.length,
                    a = new e(o);
                return function o() {
                  if (i >= s) return a._fulfill();

                  var u = function (t) {
                    var e = n(t);
                    return e !== t && "function" == typeof t._isDisposable && "function" == typeof t._getDisposer && t._isDisposable() && e._setDisposable(t._getDisposer()), e;
                  }(t[i++]);

                  if (u instanceof e && u._isDisposable()) {
                    try {
                      u = n(u._getDisposer().tryDispose(r), t.promise);
                    } catch (t) {
                      return p(t);
                    }

                    if (u instanceof e) return u._then(o, p, null, null, null);
                  }

                  o();
                }(), a;
              }

              function y(t, e, r) {
                this._data = t, this._promise = e, this._context = r;
              }

              function v(t, e, r) {
                this.constructor$(t, e, r);
              }

              function m(t) {
                return y.isDisposer(t) ? (this.resources[this.index]._setDisposable(t), t.promise()) : t;
              }

              function g(t) {
                this.length = t, this.promise = null, this[t - 1] = null;
              }

              y.prototype.data = function () {
                return this._data;
              }, y.prototype.promise = function () {
                return this._promise;
              }, y.prototype.resource = function () {
                return this.promise().isFulfilled() ? this.promise().value() : f;
              }, y.prototype.tryDispose = function (t) {
                var e = this.resource(),
                    r = this._context;
                void 0 !== r && r._pushContext();
                var n = e !== f ? this.doDispose(e, t) : null;
                return void 0 !== r && r._popContext(), this._promise._unsetDisposable(), this._data = null, n;
              }, y.isDisposer = function (t) {
                return null != t && "function" == typeof t.resource && "function" == typeof t.tryDispose;
              }, c(v, y), v.prototype.doDispose = function (t, e) {
                return this.data().call(t, t, e);
              }, g.prototype._resultCancelled = function () {
                for (var t = this.length, r = 0; r < t; ++r) {
                  var n = this[r];
                  n instanceof e && n.cancel();
                }
              }, e.using = function () {
                var t = arguments.length;
                if (t < 2) return r("you must pass at least 2 arguments to Promise.using");
                var i,
                    o = arguments[t - 1];
                if ("function" != typeof o) return r("expecting a function but got " + a.classString(o));
                var u = !0;
                2 === t && Array.isArray(arguments[0]) ? (t = (i = arguments[0]).length, u = !1) : (i = arguments, t--);

                for (var c = new g(t), f = 0; f < t; ++f) {
                  var p = i[f];

                  if (y.isDisposer(p)) {
                    var v = p;

                    (p = p.promise())._setDisposable(v);
                  } else {
                    var _ = n(p);

                    _ instanceof e && (p = _._then(m, null, null, {
                      resources: c,
                      index: f
                    }, void 0));
                  }

                  c[f] = p;
                }

                var b = new Array(c.length);

                for (f = 0; f < b.length; ++f) {
                  b[f] = e.resolve(c[f]).reflect();
                }

                var w = e.all(b).then(function (t) {
                  for (var e = 0; e < t.length; ++e) {
                    var r = t[e];
                    if (r.isRejected()) return h.e = r.error(), h;
                    if (!r.isFulfilled()) return void w.cancel();
                    t[e] = r.value();
                  }

                  E._pushContext(), o = l(o);

                  var n = u ? o.apply(void 0, t) : o(t),
                      i = E._popContext();

                  return s.checkForgottenReturns(n, i, "Promise.using", E), n;
                }),
                    E = w.lastly(function () {
                  var t = new e.PromiseInspection(w);
                  return d(c, t);
                });
                return c.promise = E, E._setOnCancel(c), E;
              }, e.prototype._setDisposable = function (t) {
                this._bitField = 131072 | this._bitField, this._disposer = t;
              }, e.prototype._isDisposable = function () {
                return (131072 & this._bitField) > 0;
              }, e.prototype._getDisposer = function () {
                return this._disposer;
              }, e.prototype._unsetDisposable = function () {
                this._bitField = -131073 & this._bitField, this._disposer = void 0;
              }, e.prototype.disposer = function (t) {
                if ("function" == typeof t) return new v(t, this, i());
                throw new u();
              };
            };
          }, {
            "./errors": 12,
            "./util": 36
          }],
          36: [function (t, n, i) {
            "use strict";

            var o = t("./es5"),
                s = "undefined" == typeof navigator,
                a = {
              e: {}
            },
                u,
                c = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== r ? r : void 0 !== this ? this : null;

            function h() {
              try {
                var t = u;
                return u = null, t.apply(this, arguments);
              } catch (t) {
                return a.e = t, a;
              }
            }

            function l(t) {
              return u = t, h;
            }

            var f = function f(t, e) {
              var r = {}.hasOwnProperty;

              function n() {
                for (var n in this.constructor = t, this.constructor$ = e, e.prototype) {
                  r.call(e.prototype, n) && "$" !== n.charAt(n.length - 1) && (this[n + "$"] = e.prototype[n]);
                }
              }

              return n.prototype = e.prototype, t.prototype = new n(), t.prototype;
            };

            function p(t) {
              return null == t || !0 === t || !1 === t || "string" == typeof t || "number" == typeof t;
            }

            function d(t) {
              return "function" == typeof t || "object" == typeof t && null !== t;
            }

            function y(t) {
              return p(t) ? new Error(S(t)) : t;
            }

            function v(t, e) {
              var r,
                  n = t.length,
                  i = new Array(n + 1);

              for (r = 0; r < n; ++r) {
                i[r] = t[r];
              }

              return i[r] = e, i;
            }

            function m(t, e, r) {
              if (!o.isES5) return {}.hasOwnProperty.call(t, e) ? t[e] : void 0;
              var n = Object.getOwnPropertyDescriptor(t, e);
              return null != n ? null == n.get && null == n.set ? n.value : r : void 0;
            }

            function g(t, e, r) {
              if (p(t)) return t;
              var n = {
                value: r,
                configurable: !0,
                enumerable: !1,
                writable: !0
              };
              return o.defineProperty(t, e, n), t;
            }

            function _(t) {
              throw t;
            }

            var b = function () {
              var t = [Array.prototype, Object.prototype, Function.prototype],
                  e = function e(_e2) {
                for (var r = 0; r < t.length; ++r) {
                  if (t[r] === _e2) return !0;
                }

                return !1;
              };

              if (o.isES5) {
                var r = Object.getOwnPropertyNames;
                return function (t) {
                  for (var n = [], i = Object.create(null); null != t && !e(t);) {
                    var s;

                    try {
                      s = r(t);
                    } catch (t) {
                      return n;
                    }

                    for (var a = 0; a < s.length; ++a) {
                      var u = s[a];

                      if (!i[u]) {
                        i[u] = !0;
                        var c = Object.getOwnPropertyDescriptor(t, u);
                        null != c && null == c.get && null == c.set && n.push(u);
                      }
                    }

                    t = o.getPrototypeOf(t);
                  }

                  return n;
                };
              }

              var n = {}.hasOwnProperty;
              return function (r) {
                if (e(r)) return [];
                var i = [];

                t: for (var o in r) {
                  if (n.call(r, o)) i.push(o);else {
                    for (var s = 0; s < t.length; ++s) {
                      if (n.call(t[s], o)) continue t;
                    }

                    i.push(o);
                  }
                }

                return i;
              };
            }(),
                w = /this\s*\.\s*\S+\s*=/;

            function E(t) {
              try {
                if ("function" == typeof t) {
                  var e = o.names(t.prototype),
                      r = o.isES5 && e.length > 1,
                      n = e.length > 0 && !(1 === e.length && "constructor" === e[0]),
                      i = w.test(t + "") && o.names(t).length > 0;
                  if (r || n || i) return !0;
                }

                return !1;
              } catch (t) {
                return !1;
              }
            }

            function k(t) {
              function e() {}

              e.prototype = t;
              var r = new e();

              function n() {
                return typeof r.foo;
              }

              return n(), n(), t;
            }

            var x = /^[a-z$_][a-z$_0-9]*$/i;

            function C(t) {
              return x.test(t);
            }

            function A(t, e, r) {
              for (var n = new Array(t), i = 0; i < t; ++i) {
                n[i] = e + i + r;
              }

              return n;
            }

            function S(t) {
              try {
                return t + "";
              } catch (t) {
                return "[no string representation]";
              }
            }

            function T(t) {
              return t instanceof Error || null !== t && "object" == typeof t && "string" == typeof t.message && "string" == typeof t.name;
            }

            function R(t) {
              try {
                g(t, "isOperational", !0);
              } catch (t) {}
            }

            function O(t) {
              return null != t && (t instanceof Error.__BluebirdErrorTypes__.OperationalError || !0 === t.isOperational);
            }

            function j(t) {
              return T(t) && o.propertyIsWritable(t, "stack");
            }

            var P = "stack" in new Error() ? function (t) {
              return j(t) ? t : new Error(S(t));
            } : function (t) {
              if (j(t)) return t;

              try {
                throw new Error(S(t));
              } catch (t) {
                return t;
              }
            };

            function I(t) {
              return {}.toString.call(t);
            }

            function B(t, e, r) {
              for (var n = o.names(t), i = 0; i < n.length; ++i) {
                var s = n[i];
                if (r(s)) try {
                  o.defineProperty(e, s, o.getDescriptor(t, s));
                } catch (t) {}
              }
            }

            var F = function F(t) {
              return o.isArray(t) ? t : null;
            };

            if ("undefined" != typeof Symbol && Symbol.iterator) {
              var L = "function" == typeof Array.from ? function (t) {
                return Array.from(t);
              } : function (t) {
                for (var e, r = [], n = t[Symbol.iterator](); !(e = n.next()).done;) {
                  r.push(e.value);
                }

                return r;
              };

              F = function F(t) {
                return o.isArray(t) ? t : null != t && "function" == typeof t[Symbol.iterator] ? L(t) : null;
              };
            }

            var M = void 0 !== e && "[object process]" === I(e).toLowerCase(),
                D = void 0 !== e && void 0 !== e.env;

            function U(t) {
              return D ? e.env[t] : void 0;
            }

            function N() {
              if ("function" == typeof Promise) try {
                var t = new Promise(function () {});
                if ("[object Promise]" === {}.toString.call(t)) return Promise;
              } catch (t) {}
            }

            function H(t, e) {
              return t.bind(e);
            }

            var q = {
              isClass: E,
              isIdentifier: C,
              inheritedDataKeys: b,
              getDataPropertyOrDefault: m,
              thrower: _,
              isArray: o.isArray,
              asArray: F,
              notEnumerableProp: g,
              isPrimitive: p,
              isObject: d,
              isError: T,
              canEvaluate: s,
              errorObj: a,
              tryCatch: l,
              inherits: f,
              withAppended: v,
              maybeWrapAsError: y,
              toFastProperties: k,
              filledRange: A,
              toString: S,
              canAttachTrace: j,
              ensureErrorObject: P,
              originatesFromRejection: O,
              markAsOriginatingFromRejection: R,
              classString: I,
              copyDescriptors: B,
              hasDevTools: "undefined" != typeof chrome && chrome && "function" == typeof chrome.loadTimes,
              isNode: M,
              hasEnvVariables: D,
              env: U,
              global: c,
              getNativePromise: N,
              domainBind: H
            },
                V;
            q.isRecentNode = q.isNode && (e.versions && e.versions.node ? V = e.versions.node.split(".").map(Number) : e.version && (V = e.version.split(".").map(Number)), 0 === V[0] && V[1] > 10 || V[0] > 0), q.isNode && q.toFastProperties(e);

            try {
              throw new Error();
            } catch (t) {
              q.lastLineError = t;
            }

            n.exports = q;
          }, {
            "./es5": 13
          }]
        }, {}, [4])(4);
      }, t.exports = i(), "undefined" != typeof window && null !== window ? window.P = window.Promise : "undefined" != typeof self && null !== self && (self.P = self.Promise);
    }).call(this, r(15), r(3), r(66).setImmediate);
  }, function (t, e) {
    function r(e) {
      return t.exports = r = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      }, r(e);
    }

    t.exports = r;
  }, function (t, e, r) {
    (function (t) {
      function r(t) {
        return Object.prototype.toString.call(t);
      }

      e.isArray = function (t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === r(t);
      }, e.isBoolean = function (t) {
        return "boolean" == typeof t;
      }, e.isNull = function (t) {
        return null === t;
      }, e.isNullOrUndefined = function (t) {
        return null == t;
      }, e.isNumber = function (t) {
        return "number" == typeof t;
      }, e.isString = function (t) {
        return "string" == typeof t;
      }, e.isSymbol = function (t) {
        return "symbol" == typeof t;
      }, e.isUndefined = function (t) {
        return void 0 === t;
      }, e.isRegExp = function (t) {
        return "[object RegExp]" === r(t);
      }, e.isObject = function (t) {
        return "object" == typeof t && null !== t;
      }, e.isDate = function (t) {
        return "[object Date]" === r(t);
      }, e.isError = function (t) {
        return "[object Error]" === r(t) || t instanceof Error;
      }, e.isFunction = function (t) {
        return "function" == typeof t;
      }, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t;
      }, e.isBuffer = t.isBuffer;
    }).call(this, r(0).Buffer);
  }, function (t, e, r) {
    "use strict";

    var n = r(13),
        i = r(14);

    function o() {
      this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
    }

    e.BlockHash = o, o.prototype.update = function (t, e) {
      if (t = n.toArray(t, e), this.pending ? this.pending = this.pending.concat(t) : this.pending = t, this.pendingTotal += t.length, this.pending.length >= this._delta8) {
        var r = (t = this.pending).length % this._delta8;
        this.pending = t.slice(t.length - r, t.length), 0 === this.pending.length && (this.pending = null), t = n.join32(t, 0, t.length - r, this.endian);

        for (var i = 0; i < t.length; i += this._delta32) {
          this._update(t, i, i + this._delta32);
        }
      }

      return this;
    }, o.prototype.digest = function (t) {
      return this.update(this._pad()), i(null === this.pending), this._digest(t);
    }, o.prototype._pad = function () {
      var t = this.pendingTotal,
          e = this._delta8,
          r = e - (t + this.padLength) % e,
          n = new Array(r + this.padLength);
      n[0] = 128;

      for (var i = 1; i < r; i++) {
        n[i] = 0;
      }

      if (t <<= 3, "big" === this.endian) {
        for (var o = 8; o < this.padLength; o++) {
          n[i++] = 0;
        }

        n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = t >>> 24 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 8 & 255, n[i++] = 255 & t;
      } else for (n[i++] = 255 & t, n[i++] = t >>> 8 & 255, n[i++] = t >>> 16 & 255, n[i++] = t >>> 24 & 255, n[i++] = 0, n[i++] = 0, n[i++] = 0, n[i++] = 0, o = 8; o < this.padLength; o++) {
        n[i++] = 0;
      }

      return n;
    };
  }, function (t, e, r) {
    (function (t, e) {
      (function () {
        var r, n, i, o;

        for (i = (null !== t ? t.exports : void 0) || (window.Base58 = {}), r = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz", n = {}, o = 0; o < r.length;) {
          n[r.charAt(o)] = o, o++;
        }

        i.encode = function (t) {
          var e, n, i;
          if (0 === t.length) return "";

          for (o = void 0, i = void 0, n = [0], o = 0; o < t.length;) {
            for (i = 0; i < n.length;) {
              n[i] <<= 8, i++;
            }

            for (n[0] += t[o], e = 0, i = 0; i < n.length;) {
              n[i] += e, e = n[i] / 58 | 0, n[i] %= 58, ++i;
            }

            for (; e;) {
              n.push(e % 58), e = e / 58 | 0;
            }

            o++;
          }

          for (o = 0; 0 === t[o] && o < t.length - 1;) {
            n.push(0), o++;
          }

          return n.reverse().map(function (t) {
            return r[t];
          }).join("");
        }, i.decode = function (t) {
          var r, i, s, a;
          if (0 === t.length) return new ("undefined" != typeof Uint8Array && null !== Uint8Array ? Uint8Array : e)(0);

          for (o = void 0, a = void 0, r = [0], o = 0; o < t.length;) {
            if (!((i = t[o]) in n)) throw "Base58.decode received unacceptable input. Character '" + i + "' is not in the Base58 alphabet.";

            for (a = 0; a < r.length;) {
              r[a] *= 58, a++;
            }

            for (r[0] += n[i], s = 0, a = 0; a < r.length;) {
              r[a] += s, s = r[a] >> 8, r[a] &= 255, ++a;
            }

            for (; s;) {
              r.push(255 & s), s >>= 8;
            }

            o++;
          }

          for (o = 0; "1" === t[o] && o < t.length - 1;) {
            r.push(0), o++;
          }

          return new ("undefined" != typeof Uint8Array && null !== Uint8Array ? Uint8Array : e)(r.reverse());
        };
      }).call(this);
    }).call(this, r(29)(t), r(0).Buffer);
  }, function (t, e) {
    var r = {}.toString;

    t.exports = Array.isArray || function (t) {
      return "[object Array]" == r.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: function nextTick(t, r, n, i) {
          if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
          var o,
              s,
              a = arguments.length;

          switch (a) {
            case 0:
            case 1:
              return e.nextTick(t);

            case 2:
              return e.nextTick(function () {
                t.call(null, r);
              });

            case 3:
              return e.nextTick(function () {
                t.call(null, r, n);
              });

            case 4:
              return e.nextTick(function () {
                t.call(null, r, n, i);
              });

            default:
              for (o = new Array(a - 1), s = 0; s < o.length;) {
                o[s++] = arguments[s];
              }

              return e.nextTick(function () {
                t.apply(null, o);
              });
          }
        }
      } : t.exports = e;
    }).call(this, r(15));
  }, function (t, e, r) {
    var n = r(0),
        i = n.Buffer;

    function o(t, e) {
      for (var r in t) {
        e[r] = t[r];
      }
    }

    function s(t, e, r) {
      return i(t, e, r);
    }

    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = n : (o(n, e), e.Buffer = s), o(i, s), s.from = function (t, e, r) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return i(t, e, r);
    }, s.alloc = function (t, e, r) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var n = i(t);
      return void 0 !== e ? "string" == typeof r ? n.fill(e, r) : n.fill(e) : n.fill(0), n;
    }, s.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return i(t);
    }, s.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return n.SlowBuffer(t);
    };
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function get() {
          return t.l;
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function get() {
          return t.i;
        }
      }), t.webpackPolyfill = 1), t;
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(1),
          i = n(r(5)),
          o = n(r(6)),
          s = n(r(7)),
          a = n(r(10)),
          u = r(11).sign,
          c = r(2),
          h = c.addressToKey,
          l = c.isValidPrivateEcAddress,
          f = c.isValidPublicEcAddress,
          p = r(19).Entry,
          d = r(8),
          y = d.sha256,
          v = d.sha256d,
          m = r(9).CHAIN_CREATION_COST,
          g = function () {
        function t(e) {
          if ((0, s.default)(this, t), e instanceof p) {
            var r = A(e);
            this.firstEntry = p.builder(e).chainId(r).build(), this.id = r;
          } else {
            if (!(e.firstEntry instanceof p)) throw new Error("Argument of Chain constructor must be an instance of Entry or Chain.");
            var n = A(e.firstEntry);
            this.firstEntry = p.builder(e.firstEntry).chainId(n).build(), this.id = n;
          }

          Object.freeze(this);
        }

        return (0, a.default)(t, [{
          key: "ecCost",
          value: function value() {
            return m + this.firstEntry.ecCost();
          }
        }, {
          key: "toObject",
          value: function value() {
            return {
              firstEntry: this.firstEntry.toObject(),
              id: this.idHex
            };
          }
        }, {
          key: "idHex",
          get: function get() {
            return this.id.toString("hex");
          }
        }]), t;
      }();

      function _(t, r, n) {
        C(t);
        var i,
            o,
            s = E(t);

        if (l(r)) {
          var a = h(r),
              c = u.keyPair.fromSeed(a);
          i = e.from(c.publicKey), o = e.from(u.detached(s, c.secretKey));
        } else {
          if (!f(r)) throw new Error("".concat(r, " is not a valid EC address"));
          if (!n) throw new Error("Signature of the commit missing.");
          if (console.warn("composeChainCommit with signature is deprecated. Use composeEntryCommitDelegateSig."), i = h(r), o = e.from(n, "hex"), !u.detached.verify(s, o, i)) throw new Error("Invalid signature manually provided for the chain commit. (first entry timestamp not fixed?)");
        }

        return e.concat([s, i, o]);
      }

      function b(t, e, r) {
        return w.apply(this, arguments);
      }

      function w() {
        return (w = (0, o.default)(i.default.mark(function t(r, n, o) {
          var s, a, c;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if (C(r), f(n)) {
                    t.next = 3;
                    break;
                  }

                  throw new Error("".concat(n, " is not a valid public EC address"));

                case 3:
                  if ("function" == typeof o) {
                    t.next = 5;
                    break;
                  }

                  throw new Error("sign must be a function");

                case 5:
                  return s = E(r), t.t0 = e, t.next = 9, o(s);

                case 9:
                  if (t.t1 = t.sent, a = t.t0.from.call(t.t0, t.t1, "hex"), c = h(n), u.detached.verify(s, a, c)) {
                    t.next = 14;
                    break;
                  }

                  throw new Error("Invalid signature manually returned by the signing function for the chain commit.");

                case 14:
                  return t.abrupt("return", e.concat([s, c, a]));

                case 15:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).apply(this, arguments);
      }

      function E(t) {
        C(t);
        var r = t.firstEntry,
            n = r.hash(),
            i = e.alloc(104);
        return i.writeInt8(0), i.writeIntBE(r.timestamp || Date.now(), 1, 6), v(t.id).copy(i, 7), v(e.concat([n, t.id])).copy(i, 39), n.copy(i, 71), i.writeInt8(t.ecCost(), 103), i;
      }

      function k(t) {
        return C(t), t.firstEntry.marshalBinary();
      }

      function x() {
        return (x = (0, o.default)(i.default.mark(function t(e, r, n) {
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, b(e, r, n);

                case 2:
                  return t.t0 = t.sent, t.t1 = k(e), t.abrupt("return", {
                    commit: t.t0,
                    reveal: t.t1
                  });

                case 5:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        }))).apply(this, arguments);
      }

      function C(t) {
        if (!(t instanceof g)) throw new Error("Argument must be an instance of Chain");
      }

      function A(t) {
        var r = t.extIds.map(y),
            n = e.concat(r);
        return y(n);
      }

      t.exports = {
        Chain: g,
        computeChainTxId: function computeChainTxId(t) {
          return C(t), y(E(t));
        },
        computeChainId: A,
        composeChainCommit: _,
        composeChainCommitDelegateSig: b,
        composeChainReveal: k,
        composeChain: function composeChain(t, e, r) {
          return {
            commit: _(t, e, r),
            reveal: k(t)
          };
        },
        composeChainDelegateSig: function composeChainDelegateSig(t, e, r) {
          return x.apply(this, arguments);
        },
        composeChainLedger: E,
        validateChainInstance: C
      };
    }).call(this, r(0).Buffer);
  }, function (t, e, r) {
    var n = function (t) {
      "use strict";

      var e,
          r = Object.prototype,
          n = r.hasOwnProperty,
          i = "function" == typeof Symbol ? Symbol : {},
          o = i.iterator || "@@iterator",
          s = i.asyncIterator || "@@asyncIterator",
          a = i.toStringTag || "@@toStringTag";

      function u(t, e, r, n) {
        var i = e && e.prototype instanceof y ? e : y,
            o = Object.create(i.prototype),
            s = new S(n || []);
        return o._invoke = function (t, e, r) {
          var n = h;
          return function (i, o) {
            if (n === f) throw new Error("Generator is already running");

            if (n === p) {
              if ("throw" === i) throw o;
              return R();
            }

            for (r.method = i, r.arg = o;;) {
              var s = r.delegate;

              if (s) {
                var a = x(s, r);

                if (a) {
                  if (a === d) continue;
                  return a;
                }
              }

              if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
                if (n === h) throw n = p, r.arg;
                r.dispatchException(r.arg);
              } else "return" === r.method && r.abrupt("return", r.arg);
              n = f;
              var u = c(t, e, r);

              if ("normal" === u.type) {
                if (n = r.done ? p : l, u.arg === d) continue;
                return {
                  value: u.arg,
                  done: r.done
                };
              }

              "throw" === u.type && (n = p, r.method = "throw", r.arg = u.arg);
            }
          };
        }(t, r, s), o;
      }

      function c(t, e, r) {
        try {
          return {
            type: "normal",
            arg: t.call(e, r)
          };
        } catch (t) {
          return {
            type: "throw",
            arg: t
          };
        }
      }

      t.wrap = u;
      var h = "suspendedStart",
          l = "suspendedYield",
          f = "executing",
          p = "completed",
          d = {};

      function y() {}

      function v() {}

      function m() {}

      var g = {};

      g[o] = function () {
        return this;
      };

      var _ = Object.getPrototypeOf,
          b = _ && _(_(T([])));

      b && b !== r && n.call(b, o) && (g = b);
      var w = m.prototype = y.prototype = Object.create(g);

      function E(t) {
        ["next", "throw", "return"].forEach(function (e) {
          t[e] = function (t) {
            return this._invoke(e, t);
          };
        });
      }

      function k(t) {
        var e;

        this._invoke = function (r, i) {
          function o() {
            return new Promise(function (e, o) {
              !function e(r, i, o, s) {
                var a = c(t[r], t, i);

                if ("throw" !== a.type) {
                  var u = a.arg,
                      h = u.value;
                  return h && "object" == typeof h && n.call(h, "__await") ? Promise.resolve(h.__await).then(function (t) {
                    e("next", t, o, s);
                  }, function (t) {
                    e("throw", t, o, s);
                  }) : Promise.resolve(h).then(function (t) {
                    u.value = t, o(u);
                  }, function (t) {
                    return e("throw", t, o, s);
                  });
                }

                s(a.arg);
              }(r, i, e, o);
            });
          }

          return e = e ? e.then(o, o) : o();
        };
      }

      function x(t, r) {
        var n = t.iterator[r.method];

        if (n === e) {
          if (r.delegate = null, "throw" === r.method) {
            if (t.iterator.return && (r.method = "return", r.arg = e, x(t, r), "throw" === r.method)) return d;
            r.method = "throw", r.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return d;
        }

        var i = c(n, t.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, d;
        var o = i.arg;
        return o ? o.done ? (r[t.resultName] = o.value, r.next = t.nextLoc, "return" !== r.method && (r.method = "next", r.arg = e), r.delegate = null, d) : o : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, d);
      }

      function C(t) {
        var e = {
          tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
      }

      function A(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
      }

      function S(t) {
        this.tryEntries = [{
          tryLoc: "root"
        }], t.forEach(C, this), this.reset(!0);
      }

      function T(t) {
        if (t) {
          var r = t[o];
          if (r) return r.call(t);
          if ("function" == typeof t.next) return t;

          if (!isNaN(t.length)) {
            var i = -1,
                s = function r() {
              for (; ++i < t.length;) {
                if (n.call(t, i)) return r.value = t[i], r.done = !1, r;
              }

              return r.value = e, r.done = !0, r;
            };

            return s.next = s;
          }
        }

        return {
          next: R
        };
      }

      function R() {
        return {
          value: e,
          done: !0
        };
      }

      return v.prototype = w.constructor = m, m.constructor = v, m[a] = v.displayName = "GeneratorFunction", t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === v || "GeneratorFunction" === (e.displayName || e.name));
      }, t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, m) : (t.__proto__ = m, a in t || (t[a] = "GeneratorFunction")), t.prototype = Object.create(w), t;
      }, t.awrap = function (t) {
        return {
          __await: t
        };
      }, E(k.prototype), k.prototype[s] = function () {
        return this;
      }, t.AsyncIterator = k, t.async = function (e, r, n, i) {
        var o = new k(u(e, r, n, i));
        return t.isGeneratorFunction(r) ? o : o.next().then(function (t) {
          return t.done ? t.value : o.next();
        });
      }, E(w), w[a] = "Generator", w[o] = function () {
        return this;
      }, w.toString = function () {
        return "[object Generator]";
      }, t.keys = function (t) {
        var e = [];

        for (var r in t) {
          e.push(r);
        }

        return e.reverse(), function r() {
          for (; e.length;) {
            var n = e.pop();
            if (n in t) return r.value = n, r.done = !1, r;
          }

          return r.done = !0, r;
        };
      }, t.values = T, S.prototype = {
        constructor: S,
        reset: function reset(t) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(A), !t) for (var r in this) {
            "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = e);
          }
        },
        stop: function stop() {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(t) {
          if (this.done) throw t;
          var r = this;

          function i(n, i) {
            return a.type = "throw", a.arg = t, r.next = n, i && (r.method = "next", r.arg = e), !!i;
          }

          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var s = this.tryEntries[o],
                a = s.completion;
            if ("root" === s.tryLoc) return i("end");

            if (s.tryLoc <= this.prev) {
              var u = n.call(s, "catchLoc"),
                  c = n.call(s, "finallyLoc");

              if (u && c) {
                if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
                if (this.prev < s.finallyLoc) return i(s.finallyLoc);
              } else if (u) {
                if (this.prev < s.catchLoc) return i(s.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < s.finallyLoc) return i(s.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var i = this.tryEntries[r];

            if (i.tryLoc <= this.prev && n.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var o = i;
              break;
            }
          }

          o && ("break" === t || "continue" === t) && o.tryLoc <= e && e <= o.finallyLoc && (o = null);
          var s = o ? o.completion : {};
          return s.type = t, s.arg = e, o ? (this.method = "next", this.next = o.finallyLoc, d) : this.complete(s);
        },
        complete: function complete(t, e) {
          if ("throw" === t.type) throw t.arg;
          return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), d;
        },
        finish: function finish(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];
            if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), A(r), d;
          }
        },
        catch: function _catch(t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var r = this.tryEntries[e];

            if (r.tryLoc === t) {
              var n = r.completion;

              if ("throw" === n.type) {
                var i = n.arg;
                A(r);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(t, r, n) {
          return this.delegate = {
            iterator: T(t),
            resultName: r,
            nextLoc: n
          }, "next" === this.method && (this.arg = e), d;
        }
      }, t;
    }(t.exports);

    try {
      regeneratorRuntime = n;
    } catch (t) {
      Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (t, e, r) {
    var n = r(16),
        i = r(33);

    t.exports = function (t, e) {
      return !e || "object" !== n(e) && "function" != typeof e ? i(t) : e;
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t;
    };
  }, function (t, e, r) {
    var n = r(35);

    t.exports = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && n(t, e);
    };
  }, function (t, e) {
    function r(e, n) {
      return t.exports = r = Object.setPrototypeOf || function (t, e) {
        return t.__proto__ = e, t;
      }, r(e, n);
    }

    t.exports = r;
  }, function (t, e, r) {
    "use strict";

    e.byteLength = function (t) {
      var e = c(t),
          r = e[0],
          n = e[1];
      return 3 * (r + n) / 4 - n;
    }, e.toByteArray = function (t) {
      var e,
          r,
          n = c(t),
          s = n[0],
          a = n[1],
          u = new o(function (t, e, r) {
        return 3 * (e + r) / 4 - r;
      }(0, s, a)),
          h = 0,
          l = a > 0 ? s - 4 : s;

      for (r = 0; r < l; r += 4) {
        e = i[t.charCodeAt(r)] << 18 | i[t.charCodeAt(r + 1)] << 12 | i[t.charCodeAt(r + 2)] << 6 | i[t.charCodeAt(r + 3)], u[h++] = e >> 16 & 255, u[h++] = e >> 8 & 255, u[h++] = 255 & e;
      }

      2 === a && (e = i[t.charCodeAt(r)] << 2 | i[t.charCodeAt(r + 1)] >> 4, u[h++] = 255 & e);
      1 === a && (e = i[t.charCodeAt(r)] << 10 | i[t.charCodeAt(r + 1)] << 4 | i[t.charCodeAt(r + 2)] >> 2, u[h++] = e >> 8 & 255, u[h++] = 255 & e);
      return u;
    }, e.fromByteArray = function (t) {
      for (var e, r = t.length, i = r % 3, o = [], s = 0, a = r - i; s < a; s += 16383) {
        o.push(h(t, s, s + 16383 > a ? a : s + 16383));
      }

      1 === i ? (e = t[r - 1], o.push(n[e >> 2] + n[e << 4 & 63] + "==")) : 2 === i && (e = (t[r - 2] << 8) + t[r - 1], o.push(n[e >> 10] + n[e >> 4 & 63] + n[e << 2 & 63] + "="));
      return o.join("");
    };

    for (var n = [], i = [], o = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, u = s.length; a < u; ++a) {
      n[a] = s[a], i[s.charCodeAt(a)] = a;
    }

    function c(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var r = t.indexOf("=");
      return -1 === r && (r = e), [r, r === e ? 0 : 4 - r % 4];
    }

    function h(t, e, r) {
      for (var i, o, s = [], a = e; a < r; a += 3) {
        i = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(n[(o = i) >> 18 & 63] + n[o >> 12 & 63] + n[o >> 6 & 63] + n[63 & o]);
      }

      return s.join("");
    }

    i["-".charCodeAt(0)] = 62, i["_".charCodeAt(0)] = 63;
  }, function (t, e) {
    e.read = function (t, e, r, n, i) {
      var o,
          s,
          a = 8 * i - n - 1,
          u = (1 << a) - 1,
          c = u >> 1,
          h = -7,
          l = r ? i - 1 : 0,
          f = r ? -1 : 1,
          p = t[e + l];

      for (l += f, o = p & (1 << -h) - 1, p >>= -h, h += a; h > 0; o = 256 * o + t[e + l], l += f, h -= 8) {
        ;
      }

      for (s = o & (1 << -h) - 1, o >>= -h, h += n; h > 0; s = 256 * s + t[e + l], l += f, h -= 8) {
        ;
      }

      if (0 === o) o = 1 - c;else {
        if (o === u) return s ? NaN : 1 / 0 * (p ? -1 : 1);
        s += Math.pow(2, n), o -= c;
      }
      return (p ? -1 : 1) * s * Math.pow(2, o - n);
    }, e.write = function (t, e, r, n, i, o) {
      var s,
          a,
          u,
          c = 8 * o - i - 1,
          h = (1 << c) - 1,
          l = h >> 1,
          f = 23 === i ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
          p = n ? 0 : o - 1,
          d = n ? 1 : -1,
          y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = h) : (s = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), (e += s + l >= 1 ? f / u : f * Math.pow(2, 1 - l)) * u >= 2 && (s++, u /= 2), s + l >= h ? (a = 0, s = h) : s + l >= 1 ? (a = (e * u - 1) * Math.pow(2, i), s += l) : (a = e * Math.pow(2, l - 1) * Math.pow(2, i), s = 0)); i >= 8; t[r + p] = 255 & a, p += d, a /= 256, i -= 8) {
        ;
      }

      for (s = s << i | a, c += i; c > 0; t[r + p] = 255 & s, p += d, s /= 256, c -= 8) {
        ;
      }

      t[r + p - d] |= 128 * y;
    };
  }, function (t, e, r) {
    "use strict";

    var n,
        i = "object" == typeof Reflect ? Reflect : null,
        o = i && "function" == typeof i.apply ? i.apply : function (t, e, r) {
      return Function.prototype.apply.call(t, e, r);
    };
    n = i && "function" == typeof i.ownKeys ? i.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
    } : function (t) {
      return Object.getOwnPropertyNames(t);
    };

    var s = Number.isNaN || function (t) {
      return t != t;
    };

    function a() {
      a.init.call(this);
    }

    t.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
    var u = 10;

    function c(t) {
      return void 0 === t._maxListeners ? a.defaultMaxListeners : t._maxListeners;
    }

    function h(t, e, r, n) {
      var i, o, s, a;
      if ("function" != typeof r) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof r);
      if (void 0 === (o = t._events) ? (o = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== o.newListener && (t.emit("newListener", e, r.listener ? r.listener : r), o = t._events), s = o[e]), void 0 === s) s = o[e] = r, ++t._eventsCount;else if ("function" == typeof s ? s = o[e] = n ? [r, s] : [s, r] : n ? s.unshift(r) : s.push(r), (i = c(t)) > 0 && s.length > i && !s.warned) {
        s.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = s.length, a = u, console && console.warn && console.warn(a);
      }
      return t;
    }

    function l() {
      for (var t = [], e = 0; e < arguments.length; e++) {
        t.push(arguments[e]);
      }

      this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, o(this.listener, this.target, t));
    }

    function f(t, e, r) {
      var n = {
        fired: !1,
        wrapFn: void 0,
        target: t,
        type: e,
        listener: r
      },
          i = l.bind(n);
      return i.listener = r, n.wrapFn = i, i;
    }

    function p(t, e, r) {
      var n = t._events;
      if (void 0 === n) return [];
      var i = n[e];
      return void 0 === i ? [] : "function" == typeof i ? r ? [i.listener || i] : [i] : r ? function (t) {
        for (var e = new Array(t.length), r = 0; r < e.length; ++r) {
          e[r] = t[r].listener || t[r];
        }

        return e;
      }(i) : y(i, i.length);
    }

    function d(t) {
      var e = this._events;

      if (void 0 !== e) {
        var r = e[t];
        if ("function" == typeof r) return 1;
        if (void 0 !== r) return r.length;
      }

      return 0;
    }

    function y(t, e) {
      for (var r = new Array(e), n = 0; n < e; ++n) {
        r[n] = t[n];
      }

      return r;
    }

    Object.defineProperty(a, "defaultMaxListeners", {
      enumerable: !0,
      get: function get() {
        return u;
      },
      set: function set(t) {
        if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        u = t;
      }
    }), a.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, a.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || s(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this;
    }, a.prototype.getMaxListeners = function () {
      return c(this);
    }, a.prototype.emit = function (t) {
      for (var e = [], r = 1; r < arguments.length; r++) {
        e.push(arguments[r]);
      }

      var n = "error" === t,
          i = this._events;
      if (void 0 !== i) n = n && void 0 === i.error;else if (!n) return !1;

      if (n) {
        var s;
        if (e.length > 0 && (s = e[0]), s instanceof Error) throw s;
        var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
        throw a.context = s, a;
      }

      var u = i[t];
      if (void 0 === u) return !1;
      if ("function" == typeof u) o(u, this, e);else {
        var c = u.length,
            h = y(u, c);

        for (r = 0; r < c; ++r) {
          o(h[r], this, e);
        }
      }
      return !0;
    }, a.prototype.addListener = function (t, e) {
      return h(this, t, e, !1);
    }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (t, e) {
      return h(this, t, e, !0);
    }, a.prototype.once = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.on(t, f(this, t, e)), this;
    }, a.prototype.prependOnceListener = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.prependListener(t, f(this, t, e)), this;
    }, a.prototype.removeListener = function (t, e) {
      var r, n, i, o, s;
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      if (void 0 === (n = this._events)) return this;
      if (void 0 === (r = n[t])) return this;
      if (r === e || r.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[t], n.removeListener && this.emit("removeListener", t, r.listener || e));else if ("function" != typeof r) {
        for (i = -1, o = r.length - 1; o >= 0; o--) {
          if (r[o] === e || r[o].listener === e) {
            s = r[o].listener, i = o;
            break;
          }
        }

        if (i < 0) return this;
        0 === i ? r.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) {
            t[e] = t[e + 1];
          }

          t.pop();
        }(r, i), 1 === r.length && (n[t] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", t, s || e);
      }
      return this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (t) {
      var e, r, n;
      if (void 0 === (r = this._events)) return this;
      if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[t]), this;

      if (0 === arguments.length) {
        var i,
            o = Object.keys(r);

        for (n = 0; n < o.length; ++n) {
          "removeListener" !== (i = o[n]) && this.removeAllListeners(i);
        }

        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }

      if ("function" == typeof (e = r[t])) this.removeListener(t, e);else if (void 0 !== e) for (n = e.length - 1; n >= 0; n--) {
        this.removeListener(t, e[n]);
      }
      return this;
    }, a.prototype.listeners = function (t) {
      return p(this, t, !0);
    }, a.prototype.rawListeners = function (t) {
      return p(this, t, !1);
    }, a.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : d.call(t, e);
    }, a.prototype.listenerCount = d, a.prototype.eventNames = function () {
      return this._eventsCount > 0 ? n(this._events) : [];
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (Array.isArray(t)) {
        for (var e = 0, r = new Array(t.length); e < t.length; e++) {
          r[e] = t[e];
        }

        return r;
      }
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (Symbol.iterator in Object(t) || "[object Arguments]" === Object.prototype.toString.call(t)) return Array.from(t);
    };
  }, function (t, e) {
    t.exports = function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    };
  }, function (t, e) {}, function (t, e) {
    t.exports = n;
    var r = null;

    try {
      r = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127, 3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1, 5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95, 115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0, 0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11])), {}).exports;
    } catch (t) {}

    function n(t, e, r) {
      this.low = 0 | t, this.high = 0 | e, this.unsigned = !!r;
    }

    function i(t) {
      return !0 === (t && t.__isLong__);
    }

    n.prototype.__isLong__, Object.defineProperty(n.prototype, "__isLong__", {
      value: !0
    }), n.isLong = i;
    var o = {},
        s = {};

    function a(t, e) {
      var r, n, i;
      return e ? (i = 0 <= (t >>>= 0) && t < 256) && (n = s[t]) ? n : (r = c(t, (0 | t) < 0 ? -1 : 0, !0), i && (s[t] = r), r) : (i = -128 <= (t |= 0) && t < 128) && (n = o[t]) ? n : (r = c(t, t < 0 ? -1 : 0, !1), i && (o[t] = r), r);
    }

    function u(t, e) {
      if (isNaN(t)) return e ? g : m;

      if (e) {
        if (t < 0) return g;
        if (t >= d) return k;
      } else {
        if (t <= -y) return x;
        if (t + 1 >= y) return E;
      }

      return t < 0 ? u(-t, e).neg() : c(t % p | 0, t / p | 0, e);
    }

    function c(t, e, r) {
      return new n(t, e, r);
    }

    n.fromInt = a, n.fromNumber = u, n.fromBits = c;
    var h = Math.pow;

    function l(t, e, r) {
      if (0 === t.length) throw Error("empty string");
      if ("NaN" === t || "Infinity" === t || "+Infinity" === t || "-Infinity" === t) return m;
      if ("number" == typeof e ? (r = e, e = !1) : e = !!e, (r = r || 10) < 2 || 36 < r) throw RangeError("radix");
      var n;
      if ((n = t.indexOf("-")) > 0) throw Error("interior hyphen");
      if (0 === n) return l(t.substring(1), e, r).neg();

      for (var i = u(h(r, 8)), o = m, s = 0; s < t.length; s += 8) {
        var a = Math.min(8, t.length - s),
            c = parseInt(t.substring(s, s + a), r);

        if (a < 8) {
          var f = u(h(r, a));
          o = o.mul(f).add(u(c));
        } else o = (o = o.mul(i)).add(u(c));
      }

      return o.unsigned = e, o;
    }

    function f(t, e) {
      return "number" == typeof t ? u(t, e) : "string" == typeof t ? l(t, e) : c(t.low, t.high, "boolean" == typeof e ? e : t.unsigned);
    }

    n.fromString = l, n.fromValue = f;
    var p = 4294967296,
        d = p * p,
        y = d / 2,
        v = a(1 << 24),
        m = a(0);
    n.ZERO = m;
    var g = a(0, !0);
    n.UZERO = g;

    var _ = a(1);

    n.ONE = _;
    var b = a(1, !0);
    n.UONE = b;
    var w = a(-1);
    n.NEG_ONE = w;
    var E = c(-1, 2147483647, !1);
    n.MAX_VALUE = E;
    var k = c(-1, -1, !0);
    n.MAX_UNSIGNED_VALUE = k;
    var x = c(0, -2147483648, !1);
    n.MIN_VALUE = x;
    var C = n.prototype;
    C.toInt = function () {
      return this.unsigned ? this.low >>> 0 : this.low;
    }, C.toNumber = function () {
      return this.unsigned ? (this.high >>> 0) * p + (this.low >>> 0) : this.high * p + (this.low >>> 0);
    }, C.toString = function (t) {
      if ((t = t || 10) < 2 || 36 < t) throw RangeError("radix");
      if (this.isZero()) return "0";

      if (this.isNegative()) {
        if (this.eq(x)) {
          var e = u(t),
              r = this.div(e),
              n = r.mul(e).sub(this);
          return r.toString(t) + n.toInt().toString(t);
        }

        return "-" + this.neg().toString(t);
      }

      for (var i = u(h(t, 6), this.unsigned), o = this, s = "";;) {
        var a = o.div(i),
            c = (o.sub(a.mul(i)).toInt() >>> 0).toString(t);
        if ((o = a).isZero()) return c + s;

        for (; c.length < 6;) {
          c = "0" + c;
        }

        s = "" + c + s;
      }
    }, C.getHighBits = function () {
      return this.high;
    }, C.getHighBitsUnsigned = function () {
      return this.high >>> 0;
    }, C.getLowBits = function () {
      return this.low;
    }, C.getLowBitsUnsigned = function () {
      return this.low >>> 0;
    }, C.getNumBitsAbs = function () {
      if (this.isNegative()) return this.eq(x) ? 64 : this.neg().getNumBitsAbs();

      for (var t = 0 != this.high ? this.high : this.low, e = 31; e > 0 && 0 == (t & 1 << e); e--) {
        ;
      }

      return 0 != this.high ? e + 33 : e + 1;
    }, C.isZero = function () {
      return 0 === this.high && 0 === this.low;
    }, C.eqz = C.isZero, C.isNegative = function () {
      return !this.unsigned && this.high < 0;
    }, C.isPositive = function () {
      return this.unsigned || this.high >= 0;
    }, C.isOdd = function () {
      return 1 == (1 & this.low);
    }, C.isEven = function () {
      return 0 == (1 & this.low);
    }, C.equals = function (t) {
      return i(t) || (t = f(t)), (this.unsigned === t.unsigned || this.high >>> 31 != 1 || t.high >>> 31 != 1) && this.high === t.high && this.low === t.low;
    }, C.eq = C.equals, C.notEquals = function (t) {
      return !this.eq(t);
    }, C.neq = C.notEquals, C.ne = C.notEquals, C.lessThan = function (t) {
      return this.comp(t) < 0;
    }, C.lt = C.lessThan, C.lessThanOrEqual = function (t) {
      return this.comp(t) <= 0;
    }, C.lte = C.lessThanOrEqual, C.le = C.lessThanOrEqual, C.greaterThan = function (t) {
      return this.comp(t) > 0;
    }, C.gt = C.greaterThan, C.greaterThanOrEqual = function (t) {
      return this.comp(t) >= 0;
    }, C.gte = C.greaterThanOrEqual, C.ge = C.greaterThanOrEqual, C.compare = function (t) {
      if (i(t) || (t = f(t)), this.eq(t)) return 0;
      var e = this.isNegative(),
          r = t.isNegative();
      return e && !r ? -1 : !e && r ? 1 : this.unsigned ? t.high >>> 0 > this.high >>> 0 || t.high === this.high && t.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(t).isNegative() ? -1 : 1;
    }, C.comp = C.compare, C.negate = function () {
      return !this.unsigned && this.eq(x) ? x : this.not().add(_);
    }, C.neg = C.negate, C.add = function (t) {
      i(t) || (t = f(t));
      var e = this.high >>> 16,
          r = 65535 & this.high,
          n = this.low >>> 16,
          o = 65535 & this.low,
          s = t.high >>> 16,
          a = 65535 & t.high,
          u = t.low >>> 16,
          h = 0,
          l = 0,
          p = 0,
          d = 0;
      return p += (d += o + (65535 & t.low)) >>> 16, l += (p += n + u) >>> 16, h += (l += r + a) >>> 16, h += e + s, c((p &= 65535) << 16 | (d &= 65535), (h &= 65535) << 16 | (l &= 65535), this.unsigned);
    }, C.subtract = function (t) {
      return i(t) || (t = f(t)), this.add(t.neg());
    }, C.sub = C.subtract, C.multiply = function (t) {
      if (this.isZero()) return m;
      if (i(t) || (t = f(t)), r) return c(r.mul(this.low, this.high, t.low, t.high), r.get_high(), this.unsigned);
      if (t.isZero()) return m;
      if (this.eq(x)) return t.isOdd() ? x : m;
      if (t.eq(x)) return this.isOdd() ? x : m;
      if (this.isNegative()) return t.isNegative() ? this.neg().mul(t.neg()) : this.neg().mul(t).neg();
      if (t.isNegative()) return this.mul(t.neg()).neg();
      if (this.lt(v) && t.lt(v)) return u(this.toNumber() * t.toNumber(), this.unsigned);
      var e = this.high >>> 16,
          n = 65535 & this.high,
          o = this.low >>> 16,
          s = 65535 & this.low,
          a = t.high >>> 16,
          h = 65535 & t.high,
          l = t.low >>> 16,
          p = 65535 & t.low,
          d = 0,
          y = 0,
          g = 0,
          _ = 0;
      return g += (_ += s * p) >>> 16, y += (g += o * p) >>> 16, g &= 65535, y += (g += s * l) >>> 16, d += (y += n * p) >>> 16, y &= 65535, d += (y += o * l) >>> 16, y &= 65535, d += (y += s * h) >>> 16, d += e * p + n * l + o * h + s * a, c((g &= 65535) << 16 | (_ &= 65535), (d &= 65535) << 16 | (y &= 65535), this.unsigned);
    }, C.mul = C.multiply, C.divide = function (t) {
      if (i(t) || (t = f(t)), t.isZero()) throw Error("division by zero");
      var e, n, o;
      if (r) return this.unsigned || -2147483648 !== this.high || -1 !== t.low || -1 !== t.high ? c((this.unsigned ? r.div_u : r.div_s)(this.low, this.high, t.low, t.high), r.get_high(), this.unsigned) : this;
      if (this.isZero()) return this.unsigned ? g : m;

      if (this.unsigned) {
        if (t.unsigned || (t = t.toUnsigned()), t.gt(this)) return g;
        if (t.gt(this.shru(1))) return b;
        o = g;
      } else {
        if (this.eq(x)) return t.eq(_) || t.eq(w) ? x : t.eq(x) ? _ : (e = this.shr(1).div(t).shl(1)).eq(m) ? t.isNegative() ? _ : w : (n = this.sub(t.mul(e)), o = e.add(n.div(t)));
        if (t.eq(x)) return this.unsigned ? g : m;
        if (this.isNegative()) return t.isNegative() ? this.neg().div(t.neg()) : this.neg().div(t).neg();
        if (t.isNegative()) return this.div(t.neg()).neg();
        o = m;
      }

      for (n = this; n.gte(t);) {
        e = Math.max(1, Math.floor(n.toNumber() / t.toNumber()));

        for (var s = Math.ceil(Math.log(e) / Math.LN2), a = s <= 48 ? 1 : h(2, s - 48), l = u(e), p = l.mul(t); p.isNegative() || p.gt(n);) {
          p = (l = u(e -= a, this.unsigned)).mul(t);
        }

        l.isZero() && (l = _), o = o.add(l), n = n.sub(p);
      }

      return o;
    }, C.div = C.divide, C.modulo = function (t) {
      return i(t) || (t = f(t)), r ? c((this.unsigned ? r.rem_u : r.rem_s)(this.low, this.high, t.low, t.high), r.get_high(), this.unsigned) : this.sub(this.div(t).mul(t));
    }, C.mod = C.modulo, C.rem = C.modulo, C.not = function () {
      return c(~this.low, ~this.high, this.unsigned);
    }, C.and = function (t) {
      return i(t) || (t = f(t)), c(this.low & t.low, this.high & t.high, this.unsigned);
    }, C.or = function (t) {
      return i(t) || (t = f(t)), c(this.low | t.low, this.high | t.high, this.unsigned);
    }, C.xor = function (t) {
      return i(t) || (t = f(t)), c(this.low ^ t.low, this.high ^ t.high, this.unsigned);
    }, C.shiftLeft = function (t) {
      return i(t) && (t = t.toInt()), 0 == (t &= 63) ? this : t < 32 ? c(this.low << t, this.high << t | this.low >>> 32 - t, this.unsigned) : c(0, this.low << t - 32, this.unsigned);
    }, C.shl = C.shiftLeft, C.shiftRight = function (t) {
      return i(t) && (t = t.toInt()), 0 == (t &= 63) ? this : t < 32 ? c(this.low >>> t | this.high << 32 - t, this.high >> t, this.unsigned) : c(this.high >> t - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    }, C.shr = C.shiftRight, C.shiftRightUnsigned = function (t) {
      if (i(t) && (t = t.toInt()), 0 === (t &= 63)) return this;
      var e = this.high;
      return t < 32 ? c(this.low >>> t | e << 32 - t, e >>> t, this.unsigned) : c(32 === t ? e : e >>> t - 32, 0, this.unsigned);
    }, C.shru = C.shiftRightUnsigned, C.shr_u = C.shiftRightUnsigned, C.toSigned = function () {
      return this.unsigned ? c(this.low, this.high, !1) : this;
    }, C.toUnsigned = function () {
      return this.unsigned ? this : c(this.low, this.high, !0);
    }, C.toBytes = function (t) {
      return t ? this.toBytesLE() : this.toBytesBE();
    }, C.toBytesLE = function () {
      var t = this.high,
          e = this.low;
      return [255 & e, e >>> 8 & 255, e >>> 16 & 255, e >>> 24, 255 & t, t >>> 8 & 255, t >>> 16 & 255, t >>> 24];
    }, C.toBytesBE = function () {
      var t = this.high,
          e = this.low;
      return [t >>> 24, t >>> 16 & 255, t >>> 8 & 255, 255 & t, e >>> 24, e >>> 16 & 255, e >>> 8 & 255, 255 & e];
    }, n.fromBytes = function (t, e, r) {
      return r ? n.fromBytesLE(t, e) : n.fromBytesBE(t, e);
    }, n.fromBytesLE = function (t, e) {
      return new n(t[0] | t[1] << 8 | t[2] << 16 | t[3] << 24, t[4] | t[5] << 8 | t[6] << 16 | t[7] << 24, e);
    }, n.fromBytesBE = function (t, e) {
      return new n(t[4] << 24 | t[5] << 16 | t[6] << 8 | t[7], t[0] << 24 | t[1] << 16 | t[2] << 8 | t[3], e);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(13),
        i = r(24),
        o = r(45),
        s = r(14),
        a = n.sum32,
        u = n.sum32_4,
        c = n.sum32_5,
        h = o.ch32,
        l = o.maj32,
        f = o.s0_256,
        p = o.s1_256,
        d = o.g0_256,
        y = o.g1_256,
        v = i.BlockHash,
        m = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];

    function g() {
      if (!(this instanceof g)) return new g();
      v.call(this), this.h = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], this.k = m, this.W = new Array(64);
    }

    n.inherits(g, v), t.exports = g, g.blockSize = 512, g.outSize = 256, g.hmacStrength = 192, g.padLength = 64, g.prototype._update = function (t, e) {
      for (var r = this.W, n = 0; n < 16; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n++) {
        r[n] = u(y(r[n - 2]), r[n - 7], d(r[n - 15]), r[n - 16]);
      }

      var i = this.h[0],
          o = this.h[1],
          v = this.h[2],
          m = this.h[3],
          g = this.h[4],
          _ = this.h[5],
          b = this.h[6],
          w = this.h[7];

      for (s(this.k.length === r.length), n = 0; n < r.length; n++) {
        var E = c(w, p(g), h(g, _, b), this.k[n], r[n]),
            k = a(f(i), l(i, o, v));
        w = b, b = _, _ = g, g = a(m, E), m = v, v = o, o = i, i = a(E, k);
      }

      this.h[0] = a(this.h[0], i), this.h[1] = a(this.h[1], o), this.h[2] = a(this.h[2], v), this.h[3] = a(this.h[3], m), this.h[4] = a(this.h[4], g), this.h[5] = a(this.h[5], _), this.h[6] = a(this.h[6], b), this.h[7] = a(this.h[7], w);
    }, g.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(13).rotr32;

    function i(t, e, r) {
      return t & e ^ ~t & r;
    }

    function o(t, e, r) {
      return t & e ^ t & r ^ e & r;
    }

    function s(t, e, r) {
      return t ^ e ^ r;
    }

    e.ft_1 = function (t, e, r, n) {
      return 0 === t ? i(e, r, n) : 1 === t || 3 === t ? s(e, r, n) : 2 === t ? o(e, r, n) : void 0;
    }, e.ch32 = i, e.maj32 = o, e.p32 = s, e.s0_256 = function (t) {
      return n(t, 2) ^ n(t, 13) ^ n(t, 22);
    }, e.s1_256 = function (t) {
      return n(t, 6) ^ n(t, 11) ^ n(t, 25);
    }, e.g0_256 = function (t) {
      return n(t, 7) ^ n(t, 18) ^ t >>> 3;
    }, e.g1_256 = function (t) {
      return n(t, 17) ^ n(t, 19) ^ t >>> 10;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(13),
        i = r(24),
        o = r(14),
        s = n.rotr64_hi,
        a = n.rotr64_lo,
        u = n.shr64_hi,
        c = n.shr64_lo,
        h = n.sum64,
        l = n.sum64_hi,
        f = n.sum64_lo,
        p = n.sum64_4_hi,
        d = n.sum64_4_lo,
        y = n.sum64_5_hi,
        v = n.sum64_5_lo,
        m = i.BlockHash,
        g = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];

    function _() {
      if (!(this instanceof _)) return new _();
      m.call(this), this.h = [1779033703, 4089235720, 3144134277, 2227873595, 1013904242, 4271175723, 2773480762, 1595750129, 1359893119, 2917565137, 2600822924, 725511199, 528734635, 4215389547, 1541459225, 327033209], this.k = g, this.W = new Array(160);
    }

    function b(t, e, r, n, i) {
      var o = t & r ^ ~t & i;
      return o < 0 && (o += 4294967296), o;
    }

    function w(t, e, r, n, i, o) {
      var s = e & n ^ ~e & o;
      return s < 0 && (s += 4294967296), s;
    }

    function E(t, e, r, n, i) {
      var o = t & r ^ t & i ^ r & i;
      return o < 0 && (o += 4294967296), o;
    }

    function k(t, e, r, n, i, o) {
      var s = e & n ^ e & o ^ n & o;
      return s < 0 && (s += 4294967296), s;
    }

    function x(t, e) {
      var r = s(t, e, 28) ^ s(e, t, 2) ^ s(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function C(t, e) {
      var r = a(t, e, 28) ^ a(e, t, 2) ^ a(e, t, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function A(t, e) {
      var r = s(t, e, 14) ^ s(t, e, 18) ^ s(e, t, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function S(t, e) {
      var r = a(t, e, 14) ^ a(t, e, 18) ^ a(e, t, 9);
      return r < 0 && (r += 4294967296), r;
    }

    function T(t, e) {
      var r = s(t, e, 1) ^ s(t, e, 8) ^ u(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function R(t, e) {
      var r = a(t, e, 1) ^ a(t, e, 8) ^ c(t, e, 7);
      return r < 0 && (r += 4294967296), r;
    }

    function O(t, e) {
      var r = s(t, e, 19) ^ s(e, t, 29) ^ u(t, e, 6);
      return r < 0 && (r += 4294967296), r;
    }

    function j(t, e) {
      var r = a(t, e, 19) ^ a(e, t, 29) ^ c(t, e, 6);
      return r < 0 && (r += 4294967296), r;
    }

    n.inherits(_, m), t.exports = _, _.blockSize = 1024, _.outSize = 512, _.hmacStrength = 192, _.padLength = 128, _.prototype._prepareBlock = function (t, e) {
      for (var r = this.W, n = 0; n < 32; n++) {
        r[n] = t[e + n];
      }

      for (; n < r.length; n += 2) {
        var i = O(r[n - 4], r[n - 3]),
            o = j(r[n - 4], r[n - 3]),
            s = r[n - 14],
            a = r[n - 13],
            u = T(r[n - 30], r[n - 29]),
            c = R(r[n - 30], r[n - 29]),
            h = r[n - 32],
            l = r[n - 31];
        r[n] = p(i, o, s, a, u, c, h, l), r[n + 1] = d(i, o, s, a, u, c, h, l);
      }
    }, _.prototype._update = function (t, e) {
      this._prepareBlock(t, e);

      var r = this.W,
          n = this.h[0],
          i = this.h[1],
          s = this.h[2],
          a = this.h[3],
          u = this.h[4],
          c = this.h[5],
          p = this.h[6],
          d = this.h[7],
          m = this.h[8],
          g = this.h[9],
          _ = this.h[10],
          T = this.h[11],
          R = this.h[12],
          O = this.h[13],
          j = this.h[14],
          P = this.h[15];
      o(this.k.length === r.length);

      for (var I = 0; I < r.length; I += 2) {
        var B = j,
            F = P,
            L = A(m, g),
            M = S(m, g),
            D = b(m, g, _, T, R),
            U = w(m, g, _, T, R, O),
            N = this.k[I],
            H = this.k[I + 1],
            q = r[I],
            V = r[I + 1],
            z = y(B, F, L, M, D, U, N, H, q, V),
            Y = v(B, F, L, M, D, U, N, H, q, V);
        B = x(n, i), F = C(n, i), L = E(n, i, s, a, u), M = k(n, i, s, a, u, c);
        var K = l(B, F, L, M),
            W = f(B, F, L, M);
        j = R, P = O, R = _, O = T, _ = m, T = g, m = l(p, d, z, Y), g = f(d, d, z, Y), p = u, d = c, u = s, c = a, s = n, a = i, n = l(z, Y, K, W), i = f(z, Y, K, W);
      }

      h(this.h, 0, n, i), h(this.h, 2, s, a), h(this.h, 4, u, c), h(this.h, 6, p, d), h(this.h, 8, m, g), h(this.h, 10, _, T), h(this.h, 12, R, O), h(this.h, 14, j, P);
    }, _.prototype._digest = function (t) {
      return "hex" === t ? n.toHex32(this.h, "big") : n.split32(this.h, "big");
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(17)),
        o = n(r(5)),
        s = n(r(16)),
        a = n(r(6)),
        u = r(21),
        c = r(18).Transaction,
        h = r(9).NULL_HASH,
        l = r(19).Entry,
        f = r(114),
        p = f.DirectoryBlock,
        d = f.AdminBlock,
        y = f.EntryBlock,
        v = f.FactoidBlock,
        m = f.EntryCreditBlock,
        g = r(2).getPublicAddress,
        _ = r(8).toHex;

    function b(t, e) {
      return t.call("chain-head", {
        chainid: _(e)
      }).then(function (t) {
        return {
          keyMR: t.chainhead,
          chainInProcessList: t.chaininprocesslist
        };
      });
    }

    function w(t, e, r) {
      return E.apply(this, arguments);
    }

    function E() {
      return (E = (0, a.default)(o.default.mark(function t(e, r, n) {
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", e.call("entry", {
                  hash: _(r)
                }).then(function (t) {
                  return O(t, n);
                }));

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function k() {
      return (k = (0, a.default)(o.default.mark(function t(e, r) {
        var n, i, s;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, e.call("receipt", {
                  hash: _(r)
                }).then(function (t) {
                  return t.receipt.entryblockkeymr;
                });

              case 2:
                return n = t.sent, t.next = 5, e.call("entry-block", {
                  keymr: n
                });

              case 5:
                return i = t.sent, s = i.entrylist.find(function (t) {
                  return t.entryhash === r;
                }).timestamp, t.abrupt("return", w(e, r, R(n, i, s)));

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function x() {
      return (x = (0, a.default)(o.default.mark(function t(e, r) {
        var n, i, s, a, u;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, b(e, r);

              case 2:
                if ("" !== (n = t.sent).keyMR || !n.chainInProcessList) {
                  t.next = 5;
                  break;
                }

                throw new Error("Chain not yet included in a Directory Block");

              case 5:
                i = n.keyMR;

              case 6:
                if (i === h) {
                  t.next = 14;
                  break;
                }

                return a = i, t.next = 10, e.call("entry-block", {
                  keymr: i
                });

              case 10:
                s = t.sent, i = s.header.prevkeymr, t.next = 6;
                break;

              case 14:
                return u = s.entrylist[0], t.abrupt("return", w(e, u.entryhash, R(a, s, u.timestamp)));

              case 16:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function C() {
      return (C = (0, a.default)(o.default.mark(function t(e, r) {
        var n, s, a, c, l, f;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return n = [], t.next = 3, b(e, r);

              case 3:
                if ("" !== (s = t.sent).keyMR || !s.chainInProcessList) {
                  t.next = 6;
                  break;
                }

                throw new Error("Chain not yet included in a Directory Block");

              case 6:
                a = s.keyMR;

              case 7:
                if (a === h) {
                  t.next = 17;
                  break;
                }

                return t.next = 10, S(e, a);

              case 10:
                c = t.sent, l = c.entries, f = c.previousKeyMR, n.push.apply(n, (0, i.default)(l.reverse())), a = f, t.next = 7;
                break;

              case 17:
                return t.abrupt("return", u.resolve(n.reverse()));

              case 18:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function A() {
      return (A = (0, a.default)(o.default.mark(function t(e, r, n, i) {
        var s, a, u, c, l, f;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if ("function" == typeof n) {
                  t.next = 2;
                  break;
                }

                throw new Error("".concat(n, " is not a function"));

              case 2:
                if ("function" == typeof i) {
                  t.next = 4;
                  break;
                }

                throw new Error("".concat(i, " is not a function"));

              case 4:
                return t.next = 6, b(e, r);

              case 6:
                if ("" !== (s = t.sent).keyMR || !s.chainInProcessList) {
                  t.next = 9;
                  break;
                }

                throw new Error("Chain not yet included in a Directory Block");

              case 9:
                a = s.keyMR;

              case 10:
                if (a === h) {
                  t.next = 33;
                  break;
                }

                return t.next = 13, S(e, a);

              case 13:
                u = t.sent, c = u.entries, l = u.previousKeyMR, f = c.length - 1;

              case 17:
                if (t.t0 = f >= 0, !t.t0) {
                  t.next = 22;
                  break;
                }

                return t.next = 21, n(c[f]);

              case 21:
                t.t0 = t.sent;

              case 22:
                if (!t.t0) {
                  t.next = 28;
                  break;
                }

                return t.next = 25, i(c[f]);

              case 25:
                f--, t.next = 17;
                break;

              case 28:
                if (!(f >= 0)) {
                  t.next = 30;
                  break;
                }

                return t.abrupt("break", 33);

              case 30:
                a = l, t.next = 10;
                break;

              case 33:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function S(t, e) {
      return T.apply(this, arguments);
    }

    function T() {
      return (T = (0, a.default)(o.default.mark(function t(e, r) {
        var n, i;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, e.call("entry-block", {
                  keymr: r
                });

              case 2:
                return n = t.sent, t.next = 5, u.map(n.entrylist, function (t) {
                  return w(e, t.entryhash, R(r, n, t.timestamp));
                });

              case 5:
                return i = t.sent, t.abrupt("return", {
                  entries: i,
                  previousKeyMR: n.header.prevkeymr
                });

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function R(t, e, r) {
      return {
        entryTimestamp: r,
        directoryBlockHeight: e.header.dbheight,
        entryBlockTimestamp: e.header.timestamp,
        entryBlockSequenceNumber: e.header.blocksequencenumber,
        entryBlockKeyMR: t
      };
    }

    function O(t, e) {
      return l.builder().chainId(t.chainid, "hex").extIds(t.extids, "hex").content(t.content, "hex").blockContext(e).timestamp(e ? 1e3 * e.entryTimestamp : void 0).build();
    }

    function j() {
      return (j = (0, a.default)(o.default.mark(function t(e, r) {
        var n;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if ("string" == typeof r) {
                  t.next = 2;
                  break;
                }

                throw new Error("Argument is not a transaction ID: ".concat(r));

              case 2:
                return t.next = 4, e.call("transaction", {
                  hash: r
                });

              case 4:
                if (!(n = t.sent).factoidtransaction) {
                  t.next = 9;
                  break;
                }

                return t.abrupt("return", new c(n.factoidtransaction, {
                  factoidBlockKeyMR: n.includedintransactionblock,
                  directoryBlockKeyMR: n.includedindirectoryblock,
                  directoryBlockHeight: n.includedindirectoryblockheight
                }));

              case 9:
                throw new Error("No Transaction with ID [".concat(r, "] found."));

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function P() {
      return (P = (0, a.default)(o.default.mark(function t(e) {
        var r;
        return o.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, e.call("heights");

              case 2:
                return r = t.sent, t.abrupt("return", {
                  directoryBlockHeight: r.directoryblockheight,
                  leaderHeight: r.leaderheight,
                  entryBlockHeight: r.entryblockheight,
                  entryHeight: r.entryheight
                });

              case 4:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function I(t, e) {
      var r;

      switch ((0, s.default)(e)) {
        case "number":
          if (e < 0) throw new RangeError("Directory Block height out of range");
          r = t.call("dblock-by-height", {
            height: e
          });
          break;

        case "string":
          r = t.call("directory-block", {
            keymr: e
          });
          break;

        default:
          throw Error("Invalid argument: ".concat(e));
      }

      return r.then(function (t) {
        return new p(t, e);
      });
    }

    t.exports = {
      getEntry: w,
      getEntryWithBlockContext: function getEntryWithBlockContext(t, e) {
        return k.apply(this, arguments);
      },
      getAllEntriesOfChain: function getAllEntriesOfChain(t, e) {
        return C.apply(this, arguments);
      },
      getFirstEntry: function getFirstEntry(t, e) {
        return x.apply(this, arguments);
      },
      getChainHead: b,
      chainExists: function chainExists(t, e) {
        return t.call("chain-head", {
          chainid: _(e)
        }).then(function () {
          return !0;
        }).catch(function (t) {
          if (-32009 === t.code) return !1;
          throw t;
        });
      },
      getEntryCreditRate: function getEntryCreditRate(t) {
        return t.call("entry-credit-rate").then(function (t) {
          return t.rate;
        });
      },
      getTransaction: function getTransaction(t, e) {
        return j.apply(this, arguments);
      },
      getBalance: function getBalance(t, e) {
        var r = g(e);
        return ("E" === r[0] ? t.call.bind(t, "entry-credit-balance") : t.call.bind(t, "factoid-balance"))({
          address: r
        }).then(function (t) {
          return t.balance;
        });
      },
      getHeights: function getHeights(t) {
        return P.apply(this, arguments);
      },
      getDirectoryBlockHead: function getDirectoryBlockHead(t) {
        return t.call("directory-block-head").then(function (e) {
          return I(t, e.keymr);
        });
      },
      getDirectoryBlock: I,
      getEntryBlock: function getEntryBlock(t, e) {
        if ("string" != typeof e) throw new Error("Argument should be the KeyMR of the Entry Block");
        return t.call("entry-block", {
          keymr: e
        }).then(function (t) {
          return new y(t, e);
        });
      },
      getAdminBlock: function getAdminBlock(t, e) {
        var r;

        switch ((0, s.default)(e)) {
          case "number":
            if (e < 0) throw new RangeError("Admin Block height out of range");
            r = t.call("ablock-by-height", {
              height: e
            });
            break;

          case "string":
            r = t.call("admin-block", {
              keymr: e
            });
            break;

          default:
            throw Error("Invalid argument: ".concat(e));
        }

        return r.then(function (t) {
          return new d(t);
        });
      },
      getFactoidBlock: function getFactoidBlock(t, e) {
        var r;

        switch ((0, s.default)(e)) {
          case "number":
            if (e < 0) throw new RangeError("Factoid Block height out of range");
            r = t.call("fblock-by-height", {
              height: e
            });
            break;

          case "string":
            r = t.call("factoid-block", {
              keymr: e
            });
            break;

          default:
            throw Error("Invalid argument: ".concat(e));
        }

        return r.then(function (t) {
          return new v(t);
        });
      },
      getEntryCreditBlock: function getEntryCreditBlock(t, e) {
        var r;

        switch ((0, s.default)(e)) {
          case "number":
            if (e < 0) throw new RangeError("Entry Credit Block height out of range");
            r = t.call("ecblock-by-height", {
              height: e
            });
            break;

          case "string":
            r = t.call("entrycredit-block", {
              keymr: e
            });
            break;

          default:
            throw Error("Invalid argument: ".concat(e));
        }

        return r.then(function (t) {
          return new m(t);
        });
      },
      rewindChainWhile: function rewindChainWhile(t, e, r, n) {
        return A.apply(this, arguments);
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(7)),
        o = n(r(32)),
        s = n(r(22)),
        a = n(r(33)),
        u = n(r(34)),
        c = n(r(50)),
        h = n(r(5)),
        l = n(r(6)),
        f = r(21),
        p = r(8).toHex;

    function d(t, e, r, n, i, o) {
      if (!e || !r) return f.reject(new y("Invalid argument: hash or chain ID is missing", o, e));
      var s = i || 60,
          a = Date.now();
      return new f(function (i, u) {
        var c = setInterval((0, l.default)(h.default.mark(function l() {
          var f, p, d;
          return h.default.wrap(function (h) {
            for (;;) {
              switch (h.prev = h.next) {
                case 0:
                  return h.prev = 0, h.next = 3, t.call("ack", {
                    hash: e,
                    chainid: r
                  }).catch(function (t) {
                    clearInterval(c), f = t;
                  });

                case 3:
                  if (p = h.sent, !f) {
                    h.next = 6;
                    break;
                  }

                  return h.abrupt("return", u(new y(f, o, e)));

                case 6:
                  if ("Unknown" === (d = n ? p[n].status : p.status) || "NotConfirmed" === d) {
                    h.next = 10;
                    break;
                  }

                  return clearInterval(c), h.abrupt("return", i(d));

                case 10:
                  if (!(Date.now() - a > 1e3 * s)) {
                    h.next = 13;
                    break;
                  }

                  return clearInterval(c), h.abrupt("return", u(new y("Timeout", o, e)));

                case 13:
                  h.next = 19;
                  break;

                case 15:
                  return h.prev = 15, h.t0 = h.catch(0), clearInterval(c), h.abrupt("return", u(new y("Unexpected error: " + h.t0.message, o, e)));

                case 19:
                case "end":
                  return h.stop();
              }
            }
          }, l, null, [[0, 15]]);
        })), 500);
      });
    }

    var y = function (t) {
      function e(t, r, n) {
        var u;
        return (0, i.default)(this, e), (u = (0, o.default)(this, (0, s.default)(e).call(this, "Acknowledgement of type [".concat(r, "] failed for [").concat(n, "]: ").concat(t)))).ackType = r, u.hash = n, Error.captureStackTrace && Error.captureStackTrace((0, a.default)(u), e), u;
      }

      return (0, u.default)(e, t), e;
    }((0, c.default)(Error));

    t.exports = {
      waitOnCommitAck: function waitOnCommitAck(t, e, r) {
        return d(t, e, "c", "commitdata", r, "entry-commit");
      },
      waitOnRevealAck: function waitOnRevealAck(t, e, r, n) {
        return d(t, e, p(r), "entrydata", n, "entry-reveal");
      },
      waitOnFactoidTransactionAck: function waitOnFactoidTransactionAck(t, e, r) {
        return d(t, e, "f", null, r, "factoid-transaction");
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(72)),
        o = n(r(10)),
        s = n(r(16)),
        a = n(r(7)),
        u = n(r(32)),
        c = n(r(22)),
        h = n(r(33)),
        l = n(r(34)),
        f = n(r(50)),
        p = r(76),
        d = r(93).Agent,
        y = r(21),
        v = r(110),
        m = new Set(["holding-queue", "network-info", "predictive-fer", "audit-servers", "federated-servers", "configuration", "process-list", "authorities", "reload-configuration", "drop-rate", "set-drop-rate", "delay", "set-delay", "summary", "messages"]),
        g = {
      retries: 3,
      factor: 2,
      minTimeout: 500,
      maxTimeout: 2e3
    },
        _ = function (t) {
      function e(t, r, n) {
        var i;
        (0, a.default)(this, e);
        var o = ["API call to [".concat(t, "] ")];
        return "object" === (0, s.default)(r) && o.push("with params ".concat(JSON.stringify(r), " ")), o.push("got rejected: ".concat(n.message, " (code: ").concat(n.code, ")")), (i = (0, u.default)(this, (0, c.default)(e).call(this, o.join("")))).code = n.code, i.data = n.data, Error.captureStackTrace && Error.captureStackTrace((0, h.default)(i), e), i;
      }

      return (0, l.default)(e, t), e;
    }((0, f.default)(Error)),
        b = function () {
      function t(e, r) {
        (0, a.default)(this, t);
        var n,
            i = e.host || "localhost",
            o = e.protocol || "http",
            s = e.port || r,
            u = {
          baseURL: "".concat(o, "://").concat(i, ":").concat(s),
          headers: {
            "Content-Type": "application/json"
          }
        };
        "string" == typeof e.user && "" !== e.user && (u.auth = {
          username: e.user,
          password: e.password || ""
        }, u.withCredentials = !0), "https" === o && void 0 !== e.rejectUnauthorized && (u.httpsAgent = new d({
          rejectUnauthorized: e.rejectUnauthorized
        })), e.timeout && (u.timeout = parseInt(e.timeout)), this.httpCli = p.create(u), this.path = e.path || "/v2", this.apiCounter = (n = 0, function () {
          return ++n;
        }), this.retry = e.retry || g, this.cookies = {};
      }

      return (0, o.default)(t, [{
        key: "_processCookieHeader",
        value: function value(t) {
          var e = this;
          Array.isArray(t) && (t.map(function (t) {
            return t.split(";")[0];
          }).forEach(function (t) {
            var r = t.split("=");
            e.cookies[r[0]] = r[1];
          }), this.httpCli.defaults.headers.Cookie = Object.entries(this.cookies).map(function (t) {
            return "".concat(t[0], "=").concat(t[1]);
          }).join(";"));
        }
      }, {
        key: "call",
        value: function value(t, e, r, n) {
          var i = this,
              o = n || {},
              a = o.timeout,
              u = o.retry;
          return new y(function (n, o) {
            var c = v.operation(u || i.retry),
                h = {
              jsonrpc: "2.0",
              id: i.apiCounter(),
              method: e,
              params: r
            };
            c.attempt(function () {
              i.httpCli.post(t, h, {
                timeout: a
              }).then(function (t) {
                i._processCookieHeader(t.headers["set-cookie"]), n(t.data.result);
              }).catch(function (t) {
                return function (t) {
                  var e,
                      r = t.error,
                      n = t.reject,
                      i = t.method,
                      o = t.params,
                      a = t.operation;

                  if (r.response) {
                    var u = r.response.data;

                    switch (r.response.status) {
                      case 400:
                        return "object" === (0, s.default)(u.error) ? n(new _(i, o, u.error)) : n(new Error(u));

                      case 401:
                        return n(new Error(r.response.data));

                      default:
                        e = "object" === (0, s.default)(u) ? JSON.stringify(u) : u;
                    }
                  } else e = r.message;

                  var c = new Error(e);
                  if (!a.retry(c)) return n(a.mainError());
                }({
                  error: t,
                  reject: o,
                  method: e,
                  params: r,
                  operation: c
                });
              });
            });
          });
        }
      }]), t;
    }();

    var w = function (t) {
      function e(t) {
        var r;
        (0, a.default)(this, e);
        var n = t || {};
        return (r = (0, u.default)(this, (0, c.default)(e).call(this, n, 8088))).debugPath = n.debugPath || "/debug", r;
      }

      return (0, l.default)(e, t), (0, o.default)(e, [{
        key: "call",
        value: function value(t, r, n) {
          var o = m.has(t) ? this.debugPath : this.path;
          return (0, i.default)((0, c.default)(e.prototype), "call", this).call(this, o, t, r, n);
        }
      }]), e;
    }(b),
        E = function (t) {
      function e(t) {
        (0, a.default)(this, e);
        var r = t || {};
        return (0, u.default)(this, (0, c.default)(e).call(this, r, 8089));
      }

      return (0, l.default)(e, t), (0, o.default)(e, [{
        key: "call",
        value: function value(t, r, n) {
          return (0, i.default)((0, c.default)(e.prototype), "call", this).call(this, this.path, t, r, n);
        }
      }]), e;
    }(b);

    t.exports = {
      FactomdCli: w,
      WalletdCli: E
    };
  }, function (t, e, r) {
    var n = r(22),
        i = r(35),
        o = r(74),
        s = r(75);

    function a(e) {
      var r = "function" == typeof Map ? new Map() : void 0;
      return t.exports = a = function a(t) {
        if (null === t || !o(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");

        if (void 0 !== r) {
          if (r.has(t)) return r.get(t);
          r.set(t, e);
        }

        function e() {
          return s(t, arguments, n(this).constructor);
        }

        return e.prototype = Object.create(t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), i(e, t);
      }, a(e);
    }

    t.exports = a;
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e) {
      return function () {
        for (var r = new Array(arguments.length), n = 0; n < r.length; n++) {
          r[n] = arguments[n];
        }

        return t.apply(e, r);
      };
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4);

    function i(t) {
      return encodeURIComponent(t).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }

    t.exports = function (t, e, r) {
      if (!e) return t;
      var o;
      if (r) o = r(e);else if (n.isURLSearchParams(e)) o = e.toString();else {
        var s = [];
        n.forEach(e, function (t, e) {
          null != t && (n.isArray(t) ? e += "[]" : t = [t], n.forEach(t, function (t) {
            n.isDate(t) ? t = t.toISOString() : n.isObject(t) && (t = JSON.stringify(t)), s.push(i(e) + "=" + i(t));
          }));
        }), o = s.join("&");
      }

      if (o) {
        var a = t.indexOf("#");
        -1 !== a && (t = t.slice(0, a)), t += (-1 === t.indexOf("?") ? "?" : "&") + o;
      }

      return t;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return !(!t || !t.__CANCEL__);
    };
  }, function (t, e, r) {
    "use strict";

    (function (e) {
      var n = r(4),
          i = r(83),
          o = {
        "Content-Type": "application/x-www-form-urlencoded"
      };

      function s(t, e) {
        !n.isUndefined(t) && n.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
      }

      var a,
          u = {
        adapter: (void 0 !== e && "[object process]" === Object.prototype.toString.call(e) ? a = r(55) : "undefined" != typeof XMLHttpRequest && (a = r(55)), a),
        transformRequest: [function (t, e) {
          return i(e, "Accept"), i(e, "Content-Type"), n.isFormData(t) || n.isArrayBuffer(t) || n.isBuffer(t) || n.isStream(t) || n.isFile(t) || n.isBlob(t) ? t : n.isArrayBufferView(t) ? t.buffer : n.isURLSearchParams(t) ? (s(e, "application/x-www-form-urlencoded;charset=utf-8"), t.toString()) : n.isObject(t) ? (s(e, "application/json;charset=utf-8"), JSON.stringify(t)) : t;
        }],
        transformResponse: [function (t) {
          if ("string" == typeof t) try {
            t = JSON.parse(t);
          } catch (t) {}
          return t;
        }],
        timeout: 0,
        xsrfCookieName: "XSRF-TOKEN",
        xsrfHeaderName: "X-XSRF-TOKEN",
        maxContentLength: -1,
        validateStatus: function validateStatus(t) {
          return t >= 200 && t < 300;
        }
      };
      u.headers = {
        common: {
          Accept: "application/json, text/plain, */*"
        }
      }, n.forEach(["delete", "get", "head"], function (t) {
        u.headers[t] = {};
      }), n.forEach(["post", "put", "patch"], function (t) {
        u.headers[t] = n.merge(o);
      }), t.exports = u;
    }).call(this, r(15));
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(84),
        o = r(52),
        s = r(86),
        a = r(87),
        u = r(56);

    t.exports = function (t) {
      return new Promise(function (e, c) {
        var h = t.data,
            l = t.headers;
        n.isFormData(h) && delete l["Content-Type"];
        var f = new XMLHttpRequest();

        if (t.auth) {
          var p = t.auth.username || "",
              d = t.auth.password || "";
          l.Authorization = "Basic " + btoa(p + ":" + d);
        }

        if (f.open(t.method.toUpperCase(), o(t.url, t.params, t.paramsSerializer), !0), f.timeout = t.timeout, f.onreadystatechange = function () {
          if (f && 4 === f.readyState && (0 !== f.status || f.responseURL && 0 === f.responseURL.indexOf("file:"))) {
            var r = "getAllResponseHeaders" in f ? s(f.getAllResponseHeaders()) : null,
                n = {
              data: t.responseType && "text" !== t.responseType ? f.response : f.responseText,
              status: f.status,
              statusText: f.statusText,
              headers: r,
              config: t,
              request: f
            };
            i(e, c, n), f = null;
          }
        }, f.onabort = function () {
          f && (c(u("Request aborted", t, "ECONNABORTED", f)), f = null);
        }, f.onerror = function () {
          c(u("Network Error", t, null, f)), f = null;
        }, f.ontimeout = function () {
          c(u("timeout of " + t.timeout + "ms exceeded", t, "ECONNABORTED", f)), f = null;
        }, n.isStandardBrowserEnv()) {
          var y = r(88),
              v = (t.withCredentials || a(t.url)) && t.xsrfCookieName ? y.read(t.xsrfCookieName) : void 0;
          v && (l[t.xsrfHeaderName] = v);
        }

        if ("setRequestHeader" in f && n.forEach(l, function (t, e) {
          void 0 === h && "content-type" === e.toLowerCase() ? delete l[e] : f.setRequestHeader(e, t);
        }), t.withCredentials && (f.withCredentials = !0), t.responseType) try {
          f.responseType = t.responseType;
        } catch (e) {
          if ("json" !== t.responseType) throw e;
        }
        "function" == typeof t.onDownloadProgress && f.addEventListener("progress", t.onDownloadProgress), "function" == typeof t.onUploadProgress && f.upload && f.upload.addEventListener("progress", t.onUploadProgress), t.cancelToken && t.cancelToken.promise.then(function (t) {
          f && (f.abort(), c(t), f = null);
        }), void 0 === h && (h = null), f.send(h);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(85);

    t.exports = function (t, e, r, i, o) {
      var s = new Error(t);
      return n(s, e, r, i, o);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4);

    t.exports = function (t, e) {
      e = e || {};
      var r = {};
      return n.forEach(["url", "method", "params", "data"], function (t) {
        void 0 !== e[t] && (r[t] = e[t]);
      }), n.forEach(["headers", "auth", "proxy"], function (i) {
        n.isObject(e[i]) ? r[i] = n.deepMerge(t[i], e[i]) : void 0 !== e[i] ? r[i] = e[i] : n.isObject(t[i]) ? r[i] = n.deepMerge(t[i]) : void 0 !== t[i] && (r[i] = t[i]);
      }), n.forEach(["baseURL", "transformRequest", "transformResponse", "paramsSerializer", "timeout", "withCredentials", "adapter", "responseType", "xsrfCookieName", "xsrfHeaderName", "onUploadProgress", "onDownloadProgress", "maxContentLength", "validateStatus", "maxRedirects", "httpAgent", "httpsAgent", "cancelToken", "socketPath"], function (n) {
        void 0 !== e[n] ? r[n] = e[n] : void 0 !== t[n] && (r[n] = t[n]);
      }), r;
    };
  }, function (t, e, r) {
    "use strict";

    function n(t) {
      this.message = t;
    }

    n.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }, n.prototype.__CANCEL__ = !0, t.exports = n;
  }, function (t, e, r) {
    (function (t) {
      e.fetch = a(t.fetch) && a(t.ReadableStream), e.writableStream = a(t.WritableStream), e.abortController = a(t.AbortController), e.blobConstructor = !1;

      try {
        new Blob([new ArrayBuffer(1)]), e.blobConstructor = !0;
      } catch (t) {}

      var r;

      function n() {
        if (void 0 !== r) return r;

        if (t.XMLHttpRequest) {
          r = new t.XMLHttpRequest();

          try {
            r.open("GET", t.XDomainRequest ? "/" : "https://example.com");
          } catch (t) {
            r = null;
          }
        } else r = null;

        return r;
      }

      function i(t) {
        var e = n();
        if (!e) return !1;

        try {
          return e.responseType = t, e.responseType === t;
        } catch (t) {}

        return !1;
      }

      var o = void 0 !== t.ArrayBuffer,
          s = o && a(t.ArrayBuffer.prototype.slice);

      function a(t) {
        return "function" == typeof t;
      }

      e.arraybuffer = e.fetch || o && i("arraybuffer"), e.msstream = !e.fetch && s && i("ms-stream"), e.mozchunkedarraybuffer = !e.fetch && o && i("moz-chunked-arraybuffer"), e.overrideMimeType = e.fetch || !!n() && a(n().overrideMimeType), e.vbArray = a(t.VBArray), r = null;
    }).call(this, r(3));
  }, function (t, e, r) {
    (function (t, n, i) {
      var o = r(59),
          s = r(12),
          a = r(61),
          u = e.readyStates = {
        UNSENT: 0,
        OPENED: 1,
        HEADERS_RECEIVED: 2,
        LOADING: 3,
        DONE: 4
      },
          c = e.IncomingMessage = function (e, r, s, u) {
        var c = this;

        if (a.Readable.call(c), c._mode = s, c.headers = {}, c.rawHeaders = [], c.trailers = {}, c.rawTrailers = [], c.on("end", function () {
          t.nextTick(function () {
            c.emit("close");
          });
        }), "fetch" === s) {
          if (c._fetchResponse = r, c.url = r.url, c.statusCode = r.status, c.statusMessage = r.statusText, r.headers.forEach(function (t, e) {
            c.headers[e.toLowerCase()] = t, c.rawHeaders.push(e, t);
          }), o.writableStream) {
            var h = new WritableStream({
              write: function write(t) {
                return new Promise(function (e, r) {
                  c._destroyed ? r() : c.push(new n(t)) ? e() : c._resumeFetch = e;
                });
              },
              close: function close() {
                i.clearTimeout(u), c._destroyed || c.push(null);
              },
              abort: function abort(t) {
                c._destroyed || c.emit("error", t);
              }
            });

            try {
              return void r.body.pipeTo(h).catch(function (t) {
                i.clearTimeout(u), c._destroyed || c.emit("error", t);
              });
            } catch (t) {}
          }

          var l = r.body.getReader();
          !function t() {
            l.read().then(function (e) {
              if (!c._destroyed) {
                if (e.done) return i.clearTimeout(u), void c.push(null);
                c.push(new n(e.value)), t();
              }
            }).catch(function (t) {
              i.clearTimeout(u), c._destroyed || c.emit("error", t);
            });
          }();
        } else {
          if (c._xhr = e, c._pos = 0, c.url = e.responseURL, c.statusCode = e.status, c.statusMessage = e.statusText, e.getAllResponseHeaders().split(/\r?\n/).forEach(function (t) {
            var e = t.match(/^([^:]+):\s*(.*)/);

            if (e) {
              var r = e[1].toLowerCase();
              "set-cookie" === r ? (void 0 === c.headers[r] && (c.headers[r] = []), c.headers[r].push(e[2])) : void 0 !== c.headers[r] ? c.headers[r] += ", " + e[2] : c.headers[r] = e[2], c.rawHeaders.push(e[1], e[2]);
            }
          }), c._charset = "x-user-defined", !o.overrideMimeType) {
            var f = c.rawHeaders["mime-type"];

            if (f) {
              var p = f.match(/;\s*charset=([^;])(;|$)/);
              p && (c._charset = p[1].toLowerCase());
            }

            c._charset || (c._charset = "utf-8");
          }
        }
      };

      s(c, a.Readable), c.prototype._read = function () {
        var t = this._resumeFetch;
        t && (this._resumeFetch = null, t());
      }, c.prototype._onXHRProgress = function () {
        var t = this,
            e = t._xhr,
            r = null;

        switch (t._mode) {
          case "text:vbarray":
            if (e.readyState !== u.DONE) break;

            try {
              r = new i.VBArray(e.responseBody).toArray();
            } catch (t) {}

            if (null !== r) {
              t.push(new n(r));
              break;
            }

          case "text":
            try {
              r = e.responseText;
            } catch (e) {
              t._mode = "text:vbarray";
              break;
            }

            if (r.length > t._pos) {
              var o = r.substr(t._pos);

              if ("x-user-defined" === t._charset) {
                for (var s = new n(o.length), a = 0; a < o.length; a++) {
                  s[a] = 255 & o.charCodeAt(a);
                }

                t.push(s);
              } else t.push(o, t._charset);

              t._pos = r.length;
            }

            break;

          case "arraybuffer":
            if (e.readyState !== u.DONE || !e.response) break;
            r = e.response, t.push(new n(new Uint8Array(r)));
            break;

          case "moz-chunked-arraybuffer":
            if (r = e.response, e.readyState !== u.LOADING || !r) break;
            t.push(new n(new Uint8Array(r)));
            break;

          case "ms-stream":
            if (r = e.response, e.readyState !== u.LOADING) break;
            var c = new i.MSStreamReader();
            c.onprogress = function () {
              c.result.byteLength > t._pos && (t.push(new n(new Uint8Array(c.result.slice(t._pos)))), t._pos = c.result.byteLength);
            }, c.onload = function () {
              t.push(null);
            }, c.readAsArrayBuffer(r);
        }

        t._xhr.readyState === u.DONE && "ms-stream" !== t._mode && t.push(null);
      };
    }).call(this, r(15), r(0).Buffer, r(3));
  }, function (t, e, r) {
    (e = t.exports = r(62)).Stream = e, e.Readable = e, e.Writable = r(65), e.Duplex = r(20), e.Transform = r(68), e.PassThrough = r(101);
  }, function (t, e, r) {
    "use strict";

    (function (e, n) {
      var i = r(27);
      t.exports = _;
      var o,
          s = r(26);
      _.ReadableState = g;
      r(38).EventEmitter;

      var a = function a(t, e) {
        return t.listeners(e).length;
      },
          u = r(63),
          c = r(28).Buffer,
          h = e.Uint8Array || function () {};

      var l = r(23);
      l.inherits = r(12);
      var f = r(96),
          p = void 0;
      p = f && f.debuglog ? f.debuglog("stream") : function () {};
      var d,
          y = r(97),
          v = r(64);
      l.inherits(_, u);
      var m = ["error", "close", "destroy", "pause", "resume"];

      function g(t, e) {
        t = t || {};
        var n = e instanceof (o = o || r(20));
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var i = t.highWaterMark,
            s = t.readableHighWaterMark,
            a = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (s || 0 === s) ? s : a, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new y(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (d || (d = r(67).StringDecoder), this.decoder = new d(t.encoding), this.encoding = t.encoding);
      }

      function _(t) {
        if (o = o || r(20), !(this instanceof _)) return new _(t);
        this._readableState = new g(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), u.call(this);
      }

      function b(t, e, r, n, i) {
        var o,
            s = t._readableState;
        null === e ? (s.reading = !1, function (t, e) {
          if (e.ended) return;

          if (e.decoder) {
            var r = e.decoder.end();
            r && r.length && (e.buffer.push(r), e.length += e.objectMode ? 1 : r.length);
          }

          e.ended = !0, x(t);
        }(t, s)) : (i || (o = function (t, e) {
          var r;
          n = e, c.isBuffer(n) || n instanceof h || "string" == typeof e || void 0 === e || t.objectMode || (r = new TypeError("Invalid non-string/buffer chunk"));
          var n;
          return r;
        }(s, e)), o ? t.emit("error", o) : s.objectMode || e && e.length > 0 ? ("string" == typeof e || s.objectMode || Object.getPrototypeOf(e) === c.prototype || (e = function (t) {
          return c.from(t);
        }(e)), n ? s.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : w(t, s, e, !0) : s.ended ? t.emit("error", new Error("stream.push() after EOF")) : (s.reading = !1, s.decoder && !r ? (e = s.decoder.write(e), s.objectMode || 0 !== e.length ? w(t, s, e, !1) : A(t, s)) : w(t, s, e, !1))) : n || (s.reading = !1));
        return function (t) {
          return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length);
        }(s);
      }

      function w(t, e, r, n) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", r), t.read(0)) : (e.length += e.objectMode ? 1 : r.length, n ? e.buffer.unshift(r) : e.buffer.push(r), e.needReadable && x(t)), A(t, e);
      }

      Object.defineProperty(_.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._readableState && this._readableState.destroyed;
        },
        set: function set(t) {
          this._readableState && (this._readableState.destroyed = t);
        }
      }), _.prototype.destroy = v.destroy, _.prototype._undestroy = v.undestroy, _.prototype._destroy = function (t, e) {
        this.push(null), e(t);
      }, _.prototype.push = function (t, e) {
        var r,
            n = this._readableState;
        return n.objectMode ? r = !0 : "string" == typeof t && ((e = e || n.defaultEncoding) !== n.encoding && (t = c.from(t, e), e = ""), r = !0), b(this, t, e, !1, r);
      }, _.prototype.unshift = function (t) {
        return b(this, t, null, !0, !1);
      }, _.prototype.isPaused = function () {
        return !1 === this._readableState.flowing;
      }, _.prototype.setEncoding = function (t) {
        return d || (d = r(67).StringDecoder), this._readableState.decoder = new d(t), this._readableState.encoding = t, this;
      };
      var E = 8388608;

      function k(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
          return t >= E ? t = E : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t;
        }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0));
      }

      function x(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (p("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? i.nextTick(C, t) : C(t));
      }

      function C(t) {
        p("emit readable"), t.emit("readable"), O(t);
      }

      function A(t, e) {
        e.readingMore || (e.readingMore = !0, i.nextTick(S, t, e));
      }

      function S(t, e) {
        for (var r = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (p("maybeReadMore read 0"), t.read(0), r !== e.length);) {
          r = e.length;
        }

        e.readingMore = !1;
      }

      function T(t) {
        p("readable nexttick read 0"), t.read(0);
      }

      function R(t, e) {
        e.reading || (p("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), O(t), e.flowing && !e.reading && t.read(0);
      }

      function O(t) {
        var e = t._readableState;

        for (p("flow", e.flowing); e.flowing && null !== t.read();) {
          ;
        }
      }

      function j(t, e) {
        return 0 === e.length ? null : (e.objectMode ? r = e.buffer.shift() : !t || t >= e.length ? (r = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : r = function (t, e, r) {
          var n;
          t < e.head.data.length ? (n = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : n = t === e.head.data.length ? e.shift() : r ? function (t, e) {
            var r = e.head,
                n = 1,
                i = r.data;
            t -= i.length;

            for (; r = r.next;) {
              var o = r.data,
                  s = t > o.length ? o.length : t;

              if (s === o.length ? i += o : i += o.slice(0, t), 0 === (t -= s)) {
                s === o.length ? (++n, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = o.slice(s));
                break;
              }

              ++n;
            }

            return e.length -= n, i;
          }(t, e) : function (t, e) {
            var r = c.allocUnsafe(t),
                n = e.head,
                i = 1;
            n.data.copy(r), t -= n.data.length;

            for (; n = n.next;) {
              var o = n.data,
                  s = t > o.length ? o.length : t;

              if (o.copy(r, r.length - t, 0, s), 0 === (t -= s)) {
                s === o.length ? (++i, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = o.slice(s));
                break;
              }

              ++i;
            }

            return e.length -= i, r;
          }(t, e);
          return n;
        }(t, e.buffer, e.decoder), r);
        var r;
      }

      function P(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, i.nextTick(I, e, t));
      }

      function I(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"));
      }

      function B(t, e) {
        for (var r = 0, n = t.length; r < n; r++) {
          if (t[r] === e) return r;
        }

        return -1;
      }

      _.prototype.read = function (t) {
        p("read", t), t = parseInt(t, 10);
        var e = this._readableState,
            r = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return p("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? P(this) : x(this), null;
        if (0 === (t = k(t, e)) && e.ended) return 0 === e.length && P(this), null;
        var n,
            i = e.needReadable;
        return p("need readable", i), (0 === e.length || e.length - t < e.highWaterMark) && p("length less than watermark", i = !0), e.ended || e.reading ? p("reading or ended", i = !1) : i && (p("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = k(r, e))), null === (n = t > 0 ? j(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), r !== t && e.ended && P(this)), null !== n && this.emit("data", n), n;
      }, _.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"));
      }, _.prototype.pipe = function (t, e) {
        var r = this,
            o = this._readableState;

        switch (o.pipesCount) {
          case 0:
            o.pipes = t;
            break;

          case 1:
            o.pipes = [o.pipes, t];
            break;

          default:
            o.pipes.push(t);
        }

        o.pipesCount += 1, p("pipe count=%d opts=%j", o.pipesCount, e);
        var u = (!e || !1 !== e.end) && t !== n.stdout && t !== n.stderr ? h : _;

        function c(e, n) {
          p("onunpipe"), e === r && n && !1 === n.hasUnpiped && (n.hasUnpiped = !0, p("cleanup"), t.removeListener("close", m), t.removeListener("finish", g), t.removeListener("drain", l), t.removeListener("error", v), t.removeListener("unpipe", c), r.removeListener("end", h), r.removeListener("end", _), r.removeListener("data", y), f = !0, !o.awaitDrain || t._writableState && !t._writableState.needDrain || l());
        }

        function h() {
          p("onend"), t.end();
        }

        o.endEmitted ? i.nextTick(u) : r.once("end", u), t.on("unpipe", c);

        var l = function (t) {
          return function () {
            var e = t._readableState;
            p("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && a(t, "data") && (e.flowing = !0, O(t));
          };
        }(r);

        t.on("drain", l);
        var f = !1;
        var d = !1;

        function y(e) {
          p("ondata"), d = !1, !1 !== t.write(e) || d || ((1 === o.pipesCount && o.pipes === t || o.pipesCount > 1 && -1 !== B(o.pipes, t)) && !f && (p("false write response, pause", r._readableState.awaitDrain), r._readableState.awaitDrain++, d = !0), r.pause());
        }

        function v(e) {
          p("onerror", e), _(), t.removeListener("error", v), 0 === a(t, "error") && t.emit("error", e);
        }

        function m() {
          t.removeListener("finish", g), _();
        }

        function g() {
          p("onfinish"), t.removeListener("close", m), _();
        }

        function _() {
          p("unpipe"), r.unpipe(t);
        }

        return r.on("data", y), function (t, e, r) {
          if ("function" == typeof t.prependListener) return t.prependListener(e, r);
          t._events && t._events[e] ? s(t._events[e]) ? t._events[e].unshift(r) : t._events[e] = [r, t._events[e]] : t.on(e, r);
        }(t, "error", v), t.once("close", m), t.once("finish", g), t.emit("pipe", r), o.flowing || (p("pipe resume"), r.resume()), t;
      }, _.prototype.unpipe = function (t) {
        var e = this._readableState,
            r = {
          hasUnpiped: !1
        };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, r), this);

        if (!t) {
          var n = e.pipes,
              i = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;

          for (var o = 0; o < i; o++) {
            n[o].emit("unpipe", this, r);
          }

          return this;
        }

        var s = B(e.pipes, t);
        return -1 === s ? this : (e.pipes.splice(s, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, r), this);
      }, _.prototype.on = function (t, e) {
        var r = u.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();else if ("readable" === t) {
          var n = this._readableState;
          n.endEmitted || n.readableListening || (n.readableListening = n.needReadable = !0, n.emittedReadable = !1, n.reading ? n.length && x(this) : i.nextTick(T, this));
        }
        return r;
      }, _.prototype.addListener = _.prototype.on, _.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (p("resume"), t.flowing = !0, function (t, e) {
          e.resumeScheduled || (e.resumeScheduled = !0, i.nextTick(R, t, e));
        }(this, t)), this;
      }, _.prototype.pause = function () {
        return p("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (p("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
      }, _.prototype.wrap = function (t) {
        var e = this,
            r = this._readableState,
            n = !1;

        for (var i in t.on("end", function () {
          if (p("wrapped end"), r.decoder && !r.ended) {
            var t = r.decoder.end();
            t && t.length && e.push(t);
          }

          e.push(null);
        }), t.on("data", function (i) {
          (p("wrapped data"), r.decoder && (i = r.decoder.write(i)), r.objectMode && null == i) || (r.objectMode || i && i.length) && (e.push(i) || (n = !0, t.pause()));
        }), t) {
          void 0 === this[i] && "function" == typeof t[i] && (this[i] = function (e) {
            return function () {
              return t[e].apply(t, arguments);
            };
          }(i));
        }

        for (var o = 0; o < m.length; o++) {
          t.on(m[o], this.emit.bind(this, m[o]));
        }

        return this._read = function (e) {
          p("wrapped _read", e), n && (n = !1, t.resume());
        }, this;
      }, Object.defineProperty(_.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._readableState.highWaterMark;
        }
      }), _._fromList = j;
    }).call(this, r(3), r(15));
  }, function (t, e, r) {
    t.exports = r(38).EventEmitter;
  }, function (t, e, r) {
    "use strict";

    var n = r(27);

    function i(t, e) {
      t.emit("error", e);
    }

    t.exports = {
      destroy: function destroy(t, e) {
        var r = this,
            o = this._readableState && this._readableState.destroyed,
            s = this._writableState && this._writableState.destroyed;
        return o || s ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || n.nextTick(i, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, function (t) {
          !e && t ? (n.nextTick(i, r, t), r._writableState && (r._writableState.errorEmitted = !0)) : e && e(t);
        }), this);
      },
      undestroy: function undestroy() {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
      }
    };
  }, function (t, e, r) {
    "use strict";

    (function (e, n, i) {
      var o = r(27);

      function s(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          !function (t, e, r) {
            var n = t.entry;
            t.entry = null;

            for (; n;) {
              var i = n.callback;
              e.pendingcb--, i(r), n = n.next;
            }

            e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t;
          }(e, t);
        };
      }

      t.exports = g;
      var a,
          u = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? n : o.nextTick;
      g.WritableState = m;
      var c = r(23);
      c.inherits = r(12);

      var h = {
        deprecate: r(100)
      },
          l = r(63),
          f = r(28).Buffer,
          p = i.Uint8Array || function () {};

      var d,
          y = r(64);

      function v() {}

      function m(t, e) {
        a = a || r(20), t = t || {};
        var n = e instanceof a;
        this.objectMode = !!t.objectMode, n && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var i = t.highWaterMark,
            c = t.writableHighWaterMark,
            h = this.objectMode ? 16 : 16384;
        this.highWaterMark = i || 0 === i ? i : n && (c || 0 === c) ? c : h, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var l = !1 === t.decodeStrings;
        this.decodeStrings = !l, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          !function (t, e) {
            var r = t._writableState,
                n = r.sync,
                i = r.writecb;
            if (function (t) {
              t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0;
            }(r), e) !function (t, e, r, n, i) {
              --e.pendingcb, r ? (o.nextTick(i, n), o.nextTick(x, t, e), t._writableState.errorEmitted = !0, t.emit("error", n)) : (i(n), t._writableState.errorEmitted = !0, t.emit("error", n), x(t, e));
            }(t, r, n, e, i);else {
              var s = E(r);
              s || r.corked || r.bufferProcessing || !r.bufferedRequest || w(t, r), n ? u(b, t, r, s, i) : b(t, r, s, i);
            }
          }(e, t);
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new s(this);
      }

      function g(t) {
        if (a = a || r(20), !(d.call(g, this) || this instanceof a)) return new g(t);
        this._writableState = new m(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), l.call(this);
      }

      function _(t, e, r, n, i, o, s) {
        e.writelen = n, e.writecb = s, e.writing = !0, e.sync = !0, r ? t._writev(i, e.onwrite) : t._write(i, o, e.onwrite), e.sync = !1;
      }

      function b(t, e, r, n) {
        r || function (t, e) {
          0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"));
        }(t, e), e.pendingcb--, n(), x(t, e);
      }

      function w(t, e) {
        e.bufferProcessing = !0;
        var r = e.bufferedRequest;

        if (t._writev && r && r.next) {
          var n = e.bufferedRequestCount,
              i = new Array(n),
              o = e.corkedRequestsFree;
          o.entry = r;

          for (var a = 0, u = !0; r;) {
            i[a] = r, r.isBuf || (u = !1), r = r.next, a += 1;
          }

          i.allBuffers = u, _(t, e, !0, e.length, i, "", o.finish), e.pendingcb++, e.lastBufferedRequest = null, o.next ? (e.corkedRequestsFree = o.next, o.next = null) : e.corkedRequestsFree = new s(e), e.bufferedRequestCount = 0;
        } else {
          for (; r;) {
            var c = r.chunk,
                h = r.encoding,
                l = r.callback;
            if (_(t, e, !1, e.objectMode ? 1 : c.length, c, h, l), r = r.next, e.bufferedRequestCount--, e.writing) break;
          }

          null === r && (e.lastBufferedRequest = null);
        }

        e.bufferedRequest = r, e.bufferProcessing = !1;
      }

      function E(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing;
      }

      function k(t, e) {
        t._final(function (r) {
          e.pendingcb--, r && t.emit("error", r), e.prefinished = !0, t.emit("prefinish"), x(t, e);
        });
      }

      function x(t, e) {
        var r = E(e);
        return r && (!function (t, e) {
          e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, o.nextTick(k, t, e)) : (e.prefinished = !0, t.emit("prefinish")));
        }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), r;
      }

      c.inherits(g, l), m.prototype.getBuffer = function () {
        for (var t = this.bufferedRequest, e = []; t;) {
          e.push(t), t = t.next;
        }

        return e;
      }, function () {
        try {
          Object.defineProperty(m.prototype, "buffer", {
            get: h.deprecate(function () {
              return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
          });
        } catch (t) {}
      }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (d = Function.prototype[Symbol.hasInstance], Object.defineProperty(g, Symbol.hasInstance, {
        value: function value(t) {
          return !!d.call(this, t) || this === g && t && t._writableState instanceof m;
        }
      })) : d = function d(t) {
        return t instanceof this;
      }, g.prototype.pipe = function () {
        this.emit("error", new Error("Cannot pipe, not readable"));
      }, g.prototype.write = function (t, e, r) {
        var n,
            i = this._writableState,
            s = !1,
            a = !i.objectMode && (n = t, f.isBuffer(n) || n instanceof p);
        return a && !f.isBuffer(t) && (t = function (t) {
          return f.from(t);
        }(t)), "function" == typeof e && (r = e, e = null), a ? e = "buffer" : e || (e = i.defaultEncoding), "function" != typeof r && (r = v), i.ended ? function (t, e) {
          var r = new Error("write after end");
          t.emit("error", r), o.nextTick(e, r);
        }(this, r) : (a || function (t, e, r, n) {
          var i = !0,
              s = !1;
          return null === r ? s = new TypeError("May not write null values to stream") : "string" == typeof r || void 0 === r || e.objectMode || (s = new TypeError("Invalid non-string/buffer chunk")), s && (t.emit("error", s), o.nextTick(n, s), i = !1), i;
        }(this, i, t, r)) && (i.pendingcb++, s = function (t, e, r, n, i, o) {
          if (!r) {
            var s = function (t, e, r) {
              t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = f.from(e, r));
              return e;
            }(e, n, i);

            n !== s && (r = !0, i = "buffer", n = s);
          }

          var a = e.objectMode ? 1 : n.length;
          e.length += a;
          var u = e.length < e.highWaterMark;
          u || (e.needDrain = !0);

          if (e.writing || e.corked) {
            var c = e.lastBufferedRequest;
            e.lastBufferedRequest = {
              chunk: n,
              encoding: i,
              isBuf: r,
              callback: o,
              next: null
            }, c ? c.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1;
          } else _(t, e, !1, a, n, i, o);

          return u;
        }(this, i, a, t, e, r)), s;
      }, g.prototype.cork = function () {
        this._writableState.corked++;
      }, g.prototype.uncork = function () {
        var t = this._writableState;
        t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || w(this, t));
      }, g.prototype.setDefaultEncoding = function (t) {
        if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
        return this._writableState.defaultEncoding = t, this;
      }, Object.defineProperty(g.prototype, "writableHighWaterMark", {
        enumerable: !1,
        get: function get() {
          return this._writableState.highWaterMark;
        }
      }), g.prototype._write = function (t, e, r) {
        r(new Error("_write() is not implemented"));
      }, g.prototype._writev = null, g.prototype.end = function (t, e, r) {
        var n = this._writableState;
        "function" == typeof t ? (r = t, t = null, e = null) : "function" == typeof e && (r = e, e = null), null != t && this.write(t, e), n.corked && (n.corked = 1, this.uncork()), n.ending || n.finished || function (t, e, r) {
          e.ending = !0, x(t, e), r && (e.finished ? o.nextTick(r) : t.once("finish", r));
          e.ended = !0, t.writable = !1;
        }(this, n, r);
      }, Object.defineProperty(g.prototype, "destroyed", {
        get: function get() {
          return void 0 !== this._writableState && this._writableState.destroyed;
        },
        set: function set(t) {
          this._writableState && (this._writableState.destroyed = t);
        }
      }), g.prototype.destroy = y.destroy, g.prototype._undestroy = y.undestroy, g.prototype._destroy = function (t, e) {
        this.end(), e(t);
      };
    }).call(this, r(15), r(66).setImmediate, r(3));
  }, function (t, e, r) {
    (function (t) {
      var n = void 0 !== t && t || "undefined" != typeof self && self || window,
          i = Function.prototype.apply;

      function o(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new o(i.call(setTimeout, n, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new o(i.call(setInterval, n, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, o.prototype.unref = o.prototype.ref = function () {}, o.prototype.close = function () {
        this._clearFn.call(n, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, r(99), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, r(3));
  }, function (t, e, r) {
    "use strict";

    var n = r(28).Buffer,
        i = n.isEncoding || function (t) {
      switch ((t = "" + t) && t.toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
          return !0;

        default:
          return !1;
      }
    };

    function o(t) {
      var e;

      switch (this.encoding = function (t) {
        var e = function (t) {
          if (!t) return "utf8";

          for (var e;;) {
            switch (t) {
              case "utf8":
              case "utf-8":
                return "utf8";

              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";

              case "latin1":
              case "binary":
                return "latin1";

              case "base64":
              case "ascii":
              case "hex":
                return t;

              default:
                if (e) return;
                t = ("" + t).toLowerCase(), e = !0;
            }
          }
        }(t);

        if ("string" != typeof e && (n.isEncoding === i || !i(t))) throw new Error("Unknown encoding: " + t);
        return e || t;
      }(t), this.encoding) {
        case "utf16le":
          this.text = u, this.end = c, e = 4;
          break;

        case "utf8":
          this.fillLast = a, e = 4;
          break;

        case "base64":
          this.text = h, this.end = l, e = 3;
          break;

        default:
          return this.write = f, void (this.end = p);
      }

      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = n.allocUnsafe(e);
    }

    function s(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2;
    }

    function a(t) {
      var e = this.lastTotal - this.lastNeed,
          r = function (t, e, r) {
        if (128 != (192 & e[0])) return t.lastNeed = 0, "�";

        if (t.lastNeed > 1 && e.length > 1) {
          if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
          if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�";
        }
      }(this, t);

      return void 0 !== r ? r : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void (this.lastNeed -= t.length));
    }

    function u(t, e) {
      if ((t.length - e) % 2 == 0) {
        var r = t.toString("utf16le", e);

        if (r) {
          var n = r.charCodeAt(r.length - 1);
          if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], r.slice(0, -1);
        }

        return r;
      }

      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1);
    }

    function c(t) {
      var e = t && t.length ? this.write(t) : "";

      if (this.lastNeed) {
        var r = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, r);
      }

      return e;
    }

    function h(t, e) {
      var r = (t.length - e) % 3;
      return 0 === r ? t.toString("base64", e) : (this.lastNeed = 3 - r, this.lastTotal = 3, 1 === r ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - r));
    }

    function l(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e;
    }

    function f(t) {
      return t.toString(this.encoding);
    }

    function p(t) {
      return t && t.length ? this.write(t) : "";
    }

    e.StringDecoder = o, o.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, r;

      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        r = this.lastNeed, this.lastNeed = 0;
      } else r = 0;

      return r < t.length ? e ? e + this.text(t, r) : this.text(t, r) : e || "";
    }, o.prototype.end = function (t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�" : e;
    }, o.prototype.text = function (t, e) {
      var r = function (t, e, r) {
        var n = e.length - 1;
        if (n < r) return 0;
        var i = s(e[n]);
        if (i >= 0) return i > 0 && (t.lastNeed = i - 1), i;
        if (--n < r || -2 === i) return 0;
        if ((i = s(e[n])) >= 0) return i > 0 && (t.lastNeed = i - 2), i;
        if (--n < r || -2 === i) return 0;
        if ((i = s(e[n])) >= 0) return i > 0 && (2 === i ? i = 0 : t.lastNeed = i - 3), i;
        return 0;
      }(this, t, e);

      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = r;
      var n = t.length - (r - this.lastNeed);
      return t.copy(this.lastChar, 0, n), t.toString("utf8", e, n);
    }, o.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length;
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = s;
    var n = r(20),
        i = r(23);

    function o(t, e) {
      var r = this._transformState;
      r.transforming = !1;
      var n = r.writecb;
      if (!n) return this.emit("error", new Error("write callback called multiple times"));
      r.writechunk = null, r.writecb = null, null != e && this.push(e), n(t);
      var i = this._readableState;
      i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
    }

    function s(t) {
      if (!(this instanceof s)) return new s(t);
      n.call(this, t), this._transformState = {
        afterTransform: o.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", a);
    }

    function a() {
      var t = this;
      "function" == typeof this._flush ? this._flush(function (e, r) {
        u(t, e, r);
      }) : u(this, null, null);
    }

    function u(t, e, r) {
      if (e) return t.emit("error", e);
      if (null != r && t.push(r), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null);
    }

    i.inherits = r(12), i.inherits(s, n), s.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, n.prototype.push.call(this, t, e);
    }, s.prototype._transform = function (t, e, r) {
      throw new Error("_transform() is not implemented");
    }, s.prototype._write = function (t, e, r) {
      var n = this._transformState;

      if (n.writecb = r, n.writechunk = t, n.writeencoding = e, !n.transforming) {
        var i = this._readableState;
        (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
      }
    }, s.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0;
    }, s.prototype._destroy = function (t, e) {
      var r = this;

      n.prototype._destroy.call(this, t, function (t) {
        e(t), r.emit("close");
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(105),
        i = r(106);

    function o() {
      this.protocol = null, this.slashes = null, this.auth = null, this.host = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.query = null, this.pathname = null, this.path = null, this.href = null;
    }

    e.parse = _, e.resolve = function (t, e) {
      return _(t, !1, !0).resolve(e);
    }, e.resolveObject = function (t, e) {
      return t ? _(t, !1, !0).resolveObject(e) : e;
    }, e.format = function (t) {
      i.isString(t) && (t = _(t));
      return t instanceof o ? t.format() : o.prototype.format.call(t);
    }, e.Url = o;
    var s = /^([a-z0-9.+-]+:)/i,
        a = /:[0-9]*$/,
        u = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
        c = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
        h = ["'"].concat(c),
        l = ["%", "/", "?", ";", "#"].concat(h),
        f = ["/", "?", "#"],
        p = /^[+a-z0-9A-Z_-]{0,63}$/,
        d = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
        y = {
      javascript: !0,
      "javascript:": !0
    },
        v = {
      javascript: !0,
      "javascript:": !0
    },
        m = {
      http: !0,
      https: !0,
      ftp: !0,
      gopher: !0,
      file: !0,
      "http:": !0,
      "https:": !0,
      "ftp:": !0,
      "gopher:": !0,
      "file:": !0
    },
        g = r(107);

    function _(t, e, r) {
      if (t && i.isObject(t) && t instanceof o) return t;
      var n = new o();
      return n.parse(t, e, r), n;
    }

    o.prototype.parse = function (t, e, r) {
      if (!i.isString(t)) throw new TypeError("Parameter 'url' must be a string, not " + typeof t);
      var o = t.indexOf("?"),
          a = -1 !== o && o < t.indexOf("#") ? "?" : "#",
          c = t.split(a);
      c[0] = c[0].replace(/\\/g, "/");

      var _ = t = c.join(a);

      if (_ = _.trim(), !r && 1 === t.split("#").length) {
        var b = u.exec(_);
        if (b) return this.path = _, this.href = _, this.pathname = b[1], b[2] ? (this.search = b[2], this.query = e ? g.parse(this.search.substr(1)) : this.search.substr(1)) : e && (this.search = "", this.query = {}), this;
      }

      var w = s.exec(_);

      if (w) {
        var E = (w = w[0]).toLowerCase();
        this.protocol = E, _ = _.substr(w.length);
      }

      if (r || w || _.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var k = "//" === _.substr(0, 2);

        !k || w && v[w] || (_ = _.substr(2), this.slashes = !0);
      }

      if (!v[w] && (k || w && !m[w])) {
        for (var x, C, A = -1, S = 0; S < f.length; S++) {
          -1 !== (T = _.indexOf(f[S])) && (-1 === A || T < A) && (A = T);
        }

        -1 !== (C = -1 === A ? _.lastIndexOf("@") : _.lastIndexOf("@", A)) && (x = _.slice(0, C), _ = _.slice(C + 1), this.auth = decodeURIComponent(x)), A = -1;

        for (S = 0; S < l.length; S++) {
          var T;
          -1 !== (T = _.indexOf(l[S])) && (-1 === A || T < A) && (A = T);
        }

        -1 === A && (A = _.length), this.host = _.slice(0, A), _ = _.slice(A), this.parseHost(), this.hostname = this.hostname || "";
        var R = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
        if (!R) for (var O = this.hostname.split(/\./), j = (S = 0, O.length); S < j; S++) {
          var P = O[S];

          if (P && !P.match(p)) {
            for (var I = "", B = 0, F = P.length; B < F; B++) {
              P.charCodeAt(B) > 127 ? I += "x" : I += P[B];
            }

            if (!I.match(p)) {
              var L = O.slice(0, S),
                  M = O.slice(S + 1),
                  D = P.match(d);
              D && (L.push(D[1]), M.unshift(D[2])), M.length && (_ = "/" + M.join(".") + _), this.hostname = L.join(".");
              break;
            }
          }
        }
        this.hostname.length > 255 ? this.hostname = "" : this.hostname = this.hostname.toLowerCase(), R || (this.hostname = n.toASCII(this.hostname));
        var U = this.port ? ":" + this.port : "",
            N = this.hostname || "";
        this.host = N + U, this.href += this.host, R && (this.hostname = this.hostname.substr(1, this.hostname.length - 2), "/" !== _[0] && (_ = "/" + _));
      }

      if (!y[E]) for (S = 0, j = h.length; S < j; S++) {
        var H = h[S];

        if (-1 !== _.indexOf(H)) {
          var q = encodeURIComponent(H);
          q === H && (q = escape(H)), _ = _.split(H).join(q);
        }
      }

      var V = _.indexOf("#");

      -1 !== V && (this.hash = _.substr(V), _ = _.slice(0, V));

      var z = _.indexOf("?");

      if (-1 !== z ? (this.search = _.substr(z), this.query = _.substr(z + 1), e && (this.query = g.parse(this.query)), _ = _.slice(0, z)) : e && (this.search = "", this.query = {}), _ && (this.pathname = _), m[E] && this.hostname && !this.pathname && (this.pathname = "/"), this.pathname || this.search) {
        U = this.pathname || "";
        var Y = this.search || "";
        this.path = U + Y;
      }

      return this.href = this.format(), this;
    }, o.prototype.format = function () {
      var t = this.auth || "";
      t && (t = (t = encodeURIComponent(t)).replace(/%3A/i, ":"), t += "@");
      var e = this.protocol || "",
          r = this.pathname || "",
          n = this.hash || "",
          o = !1,
          s = "";
      this.host ? o = t + this.host : this.hostname && (o = t + (-1 === this.hostname.indexOf(":") ? this.hostname : "[" + this.hostname + "]"), this.port && (o += ":" + this.port)), this.query && i.isObject(this.query) && Object.keys(this.query).length && (s = g.stringify(this.query));
      var a = this.search || s && "?" + s || "";
      return e && ":" !== e.substr(-1) && (e += ":"), this.slashes || (!e || m[e]) && !1 !== o ? (o = "//" + (o || ""), r && "/" !== r.charAt(0) && (r = "/" + r)) : o || (o = ""), n && "#" !== n.charAt(0) && (n = "#" + n), a && "?" !== a.charAt(0) && (a = "?" + a), e + o + (r = r.replace(/[?#]/g, function (t) {
        return encodeURIComponent(t);
      })) + (a = a.replace("#", "%23")) + n;
    }, o.prototype.resolve = function (t) {
      return this.resolveObject(_(t, !1, !0)).format();
    }, o.prototype.resolveObject = function (t) {
      if (i.isString(t)) {
        var e = new o();
        e.parse(t, !1, !0), t = e;
      }

      for (var r = new o(), n = Object.keys(this), s = 0; s < n.length; s++) {
        var a = n[s];
        r[a] = this[a];
      }

      if (r.hash = t.hash, "" === t.href) return r.href = r.format(), r;

      if (t.slashes && !t.protocol) {
        for (var u = Object.keys(t), c = 0; c < u.length; c++) {
          var h = u[c];
          "protocol" !== h && (r[h] = t[h]);
        }

        return m[r.protocol] && r.hostname && !r.pathname && (r.path = r.pathname = "/"), r.href = r.format(), r;
      }

      if (t.protocol && t.protocol !== r.protocol) {
        if (!m[t.protocol]) {
          for (var l = Object.keys(t), f = 0; f < l.length; f++) {
            var p = l[f];
            r[p] = t[p];
          }

          return r.href = r.format(), r;
        }

        if (r.protocol = t.protocol, t.host || v[t.protocol]) r.pathname = t.pathname;else {
          for (var d = (t.pathname || "").split("/"); d.length && !(t.host = d.shift());) {
            ;
          }

          t.host || (t.host = ""), t.hostname || (t.hostname = ""), "" !== d[0] && d.unshift(""), d.length < 2 && d.unshift(""), r.pathname = d.join("/");
        }

        if (r.search = t.search, r.query = t.query, r.host = t.host || "", r.auth = t.auth, r.hostname = t.hostname || t.host, r.port = t.port, r.pathname || r.search) {
          var y = r.pathname || "",
              g = r.search || "";
          r.path = y + g;
        }

        return r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
      }

      var _ = r.pathname && "/" === r.pathname.charAt(0),
          b = t.host || t.pathname && "/" === t.pathname.charAt(0),
          w = b || _ || r.host && t.pathname,
          E = w,
          k = r.pathname && r.pathname.split("/") || [],
          x = (d = t.pathname && t.pathname.split("/") || [], r.protocol && !m[r.protocol]);

      if (x && (r.hostname = "", r.port = null, r.host && ("" === k[0] ? k[0] = r.host : k.unshift(r.host)), r.host = "", t.protocol && (t.hostname = null, t.port = null, t.host && ("" === d[0] ? d[0] = t.host : d.unshift(t.host)), t.host = null), w = w && ("" === d[0] || "" === k[0])), b) r.host = t.host || "" === t.host ? t.host : r.host, r.hostname = t.hostname || "" === t.hostname ? t.hostname : r.hostname, r.search = t.search, r.query = t.query, k = d;else if (d.length) k || (k = []), k.pop(), k = k.concat(d), r.search = t.search, r.query = t.query;else if (!i.isNullOrUndefined(t.search)) {
        if (x) r.hostname = r.host = k.shift(), (R = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = R.shift(), r.host = r.hostname = R.shift());
        return r.search = t.search, r.query = t.query, i.isNull(r.pathname) && i.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.href = r.format(), r;
      }
      if (!k.length) return r.pathname = null, r.search ? r.path = "/" + r.search : r.path = null, r.href = r.format(), r;

      for (var C = k.slice(-1)[0], A = (r.host || t.host || k.length > 1) && ("." === C || ".." === C) || "" === C, S = 0, T = k.length; T >= 0; T--) {
        "." === (C = k[T]) ? k.splice(T, 1) : ".." === C ? (k.splice(T, 1), S++) : S && (k.splice(T, 1), S--);
      }

      if (!w && !E) for (; S--; S) {
        k.unshift("..");
      }
      !w || "" === k[0] || k[0] && "/" === k[0].charAt(0) || k.unshift(""), A && "/" !== k.join("/").substr(-1) && k.push("");
      var R,
          O = "" === k[0] || k[0] && "/" === k[0].charAt(0);
      x && (r.hostname = r.host = O ? "" : k.length ? k.shift() : "", (R = !!(r.host && r.host.indexOf("@") > 0) && r.host.split("@")) && (r.auth = R.shift(), r.host = r.hostname = R.shift()));
      return (w = w || r.host && k.length) && !O && k.unshift(""), k.length ? r.pathname = k.join("/") : (r.pathname = null, r.path = null), i.isNull(r.pathname) && i.isNull(r.search) || (r.path = (r.pathname ? r.pathname : "") + (r.search ? r.search : "")), r.auth = t.auth || r.auth, r.slashes = r.slashes || t.slashes, r.href = r.format(), r;
    }, o.prototype.parseHost = function () {
      var t = this.host,
          e = a.exec(t);
      e && (":" !== (e = e[0]) && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = Object.assign({}, r(71), r(49), r(19), r(30), r(2), r(18), r(117));
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(5)),
        o = n(r(6)),
        s = n(r(7)),
        a = n(r(10)),
        u = r(49),
        c = u.FactomdCli,
        h = u.WalletdCli,
        l = r(113),
        f = r(115),
        p = r(47),
        d = r(48),
        y = r(116),
        v = function () {
      function t(e) {
        (0, s.default)(this, t);
        var r = e || {},
            n = r.factomd || r,
            i = r.walletd;
        this.factomd = new c(n), this.walletd = new h(i);
      }

      var e, r, n, u, v, m, g, _, b, w, E, k, x, C;

      return (0, a.default)(t, [{
        key: "commit",
        value: (C = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.commit(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.commit(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return C.apply(this, arguments);
        })
      }, {
        key: "commitChain",
        value: (x = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.commitChain(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.commitChain(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return x.apply(this, arguments);
        })
      }, {
        key: "commitEntry",
        value: (k = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.commitEntry(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.commitEntry(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return k.apply(this, arguments);
        })
      }, {
        key: "reveal",
        value: (E = (0, o.default)(i.default.mark(function t(e, r) {
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", l.reveal(this.factomd, e, r));

                case 1:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return E.apply(this, arguments);
        })
      }, {
        key: "revealChain",
        value: (w = (0, o.default)(i.default.mark(function t(e, r) {
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", l.revealChain(this.factomd, e, r));

                case 1:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return w.apply(this, arguments);
        })
      }, {
        key: "revealEntry",
        value: (b = (0, o.default)(i.default.mark(function t(e, r) {
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.abrupt("return", l.revealEntry(this.factomd, e, r));

                case 1:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return b.apply(this, arguments);
        })
      }, {
        key: "add",
        value: (_ = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.add(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.add(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return _.apply(this, arguments);
        })
      }, {
        key: "addChain",
        value: (g = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.addChain(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.addChain(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return g.apply(this, arguments);
        })
      }, {
        key: "addChains",
        value: (m = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.addChains(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.addChains(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return m.apply(this, arguments);
        })
      }, {
        key: "addEntry",
        value: (v = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.addEntry(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.addEntry(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return v.apply(this, arguments);
        })
      }, {
        key: "addEntries",
        value: (u = (0, o.default)(i.default.mark(function t(e, r) {
          var n,
              o,
              s = arguments;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ((n = s.length > 2 && void 0 !== s[2] ? s[2] : {}).sign) {
                    t.next = 8;
                    break;
                  }

                  return t.next = 4, this.getPrivateAddress(r);

                case 4:
                  return o = t.sent, t.abrupt("return", l.addEntries(this.factomd, e, o, n));

                case 8:
                  return t.abrupt("return", l.addEntries(this.factomd, e, r, n));

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e) {
          return u.apply(this, arguments);
        })
      }, {
        key: "getPrivateAddress",
        value: (n = (0, o.default)(i.default.mark(function t(e) {
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, y.getPrivateAddress(this.walletd, e);

                case 2:
                  return t.abrupt("return", t.sent);

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return n.apply(this, arguments);
        })
      }, {
        key: "getAllEntriesOfChain",
        value: function value(t) {
          return p.getAllEntriesOfChain(this.factomd, t);
        }
      }, {
        key: "getChainHead",
        value: function value(t) {
          return p.getChainHead(this.factomd, t);
        }
      }, {
        key: "getEntry",
        value: function value(t) {
          return p.getEntry(this.factomd, t);
        }
      }, {
        key: "getEntryWithBlockContext",
        value: function value(t) {
          return p.getEntryWithBlockContext(this.factomd, t);
        }
      }, {
        key: "getFirstEntry",
        value: function value(t) {
          return p.getFirstEntry(this.factomd, t);
        }
      }, {
        key: "getBalance",
        value: function value(t) {
          return p.getBalance(this.factomd, t);
        }
      }, {
        key: "chainExists",
        value: function value(t) {
          return p.chainExists(this.factomd, t);
        }
      }, {
        key: "getEntryCreditRate",
        value: function value() {
          return p.getEntryCreditRate(this.factomd);
        }
      }, {
        key: "getTransaction",
        value: function value(t) {
          return p.getTransaction(this.factomd, t);
        }
      }, {
        key: "rewindChainWhile",
        value: function value(t, e, r) {
          return p.rewindChainWhile(this.factomd, t, e, r);
        }
      }, {
        key: "sendTransaction",
        value: function value(t, e) {
          return f.sendTransaction(this.factomd, t, e);
        }
      }, {
        key: "createFactoidTransaction",
        value: (r = (0, o.default)(i.default.mark(function t(e, r, n, o) {
          var s;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.getPrivateAddress(e);

                case 2:
                  return s = t.sent, t.abrupt("return", f.createFactoidTransaction(this.factomd, s, r, n, o));

                case 4:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, e, n, i) {
          return r.apply(this, arguments);
        })
      }, {
        key: "createEntryCreditPurchaseTransaction",
        value: (e = (0, o.default)(i.default.mark(function t(e, r, n, o) {
          var s;
          return i.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this.getPrivateAddress(e);

                case 2:
                  return s = t.sent, t.abrupt("return", f.createEntryCreditPurchaseTransaction(this.factomd, s, r, n, o));

                case 4:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t, r, n, i) {
          return e.apply(this, arguments);
        })
      }, {
        key: "waitOnCommitAck",
        value: function value(t, e) {
          return d.waitOnCommitAck(this.factomd, t, e);
        }
      }, {
        key: "waitOnRevealAck",
        value: function value(t, e, r) {
          return d.waitOnRevealAck(this.factomd, t, e, r);
        }
      }, {
        key: "waitOnFactoidTransactionAck",
        value: function value(t, e) {
          return d.waitOnFactoidTransactionAck(this.factomd, t, e);
        }
      }, {
        key: "factomdApi",
        value: function value(t, e, r) {
          return this.factomd.call(t, e, r);
        }
      }, {
        key: "walletdApi",
        value: function value(t, e, r) {
          return this.walletd.call(t, e, r);
        }
      }, {
        key: "getHeights",
        value: function value() {
          return p.getHeights(this.factomd);
        }
      }, {
        key: "getDirectoryBlockHead",
        value: function value() {
          return p.getDirectoryBlockHead(this.factomd);
        }
      }, {
        key: "getDirectoryBlock",
        value: function value(t) {
          return p.getDirectoryBlock(this.factomd, t);
        }
      }, {
        key: "getAdminBlock",
        value: function value(t) {
          return p.getAdminBlock(this.factomd, t);
        }
      }, {
        key: "getEntryCreditBlock",
        value: function value(t) {
          return p.getEntryCreditBlock(this.factomd, t);
        }
      }, {
        key: "getFactoidBlock",
        value: function value(t) {
          return p.getFactoidBlock(this.factomd, t);
        }
      }, {
        key: "getEntryBlock",
        value: function value(t) {
          return p.getEntryBlock(this.factomd, t);
        }
      }]), t;
    }();

    t.exports = {
      FactomCli: v
    };
  }, function (t, e, r) {
    var n = r(73);

    function i(e, r, o) {
      return "undefined" != typeof Reflect && Reflect.get ? t.exports = i = Reflect.get : t.exports = i = function i(t, e, r) {
        var i = n(t, e);

        if (i) {
          var o = Object.getOwnPropertyDescriptor(i, e);
          return o.get ? o.get.call(r) : o.value;
        }
      }, i(e, r, o || e);
    }

    t.exports = i;
  }, function (t, e, r) {
    var n = r(22);

    t.exports = function (t, e) {
      for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = n(t));) {
        ;
      }

      return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    };
  }, function (t, e, r) {
    var n = r(35);

    function i(e, r, o) {
      return !function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }() ? t.exports = i = function i(t, e, r) {
        var i = [null];
        i.push.apply(i, e);
        var o = new (Function.bind.apply(t, i))();
        return r && n(o, r.prototype), o;
      } : t.exports = i = Reflect.construct, i.apply(null, arguments);
    }

    t.exports = i;
  }, function (t, e, r) {
    t.exports = r(77);
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(51),
        o = r(79),
        s = r(57);

    function a(t) {
      var e = new o(t),
          r = i(o.prototype.request, e);
      return n.extend(r, o.prototype, e), n.extend(r, e), r;
    }

    var u = a(r(54));
    u.Axios = o, u.create = function (t) {
      return a(s(u.defaults, t));
    }, u.Cancel = r(58), u.CancelToken = r(91), u.isCancel = r(53), u.all = function (t) {
      return Promise.all(t);
    }, u.spread = r(92), t.exports = u, t.exports.default = u;
  }, function (t, e) {
    /*!
     * Determine if an object is a Buffer
     *
     * @author   Feross Aboukhadijeh <https://feross.org>
     * @license  MIT
     */
    t.exports = function (t) {
      return null != t && null != t.constructor && "function" == typeof t.constructor.isBuffer && t.constructor.isBuffer(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(52),
        o = r(80),
        s = r(81),
        a = r(57);

    function u(t) {
      this.defaults = t, this.interceptors = {
        request: new o(),
        response: new o()
      };
    }

    u.prototype.request = function (t) {
      "string" == typeof t ? (t = arguments[1] || {}).url = arguments[0] : t = t || {}, (t = a(this.defaults, t)).method = t.method ? t.method.toLowerCase() : "get";
      var e = [s, void 0],
          r = Promise.resolve(t);

      for (this.interceptors.request.forEach(function (t) {
        e.unshift(t.fulfilled, t.rejected);
      }), this.interceptors.response.forEach(function (t) {
        e.push(t.fulfilled, t.rejected);
      }); e.length;) {
        r = r.then(e.shift(), e.shift());
      }

      return r;
    }, u.prototype.getUri = function (t) {
      return t = a(this.defaults, t), i(t.url, t.params, t.paramsSerializer).replace(/^\?/, "");
    }, n.forEach(["delete", "get", "head", "options"], function (t) {
      u.prototype[t] = function (e, r) {
        return this.request(n.merge(r || {}, {
          method: t,
          url: e
        }));
      };
    }), n.forEach(["post", "put", "patch"], function (t) {
      u.prototype[t] = function (e, r, i) {
        return this.request(n.merge(i || {}, {
          method: t,
          url: e,
          data: r
        }));
      };
    }), t.exports = u;
  }, function (t, e, r) {
    "use strict";

    var n = r(4);

    function i() {
      this.handlers = [];
    }

    i.prototype.use = function (t, e) {
      return this.handlers.push({
        fulfilled: t,
        rejected: e
      }), this.handlers.length - 1;
    }, i.prototype.eject = function (t) {
      this.handlers[t] && (this.handlers[t] = null);
    }, i.prototype.forEach = function (t) {
      n.forEach(this.handlers, function (e) {
        null !== e && t(e);
      });
    }, t.exports = i;
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = r(82),
        o = r(53),
        s = r(54),
        a = r(89),
        u = r(90);

    function c(t) {
      t.cancelToken && t.cancelToken.throwIfRequested();
    }

    t.exports = function (t) {
      return c(t), t.baseURL && !a(t.url) && (t.url = u(t.baseURL, t.url)), t.headers = t.headers || {}, t.data = i(t.data, t.headers, t.transformRequest), t.headers = n.merge(t.headers.common || {}, t.headers[t.method] || {}, t.headers || {}), n.forEach(["delete", "get", "head", "post", "put", "patch", "common"], function (e) {
        delete t.headers[e];
      }), (t.adapter || s.adapter)(t).then(function (e) {
        return c(t), e.data = i(e.data, e.headers, t.transformResponse), e;
      }, function (e) {
        return o(e) || (c(t), e && e.response && (e.response.data = i(e.response.data, e.response.headers, t.transformResponse))), Promise.reject(e);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4);

    t.exports = function (t, e, r) {
      return n.forEach(r, function (r) {
        t = r(t, e);
      }), t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4);

    t.exports = function (t, e) {
      n.forEach(t, function (r, n) {
        n !== e && n.toUpperCase() === e.toUpperCase() && (t[e] = r, delete t[n]);
      });
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(56);

    t.exports = function (t, e, r) {
      var i = r.config.validateStatus;
      !i || i(r.status) ? t(r) : e(n("Request failed with status code " + r.status, r.config, null, r.request, r));
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e, r, n, i) {
      return t.config = e, r && (t.code = r), t.request = n, t.response = i, t.isAxiosError = !0, t.toJSON = function () {
        return {
          message: this.message,
          name: this.name,
          description: this.description,
          number: this.number,
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          config: this.config,
          code: this.code
        };
      }, t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4),
        i = ["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"];

    t.exports = function (t) {
      var e,
          r,
          o,
          s = {};
      return t ? (n.forEach(t.split("\n"), function (t) {
        if (o = t.indexOf(":"), e = n.trim(t.substr(0, o)).toLowerCase(), r = n.trim(t.substr(o + 1)), e) {
          if (s[e] && i.indexOf(e) >= 0) return;
          s[e] = "set-cookie" === e ? (s[e] ? s[e] : []).concat([r]) : s[e] ? s[e] + ", " + r : r;
        }
      }), s) : s;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4);
    t.exports = n.isStandardBrowserEnv() ? function () {
      var t,
          e = /(msie|trident)/i.test(navigator.userAgent),
          r = document.createElement("a");

      function i(t) {
        var n = t;
        return e && (r.setAttribute("href", n), n = r.href), r.setAttribute("href", n), {
          href: r.href,
          protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
          host: r.host,
          search: r.search ? r.search.replace(/^\?/, "") : "",
          hash: r.hash ? r.hash.replace(/^#/, "") : "",
          hostname: r.hostname,
          port: r.port,
          pathname: "/" === r.pathname.charAt(0) ? r.pathname : "/" + r.pathname
        };
      }

      return t = i(window.location.href), function (e) {
        var r = n.isString(e) ? i(e) : e;
        return r.protocol === t.protocol && r.host === t.host;
      };
    }() : function () {
      return !0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(4);
    t.exports = n.isStandardBrowserEnv() ? {
      write: function write(t, e, r, i, o, s) {
        var a = [];
        a.push(t + "=" + encodeURIComponent(e)), n.isNumber(r) && a.push("expires=" + new Date(r).toGMTString()), n.isString(i) && a.push("path=" + i), n.isString(o) && a.push("domain=" + o), !0 === s && a.push("secure"), document.cookie = a.join("; ");
      },
      read: function read(t) {
        var e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
        return e ? decodeURIComponent(e[3]) : null;
      },
      remove: function remove(t) {
        this.write(t, "", Date.now() - 864e5);
      }
    } : {
      write: function write() {},
      read: function read() {
        return null;
      },
      remove: function remove() {}
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
    };
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t, e) {
      return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(58);

    function i(t) {
      if ("function" != typeof t) throw new TypeError("executor must be a function.");
      var e;
      this.promise = new Promise(function (t) {
        e = t;
      });
      var r = this;
      t(function (t) {
        r.reason || (r.reason = new n(t), e(r.reason));
      });
    }

    i.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }, i.source = function () {
      var t;
      return {
        token: new i(function (e) {
          t = e;
        }),
        cancel: t
      };
    }, t.exports = i;
  }, function (t, e, r) {
    "use strict";

    t.exports = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    };
  }, function (t, e, r) {
    var n = r(94),
        i = r(69),
        o = t.exports;

    for (var s in n) {
      n.hasOwnProperty(s) && (o[s] = n[s]);
    }

    function a(t) {
      if ("string" == typeof t && (t = i.parse(t)), t.protocol || (t.protocol = "https:"), "https:" !== t.protocol) throw new Error('Protocol "' + t.protocol + '" not supported. Expected "https:"');
      return t;
    }

    o.request = function (t, e) {
      return t = a(t), n.request.call(this, t, e);
    }, o.get = function (t, e) {
      return t = a(t), n.get.call(this, t, e);
    };
  }, function (t, e, r) {
    (function (t) {
      var n = r(95),
          i = r(60),
          o = r(103),
          s = r(104),
          a = r(69),
          u = e;
      u.request = function (e, r) {
        e = "string" == typeof e ? a.parse(e) : o(e);
        var i = -1 === t.location.protocol.search(/^https?:$/) ? "http:" : "",
            s = e.protocol || i,
            u = e.hostname || e.host,
            c = e.port,
            h = e.path || "/";
        u && -1 !== u.indexOf(":") && (u = "[" + u + "]"), e.url = (u ? s + "//" + u : "") + (c ? ":" + c : "") + h, e.method = (e.method || "GET").toUpperCase(), e.headers = e.headers || {};
        var l = new n(e);
        return r && l.on("response", r), l;
      }, u.get = function (t, e) {
        var r = u.request(t, e);
        return r.end(), r;
      }, u.ClientRequest = n, u.IncomingMessage = i.IncomingMessage, u.Agent = function () {}, u.Agent.defaultMaxSockets = 4, u.globalAgent = new u.Agent(), u.STATUS_CODES = s, u.METHODS = ["CHECKOUT", "CONNECT", "COPY", "DELETE", "GET", "HEAD", "LOCK", "M-SEARCH", "MERGE", "MKACTIVITY", "MKCOL", "MOVE", "NOTIFY", "OPTIONS", "PATCH", "POST", "PROPFIND", "PROPPATCH", "PURGE", "PUT", "REPORT", "SEARCH", "SUBSCRIBE", "TRACE", "UNLOCK", "UNSUBSCRIBE"];
    }).call(this, r(3));
  }, function (t, e, r) {
    (function (e, n, i) {
      var o = r(59),
          s = r(12),
          a = r(60),
          u = r(61),
          c = r(102),
          h = a.IncomingMessage,
          l = a.readyStates;

      var f = t.exports = function (t) {
        var r,
            n = this;
        u.Writable.call(n), n._opts = t, n._body = [], n._headers = {}, t.auth && n.setHeader("Authorization", "Basic " + new e(t.auth).toString("base64")), Object.keys(t.headers).forEach(function (e) {
          n.setHeader(e, t.headers[e]);
        });
        var i = !0;
        if ("disable-fetch" === t.mode || "requestTimeout" in t && !o.abortController) i = !1, r = !0;else if ("prefer-streaming" === t.mode) r = !1;else if ("allow-wrong-content-type" === t.mode) r = !o.overrideMimeType;else {
          if (t.mode && "default" !== t.mode && "prefer-fast" !== t.mode) throw new Error("Invalid value for opts.mode");
          r = !0;
        }
        n._mode = function (t, e) {
          return o.fetch && e ? "fetch" : o.mozchunkedarraybuffer ? "moz-chunked-arraybuffer" : o.msstream ? "ms-stream" : o.arraybuffer && t ? "arraybuffer" : o.vbArray && t ? "text:vbarray" : "text";
        }(r, i), n._fetchTimer = null, n.on("finish", function () {
          n._onFinish();
        });
      };

      s(f, u.Writable), f.prototype.setHeader = function (t, e) {
        var r = t.toLowerCase();
        -1 === p.indexOf(r) && (this._headers[r] = {
          name: t,
          value: e
        });
      }, f.prototype.getHeader = function (t) {
        var e = this._headers[t.toLowerCase()];

        return e ? e.value : null;
      }, f.prototype.removeHeader = function (t) {
        delete this._headers[t.toLowerCase()];
      }, f.prototype._onFinish = function () {
        var t = this;

        if (!t._destroyed) {
          var r = t._opts,
              s = t._headers,
              a = null;
          "GET" !== r.method && "HEAD" !== r.method && (a = o.arraybuffer ? c(e.concat(t._body)) : o.blobConstructor ? new n.Blob(t._body.map(function (t) {
            return c(t);
          }), {
            type: (s["content-type"] || {}).value || ""
          }) : e.concat(t._body).toString());
          var u = [];

          if (Object.keys(s).forEach(function (t) {
            var e = s[t].name,
                r = s[t].value;
            Array.isArray(r) ? r.forEach(function (t) {
              u.push([e, t]);
            }) : u.push([e, r]);
          }), "fetch" === t._mode) {
            var h = null;

            if (o.abortController) {
              var f = new AbortController();
              h = f.signal, t._fetchAbortController = f, "requestTimeout" in r && 0 !== r.requestTimeout && (t._fetchTimer = n.setTimeout(function () {
                t.emit("requestTimeout"), t._fetchAbortController && t._fetchAbortController.abort();
              }, r.requestTimeout));
            }

            n.fetch(t._opts.url, {
              method: t._opts.method,
              headers: u,
              body: a || void 0,
              mode: "cors",
              credentials: r.withCredentials ? "include" : "same-origin",
              signal: h
            }).then(function (e) {
              t._fetchResponse = e, t._connect();
            }, function (e) {
              n.clearTimeout(t._fetchTimer), t._destroyed || t.emit("error", e);
            });
          } else {
            var p = t._xhr = new n.XMLHttpRequest();

            try {
              p.open(t._opts.method, t._opts.url, !0);
            } catch (e) {
              return void i.nextTick(function () {
                t.emit("error", e);
              });
            }

            "responseType" in p && (p.responseType = t._mode.split(":")[0]), "withCredentials" in p && (p.withCredentials = !!r.withCredentials), "text" === t._mode && "overrideMimeType" in p && p.overrideMimeType("text/plain; charset=x-user-defined"), "requestTimeout" in r && (p.timeout = r.requestTimeout, p.ontimeout = function () {
              t.emit("requestTimeout");
            }), u.forEach(function (t) {
              p.setRequestHeader(t[0], t[1]);
            }), t._response = null, p.onreadystatechange = function () {
              switch (p.readyState) {
                case l.LOADING:
                case l.DONE:
                  t._onXHRProgress();

              }
            }, "moz-chunked-arraybuffer" === t._mode && (p.onprogress = function () {
              t._onXHRProgress();
            }), p.onerror = function () {
              t._destroyed || t.emit("error", new Error("XHR error"));
            };

            try {
              p.send(a);
            } catch (e) {
              return void i.nextTick(function () {
                t.emit("error", e);
              });
            }
          }
        }
      }, f.prototype._onXHRProgress = function () {
        (function (t) {
          try {
            var e = t.status;
            return null !== e && 0 !== e;
          } catch (t) {
            return !1;
          }
        })(this._xhr) && !this._destroyed && (this._response || this._connect(), this._response._onXHRProgress());
      }, f.prototype._connect = function () {
        var t = this;
        t._destroyed || (t._response = new h(t._xhr, t._fetchResponse, t._mode, t._fetchTimer), t._response.on("error", function (e) {
          t.emit("error", e);
        }), t.emit("response", t._response));
      }, f.prototype._write = function (t, e, r) {
        this._body.push(t), r();
      }, f.prototype.abort = f.prototype.destroy = function () {
        this._destroyed = !0, n.clearTimeout(this._fetchTimer), this._response && (this._response._destroyed = !0), this._xhr ? this._xhr.abort() : this._fetchAbortController && this._fetchAbortController.abort();
      }, f.prototype.end = function (t, e, r) {
        "function" == typeof t && (r = t, t = void 0), u.Writable.prototype.end.call(this, t, e, r);
      }, f.prototype.flushHeaders = function () {}, f.prototype.setTimeout = function () {}, f.prototype.setNoDelay = function () {}, f.prototype.setSocketKeepAlive = function () {};
      var p = ["accept-charset", "accept-encoding", "access-control-request-headers", "access-control-request-method", "connection", "content-length", "cookie", "cookie2", "date", "dnt", "expect", "host", "keep-alive", "origin", "referer", "te", "trailer", "transfer-encoding", "upgrade", "via"];
    }).call(this, r(0).Buffer, r(3), r(15));
  }, function (t, e) {}, function (t, e, r) {
    "use strict";

    var n = r(28).Buffer,
        i = r(98);
    t.exports = function () {
      function t() {
        !function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this.head = null, this.tail = null, this.length = 0;
      }

      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length;
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length;
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t;
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0;
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";

        for (var e = this.head, r = "" + e.data; e = e.next;) {
          r += t + e.data;
        }

        return r;
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return n.alloc(0);
        if (1 === this.length) return this.head.data;

        for (var e, r, i, o = n.allocUnsafe(t >>> 0), s = this.head, a = 0; s;) {
          e = s.data, r = o, i = a, e.copy(r, i), a += s.data.length, s = s.next;
        }

        return o;
      }, t;
    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function () {
      var t = i.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t;
    });
  }, function (t, e) {}, function (t, e, r) {
    (function (t, e) {
      !function (t, r) {
        "use strict";

        if (!t.setImmediate) {
          var n,
              i,
              o,
              s,
              a,
              u = 1,
              c = {},
              h = !1,
              l = t.document,
              f = Object.getPrototypeOf && Object.getPrototypeOf(t);
          f = f && f.setTimeout ? f : t, "[object process]" === {}.toString.call(t.process) ? n = function n(t) {
            e.nextTick(function () {
              d(t);
            });
          } : !function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  r = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = r, e;
            }
          }() ? t.MessageChannel ? ((o = new MessageChannel()).port1.onmessage = function (t) {
            d(t.data);
          }, n = function n(t) {
            o.port2.postMessage(t);
          }) : l && "onreadystatechange" in l.createElement("script") ? (i = l.documentElement, n = function n(t) {
            var e = l.createElement("script");
            e.onreadystatechange = function () {
              d(t), e.onreadystatechange = null, i.removeChild(e), e = null;
            }, i.appendChild(e);
          }) : n = function n(t) {
            setTimeout(d, 0, t);
          } : (s = "setImmediate$" + Math.random() + "$", a = function a(e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(s) && d(+e.data.slice(s.length));
          }, t.addEventListener ? t.addEventListener("message", a, !1) : t.attachEvent("onmessage", a), n = function n(e) {
            t.postMessage(s + e, "*");
          }), f.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));

            for (var e = new Array(arguments.length - 1), r = 0; r < e.length; r++) {
              e[r] = arguments[r + 1];
            }

            var i = {
              callback: t,
              args: e
            };
            return c[u] = i, n(u), u++;
          }, f.clearImmediate = p;
        }

        function p(t) {
          delete c[t];
        }

        function d(t) {
          if (h) setTimeout(d, 0, t);else {
            var e = c[t];

            if (e) {
              h = !0;

              try {
                !function (t) {
                  var e = t.callback,
                      n = t.args;

                  switch (n.length) {
                    case 0:
                      e();
                      break;

                    case 1:
                      e(n[0]);
                      break;

                    case 2:
                      e(n[0], n[1]);
                      break;

                    case 3:
                      e(n[0], n[1], n[2]);
                      break;

                    default:
                      e.apply(r, n);
                  }
                }(e);
              } finally {
                p(t), h = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, r(3), r(15));
  }, function (t, e, r) {
    (function (e) {
      function r(t) {
        try {
          if (!e.localStorage) return !1;
        } catch (t) {
          return !1;
        }

        var r = e.localStorage[t];
        return null != r && "true" === String(r).toLowerCase();
      }

      t.exports = function (t, e) {
        if (r("noDeprecation")) return t;
        var n = !1;
        return function () {
          if (!n) {
            if (r("throwDeprecation")) throw new Error(e);
            r("traceDeprecation") ? console.trace(e) : console.warn(e), n = !0;
          }

          return t.apply(this, arguments);
        };
      };
    }).call(this, r(3));
  }, function (t, e, r) {
    "use strict";

    t.exports = o;
    var n = r(68),
        i = r(23);

    function o(t) {
      if (!(this instanceof o)) return new o(t);
      n.call(this, t);
    }

    i.inherits = r(12), i.inherits(o, n), o.prototype._transform = function (t, e, r) {
      r(null, t);
    };
  }, function (t, e, r) {
    var n = r(0).Buffer;

    t.exports = function (t) {
      if (t instanceof Uint8Array) {
        if (0 === t.byteOffset && t.byteLength === t.buffer.byteLength) return t.buffer;
        if ("function" == typeof t.buffer.slice) return t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength);
      }

      if (n.isBuffer(t)) {
        for (var e = new Uint8Array(t.length), r = t.length, i = 0; i < r; i++) {
          e[i] = t[i];
        }

        return e.buffer;
      }

      throw new Error("Argument must be a Buffer");
    };
  }, function (t, e) {
    t.exports = function () {
      for (var t = {}, e = 0; e < arguments.length; e++) {
        var n = arguments[e];

        for (var i in n) {
          r.call(n, i) && (t[i] = n[i]);
        }
      }

      return t;
    };

    var r = Object.prototype.hasOwnProperty;
  }, function (t, e) {
    t.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Unordered Collection",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }, function (t, e, r) {
    (function (t, n) {
      var i;
      /*! https://mths.be/punycode v1.4.1 by @mathias */

      !function (o) {
        e && e.nodeType, t && t.nodeType;
        var s = "object" == typeof n && n;
        s.global !== s && s.window !== s && s.self;
        var a,
            u = 2147483647,
            c = 36,
            h = 1,
            l = 26,
            f = 38,
            p = 700,
            d = 72,
            y = 128,
            v = "-",
            m = /^xn--/,
            g = /[^\x20-\x7E]/,
            _ = /[\x2E\u3002\uFF0E\uFF61]/g,
            b = {
          overflow: "Overflow: input needs wider integers to process",
          "not-basic": "Illegal input >= 0x80 (not a basic code point)",
          "invalid-input": "Invalid input"
        },
            w = c - h,
            E = Math.floor,
            k = String.fromCharCode;

        function x(t) {
          throw new RangeError(b[t]);
        }

        function C(t, e) {
          for (var r = t.length, n = []; r--;) {
            n[r] = e(t[r]);
          }

          return n;
        }

        function A(t, e) {
          var r = t.split("@"),
              n = "";
          return r.length > 1 && (n = r[0] + "@", t = r[1]), n + C((t = t.replace(_, ".")).split("."), e).join(".");
        }

        function S(t) {
          for (var e, r, n = [], i = 0, o = t.length; i < o;) {
            (e = t.charCodeAt(i++)) >= 55296 && e <= 56319 && i < o ? 56320 == (64512 & (r = t.charCodeAt(i++))) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), i--) : n.push(e);
          }

          return n;
        }

        function T(t) {
          return C(t, function (t) {
            var e = "";
            return t > 65535 && (e += k((t -= 65536) >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += k(t);
          }).join("");
        }

        function R(t, e) {
          return t + 22 + 75 * (t < 26) - ((0 != e) << 5);
        }

        function O(t, e, r) {
          var n = 0;

          for (t = r ? E(t / p) : t >> 1, t += E(t / e); t > w * l >> 1; n += c) {
            t = E(t / w);
          }

          return E(n + (w + 1) * t / (t + f));
        }

        function j(t) {
          var e,
              r,
              n,
              i,
              o,
              s,
              a,
              f,
              p,
              m,
              g,
              _ = [],
              b = t.length,
              w = 0,
              k = y,
              C = d;

          for ((r = t.lastIndexOf(v)) < 0 && (r = 0), n = 0; n < r; ++n) {
            t.charCodeAt(n) >= 128 && x("not-basic"), _.push(t.charCodeAt(n));
          }

          for (i = r > 0 ? r + 1 : 0; i < b;) {
            for (o = w, s = 1, a = c; i >= b && x("invalid-input"), ((f = (g = t.charCodeAt(i++)) - 48 < 10 ? g - 22 : g - 65 < 26 ? g - 65 : g - 97 < 26 ? g - 97 : c) >= c || f > E((u - w) / s)) && x("overflow"), w += f * s, !(f < (p = a <= C ? h : a >= C + l ? l : a - C)); a += c) {
              s > E(u / (m = c - p)) && x("overflow"), s *= m;
            }

            C = O(w - o, e = _.length + 1, 0 == o), E(w / e) > u - k && x("overflow"), k += E(w / e), w %= e, _.splice(w++, 0, k);
          }

          return T(_);
        }

        function P(t) {
          var e,
              r,
              n,
              i,
              o,
              s,
              a,
              f,
              p,
              m,
              g,
              _,
              b,
              w,
              C,
              A = [];

          for (_ = (t = S(t)).length, e = y, r = 0, o = d, s = 0; s < _; ++s) {
            (g = t[s]) < 128 && A.push(k(g));
          }

          for (n = i = A.length, i && A.push(v); n < _;) {
            for (a = u, s = 0; s < _; ++s) {
              (g = t[s]) >= e && g < a && (a = g);
            }

            for (a - e > E((u - r) / (b = n + 1)) && x("overflow"), r += (a - e) * b, e = a, s = 0; s < _; ++s) {
              if ((g = t[s]) < e && ++r > u && x("overflow"), g == e) {
                for (f = r, p = c; !(f < (m = p <= o ? h : p >= o + l ? l : p - o)); p += c) {
                  C = f - m, w = c - m, A.push(k(R(m + C % w, 0))), f = E(C / w);
                }

                A.push(k(R(f, 0))), o = O(r, b, n == i), r = 0, ++n;
              }
            }

            ++r, ++e;
          }

          return A.join("");
        }

        a = {
          version: "1.4.1",
          ucs2: {
            decode: S,
            encode: T
          },
          decode: j,
          encode: P,
          toASCII: function toASCII(t) {
            return A(t, function (t) {
              return g.test(t) ? "xn--" + P(t) : t;
            });
          },
          toUnicode: function toUnicode(t) {
            return A(t, function (t) {
              return m.test(t) ? j(t.slice(4).toLowerCase()) : t;
            });
          }
        }, void 0 === (i = function () {
          return a;
        }.call(e, r, e, t)) || (t.exports = i);
      }();
    }).call(this, r(29)(t), r(3));
  }, function (t, e, r) {
    "use strict";

    t.exports = {
      isString: function isString(t) {
        return "string" == typeof t;
      },
      isObject: function isObject(t) {
        return "object" == typeof t && null !== t;
      },
      isNull: function isNull(t) {
        return null === t;
      },
      isNullOrUndefined: function isNullOrUndefined(t) {
        return null == t;
      }
    };
  }, function (t, e, r) {
    "use strict";

    e.decode = e.parse = r(108), e.encode = e.stringify = r(109);
  }, function (t, e, r) {
    "use strict";

    function n(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }

    t.exports = function (t, e, r, o) {
      e = e || "&", r = r || "=";
      var s = {};
      if ("string" != typeof t || 0 === t.length) return s;
      var a = /\+/g;
      t = t.split(e);
      var u = 1e3;
      o && "number" == typeof o.maxKeys && (u = o.maxKeys);
      var c = t.length;
      u > 0 && c > u && (c = u);

      for (var h = 0; h < c; ++h) {
        var l,
            f,
            p,
            d,
            y = t[h].replace(a, "%20"),
            v = y.indexOf(r);
        v >= 0 ? (l = y.substr(0, v), f = y.substr(v + 1)) : (l = y, f = ""), p = decodeURIComponent(l), d = decodeURIComponent(f), n(s, p) ? i(s[p]) ? s[p].push(d) : s[p] = [s[p], d] : s[p] = d;
      }

      return s;
    };

    var i = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    };
  }, function (t, e, r) {
    "use strict";

    var n = function n(t) {
      switch (typeof t) {
        case "string":
          return t;

        case "boolean":
          return t ? "true" : "false";

        case "number":
          return isFinite(t) ? t : "";

        default:
          return "";
      }
    };

    t.exports = function (t, e, r, a) {
      return e = e || "&", r = r || "=", null === t && (t = void 0), "object" == typeof t ? o(s(t), function (s) {
        var a = encodeURIComponent(n(s)) + r;
        return i(t[s]) ? o(t[s], function (t) {
          return a + encodeURIComponent(n(t));
        }).join(e) : a + encodeURIComponent(n(t[s]));
      }).join(e) : a ? encodeURIComponent(n(a)) + r + encodeURIComponent(n(t)) : "";
    };

    var i = Array.isArray || function (t) {
      return "[object Array]" === Object.prototype.toString.call(t);
    };

    function o(t, e) {
      if (t.map) return t.map(e);

      for (var r = [], n = 0; n < t.length; n++) {
        r.push(e(t[n], n));
      }

      return r;
    }

    var s = Object.keys || function (t) {
      var e = [];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && e.push(r);
      }

      return e;
    };
  }, function (t, e, r) {
    t.exports = r(111);
  }, function (t, e, r) {
    var n = r(112);
    e.operation = function (t) {
      var r = e.timeouts(t);
      return new n(r, {
        forever: t && t.forever,
        unref: t && t.unref,
        maxRetryTime: t && t.maxRetryTime
      });
    }, e.timeouts = function (t) {
      if (t instanceof Array) return [].concat(t);
      var e = {
        retries: 10,
        factor: 2,
        minTimeout: 1e3,
        maxTimeout: 1 / 0,
        randomize: !1
      };

      for (var r in t) {
        e[r] = t[r];
      }

      if (e.minTimeout > e.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");

      for (var n = [], i = 0; i < e.retries; i++) {
        n.push(this.createTimeout(i, e));
      }

      return t && t.forever && !n.length && n.push(this.createTimeout(i, e)), n.sort(function (t, e) {
        return t - e;
      }), n;
    }, e.createTimeout = function (t, e) {
      var r = e.randomize ? Math.random() + 1 : 1,
          n = Math.round(r * e.minTimeout * Math.pow(e.factor, t));
      return n = Math.min(n, e.maxTimeout);
    }, e.wrap = function (t, r, n) {
      if (r instanceof Array && (n = r, r = null), !n) for (var i in n = [], t) {
        "function" == typeof t[i] && n.push(i);
      }

      for (var o = 0; o < n.length; o++) {
        var s = n[o],
            a = t[s];
        t[s] = function (n) {
          var i = e.operation(r),
              o = Array.prototype.slice.call(arguments, 1),
              s = o.pop();
          o.push(function (t) {
            i.retry(t) || (t && (arguments[0] = i.mainError()), s.apply(this, arguments));
          }), i.attempt(function () {
            n.apply(t, o);
          });
        }.bind(t, a), t[s].options = r;
      }
    };
  }, function (t, e) {
    function r(t, e) {
      "boolean" == typeof e && (e = {
        forever: e
      }), this._originalTimeouts = JSON.parse(JSON.stringify(t)), this._timeouts = t, this._options = e || {}, this._maxRetryTime = e && e.maxRetryTime || 1 / 0, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
    }

    t.exports = r, r.prototype.reset = function () {
      this._attempts = 1, this._timeouts = this._originalTimeouts;
    }, r.prototype.stop = function () {
      this._timeout && clearTimeout(this._timeout), this._timeouts = [], this._cachedTimeouts = null;
    }, r.prototype.retry = function (t) {
      if (this._timeout && clearTimeout(this._timeout), !t) return !1;
      var e = new Date().getTime();
      if (t && e - this._operationStart >= this._maxRetryTime) return this._errors.unshift(new Error("RetryOperation timeout occurred")), !1;

      this._errors.push(t);

      var r = this._timeouts.shift();

      if (void 0 === r) {
        if (!this._cachedTimeouts) return !1;
        this._errors.splice(this._errors.length - 1, this._errors.length), this._timeouts = this._cachedTimeouts.slice(0), r = this._timeouts.shift();
      }

      var n = this,
          i = setTimeout(function () {
        n._attempts++, n._operationTimeoutCb && (n._timeout = setTimeout(function () {
          n._operationTimeoutCb(n._attempts);
        }, n._operationTimeout), n._options.unref && n._timeout.unref()), n._fn(n._attempts);
      }, r);
      return this._options.unref && i.unref(), !0;
    }, r.prototype.attempt = function (t, e) {
      this._fn = t, e && (e.timeout && (this._operationTimeout = e.timeout), e.cb && (this._operationTimeoutCb = e.cb));
      var r = this;
      this._operationTimeoutCb && (this._timeout = setTimeout(function () {
        r._operationTimeoutCb();
      }, r._operationTimeout)), this._operationStart = new Date().getTime(), this._fn(this._attempts);
    }, r.prototype.try = function (t) {
      console.log("Using RetryOperation.try() is deprecated"), this.attempt(t);
    }, r.prototype.start = function (t) {
      console.log("Using RetryOperation.start() is deprecated"), this.attempt(t);
    }, r.prototype.start = r.prototype.try, r.prototype.errors = function () {
      return this._errors;
    }, r.prototype.attempts = function () {
      return this._attempts;
    }, r.prototype.mainError = function () {
      if (0 === this._errors.length) return null;

      for (var t = {}, e = null, r = 0, n = 0; n < this._errors.length; n++) {
        var i = this._errors[n],
            o = i.message,
            s = (t[o] || 0) + 1;
        t[o] = s, s >= r && (e = i, r = s);
      }

      return e;
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(5)),
        o = n(r(16)),
        s = n(r(6)),
        a = r(21),
        u = r(8).isIterable,
        c = r(47).chainExists,
        h = r(48),
        l = h.waitOnCommitAck,
        f = h.waitOnRevealAck,
        p = r(2).getPublicAddress,
        d = r(30),
        y = d.Chain,
        v = d.composeChainCommit,
        m = d.composeChainCommitDelegateSig,
        g = d.composeChainReveal,
        _ = r(19),
        b = _.Entry,
        w = _.composeEntryCommit,
        E = _.composeEntryCommitDelegateSig,
        k = _.composeEntryReveal;

    function x(t, e, r, n) {
      return C.apply(this, arguments);
    }

    function C() {
      return (C = (0, s.default)(i.default.mark(function t(e, r, n, s) {
        var a;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, c(e, r.id);

              case 2:
                if (!t.sent) {
                  t.next = 4;
                  break;
                }

                throw new Error("Chain ".concat(r.idHex, " already exists."));

              case 4:
                if ("object" !== (0, o.default)(s) || "function" != typeof s.sign) {
                  t.next = 10;
                  break;
                }

                return t.next = 7, m(r, n, s.sign).then(function (t) {
                  return t.toString("hex");
                });

              case 7:
                a = t.sent, t.next = 11;
                break;

              case 10:
                a = v(r, n).toString("hex");

              case 11:
                return t.abrupt("return", R({
                  factomd: e,
                  commitApiCall: "commit-chain",
                  commit: a,
                  ackTimeout: T(s)
                }));

              case 12:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function A(t, e, r, n) {
      return S.apply(this, arguments);
    }

    function S() {
      return (S = (0, s.default)(i.default.mark(function t(e, r, n, s) {
        var a;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (r.chainId.length) {
                  t.next = 2;
                  break;
                }

                throw new Error("Entry should contain a chain id to be committed");

              case 2:
                if ("object" !== (0, o.default)(s) || "function" != typeof s.sign) {
                  t.next = 8;
                  break;
                }

                return t.next = 5, E(r, n, s.sign).then(function (t) {
                  return t.toString("hex");
                });

              case 5:
                a = t.sent, t.next = 9;
                break;

              case 8:
                a = w(r, n).toString("hex");

              case 9:
                return t.abrupt("return", R({
                  factomd: e,
                  commitApiCall: "commit-entry",
                  commit: a,
                  ackTimeout: T(s)
                }));

              case 10:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function T(t) {
      return "object" === (0, o.default)(t) ? t.ackTimeout : "number" == typeof t ? t : void 0;
    }

    function R(t) {
      return O.apply(this, arguments);
    }

    function O() {
      return (O = (0, s.default)(i.default.mark(function t(e) {
        var r, n, o, s, a, u, c;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return r = e.factomd, n = e.commit, o = e.commitApiCall, s = e.ackTimeout, a = void 0 === s ? 60 : s, u = !1, t.next = 4, r.call(o, {
                  message: n
                }).catch(function (t) {
                  if (-32011 !== t.code) throw t;
                  u = !0;
                });

              case 4:
                if (!((c = t.sent) && a >= 0)) {
                  t.next = 8;
                  break;
                }

                return t.next = 8, l(r, c.txid, a);

              case 8:
                return t.abrupt("return", {
                  txId: c ? c.txid : void 0,
                  repeatedCommit: u
                });

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function j(t, e, r) {
      return I(t, e, g, "reveal-chain", r);
    }

    function P(t, e, r) {
      if (!e.chainId.length) throw new Error("Entry should contain a chain id to be revealed");
      return I(t, e, k, "reveal-entry", r);
    }

    function I(t, e, r, n) {
      return B.apply(this, arguments);
    }

    function B() {
      return (B = (0, s.default)(i.default.mark(function t(e, r, n, o) {
        var s,
            a,
            u,
            c = arguments;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return s = c.length > 4 && void 0 !== c[4] ? c[4] : 60, a = n(r).toString("hex"), t.next = 4, e.call(o, {
                  entry: a
                });

              case 4:
                if (u = t.sent, !(s >= 0)) {
                  t.next = 8;
                  break;
                }

                return t.next = 8, f(e, u.entryhash, u.chainid, s);

              case 8:
                return t.abrupt("return", {
                  chainId: u.chainid,
                  entryHash: u.entryhash
                });

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function F(t, e, r, n) {
      switch (e.constructor) {
        case b:
          return M(t, e, r, n);

        case y:
          return L(t, e, r, n);

        default:
          throw new Error("Argument of `add` is not an instance of Chain or Entry");
      }
    }

    function L(t, e, r, n) {
      return U(t, e, x, j, r, n);
    }

    function M(t, e, r, n) {
      return D.apply(this, arguments);
    }

    function D() {
      return (D = (0, s.default)(i.default.mark(function t(e, r, n, o) {
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (r.chainId.length) {
                  t.next = 2;
                  break;
                }

                throw new Error("Entry should contain a chain id to be added to the blockchain");

              case 2:
                return t.abrupt("return", U(e, r, A, P, n, o));

              case 3:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function U(t, e, r, n, i) {
      return N.apply(this, arguments);
    }

    function N() {
      return (N = (0, s.default)(i.default.mark(function t(e, r, n, o, s) {
        var u,
            c,
            h,
            l,
            f,
            p,
            d = arguments;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if ((u = d.length > 5 && void 0 !== d[5] ? d[5] : {}).skipFundValidation) {
                  t.next = 4;
                  break;
                }

                return t.next = 4, V(e, s, r.ecCost());

              case 4:
                if (c = u.commitTimeout || 60, h = u.revealTimeout || 60, !(c < 0)) {
                  t.next = 14;
                  break;
                }

                return t.next = 9, a.all([n(e, r, s, {
                  ackTimeout: c,
                  sign: u.sign
                }), o(e, r, h)]);

              case 9:
                p = t.sent, l = p[0], f = p[1], t.next = 20;
                break;

              case 14:
                return t.next = 16, n(e, r, s, {
                  ackTimeout: c,
                  sign: u.sign
                });

              case 16:
                return l = t.sent, t.next = 19, o(e, r, h);

              case 19:
                f = t.sent;

              case 20:
                return t.abrupt("return", Object.assign({}, l, f));

              case 21:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function H(t, e, r) {
      return q.apply(this, arguments);
    }

    function q() {
      return (q = (0, s.default)(i.default.mark(function t(e, r, n) {
        var o,
            s,
            u,
            c = arguments;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if ((o = c.length > 3 && void 0 !== c[3] ? c[3] : {}).skipFundValidation) {
                  t.next = 6;
                  break;
                }

                return o.skipFundValidation = !0, s = r.reduce(function (t, e) {
                  return t + e.ecCost();
                }, 0), t.next = 6, V(e, n, s);

              case 6:
                return u = o.chunkSize || o.concurrency || 200, t.abrupt("return", a.map(r, function (t) {
                  return F(e, t, n, o);
                }, {
                  concurrency: u
                }));

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function V(t, e, r) {
      return z.apply(this, arguments);
    }

    function z() {
      return (z = (0, s.default)(i.default.mark(function t(e, r, n) {
        var o, s, a;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return o = p(r), t.next = 3, e.call("entry-credit-balance", {
                  address: o
                });

              case 3:
                if (s = t.sent, !((a = s.balance) < n)) {
                  t.next = 7;
                  break;
                }

                throw new Error("".concat(o, " current balance (").concat(a, " EC) is not sufficient to pay the total cost of ").concat(n, " EC."));

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    var Y = H,
        K = H;
    t.exports = {
      add: function add(t, e, r, n) {
        return u(e) ? H(t, e, r, n) : F(t, e, r, n);
      },
      addChain: L,
      addChains: K,
      addEntry: M,
      addEntries: Y,
      commit: function commit(t, e, r, n) {
        switch (e.constructor) {
          case b:
            return A(t, e, r, n);

          case y:
            return x(t, e, r, n);

          default:
            throw new Error("Argument of `commit` is not an instance of Chain or Entry");
        }
      },
      commitEntry: A,
      commitChain: x,
      reveal: function reveal(t, e, r) {
        switch (e.constructor) {
          case b:
            return P(t, e, r);

          case y:
            return j(t, e, r);

          default:
            throw new Error("Argument of `reveal` is not an instance of Chain or Entry");
        }
      },
      revealEntry: P,
      revealChain: j
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(10)),
        o = n(r(7)),
        s = r(18).Transaction,
        a = r(2),
        u = a.keyToPublicEcAddress,
        c = a.rcdHashToPublicFctAddress,
        h = r(9),
        l = h.ADMIN_ID_TO_CODE,
        f = h.ADMIN_BLOCKS_CHAIN_ID,
        p = h.ENTRY_CREDIT_BLOCKS_CHAIN_ID,
        d = h.FACTOID_BLOCKS_CHAIN_ID,
        y = function () {
      function t(e) {
        (0, o.default)(this, t);
        var r = e.ablock;
        this.backReferenceHash = r.backreferencehash, this.lookupHash = r.lookuphash;
        var n = r.header;
        this.directoryBlockHeight = n.dbheight, this.previousBackReferenceHash = n.prevbackrefhash, this.headerExpansionSize = n.headerexpansionsize, this.headerExpansionArea = n.headerexpansionarea, this.bodySize = n.bodysize, this.entries = r.abentries.map(v), Object.freeze(this);
      }

      return (0, i.default)(t, [{
        key: "getEntriesOfTypes",
        value: function value() {
          for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++) {
            e[r] = arguments[r];
          }

          var n = new Set(e);
          return this.entries.filter(function (t) {
            return n.has(t.adminId) || n.has(t.adminCode);
          });
        }
      }]), t;
    }();

    function v(t) {
      var e = {
        adminId: t.adminidtype,
        adminCode: l.get(t.adminidtype)
      },
          r = {};

      switch (e.adminId) {
        case 1:
          r.identityChainId = t.identityadminchainid, r.previousDirectoryBlockSignature = {
            publicKey: t.prevdbsig.pub,
            signature: t.prevdbsig.sig
          };
          break;

        case 2:
        case 3:
          r.identityChainId = t.identitychainid, r.matryoshkaHash = t.mhash;
          break;

        case 4:
          r.amount = t.amount;
          break;

        case 5:
        case 6:
        case 7:
          r.identityChainId = t.identitychainid, r.directoryBlockHeight = t.dbheight;
          break;

        case 8:
          r.identityChainId = t.identitychainid, r.keyPriority = t.keypriority, r.publicKey = t.publickey, r.directoryBlockHeight = t.dbheight;
          break;

        case 9:
          r.identityChainId = t.identitychainid, r.keyPriority = t.keypriority, r.keyType = t.keytype, r.ecdsaPublicKey = t.ecdsapublickey;
          break;

        case 11:
          r.outputs = t.Outputs.map(function (t) {
            return {
              address: t.useraddress,
              rcdHash: t.address,
              amount: t.amount
            };
          });
          break;

        case 12:
          r.descriptorHeight = t.descriptor_height, r.descriptorIndex = t.DescriptorIndex;
          break;

        case 13:
          r.identityChainId = t.IdentityChainID, r.rcdHash = t.FactoidAddress, r.factoidAddress = c(t.FactoidAddress);
          break;

        case 14:
          r.identityChainId = t.IdentityChainID, r.efficiency = t.Efficiency / 100;
      }

      return Object.assign(e, r);
    }

    var m = function () {
      function t(e) {
        var r = this;
        (0, o.default)(this, t);
        var n = e.fblock;
        this.keyMR = n.keymr, this.bodyMR = n.bodymr, this.previousBlockKeyMR = n.prevkeymr, this.ledgerKeyMR = n.ledgerkeymr, this.previousLedgerKeyMR = n.prevledgerkeymr, this.entryCreditRate = n.exchrate, this.directoryBlockHeight = n.dbheight, this.transactions = n.transactions.map(function (t) {
          return new s(t, {
            factoidBlockKeyMR: r.keyMR,
            directoryBlockHeight: r.directoryBlockHeight
          });
        });
      }

      return (0, i.default)(t, [{
        key: "getCoinbaseTransaction",
        value: function value() {
          return this.transactions[0];
        }
      }]), t;
    }(),
        g = function () {
      function t(e) {
        (0, o.default)(this, t);
        var r = e.ecblock;
        this.headerHash = r.headerhash, this.fullHash = r.fullhash;
        var n = r.header;
        this.headerExpansionArea = n.headerexpansionarea, this.bodyHash = n.bodyhash, this.previousHeaderHash = n.prevheaderhash, this.previousFullHash = n.prevfullhash, this.directoryBlockHeight = n.dbheight, this.bodySize = n.bodysize, this.objectCount = n.objectcount, this.minuteIndexes = [0], this.commits = [];
        var i = !0,
            s = !1,
            a = void 0;

        try {
          for (var c, h = r.body.entries[Symbol.iterator](); !(i = (c = h.next()).done); i = !0) {
            var l = c.value;
            if (Object.prototype.hasOwnProperty.call(l, "number")) this.minuteIndexes.push(this.commits.length);else {
              if (Object.prototype.hasOwnProperty.call(l, "serverindexnumber")) continue;
              if (Object.prototype.hasOwnProperty.call(l, "numec")) continue;
              this.commits.push({
                version: l.version,
                millis: parseInt(l.millitime, 16),
                entryHash: l.entryhash,
                credits: l.credits,
                ecPublicKey: u(l.ecpubkey),
                signature: l.sig
              });
            }
          }
        } catch (t) {
          s = !0, a = t;
        } finally {
          try {
            i || null == h.return || h.return();
          } finally {
            if (s) throw a;
          }
        }

        Object.freeze(this);
      }

      return (0, i.default)(t, [{
        key: "getCommitsForMinute",
        value: function value(t) {
          if (t < 1 || t >= this.minuteIndexes.length) throw new RangeError("Minute out of range [1, ".concat(this.minuteIndexes.length - 1, "]"));
          return this.commits.slice(this.minuteIndexes[t - 1], this.minuteIndexes[t]);
        }
      }]), t;
    }();

    t.exports = {
      DirectoryBlock: function t(e, r) {
        (0, o.default)(this, t);
        var n = [];

        if (e.dblock) {
          var i = e.dblock;
          this.keyMR = i.keymr, this.height = i.header.dbheight, this.previousBlockKeyMR = i.header.prevkeymr, this.timestamp = 60 * i.header.timestamp, n = i.dbentries, this.fullHash = i.dbhash, this.previousFullHash = i.header.prevfullhash, this.bodyKeyMR = i.header.bodymr;
        } else this.keyMR = r, this.height = e.header.sequencenumber, this.previousBlockKeyMR = e.header.prevblockkeymr, this.timestamp = e.header.timestamp, n = e.entryblocklist;

        this.entryBlockRefs = [];
        var s = !0,
            a = !1,
            u = void 0;

        try {
          for (var c, h = n[Symbol.iterator](); !(s = (c = h.next()).done); s = !0) {
            var l = c.value;

            switch (l.chainid) {
              case f:
                this.adminBlockRef = l.keymr;
                break;

              case p:
                this.entryCreditBlockRef = l.keymr;
                break;

              case d:
                this.factoidBlockRef = l.keymr;
                break;

              default:
                this.entryBlockRefs.push({
                  chainId: l.chainid,
                  keyMR: l.keymr
                });
            }
          }
        } catch (t) {
          a = !0, u = t;
        } finally {
          try {
            s || null == h.return || h.return();
          } finally {
            if (a) throw u;
          }
        }

        Object.freeze(this);
      },
      EntryBlock: function t(e, r) {
        (0, o.default)(this, t), this.keyMR = r;
        var n = e.header;
        this.directoryBlockHeight = n.dbheight, this.timestamp = n.timestamp, this.previousBlockKeyMR = n.prevkeymr, this.chainId = n.chainid, this.sequenceNumber = n.blocksequencenumber, this.entryRefs = e.entrylist.map(function (t) {
          return {
            entryHash: t.entryhash,
            timestamp: t.timestamp
          };
        }), Object.freeze(this);
      },
      AdminBlock: y,
      FactoidBlock: m,
      EntryCreditBlock: g
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(5)),
        o = n(r(6)),
        s = r(21),
        a = r(48).waitOnFactoidTransactionAck,
        u = r(2),
        c = u.isValidPublicFctAddress,
        h = u.isValidPublicEcAddress,
        l = r(18).Transaction,
        f = r(47).getEntryCreditRate,
        p = 10;

    function d() {
      return (d = (0, o.default)(i.default.mark(function t(e, r, n) {
        var o, s, u;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return s = (o = n || {}).timeout || 60, t.next = 4, y(e, r, !!o.force);

              case 4:
                if (u = t.sent, !(s >= 0)) {
                  t.next = 8;
                  break;
                }

                return t.next = 8, a(e, u, s);

              case 8:
                return t.abrupt("return", u);

              case 9:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function y(t, e, r) {
      return v.apply(this, arguments);
    }

    function v() {
      return (v = (0, o.default)(i.default.mark(function t(e, r, n) {
        var o, a;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (r instanceof l) {
                  t.next = 2;
                  break;
                }

                throw new Error("Argument must be an instance of Transaction");

              case 2:
                if (r.isSigned()) {
                  t.next = 4;
                  break;
                }

                throw new Error("Cannot submit an unsigned transaction");

              case 4:
                return t.next = 6, f(e);

              case 6:
                if (o = t.sent, !((a = r.computeRequiredFees(o)) > r.feesPaid)) {
                  t.next = 12;
                  break;
                }

                throw new Error("Insufficient fees for the transaction (paid: ".concat(r.feesPaid, ", minimum required: ").concat(a, ", current EC rate: ").concat(o, ")"));

              case 12:
                if (n || !(a * p < r.feesPaid)) {
                  t.next = 14;
                  break;
                }

                throw new Error("Transaction is overpaying required fees by more than 10 times (paid: ".concat(r.feesPaid, ", minimum required: ").concat(a, ", current EC rate: ").concat(o, ")"));

              case 14:
                return n || r.entryCreditOutputs.forEach(function (t) {
                  if (t.amount < o) throw new Error("Entry Credit output to ".concat(t.address, " is not sufficient to get a minimum of 1 Entry Credit (").concat(t.amount, " < ").concat(o, ")."));
                }), t.next = 17, s.each(r.inputs, function (t) {
                  return m(e, t.address, t.amount);
                });

              case 17:
                return t.abrupt("return", e.call("factoid-submit", {
                  transaction: r.marshalBinary().toString("hex")
                }).then(function (t) {
                  return t.txid;
                }));

              case 18:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function m(t, e, r) {
      return g.apply(this, arguments);
    }

    function g() {
      return (g = (0, o.default)(i.default.mark(function t(e, r, n) {
        var o, s;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.next = 2, e.call("factoid-balance", {
                  address: r
                });

              case 2:
                if (o = t.sent, !((s = o.balance) < n)) {
                  t.next = 6;
                  break;
                }

                throw new Error("Address ".concat(r, " doesn't have sufficient funds (balance: ").concat(s, ")"));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function _() {
      return (_ = (0, o.default)(i.default.mark(function t(e, r, n, o, s) {
        var a;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (c(n)) {
                  t.next = 2;
                  break;
                }

                throw new Error("Recipient address [".concat(n, "] is not a valid public Factoid address"));

              case 2:
                return t.next = 4, f(e);

              case 4:
                return a = t.sent, t.abrupt("return", w(r, n, o, a, s));

              case 6:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function b() {
      return (b = (0, o.default)(i.default.mark(function t(e, r, n, o, s) {
        var a, u;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (h(n)) {
                  t.next = 2;
                  break;
                }

                throw new Error("Recipient address [".concat(n, "] is not a valid public Entry Credit address"));

              case 2:
                return t.next = 4, f(e);

              case 4:
                return a = t.sent, u = o * a, t.abrupt("return", w(r, n, u, a, s));

              case 7:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    function w(t, e, r, n, i) {
      var o = l.builder().input(t, r).output(e, r).build().computeRequiredFees(n),
          s = o;
      if (i && i < o) throw new Error("Cannot set fees to ".concat(i, " factoshis because the minimum required fees are ").concat(o));
      return i && (s = i), l.builder().input(t, r + s).output(e, r).build();
    }

    t.exports = {
      sendTransaction: function sendTransaction(t, e, r) {
        return d.apply(this, arguments);
      },
      createFactoidTransaction: function createFactoidTransaction(t, e, r, n, i) {
        return _.apply(this, arguments);
      },
      createEntryCreditPurchaseTransaction: function createEntryCreditPurchaseTransaction(t, e, r, n, i) {
        return b.apply(this, arguments);
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(5)),
        o = n(r(6)),
        s = r(2).isValidAddress,
        a = r(9).PRIVATE_ADDRESS_VALID_PREFIXES;

    function u() {
      return (u = (0, o.default)(i.default.mark(function t(e, r) {
        var n;
        return i.default.wrap(function (t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                if (s(r)) {
                  t.next = 2;
                  break;
                }

                throw new Error("".concat(r, " is not a valid address"));

              case 2:
                if (!a.has(r.substring(0, 2))) {
                  t.next = 4;
                  break;
                }

                return t.abrupt("return", r);

              case 4:
                return t.next = 6, e.call("address", {
                  address: r
                });

              case 6:
                return n = t.sent, t.abrupt("return", n.secret);

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, t);
      }))).apply(this, arguments);
    }

    t.exports = {
      getPrivateAddress: function getPrivateAddress(t, e) {
        return u.apply(this, arguments);
      }
    };
  }, function (t, e, r) {
    "use strict";

    var n = r(1),
        i = n(r(17)),
        o = n(r(5)),
        s = n(r(6)),
        a = n(r(118)),
        u = n(r(7)),
        c = n(r(10)),
        h = n(r(32)),
        l = n(r(22)),
        f = n(r(34));

    function p(t, e) {
      var r = Object.keys(t);

      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(t);
        e && (n = n.filter(function (e) {
          return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r.push.apply(r, n);
      }

      return r;
    }

    var d = r(38).EventEmitter,
        y = r(21),
        v = r(2).isValidPublicFctAddress,
        m = r(18).Transaction,
        g = {
      newDirectoryBlock: "newDirectoryBlock",
      newFactoidBlock: "newFactoidBlock",
      newAdminBlock: "newAdminBlock",
      newEntryCreditBlock: "newEntryCreditBlock",
      newChain: "newChain"
    };
    Object.freeze(g);

    var _ = function (t) {
      function e(t, r) {
        var n;
        return (0, u.default)(this, e), (n = (0, h.default)(this, (0, l.default)(e).call(this)))._cli = t, n._lastBlockHeightProcessed = 0, n.opts = function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2 ? p(r, !0).forEach(function (e) {
              (0, a.default)(t, e, r[e]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : p(r).forEach(function (e) {
              Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r, e));
            });
          }

          return t;
        }({
          interval: 7500
        }, r), n._chainSubscriptions = new Set(), n._factoidAddressSubscriptions = new Set(), n.on("removeListener", function (t) {
          return n._removeListener(t);
        }), n.on("newListener", function (t) {
          return n._newListener(t);
        }), n;
      }

      var r, n, d, _, b, w, E, k;

      return (0, f.default)(e, t), (0, c.default)(e, [{
        key: "_newListener",
        value: (k = (0, s.default)(o.default.mark(function t(e) {
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ("string" == typeof e) {
                    t.next = 2;
                    break;
                  }

                  return t.abrupt("return");

                case 2:
                  if (this._isBlockchainEvent(e) && this._startPolling(), !Object.values(g).includes(e)) {
                    t.next = 5;
                    break;
                  }

                  return t.abrupt("return");

                case 5:
                  v(e) ? this._factoidAddressSubscriptions.add(e) : e.match(/\b[A-Fa-f0-9]{64}\b/) && this._chainSubscriptions.add(e);

                case 6:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return k.apply(this, arguments);
        })
      }, {
        key: "_removeListener",
        value: (E = (0, s.default)(o.default.mark(function t(e) {
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  if ("string" == typeof e) {
                    t.next = 2;
                    break;
                  }

                  return t.abrupt("return");

                case 2:
                  this._chainSubscriptions.has(e) && 0 === this.listenerCount(e) ? this._chainSubscriptions.delete(e) : this._factoidAddressSubscriptions.has(e) && 0 === this.listenerCount(e) && this._factoidAddressSubscriptions.delete(e), this.eventNames().some(this._isBlockchainEvent) || this._stopPolling();

                case 4:
                case "end":
                  return t.stop();
              }
            }
          }, t, this);
        })), function (t) {
          return E.apply(this, arguments);
        })
      }, {
        key: "_isBlockchainEvent",
        value: function value(t) {
          return Object.values(g).includes(t) || v(t) || t.match(/\b[A-Fa-f0-9]{64}\b/);
        }
      }, {
        key: "_startPolling",
        value: function value() {
          var t = this;
          this.isPolling || (this._poll(), this._isPolling = setInterval(function () {
            return t._poll();
          }, this.opts.interval));
        }
      }, {
        key: "_stopPolling",
        value: function value() {
          this.isPolling && (clearInterval(this._isPolling), this._isPolling = !1);
        }
      }, {
        key: "_poll",
        value: (w = (0, s.default)(o.default.mark(function t() {
          var e;
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, this._cli.getDirectoryBlockHead();

                case 3:
                  (e = t.sent).height > this._lastBlockHeightProcessed && (this._lastBlockHeightProcessed = e.height, this._handleDirectoryBlock(e)), t.next = 10;
                  break;

                case 7:
                  t.prev = 7, t.t0 = t.catch(0), this.emit("error", t.t0);

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 7]]);
        })), function () {
          return w.apply(this, arguments);
        })
      }, {
        key: "_handleDirectoryBlock",
        value: function value(t) {
          var e = this;
          this.emit(g.newDirectoryBlock, t), this.listenerCount(g.newAdminBlock) > 0 && this._emitAdminBlock(t), this.listenerCount(g.newEntryCreditBlock) > 0 && this._emitEntryCreditBlock(t), (this.listenerCount(g.newFactoidBlock) > 0 || this._factoidAddressSubscriptions.size > 0) && this._emitFactoidBlock(t), this.listenerCount(g.newChain) > 0 && this._emitNewChains(t);
          var r = t.entryBlockRefs.filter(function (t) {
            return e._chainSubscriptions.has(t.chainId);
          });
          r.length > 0 && this._emitEntryBlock(r);
        }
      }, {
        key: "_emitFactoidBlock",
        value: (b = (0, s.default)(o.default.mark(function t(e) {
          var r;
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, this._cli.getFactoidBlock(e.factoidBlockRef);

                case 3:
                  r = t.sent, this.listenerCount(g.newFactoidBlock) > 0 && this.emit(g.newFactoidBlock, r), this._factoidAddressSubscriptions.size > 0 && this._emitFactoidTransaction(r, e), t.next = 11;
                  break;

                case 8:
                  t.prev = 8, t.t0 = t.catch(0), this.emit("error", t.t0);

                case 11:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 8]]);
        })), function (t) {
          return b.apply(this, arguments);
        })
      }, {
        key: "_emitAdminBlock",
        value: (_ = (0, s.default)(o.default.mark(function t(e) {
          var r;
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, this._cli.getAdminBlock(e.adminBlockRef);

                case 3:
                  r = t.sent, this.emit(g.newAdminBlock, r), t.next = 10;
                  break;

                case 7:
                  t.prev = 7, t.t0 = t.catch(0), this.emit("error", t.t0);

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 7]]);
        })), function (t) {
          return _.apply(this, arguments);
        })
      }, {
        key: "_emitEntryCreditBlock",
        value: (d = (0, s.default)(o.default.mark(function t(e) {
          var r;
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, t.next = 3, this._cli.getEntryCreditBlock(e.entryCreditBlockRef);

                case 3:
                  r = t.sent, this.emit(g.newEntryCreditBlock, r), t.next = 10;
                  break;

                case 7:
                  t.prev = 7, t.t0 = t.catch(0), this.emit("error", t.t0);

                case 10:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 7]]);
        })), function (t) {
          return d.apply(this, arguments);
        })
      }, {
        key: "_emitNewChains",
        value: (n = (0, s.default)(o.default.mark(function t(e) {
          var r,
              n = this;
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return t.prev = 0, r = function () {
                    var t = (0, s.default)(o.default.mark(function t(e) {
                      var r;
                      return o.default.wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return t.next = 2, n._cli.getEntryBlock(e.keyMR);

                            case 2:
                              0 === (r = t.sent).sequenceNumber && n.emit(g.newChain, r);

                            case 4:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }(), t.next = 4, y.map(e.entryBlockRefs, r, {
                    concurrency: 10
                  });

                case 4:
                  t.next = 9;
                  break;

                case 6:
                  t.prev = 6, t.t0 = t.catch(0), this.emit("error", t.t0);

                case 9:
                case "end":
                  return t.stop();
              }
            }
          }, t, this, [[0, 6]]);
        })), function (t) {
          return n.apply(this, arguments);
        })
      }, {
        key: "_emitEntryBlock",
        value: (r = (0, s.default)(o.default.mark(function t(e) {
          var r,
              n = this;
          return o.default.wrap(function (t) {
            for (;;) {
              switch (t.prev = t.next) {
                case 0:
                  return r = function () {
                    var t = (0, s.default)(o.default.mark(function t(e) {
                      var r;
                      return o.default.wrap(function (t) {
                        for (;;) {
                          switch (t.prev = t.next) {
                            case 0:
                              return t.prev = 0, t.next = 3, n._cli.getEntryBlock(e.keyMR);

                            case 3:
                              r = t.sent, n.emit(e.chainId, r), t.next = 10;
                              break;

                            case 7:
                              t.prev = 7, t.t0 = t.catch(0), n.emit("error", t.t0);

                            case 10:
                            case "end":
                              return t.stop();
                          }
                        }
                      }, t, null, [[0, 7]]);
                    }));
                    return function (e) {
                      return t.apply(this, arguments);
                    };
                  }(), t.next = 3, y.map(e, r, {
                    concurrency: 10
                  });

                case 3:
                case "end":
                  return t.stop();
              }
            }
          }, t);
        })), function (t) {
          return r.apply(this, arguments);
        })
      }, {
        key: "_emitFactoidTransaction",
        value: function value(t, e) {
          var r = this,
              n = this._factoidAddressSubscriptions;
          t.transactions.forEach(function (t) {
            var o = new Set([].concat((0, i.default)(t.inputs), (0, i.default)(t.factoidOutputs)).filter(function (t) {
              return n.has(t.address);
            }).map(function (t) {
              return t.address;
            }));

            if (o.size > 0) {
              var s = new m(m.builder(t), {
                factoidBlockKeyMR: e.factoidBlockRef,
                directoryBlockHeight: e.height,
                directoryBlockKeyMR: e.keyMR
              });
              o.forEach(function (t) {
                return r.emit(t, s);
              });
            }
          });
        }
      }, {
        key: "chainSubscriptions",
        get: function get() {
          return this._chainSubscriptions;
        }
      }, {
        key: "factoidAddressSubscriptions",
        get: function get() {
          return this._factoidAddressSubscriptions;
        }
      }, {
        key: "isPolling",
        get: function get() {
          return !!this._isPolling;
        }
      }]), e;
    }(d);

    t.exports = {
      FactomEventEmitter: _,
      FACTOM_EVENT: g
    };
  }, function (t, e) {
    t.exports = function (t, e, r) {
      return e in t ? Object.defineProperty(t, e, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = r, t;
    };
  }]);
});